(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");

require("core-js/fn/regexp/escape");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"core-js/fn/regexp/escape":13,"core-js/shim":423,"regenerator-runtime/runtime":2}],2:[function(require,module,exports){
(function (global){(function (){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":14}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":15}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };
},{"core-js/library/fn/is-iterable":16}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":17}],7:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":18}],8:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _promise = require("../core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
},{"../core-js/promise":7}],9:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":6}],10:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _isIterable2 = require("../core-js/is-iterable");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require("../core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
},{"../core-js/get-iterator":4,"../core-js/is-iterable":5}],11:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":3}],12:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":424}],13:[function(require,module,exports){
require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;

},{"../../modules/_core":117,"../../modules/core.regexp.escape":225}],14:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":26,"../../modules/es6.array.from":87,"../../modules/es6.string.iterator":92}],15:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');

},{"../modules/core.get-iterator":85,"../modules/es6.string.iterator":92,"../modules/web.dom.iterable":95}],16:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');

},{"../modules/core.is-iterable":86,"../modules/es6.string.iterator":92,"../modules/web.dom.iterable":95}],17:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":26,"../../modules/es6.object.assign":89}],18:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;

},{"../modules/_core":26,"../modules/es6.object.to-string":90,"../modules/es6.promise":91,"../modules/es6.string.iterator":92,"../modules/es7.promise.finally":93,"../modules/es7.promise.try":94,"../modules/web.dom.iterable":95}],19:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],20:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],21:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],22:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":44}],23:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":75,"./_to-iobject":77,"./_to-length":78}],24:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":25,"./_wks":83}],25:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],26:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],27:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":56,"./_property-desc":65}],28:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":19}],29:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],30:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":34}],31:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":36,"./_is-object":44}],32:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],33:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":26,"./_ctx":28,"./_global":36,"./_has":37,"./_hide":38}],34:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],35:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":22,"./_ctx":28,"./_is-array-iter":43,"./_iter-call":45,"./_to-length":78,"./core.get-iterator-method":84}],36:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],37:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],38:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":30,"./_object-dp":56,"./_property-desc":65}],39:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":36}],40:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":30,"./_dom-create":31,"./_fails":34}],41:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],42:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":25}],43:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":50,"./_wks":83}],44:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],45:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":22}],46:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":38,"./_object-create":55,"./_property-desc":65,"./_set-to-string-tag":69,"./_wks":83}],47:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":33,"./_hide":38,"./_iter-create":46,"./_iterators":50,"./_library":51,"./_object-gpo":59,"./_redefine":67,"./_set-to-string-tag":69,"./_wks":83}],48:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":83}],49:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],50:[function(require,module,exports){
module.exports = {};

},{}],51:[function(require,module,exports){
module.exports = true;

},{}],52:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":25,"./_global":36,"./_task":74}],53:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":19}],54:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":30,"./_fails":34,"./_iobject":42,"./_object-gops":58,"./_object-keys":61,"./_object-pie":62,"./_to-object":79}],55:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":22,"./_dom-create":31,"./_enum-bug-keys":32,"./_html":39,"./_object-dps":57,"./_shared-key":70}],56:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":22,"./_descriptors":30,"./_ie8-dom-define":40,"./_to-primitive":80}],57:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":22,"./_descriptors":30,"./_object-dp":56,"./_object-keys":61}],58:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],59:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":37,"./_shared-key":70,"./_to-object":79}],60:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":23,"./_has":37,"./_shared-key":70,"./_to-iobject":77}],61:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":32,"./_object-keys-internal":60}],62:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],63:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],64:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":22,"./_is-object":44,"./_new-promise-capability":53}],65:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],66:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":38}],67:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":38}],68:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":26,"./_descriptors":30,"./_global":36,"./_object-dp":56,"./_wks":83}],69:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":37,"./_object-dp":56,"./_wks":83}],70:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":71,"./_uid":81}],71:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":26,"./_global":36,"./_library":51}],72:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":19,"./_an-object":22,"./_wks":83}],73:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":29,"./_to-integer":76}],74:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":25,"./_ctx":28,"./_dom-create":31,"./_global":36,"./_html":39,"./_invoke":41}],75:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":76}],76:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],77:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":29,"./_iobject":42}],78:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":76}],79:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":29}],80:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":44}],81:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],82:[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":36}],83:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":36,"./_shared":71,"./_uid":81}],84:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":24,"./_core":26,"./_iterators":50,"./_wks":83}],85:[function(require,module,exports){
var anObject = require('./_an-object');
var get = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

},{"./_an-object":22,"./_core":26,"./core.get-iterator-method":84}],86:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};

},{"./_classof":24,"./_core":26,"./_iterators":50,"./_wks":83}],87:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":27,"./_ctx":28,"./_export":33,"./_is-array-iter":43,"./_iter-call":45,"./_iter-detect":48,"./_to-length":78,"./_to-object":79,"./core.get-iterator-method":84}],88:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":20,"./_iter-define":47,"./_iter-step":49,"./_iterators":50,"./_to-iobject":77}],89:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":33,"./_object-assign":54}],90:[function(require,module,exports){

},{}],91:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var userAgent = require('./_user-agent');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":19,"./_an-instance":21,"./_classof":24,"./_core":26,"./_ctx":28,"./_export":33,"./_for-of":35,"./_global":36,"./_is-object":44,"./_iter-detect":48,"./_library":51,"./_microtask":52,"./_new-promise-capability":53,"./_perform":63,"./_promise-resolve":64,"./_redefine-all":66,"./_set-species":68,"./_set-to-string-tag":69,"./_species-constructor":72,"./_task":74,"./_user-agent":82,"./_wks":83}],92:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":47,"./_string-at":73}],93:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":26,"./_export":33,"./_global":36,"./_promise-resolve":64,"./_species-constructor":72}],94:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":33,"./_new-promise-capability":53,"./_perform":63}],95:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":36,"./_hide":38,"./_iterators":50,"./_wks":83,"./es6.array.iterator":88}],96:[function(require,module,exports){
arguments[4][19][0].apply(exports,arguments)
},{"dup":19}],97:[function(require,module,exports){
var cof = require('./_cof');
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

},{"./_cof":112}],98:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":137,"./_wks":223}],99:[function(require,module,exports){
'use strict';
var at = require('./_string-at')(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

},{"./_string-at":200}],100:[function(require,module,exports){
arguments[4][21][0].apply(exports,arguments)
},{"dup":21}],101:[function(require,module,exports){
arguments[4][22][0].apply(exports,arguments)
},{"./_is-object":146,"dup":22}],102:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

},{"./_to-absolute-index":208,"./_to-length":212,"./_to-object":213}],103:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"./_to-absolute-index":208,"./_to-length":212,"./_to-object":213}],104:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":133}],105:[function(require,module,exports){
arguments[4][23][0].apply(exports,arguments)
},{"./_to-absolute-index":208,"./_to-iobject":211,"./_to-length":212,"dup":23}],106:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":109,"./_ctx":119,"./_iobject":142,"./_to-length":212,"./_to-object":213}],107:[function(require,module,exports){
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var toLength = require('./_to-length');

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

},{"./_a-function":96,"./_iobject":142,"./_to-length":212,"./_to-object":213}],108:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":144,"./_is-object":146,"./_wks":223}],109:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":108}],110:[function(require,module,exports){
'use strict';
var aFunction = require('./_a-function');
var isObject = require('./_is-object');
var invoke = require('./_invoke');
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

},{"./_a-function":96,"./_invoke":141,"./_is-object":146}],111:[function(require,module,exports){
arguments[4][24][0].apply(exports,arguments)
},{"./_cof":112,"./_wks":223,"dup":24}],112:[function(require,module,exports){
arguments[4][25][0].apply(exports,arguments)
},{"dup":25}],113:[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":100,"./_ctx":119,"./_descriptors":123,"./_for-of":133,"./_iter-define":150,"./_iter-step":152,"./_meta":160,"./_object-create":165,"./_object-dp":166,"./_redefine-all":185,"./_set-species":194,"./_validate-collection":220}],114:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":104,"./_classof":111}],115:[function(require,module,exports){
'use strict';
var redefineAll = require('./_redefine-all');
var getWeak = require('./_meta').getWeak;
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var createArrayMethod = require('./_array-methods');
var $has = require('./_has');
var validate = require('./_validate-collection');
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

},{"./_an-instance":100,"./_an-object":101,"./_array-methods":106,"./_for-of":133,"./_has":136,"./_is-object":146,"./_meta":160,"./_redefine-all":185,"./_validate-collection":220}],116:[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var redefine = require('./_redefine');
var redefineAll = require('./_redefine-all');
var meta = require('./_meta');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var fails = require('./_fails');
var $iterDetect = require('./_iter-detect');
var setToStringTag = require('./_set-to-string-tag');
var inheritIfRequired = require('./_inherit-if-required');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":100,"./_export":127,"./_fails":129,"./_for-of":133,"./_global":135,"./_inherit-if-required":140,"./_is-object":146,"./_iter-detect":151,"./_meta":160,"./_redefine":186,"./_redefine-all":185,"./_set-to-string-tag":195}],117:[function(require,module,exports){
arguments[4][26][0].apply(exports,arguments)
},{"dup":26}],118:[function(require,module,exports){
arguments[4][27][0].apply(exports,arguments)
},{"./_object-dp":166,"./_property-desc":184,"dup":27}],119:[function(require,module,exports){
arguments[4][28][0].apply(exports,arguments)
},{"./_a-function":96,"dup":28}],120:[function(require,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = require('./_fails');
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

},{"./_fails":129}],121:[function(require,module,exports){
'use strict';
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

},{"./_an-object":101,"./_to-primitive":214}],122:[function(require,module,exports){
arguments[4][29][0].apply(exports,arguments)
},{"dup":29}],123:[function(require,module,exports){
arguments[4][30][0].apply(exports,arguments)
},{"./_fails":129,"dup":30}],124:[function(require,module,exports){
arguments[4][31][0].apply(exports,arguments)
},{"./_global":135,"./_is-object":146,"dup":31}],125:[function(require,module,exports){
arguments[4][32][0].apply(exports,arguments)
},{"dup":32}],126:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":172,"./_object-keys":175,"./_object-pie":176}],127:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":117,"./_ctx":119,"./_global":135,"./_hide":137,"./_redefine":186}],128:[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

},{"./_wks":223}],129:[function(require,module,exports){
arguments[4][34][0].apply(exports,arguments)
},{"dup":34}],130:[function(require,module,exports){
'use strict';
require('./es6.regexp.exec');
var redefine = require('./_redefine');
var hide = require('./_hide');
var fails = require('./_fails');
var defined = require('./_defined');
var wks = require('./_wks');
var regexpExec = require('./_regexp-exec');

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

},{"./_defined":122,"./_fails":129,"./_hide":137,"./_redefine":186,"./_regexp-exec":188,"./_wks":223,"./es6.regexp.exec":320}],131:[function(require,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

},{"./_an-object":101}],132:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = require('./_is-array');
var isObject = require('./_is-object');
var toLength = require('./_to-length');
var ctx = require('./_ctx');
var IS_CONCAT_SPREADABLE = require('./_wks')('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

},{"./_ctx":119,"./_is-array":144,"./_is-object":146,"./_to-length":212,"./_wks":223}],133:[function(require,module,exports){
arguments[4][35][0].apply(exports,arguments)
},{"./_an-object":101,"./_ctx":119,"./_is-array-iter":143,"./_iter-call":148,"./_to-length":212,"./core.get-iterator-method":224,"dup":35}],134:[function(require,module,exports){
module.exports = require('./_shared')('native-function-to-string', Function.toString);

},{"./_shared":197}],135:[function(require,module,exports){
arguments[4][36][0].apply(exports,arguments)
},{"dup":36}],136:[function(require,module,exports){
arguments[4][37][0].apply(exports,arguments)
},{"dup":37}],137:[function(require,module,exports){
arguments[4][38][0].apply(exports,arguments)
},{"./_descriptors":123,"./_object-dp":166,"./_property-desc":184,"dup":38}],138:[function(require,module,exports){
arguments[4][39][0].apply(exports,arguments)
},{"./_global":135,"dup":39}],139:[function(require,module,exports){
arguments[4][40][0].apply(exports,arguments)
},{"./_descriptors":123,"./_dom-create":124,"./_fails":129,"dup":40}],140:[function(require,module,exports){
var isObject = require('./_is-object');
var setPrototypeOf = require('./_set-proto').set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

},{"./_is-object":146,"./_set-proto":193}],141:[function(require,module,exports){
arguments[4][41][0].apply(exports,arguments)
},{"dup":41}],142:[function(require,module,exports){
arguments[4][42][0].apply(exports,arguments)
},{"./_cof":112,"dup":42}],143:[function(require,module,exports){
arguments[4][43][0].apply(exports,arguments)
},{"./_iterators":153,"./_wks":223,"dup":43}],144:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":112}],145:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"./_is-object":146}],146:[function(require,module,exports){
arguments[4][44][0].apply(exports,arguments)
},{"dup":44}],147:[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object');
var cof = require('./_cof');
var MATCH = require('./_wks')('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

},{"./_cof":112,"./_is-object":146,"./_wks":223}],148:[function(require,module,exports){
arguments[4][45][0].apply(exports,arguments)
},{"./_an-object":101,"dup":45}],149:[function(require,module,exports){
arguments[4][46][0].apply(exports,arguments)
},{"./_hide":137,"./_object-create":165,"./_property-desc":184,"./_set-to-string-tag":195,"./_wks":223,"dup":46}],150:[function(require,module,exports){
arguments[4][47][0].apply(exports,arguments)
},{"./_export":127,"./_hide":137,"./_iter-create":149,"./_iterators":153,"./_library":154,"./_object-gpo":173,"./_redefine":186,"./_set-to-string-tag":195,"./_wks":223,"dup":47}],151:[function(require,module,exports){
arguments[4][48][0].apply(exports,arguments)
},{"./_wks":223,"dup":48}],152:[function(require,module,exports){
arguments[4][49][0].apply(exports,arguments)
},{"dup":49}],153:[function(require,module,exports){
arguments[4][50][0].apply(exports,arguments)
},{"dup":50}],154:[function(require,module,exports){
module.exports = false;

},{}],155:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

},{}],156:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var sign = require('./_math-sign');
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"./_math-sign":159}],157:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

},{}],158:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

},{}],159:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

},{}],160:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":129,"./_has":136,"./_is-object":146,"./_object-dp":166,"./_uid":218}],161:[function(require,module,exports){
var Map = require('./es6.map');
var $export = require('./_export');
var shared = require('./_shared')('metadata');
var store = shared.store || (shared.store = new (require('./es6.weak-map'))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

},{"./_export":127,"./_shared":197,"./es6.map":255,"./es6.weak-map":362}],162:[function(require,module,exports){
arguments[4][52][0].apply(exports,arguments)
},{"./_cof":112,"./_global":135,"./_task":207,"dup":52}],163:[function(require,module,exports){
arguments[4][53][0].apply(exports,arguments)
},{"./_a-function":96,"dup":53}],164:[function(require,module,exports){
arguments[4][54][0].apply(exports,arguments)
},{"./_descriptors":123,"./_fails":129,"./_iobject":142,"./_object-gops":172,"./_object-keys":175,"./_object-pie":176,"./_to-object":213,"dup":54}],165:[function(require,module,exports){
arguments[4][55][0].apply(exports,arguments)
},{"./_an-object":101,"./_dom-create":124,"./_enum-bug-keys":125,"./_html":138,"./_object-dps":167,"./_shared-key":196,"dup":55}],166:[function(require,module,exports){
arguments[4][56][0].apply(exports,arguments)
},{"./_an-object":101,"./_descriptors":123,"./_ie8-dom-define":139,"./_to-primitive":214,"dup":56}],167:[function(require,module,exports){
arguments[4][57][0].apply(exports,arguments)
},{"./_an-object":101,"./_descriptors":123,"./_object-dp":166,"./_object-keys":175,"dup":57}],168:[function(require,module,exports){
'use strict';
// Forced replacement prototype accessors methods
module.exports = require('./_library') || !require('./_fails')(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete require('./_global')[K];
});

},{"./_fails":129,"./_global":135,"./_library":154}],169:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":123,"./_has":136,"./_ie8-dom-define":139,"./_object-pie":176,"./_property-desc":184,"./_to-iobject":211,"./_to-primitive":214}],170:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":171,"./_to-iobject":211}],171:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":125,"./_object-keys-internal":174}],172:[function(require,module,exports){
arguments[4][58][0].apply(exports,arguments)
},{"dup":58}],173:[function(require,module,exports){
arguments[4][59][0].apply(exports,arguments)
},{"./_has":136,"./_shared-key":196,"./_to-object":213,"dup":59}],174:[function(require,module,exports){
arguments[4][60][0].apply(exports,arguments)
},{"./_array-includes":105,"./_has":136,"./_shared-key":196,"./_to-iobject":211,"dup":60}],175:[function(require,module,exports){
arguments[4][61][0].apply(exports,arguments)
},{"./_enum-bug-keys":125,"./_object-keys-internal":174,"dup":61}],176:[function(require,module,exports){
arguments[4][62][0].apply(exports,arguments)
},{"dup":62}],177:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":117,"./_export":127,"./_fails":129}],178:[function(require,module,exports){
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

},{"./_descriptors":123,"./_object-keys":175,"./_object-pie":176,"./_to-iobject":211}],179:[function(require,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN = require('./_object-gopn');
var gOPS = require('./_object-gops');
var anObject = require('./_an-object');
var Reflect = require('./_global').Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

},{"./_an-object":101,"./_global":135,"./_object-gopn":171,"./_object-gops":172}],180:[function(require,module,exports){
var $parseFloat = require('./_global').parseFloat;
var $trim = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

},{"./_global":135,"./_string-trim":205,"./_string-ws":206}],181:[function(require,module,exports){
var $parseInt = require('./_global').parseInt;
var $trim = require('./_string-trim').trim;
var ws = require('./_string-ws');
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

},{"./_global":135,"./_string-trim":205,"./_string-ws":206}],182:[function(require,module,exports){
arguments[4][63][0].apply(exports,arguments)
},{"dup":63}],183:[function(require,module,exports){
arguments[4][64][0].apply(exports,arguments)
},{"./_an-object":101,"./_is-object":146,"./_new-promise-capability":163,"dup":64}],184:[function(require,module,exports){
arguments[4][65][0].apply(exports,arguments)
},{"dup":65}],185:[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

},{"./_redefine":186}],186:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var $toString = require('./_function-to-string');
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":117,"./_function-to-string":134,"./_global":135,"./_has":136,"./_hide":137,"./_uid":218}],187:[function(require,module,exports){
'use strict';

var classof = require('./_classof');
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

},{"./_classof":111}],188:[function(require,module,exports){
'use strict';

var regexpFlags = require('./_flags');

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;

},{"./_flags":131}],189:[function(require,module,exports){
module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

},{}],190:[function(require,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],191:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":96,"./_ctx":119,"./_export":127,"./_for-of":133}],192:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":127}],193:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":101,"./_ctx":119,"./_is-object":146,"./_object-gopd":169}],194:[function(require,module,exports){
'use strict';
var global = require('./_global');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_descriptors":123,"./_global":135,"./_object-dp":166,"./_wks":223}],195:[function(require,module,exports){
arguments[4][69][0].apply(exports,arguments)
},{"./_has":136,"./_object-dp":166,"./_wks":223,"dup":69}],196:[function(require,module,exports){
arguments[4][70][0].apply(exports,arguments)
},{"./_shared":197,"./_uid":218,"dup":70}],197:[function(require,module,exports){
arguments[4][71][0].apply(exports,arguments)
},{"./_core":117,"./_global":135,"./_library":154,"dup":71}],198:[function(require,module,exports){
arguments[4][72][0].apply(exports,arguments)
},{"./_a-function":96,"./_an-object":101,"./_wks":223,"dup":72}],199:[function(require,module,exports){
'use strict';
var fails = require('./_fails');

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"./_fails":129}],200:[function(require,module,exports){
arguments[4][73][0].apply(exports,arguments)
},{"./_defined":122,"./_to-integer":210,"dup":73}],201:[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp');
var defined = require('./_defined');

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

},{"./_defined":122,"./_is-regexp":147}],202:[function(require,module,exports){
var $export = require('./_export');
var fails = require('./_fails');
var defined = require('./_defined');
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

},{"./_defined":122,"./_export":127,"./_fails":129}],203:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = require('./_to-length');
var repeat = require('./_string-repeat');
var defined = require('./_defined');

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"./_defined":122,"./_string-repeat":204,"./_to-length":212}],204:[function(require,module,exports){
'use strict';
var toInteger = require('./_to-integer');
var defined = require('./_defined');

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

},{"./_defined":122,"./_to-integer":210}],205:[function(require,module,exports){
var $export = require('./_export');
var defined = require('./_defined');
var fails = require('./_fails');
var spaces = require('./_string-ws');
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

},{"./_defined":122,"./_export":127,"./_fails":129,"./_string-ws":206}],206:[function(require,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],207:[function(require,module,exports){
arguments[4][74][0].apply(exports,arguments)
},{"./_cof":112,"./_ctx":119,"./_dom-create":124,"./_global":135,"./_html":138,"./_invoke":141,"dup":74}],208:[function(require,module,exports){
arguments[4][75][0].apply(exports,arguments)
},{"./_to-integer":210,"dup":75}],209:[function(require,module,exports){
// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

},{"./_to-integer":210,"./_to-length":212}],210:[function(require,module,exports){
arguments[4][76][0].apply(exports,arguments)
},{"dup":76}],211:[function(require,module,exports){
arguments[4][77][0].apply(exports,arguments)
},{"./_defined":122,"./_iobject":142,"dup":77}],212:[function(require,module,exports){
arguments[4][78][0].apply(exports,arguments)
},{"./_to-integer":210,"dup":78}],213:[function(require,module,exports){
arguments[4][79][0].apply(exports,arguments)
},{"./_defined":122,"dup":79}],214:[function(require,module,exports){
arguments[4][80][0].apply(exports,arguments)
},{"./_is-object":146,"dup":80}],215:[function(require,module,exports){
'use strict';
if (require('./_descriptors')) {
  var LIBRARY = require('./_library');
  var global = require('./_global');
  var fails = require('./_fails');
  var $export = require('./_export');
  var $typed = require('./_typed');
  var $buffer = require('./_typed-buffer');
  var ctx = require('./_ctx');
  var anInstance = require('./_an-instance');
  var propertyDesc = require('./_property-desc');
  var hide = require('./_hide');
  var redefineAll = require('./_redefine-all');
  var toInteger = require('./_to-integer');
  var toLength = require('./_to-length');
  var toIndex = require('./_to-index');
  var toAbsoluteIndex = require('./_to-absolute-index');
  var toPrimitive = require('./_to-primitive');
  var has = require('./_has');
  var classof = require('./_classof');
  var isObject = require('./_is-object');
  var toObject = require('./_to-object');
  var isArrayIter = require('./_is-array-iter');
  var create = require('./_object-create');
  var getPrototypeOf = require('./_object-gpo');
  var gOPN = require('./_object-gopn').f;
  var getIterFn = require('./core.get-iterator-method');
  var uid = require('./_uid');
  var wks = require('./_wks');
  var createArrayMethod = require('./_array-methods');
  var createArrayIncludes = require('./_array-includes');
  var speciesConstructor = require('./_species-constructor');
  var ArrayIterators = require('./es6.array.iterator');
  var Iterators = require('./_iterators');
  var $iterDetect = require('./_iter-detect');
  var setSpecies = require('./_set-species');
  var arrayFill = require('./_array-fill');
  var arrayCopyWithin = require('./_array-copy-within');
  var $DP = require('./_object-dp');
  var $GOPD = require('./_object-gopd');
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };

},{"./_an-instance":100,"./_array-copy-within":102,"./_array-fill":103,"./_array-includes":105,"./_array-methods":106,"./_classof":111,"./_ctx":119,"./_descriptors":123,"./_export":127,"./_fails":129,"./_global":135,"./_has":136,"./_hide":137,"./_is-array-iter":143,"./_is-object":146,"./_iter-detect":151,"./_iterators":153,"./_library":154,"./_object-create":165,"./_object-dp":166,"./_object-gopd":169,"./_object-gopn":171,"./_object-gpo":173,"./_property-desc":184,"./_redefine-all":185,"./_set-species":194,"./_species-constructor":198,"./_to-absolute-index":208,"./_to-index":209,"./_to-integer":210,"./_to-length":212,"./_to-object":213,"./_to-primitive":214,"./_typed":217,"./_typed-buffer":216,"./_uid":218,"./_wks":223,"./core.get-iterator-method":224,"./es6.array.iterator":236}],216:[function(require,module,exports){
'use strict';
var global = require('./_global');
var DESCRIPTORS = require('./_descriptors');
var LIBRARY = require('./_library');
var $typed = require('./_typed');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var fails = require('./_fails');
var anInstance = require('./_an-instance');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var toIndex = require('./_to-index');
var gOPN = require('./_object-gopn').f;
var dP = require('./_object-dp').f;
var arrayFill = require('./_array-fill');
var setToStringTag = require('./_set-to-string-tag');
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

},{"./_an-instance":100,"./_array-fill":103,"./_descriptors":123,"./_fails":129,"./_global":135,"./_hide":137,"./_library":154,"./_object-dp":166,"./_object-gopn":171,"./_redefine-all":185,"./_set-to-string-tag":195,"./_to-index":209,"./_to-integer":210,"./_to-length":212,"./_typed":217}],217:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var uid = require('./_uid');
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

},{"./_global":135,"./_hide":137,"./_uid":218}],218:[function(require,module,exports){
arguments[4][81][0].apply(exports,arguments)
},{"dup":81}],219:[function(require,module,exports){
arguments[4][82][0].apply(exports,arguments)
},{"./_global":135,"dup":82}],220:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":146}],221:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":117,"./_global":135,"./_library":154,"./_object-dp":166,"./_wks-ext":222}],222:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":223}],223:[function(require,module,exports){
arguments[4][83][0].apply(exports,arguments)
},{"./_global":135,"./_shared":197,"./_uid":218,"dup":83}],224:[function(require,module,exports){
arguments[4][84][0].apply(exports,arguments)
},{"./_classof":111,"./_core":117,"./_iterators":153,"./_wks":223,"dup":84}],225:[function(require,module,exports){
// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });

},{"./_export":127,"./_replacer":189}],226:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { copyWithin: require('./_array-copy-within') });

require('./_add-to-unscopables')('copyWithin');

},{"./_add-to-unscopables":98,"./_array-copy-within":102,"./_export":127}],227:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $every = require('./_array-methods')(4);

$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":106,"./_export":127,"./_strict-method":199}],228:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');

},{"./_add-to-unscopables":98,"./_array-fill":103,"./_export":127}],229:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":106,"./_export":127,"./_strict-method":199}],230:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":98,"./_array-methods":106,"./_export":127}],231:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":98,"./_array-methods":106,"./_export":127}],232:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $forEach = require('./_array-methods')(0);
var STRICT = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":106,"./_export":127,"./_strict-method":199}],233:[function(require,module,exports){
arguments[4][87][0].apply(exports,arguments)
},{"./_create-property":118,"./_ctx":119,"./_export":127,"./_is-array-iter":143,"./_iter-call":148,"./_iter-detect":151,"./_to-length":212,"./_to-object":213,"./core.get-iterator-method":224,"dup":87}],234:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $indexOf = require('./_array-includes')(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"./_array-includes":105,"./_export":127,"./_strict-method":199}],235:[function(require,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });

},{"./_export":127,"./_is-array":144}],236:[function(require,module,exports){
arguments[4][88][0].apply(exports,arguments)
},{"./_add-to-unscopables":98,"./_iter-define":150,"./_iter-step":152,"./_iterators":153,"./_to-iobject":211,"dup":88}],237:[function(require,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

},{"./_export":127,"./_iobject":142,"./_strict-method":199,"./_to-iobject":211}],238:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

},{"./_export":127,"./_strict-method":199,"./_to-integer":210,"./_to-iobject":211,"./_to-length":212}],239:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $map = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":106,"./_export":127,"./_strict-method":199}],240:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var createProperty = require('./_create-property');

// WebKit Array.of isn't generic
$export($export.S + $export.F * require('./_fails')(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

},{"./_create-property":118,"./_export":127,"./_fails":129}],241:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

},{"./_array-reduce":107,"./_export":127,"./_strict-method":199}],242:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

},{"./_array-reduce":107,"./_export":127,"./_strict-method":199}],243:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var html = require('./_html');
var cof = require('./_cof');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * require('./_fails')(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

},{"./_cof":112,"./_export":127,"./_fails":129,"./_html":138,"./_to-absolute-index":208,"./_to-length":212}],244:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $some = require('./_array-methods')(3);

$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":106,"./_export":127,"./_strict-method":199}],245:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var fails = require('./_fails');
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !require('./_strict-method')($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

},{"./_a-function":96,"./_export":127,"./_fails":129,"./_strict-method":199,"./_to-object":213}],246:[function(require,module,exports){
require('./_set-species')('Array');

},{"./_set-species":194}],247:[function(require,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });

},{"./_export":127}],248:[function(require,module,exports){
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export');
var toISOString = require('./_date-to-iso-string');

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

},{"./_date-to-iso-string":120,"./_export":127}],249:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');

$export($export.P + $export.F * require('./_fails')(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"./_export":127,"./_fails":129,"./_to-object":213,"./_to-primitive":214}],250:[function(require,module,exports){
var TO_PRIMITIVE = require('./_wks')('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) require('./_hide')(proto, TO_PRIMITIVE, require('./_date-to-primitive'));

},{"./_date-to-primitive":121,"./_hide":137,"./_wks":223}],251:[function(require,module,exports){
var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  require('./_redefine')(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

},{"./_redefine":186}],252:[function(require,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', { bind: require('./_bind') });

},{"./_bind":110,"./_export":127}],253:[function(require,module,exports){
'use strict';
var isObject = require('./_is-object');
var getPrototypeOf = require('./_object-gpo');
var HAS_INSTANCE = require('./_wks')('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) require('./_object-dp').f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });

},{"./_is-object":146,"./_object-dp":166,"./_object-gpo":173,"./_wks":223}],254:[function(require,module,exports){
var dP = require('./_object-dp').f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

},{"./_descriptors":123,"./_object-dp":166}],255:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":116,"./_collection-strong":113,"./_validate-collection":220}],256:[function(require,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = require('./_export');
var log1p = require('./_math-log1p');
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

},{"./_export":127,"./_math-log1p":157}],257:[function(require,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = require('./_export');
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

},{"./_export":127}],258:[function(require,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = require('./_export');
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

},{"./_export":127}],259:[function(require,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = require('./_export');
var sign = require('./_math-sign');

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

},{"./_export":127,"./_math-sign":159}],260:[function(require,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

},{"./_export":127}],261:[function(require,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = require('./_export');
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

},{"./_export":127}],262:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = require('./_export');
var $expm1 = require('./_math-expm1');

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

},{"./_export":127,"./_math-expm1":155}],263:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });

},{"./_export":127,"./_math-fround":156}],264:[function(require,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = require('./_export');
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

},{"./_export":127}],265:[function(require,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = require('./_export');
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * require('./_fails')(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"./_export":127,"./_fails":129}],266:[function(require,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

},{"./_export":127}],267:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', { log1p: require('./_math-log1p') });

},{"./_export":127,"./_math-log1p":157}],268:[function(require,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

},{"./_export":127}],269:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });

},{"./_export":127,"./_math-sign":159}],270:[function(require,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * require('./_fails')(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

},{"./_export":127,"./_fails":129,"./_math-expm1":155}],271:[function(require,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

},{"./_export":127,"./_math-expm1":155}],272:[function(require,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

},{"./_export":127}],273:[function(require,module,exports){
'use strict';
var global = require('./_global');
var has = require('./_has');
var cof = require('./_cof');
var inheritIfRequired = require('./_inherit-if-required');
var toPrimitive = require('./_to-primitive');
var fails = require('./_fails');
var gOPN = require('./_object-gopn').f;
var gOPD = require('./_object-gopd').f;
var dP = require('./_object-dp').f;
var $trim = require('./_string-trim').trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(require('./_object-create')(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = require('./_descriptors') ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  require('./_redefine')(global, NUMBER, $Number);
}

},{"./_cof":112,"./_descriptors":123,"./_fails":129,"./_global":135,"./_has":136,"./_inherit-if-required":140,"./_object-create":165,"./_object-dp":166,"./_object-gopd":169,"./_object-gopn":171,"./_redefine":186,"./_string-trim":205,"./_to-primitive":214}],274:[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"./_export":127}],275:[function(require,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export = require('./_export');
var _isFinite = require('./_global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

},{"./_export":127,"./_global":135}],276:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

},{"./_export":127,"./_is-integer":145}],277:[function(require,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

},{"./_export":127}],278:[function(require,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export = require('./_export');
var isInteger = require('./_is-integer');
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

},{"./_export":127,"./_is-integer":145}],279:[function(require,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

},{"./_export":127}],280:[function(require,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

},{"./_export":127}],281:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

},{"./_export":127,"./_parse-float":180}],282:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

},{"./_export":127,"./_parse-int":181}],283:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toInteger = require('./_to-integer');
var aNumberValue = require('./_a-number-value');
var repeat = require('./_string-repeat');
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !require('./_fails')(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

},{"./_a-number-value":97,"./_export":127,"./_fails":129,"./_string-repeat":204,"./_to-integer":210}],284:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $fails = require('./_fails');
var aNumberValue = require('./_a-number-value');
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

},{"./_a-number-value":97,"./_export":127,"./_fails":129}],285:[function(require,module,exports){
arguments[4][89][0].apply(exports,arguments)
},{"./_export":127,"./_object-assign":164,"dup":89}],286:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":127,"./_object-create":165}],287:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":123,"./_export":127,"./_object-dps":167}],288:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":123,"./_export":127,"./_object-dp":166}],289:[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"./_is-object":146,"./_meta":160,"./_object-sap":177}],290:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":169,"./_object-sap":177,"./_to-iobject":211}],291:[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});

},{"./_object-gopn-ext":170,"./_object-sap":177}],292:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":173,"./_object-sap":177,"./_to-object":213}],293:[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"./_is-object":146,"./_object-sap":177}],294:[function(require,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = require('./_is-object');

require('./_object-sap')('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

},{"./_is-object":146,"./_object-sap":177}],295:[function(require,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = require('./_is-object');

require('./_object-sap')('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

},{"./_is-object":146,"./_object-sap":177}],296:[function(require,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', { is: require('./_same-value') });

},{"./_export":127,"./_same-value":190}],297:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":175,"./_object-sap":177,"./_to-object":213}],298:[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"./_is-object":146,"./_meta":160,"./_object-sap":177}],299:[function(require,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

},{"./_is-object":146,"./_meta":160,"./_object-sap":177}],300:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":127,"./_set-proto":193}],301:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"./_classof":111,"./_redefine":186,"./_wks":223}],302:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

},{"./_export":127,"./_parse-float":180}],303:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

},{"./_export":127,"./_parse-int":181}],304:[function(require,module,exports){
arguments[4][91][0].apply(exports,arguments)
},{"./_a-function":96,"./_an-instance":100,"./_classof":111,"./_core":117,"./_ctx":119,"./_export":127,"./_for-of":133,"./_global":135,"./_is-object":146,"./_iter-detect":151,"./_library":154,"./_microtask":162,"./_new-promise-capability":163,"./_perform":182,"./_promise-resolve":183,"./_redefine-all":185,"./_set-species":194,"./_set-to-string-tag":195,"./_species-constructor":198,"./_task":207,"./_user-agent":219,"./_wks":223,"dup":91}],305:[function(require,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = require('./_export');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var rApply = (require('./_global').Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !require('./_fails')(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

},{"./_a-function":96,"./_an-object":101,"./_export":127,"./_fails":129,"./_global":135}],306:[function(require,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = require('./_export');
var create = require('./_object-create');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var fails = require('./_fails');
var bind = require('./_bind');
var rConstruct = (require('./_global').Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"./_a-function":96,"./_an-object":101,"./_bind":110,"./_export":127,"./_fails":129,"./_global":135,"./_is-object":146,"./_object-create":165}],307:[function(require,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = require('./_object-dp');
var $export = require('./_export');
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * require('./_fails')(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":101,"./_export":127,"./_fails":129,"./_object-dp":166,"./_to-primitive":214}],308:[function(require,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = require('./_export');
var gOPD = require('./_object-gopd').f;
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

},{"./_an-object":101,"./_export":127,"./_object-gopd":169}],309:[function(require,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
require('./_iter-create')(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

},{"./_an-object":101,"./_export":127,"./_iter-create":149}],310:[function(require,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

},{"./_an-object":101,"./_export":127,"./_object-gopd":169}],311:[function(require,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export = require('./_export');
var getProto = require('./_object-gpo');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

},{"./_an-object":101,"./_export":127,"./_object-gpo":173}],312:[function(require,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var isObject = require('./_is-object');
var anObject = require('./_an-object');

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

},{"./_an-object":101,"./_export":127,"./_has":136,"./_is-object":146,"./_object-gopd":169,"./_object-gpo":173}],313:[function(require,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"./_export":127}],314:[function(require,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

},{"./_an-object":101,"./_export":127}],315:[function(require,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });

},{"./_export":127,"./_own-keys":179}],316:[function(require,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":101,"./_export":127}],317:[function(require,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = require('./_export');
var setProto = require('./_set-proto');

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_export":127,"./_set-proto":193}],318:[function(require,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = require('./_object-dp');
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var createDesc = require('./_property-desc');
var anObject = require('./_an-object');
var isObject = require('./_is-object');

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

},{"./_an-object":101,"./_export":127,"./_has":136,"./_is-object":146,"./_object-dp":166,"./_object-gopd":169,"./_object-gpo":173,"./_property-desc":184}],319:[function(require,module,exports){
var global = require('./_global');
var inheritIfRequired = require('./_inherit-if-required');
var dP = require('./_object-dp').f;
var gOPN = require('./_object-gopn').f;
var isRegExp = require('./_is-regexp');
var $flags = require('./_flags');
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (require('./_descriptors') && (!CORRECT_NEW || require('./_fails')(function () {
  re2[require('./_wks')('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  require('./_redefine')(global, 'RegExp', $RegExp);
}

require('./_set-species')('RegExp');

},{"./_descriptors":123,"./_fails":129,"./_flags":131,"./_global":135,"./_inherit-if-required":140,"./_is-regexp":147,"./_object-dp":166,"./_object-gopn":171,"./_redefine":186,"./_set-species":194,"./_wks":223}],320:[function(require,module,exports){
'use strict';
var regexpExec = require('./_regexp-exec');
require('./_export')({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});

},{"./_export":127,"./_regexp-exec":188}],321:[function(require,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});

},{"./_descriptors":123,"./_flags":131,"./_object-dp":166}],322:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var toLength = require('./_to-length');
var advanceStringIndex = require('./_advance-string-index');
var regExpExec = require('./_regexp-exec-abstract');

// @@match logic
require('./_fix-re-wks')('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

},{"./_advance-string-index":99,"./_an-object":101,"./_fix-re-wks":130,"./_regexp-exec-abstract":187,"./_to-length":212}],323:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var advanceStringIndex = require('./_advance-string-index');
var regExpExec = require('./_regexp-exec-abstract');
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
require('./_fix-re-wks')('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

},{"./_advance-string-index":99,"./_an-object":101,"./_fix-re-wks":130,"./_regexp-exec-abstract":187,"./_to-integer":210,"./_to-length":212,"./_to-object":213}],324:[function(require,module,exports){
'use strict';

var anObject = require('./_an-object');
var sameValue = require('./_same-value');
var regExpExec = require('./_regexp-exec-abstract');

// @@search logic
require('./_fix-re-wks')('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

},{"./_an-object":101,"./_fix-re-wks":130,"./_regexp-exec-abstract":187,"./_same-value":190}],325:[function(require,module,exports){
'use strict';

var isRegExp = require('./_is-regexp');
var anObject = require('./_an-object');
var speciesConstructor = require('./_species-constructor');
var advanceStringIndex = require('./_advance-string-index');
var toLength = require('./_to-length');
var callRegExpExec = require('./_regexp-exec-abstract');
var regexpExec = require('./_regexp-exec');
var fails = require('./_fails');
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
require('./_fix-re-wks')('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});

},{"./_advance-string-index":99,"./_an-object":101,"./_fails":129,"./_fix-re-wks":130,"./_is-regexp":147,"./_regexp-exec":188,"./_regexp-exec-abstract":187,"./_species-constructor":198,"./_to-length":212}],326:[function(require,module,exports){
'use strict';
require('./es6.regexp.flags');
var anObject = require('./_an-object');
var $flags = require('./_flags');
var DESCRIPTORS = require('./_descriptors');
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  require('./_redefine')(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (require('./_fails')(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

},{"./_an-object":101,"./_descriptors":123,"./_fails":129,"./_flags":131,"./_redefine":186,"./es6.regexp.flags":321}],327:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var SET = 'Set';

// 23.2 Set Objects
module.exports = require('./_collection')(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"./_collection":116,"./_collection-strong":113,"./_validate-collection":220}],328:[function(require,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

},{"./_string-html":202}],329:[function(require,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

},{"./_string-html":202}],330:[function(require,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
require('./_string-html')('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

},{"./_string-html":202}],331:[function(require,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

},{"./_string-html":202}],332:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $at = require('./_string-at')(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

},{"./_export":127,"./_string-at":200}],333:[function(require,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

},{"./_export":127,"./_fails-is-regexp":128,"./_string-context":201,"./_to-length":212}],334:[function(require,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

},{"./_string-html":202}],335:[function(require,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
require('./_string-html')('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

},{"./_string-html":202}],336:[function(require,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
require('./_string-html')('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

},{"./_string-html":202}],337:[function(require,module,exports){
var $export = require('./_export');
var toAbsoluteIndex = require('./_to-absolute-index');
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"./_export":127,"./_to-absolute-index":208}],338:[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = require('./_export');
var context = require('./_string-context');
var INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"./_export":127,"./_fails-is-regexp":128,"./_string-context":201}],339:[function(require,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
require('./_string-html')('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

},{"./_string-html":202}],340:[function(require,module,exports){
arguments[4][92][0].apply(exports,arguments)
},{"./_iter-define":150,"./_string-at":200,"dup":92}],341:[function(require,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
require('./_string-html')('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

},{"./_string-html":202}],342:[function(require,module,exports){
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

},{"./_export":127,"./_to-iobject":211,"./_to-length":212}],343:[function(require,module,exports){
var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});

},{"./_export":127,"./_string-repeat":204}],344:[function(require,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

},{"./_string-html":202}],345:[function(require,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

},{"./_export":127,"./_fails-is-regexp":128,"./_string-context":201,"./_to-length":212}],346:[function(require,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
require('./_string-html')('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

},{"./_string-html":202}],347:[function(require,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

},{"./_string-html":202}],348:[function(require,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

},{"./_string-html":202}],349:[function(require,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
require('./_string-trim')('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

},{"./_string-trim":205}],350:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":101,"./_descriptors":123,"./_enum-keys":126,"./_export":127,"./_fails":129,"./_global":135,"./_has":136,"./_hide":137,"./_is-array":144,"./_is-object":146,"./_library":154,"./_meta":160,"./_object-create":165,"./_object-dp":166,"./_object-gopd":169,"./_object-gopn":171,"./_object-gopn-ext":170,"./_object-gops":172,"./_object-keys":175,"./_object-pie":176,"./_property-desc":184,"./_redefine":186,"./_set-to-string-tag":195,"./_shared":197,"./_to-iobject":211,"./_to-object":213,"./_to-primitive":214,"./_uid":218,"./_wks":223,"./_wks-define":221,"./_wks-ext":222}],351:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $typed = require('./_typed');
var buffer = require('./_typed-buffer');
var anObject = require('./_an-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var isObject = require('./_is-object');
var ArrayBuffer = require('./_global').ArrayBuffer;
var speciesConstructor = require('./_species-constructor');
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * require('./_fails')(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

require('./_set-species')(ARRAY_BUFFER);

},{"./_an-object":101,"./_export":127,"./_fails":129,"./_global":135,"./_is-object":146,"./_set-species":194,"./_species-constructor":198,"./_to-absolute-index":208,"./_to-length":212,"./_typed":217,"./_typed-buffer":216}],352:[function(require,module,exports){
var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});

},{"./_export":127,"./_typed":217,"./_typed-buffer":216}],353:[function(require,module,exports){
require('./_typed-array')('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":215}],354:[function(require,module,exports){
require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":215}],355:[function(require,module,exports){
require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":215}],356:[function(require,module,exports){
require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":215}],357:[function(require,module,exports){
require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":215}],358:[function(require,module,exports){
require('./_typed-array')('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":215}],359:[function(require,module,exports){
require('./_typed-array')('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":215}],360:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":215}],361:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"./_typed-array":215}],362:[function(require,module,exports){
'use strict';
var global = require('./_global');
var each = require('./_array-methods')(0);
var redefine = require('./_redefine');
var meta = require('./_meta');
var assign = require('./_object-assign');
var weak = require('./_collection-weak');
var isObject = require('./_is-object');
var validate = require('./_validate-collection');
var NATIVE_WEAK_MAP = require('./_validate-collection');
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

},{"./_array-methods":106,"./_collection":116,"./_collection-weak":115,"./_global":135,"./_is-object":146,"./_meta":160,"./_object-assign":164,"./_redefine":186,"./_validate-collection":220}],363:[function(require,module,exports){
'use strict';
var weak = require('./_collection-weak');
var validate = require('./_validate-collection');
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
require('./_collection')(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

},{"./_collection":116,"./_collection-weak":115,"./_validate-collection":220}],364:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var aFunction = require('./_a-function');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

require('./_add-to-unscopables')('flatMap');

},{"./_a-function":96,"./_add-to-unscopables":98,"./_array-species-create":109,"./_export":127,"./_flatten-into-array":132,"./_to-length":212,"./_to-object":213}],365:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

require('./_add-to-unscopables')('flatten');

},{"./_add-to-unscopables":98,"./_array-species-create":109,"./_export":127,"./_flatten-into-array":132,"./_to-integer":210,"./_to-length":212,"./_to-object":213}],366:[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');

},{"./_add-to-unscopables":98,"./_array-includes":105,"./_export":127}],367:[function(require,module,exports){
// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = require('./_export');
var microtask = require('./_microtask')();
var process = require('./_global').process;
var isNode = require('./_cof')(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

},{"./_cof":112,"./_export":127,"./_global":135,"./_microtask":162}],368:[function(require,module,exports){
// https://github.com/ljharb/proposal-is-error
var $export = require('./_export');
var cof = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

},{"./_cof":112,"./_export":127}],369:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });

},{"./_export":127,"./_global":135}],370:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":191}],371:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":192}],372:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":114,"./_export":127}],373:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

},{"./_export":127}],374:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

},{"./_export":127}],375:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

},{"./_export":127}],376:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var scale = require('./_math-scale');
var fround = require('./_math-fround');

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

},{"./_export":127,"./_math-fround":156,"./_math-scale":158}],377:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

},{"./_export":127}],378:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

},{"./_export":127}],379:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

},{"./_export":127}],380:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

},{"./_export":127}],381:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

},{"./_export":127}],382:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });

},{"./_export":127,"./_math-scale":158}],383:[function(require,module,exports){
// http://jfbastien.github.io/papers/Math.signbit.html
var $export = require('./_export');

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });

},{"./_export":127}],384:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

},{"./_export":127}],385:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":96,"./_descriptors":123,"./_export":127,"./_object-dp":166,"./_object-forced-pam":168,"./_to-object":213}],386:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":96,"./_descriptors":123,"./_export":127,"./_object-dp":166,"./_object-forced-pam":168,"./_to-object":213}],387:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"./_export":127,"./_object-to-array":178}],388:[function(require,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = require('./_export');
var ownKeys = require('./_own-keys');
var toIObject = require('./_to-iobject');
var gOPD = require('./_object-gopd');
var createProperty = require('./_create-property');

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

},{"./_create-property":118,"./_export":127,"./_object-gopd":169,"./_own-keys":179,"./_to-iobject":211}],389:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":123,"./_export":127,"./_object-forced-pam":168,"./_object-gopd":169,"./_object-gpo":173,"./_to-object":213,"./_to-primitive":214}],390:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":123,"./_export":127,"./_object-forced-pam":168,"./_object-gopd":169,"./_object-gpo":173,"./_to-object":213,"./_to-primitive":214}],391:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":127,"./_object-to-array":178}],392:[function(require,module,exports){
'use strict';
// https://github.com/zenparsing/es-observable
var $export = require('./_export');
var global = require('./_global');
var core = require('./_core');
var microtask = require('./_microtask')();
var OBSERVABLE = require('./_wks')('observable');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var anInstance = require('./_an-instance');
var redefineAll = require('./_redefine-all');
var hide = require('./_hide');
var forOf = require('./_for-of');
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

require('./_set-species')('Observable');

},{"./_a-function":96,"./_an-instance":100,"./_an-object":101,"./_core":117,"./_export":127,"./_for-of":133,"./_global":135,"./_hide":137,"./_microtask":162,"./_redefine-all":185,"./_set-species":194,"./_wks":223}],393:[function(require,module,exports){
arguments[4][93][0].apply(exports,arguments)
},{"./_core":117,"./_export":127,"./_global":135,"./_promise-resolve":183,"./_species-constructor":198,"dup":93}],394:[function(require,module,exports){
arguments[4][94][0].apply(exports,arguments)
},{"./_export":127,"./_new-promise-capability":163,"./_perform":182,"dup":94}],395:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });

},{"./_an-object":101,"./_metadata":161}],396:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });

},{"./_an-object":101,"./_metadata":161}],397:[function(require,module,exports){
var Set = require('./es6.set');
var from = require('./_array-from-iterable');
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":101,"./_array-from-iterable":104,"./_metadata":161,"./_object-gpo":173,"./es6.set":327}],398:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":101,"./_metadata":161,"./_object-gpo":173}],399:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":101,"./_metadata":161}],400:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":101,"./_metadata":161}],401:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":101,"./_metadata":161,"./_object-gpo":173}],402:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":101,"./_metadata":161}],403:[function(require,module,exports){
var $metadata = require('./_metadata');
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });

},{"./_a-function":96,"./_an-object":101,"./_metadata":161}],404:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');

},{"./_set-collection-from":191}],405:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');

},{"./_set-collection-of":192}],406:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });

},{"./_collection-to-json":114,"./_export":127}],407:[function(require,module,exports){
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = require('./_export');
var $at = require('./_string-at')(true);
var $fails = require('./_fails');

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

},{"./_export":127,"./_fails":129,"./_string-at":200}],408:[function(require,module,exports){
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export = require('./_export');
var defined = require('./_defined');
var toLength = require('./_to-length');
var isRegExp = require('./_is-regexp');
var getFlags = require('./_flags');
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

require('./_iter-create')($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

},{"./_defined":122,"./_export":127,"./_flags":131,"./_is-regexp":147,"./_iter-create":149,"./_to-length":212}],409:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

},{"./_export":127,"./_string-pad":203,"./_user-agent":219}],410:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

},{"./_export":127,"./_string-pad":203,"./_user-agent":219}],411:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

},{"./_string-trim":205}],412:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

},{"./_string-trim":205}],413:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":221}],414:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":221}],415:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });

},{"./_export":127,"./_global":135}],416:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');

},{"./_set-collection-from":191}],417:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');

},{"./_set-collection-of":192}],418:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');

},{"./_set-collection-from":191}],419:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');

},{"./_set-collection-of":192}],420:[function(require,module,exports){
var $iterators = require('./es6.array.iterator');
var getKeys = require('./_object-keys');
var redefine = require('./_redefine');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var wks = require('./_wks');
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"./_global":135,"./_hide":137,"./_iterators":153,"./_object-keys":175,"./_redefine":186,"./_wks":223,"./es6.array.iterator":236}],421:[function(require,module,exports){
var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

},{"./_export":127,"./_task":207}],422:[function(require,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global = require('./_global');
var $export = require('./_export');
var userAgent = require('./_user-agent');
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

},{"./_export":127,"./_global":135,"./_user-agent":219}],423:[function(require,module,exports){
require('./modules/es6.symbol');
require('./modules/es6.object.create');
require('./modules/es6.object.define-property');
require('./modules/es6.object.define-properties');
require('./modules/es6.object.get-own-property-descriptor');
require('./modules/es6.object.get-prototype-of');
require('./modules/es6.object.keys');
require('./modules/es6.object.get-own-property-names');
require('./modules/es6.object.freeze');
require('./modules/es6.object.seal');
require('./modules/es6.object.prevent-extensions');
require('./modules/es6.object.is-frozen');
require('./modules/es6.object.is-sealed');
require('./modules/es6.object.is-extensible');
require('./modules/es6.object.assign');
require('./modules/es6.object.is');
require('./modules/es6.object.set-prototype-of');
require('./modules/es6.object.to-string');
require('./modules/es6.function.bind');
require('./modules/es6.function.name');
require('./modules/es6.function.has-instance');
require('./modules/es6.parse-int');
require('./modules/es6.parse-float');
require('./modules/es6.number.constructor');
require('./modules/es6.number.to-fixed');
require('./modules/es6.number.to-precision');
require('./modules/es6.number.epsilon');
require('./modules/es6.number.is-finite');
require('./modules/es6.number.is-integer');
require('./modules/es6.number.is-nan');
require('./modules/es6.number.is-safe-integer');
require('./modules/es6.number.max-safe-integer');
require('./modules/es6.number.min-safe-integer');
require('./modules/es6.number.parse-float');
require('./modules/es6.number.parse-int');
require('./modules/es6.math.acosh');
require('./modules/es6.math.asinh');
require('./modules/es6.math.atanh');
require('./modules/es6.math.cbrt');
require('./modules/es6.math.clz32');
require('./modules/es6.math.cosh');
require('./modules/es6.math.expm1');
require('./modules/es6.math.fround');
require('./modules/es6.math.hypot');
require('./modules/es6.math.imul');
require('./modules/es6.math.log10');
require('./modules/es6.math.log1p');
require('./modules/es6.math.log2');
require('./modules/es6.math.sign');
require('./modules/es6.math.sinh');
require('./modules/es6.math.tanh');
require('./modules/es6.math.trunc');
require('./modules/es6.string.from-code-point');
require('./modules/es6.string.raw');
require('./modules/es6.string.trim');
require('./modules/es6.string.iterator');
require('./modules/es6.string.code-point-at');
require('./modules/es6.string.ends-with');
require('./modules/es6.string.includes');
require('./modules/es6.string.repeat');
require('./modules/es6.string.starts-with');
require('./modules/es6.string.anchor');
require('./modules/es6.string.big');
require('./modules/es6.string.blink');
require('./modules/es6.string.bold');
require('./modules/es6.string.fixed');
require('./modules/es6.string.fontcolor');
require('./modules/es6.string.fontsize');
require('./modules/es6.string.italics');
require('./modules/es6.string.link');
require('./modules/es6.string.small');
require('./modules/es6.string.strike');
require('./modules/es6.string.sub');
require('./modules/es6.string.sup');
require('./modules/es6.date.now');
require('./modules/es6.date.to-json');
require('./modules/es6.date.to-iso-string');
require('./modules/es6.date.to-string');
require('./modules/es6.date.to-primitive');
require('./modules/es6.array.is-array');
require('./modules/es6.array.from');
require('./modules/es6.array.of');
require('./modules/es6.array.join');
require('./modules/es6.array.slice');
require('./modules/es6.array.sort');
require('./modules/es6.array.for-each');
require('./modules/es6.array.map');
require('./modules/es6.array.filter');
require('./modules/es6.array.some');
require('./modules/es6.array.every');
require('./modules/es6.array.reduce');
require('./modules/es6.array.reduce-right');
require('./modules/es6.array.index-of');
require('./modules/es6.array.last-index-of');
require('./modules/es6.array.copy-within');
require('./modules/es6.array.fill');
require('./modules/es6.array.find');
require('./modules/es6.array.find-index');
require('./modules/es6.array.species');
require('./modules/es6.array.iterator');
require('./modules/es6.regexp.constructor');
require('./modules/es6.regexp.exec');
require('./modules/es6.regexp.to-string');
require('./modules/es6.regexp.flags');
require('./modules/es6.regexp.match');
require('./modules/es6.regexp.replace');
require('./modules/es6.regexp.search');
require('./modules/es6.regexp.split');
require('./modules/es6.promise');
require('./modules/es6.map');
require('./modules/es6.set');
require('./modules/es6.weak-map');
require('./modules/es6.weak-set');
require('./modules/es6.typed.array-buffer');
require('./modules/es6.typed.data-view');
require('./modules/es6.typed.int8-array');
require('./modules/es6.typed.uint8-array');
require('./modules/es6.typed.uint8-clamped-array');
require('./modules/es6.typed.int16-array');
require('./modules/es6.typed.uint16-array');
require('./modules/es6.typed.int32-array');
require('./modules/es6.typed.uint32-array');
require('./modules/es6.typed.float32-array');
require('./modules/es6.typed.float64-array');
require('./modules/es6.reflect.apply');
require('./modules/es6.reflect.construct');
require('./modules/es6.reflect.define-property');
require('./modules/es6.reflect.delete-property');
require('./modules/es6.reflect.enumerate');
require('./modules/es6.reflect.get');
require('./modules/es6.reflect.get-own-property-descriptor');
require('./modules/es6.reflect.get-prototype-of');
require('./modules/es6.reflect.has');
require('./modules/es6.reflect.is-extensible');
require('./modules/es6.reflect.own-keys');
require('./modules/es6.reflect.prevent-extensions');
require('./modules/es6.reflect.set');
require('./modules/es6.reflect.set-prototype-of');
require('./modules/es7.array.includes');
require('./modules/es7.array.flat-map');
require('./modules/es7.array.flatten');
require('./modules/es7.string.at');
require('./modules/es7.string.pad-start');
require('./modules/es7.string.pad-end');
require('./modules/es7.string.trim-left');
require('./modules/es7.string.trim-right');
require('./modules/es7.string.match-all');
require('./modules/es7.symbol.async-iterator');
require('./modules/es7.symbol.observable');
require('./modules/es7.object.get-own-property-descriptors');
require('./modules/es7.object.values');
require('./modules/es7.object.entries');
require('./modules/es7.object.define-getter');
require('./modules/es7.object.define-setter');
require('./modules/es7.object.lookup-getter');
require('./modules/es7.object.lookup-setter');
require('./modules/es7.map.to-json');
require('./modules/es7.set.to-json');
require('./modules/es7.map.of');
require('./modules/es7.set.of');
require('./modules/es7.weak-map.of');
require('./modules/es7.weak-set.of');
require('./modules/es7.map.from');
require('./modules/es7.set.from');
require('./modules/es7.weak-map.from');
require('./modules/es7.weak-set.from');
require('./modules/es7.global');
require('./modules/es7.system.global');
require('./modules/es7.error.is-error');
require('./modules/es7.math.clamp');
require('./modules/es7.math.deg-per-rad');
require('./modules/es7.math.degrees');
require('./modules/es7.math.fscale');
require('./modules/es7.math.iaddh');
require('./modules/es7.math.isubh');
require('./modules/es7.math.imulh');
require('./modules/es7.math.rad-per-deg');
require('./modules/es7.math.radians');
require('./modules/es7.math.scale');
require('./modules/es7.math.umulh');
require('./modules/es7.math.signbit');
require('./modules/es7.promise.finally');
require('./modules/es7.promise.try');
require('./modules/es7.reflect.define-metadata');
require('./modules/es7.reflect.delete-metadata');
require('./modules/es7.reflect.get-metadata');
require('./modules/es7.reflect.get-metadata-keys');
require('./modules/es7.reflect.get-own-metadata');
require('./modules/es7.reflect.get-own-metadata-keys');
require('./modules/es7.reflect.has-metadata');
require('./modules/es7.reflect.has-own-metadata');
require('./modules/es7.reflect.metadata');
require('./modules/es7.asap');
require('./modules/es7.observable');
require('./modules/web.timers');
require('./modules/web.immediate');
require('./modules/web.dom.iterable');
module.exports = require('./modules/_core');

},{"./modules/_core":117,"./modules/es6.array.copy-within":226,"./modules/es6.array.every":227,"./modules/es6.array.fill":228,"./modules/es6.array.filter":229,"./modules/es6.array.find":231,"./modules/es6.array.find-index":230,"./modules/es6.array.for-each":232,"./modules/es6.array.from":233,"./modules/es6.array.index-of":234,"./modules/es6.array.is-array":235,"./modules/es6.array.iterator":236,"./modules/es6.array.join":237,"./modules/es6.array.last-index-of":238,"./modules/es6.array.map":239,"./modules/es6.array.of":240,"./modules/es6.array.reduce":242,"./modules/es6.array.reduce-right":241,"./modules/es6.array.slice":243,"./modules/es6.array.some":244,"./modules/es6.array.sort":245,"./modules/es6.array.species":246,"./modules/es6.date.now":247,"./modules/es6.date.to-iso-string":248,"./modules/es6.date.to-json":249,"./modules/es6.date.to-primitive":250,"./modules/es6.date.to-string":251,"./modules/es6.function.bind":252,"./modules/es6.function.has-instance":253,"./modules/es6.function.name":254,"./modules/es6.map":255,"./modules/es6.math.acosh":256,"./modules/es6.math.asinh":257,"./modules/es6.math.atanh":258,"./modules/es6.math.cbrt":259,"./modules/es6.math.clz32":260,"./modules/es6.math.cosh":261,"./modules/es6.math.expm1":262,"./modules/es6.math.fround":263,"./modules/es6.math.hypot":264,"./modules/es6.math.imul":265,"./modules/es6.math.log10":266,"./modules/es6.math.log1p":267,"./modules/es6.math.log2":268,"./modules/es6.math.sign":269,"./modules/es6.math.sinh":270,"./modules/es6.math.tanh":271,"./modules/es6.math.trunc":272,"./modules/es6.number.constructor":273,"./modules/es6.number.epsilon":274,"./modules/es6.number.is-finite":275,"./modules/es6.number.is-integer":276,"./modules/es6.number.is-nan":277,"./modules/es6.number.is-safe-integer":278,"./modules/es6.number.max-safe-integer":279,"./modules/es6.number.min-safe-integer":280,"./modules/es6.number.parse-float":281,"./modules/es6.number.parse-int":282,"./modules/es6.number.to-fixed":283,"./modules/es6.number.to-precision":284,"./modules/es6.object.assign":285,"./modules/es6.object.create":286,"./modules/es6.object.define-properties":287,"./modules/es6.object.define-property":288,"./modules/es6.object.freeze":289,"./modules/es6.object.get-own-property-descriptor":290,"./modules/es6.object.get-own-property-names":291,"./modules/es6.object.get-prototype-of":292,"./modules/es6.object.is":296,"./modules/es6.object.is-extensible":293,"./modules/es6.object.is-frozen":294,"./modules/es6.object.is-sealed":295,"./modules/es6.object.keys":297,"./modules/es6.object.prevent-extensions":298,"./modules/es6.object.seal":299,"./modules/es6.object.set-prototype-of":300,"./modules/es6.object.to-string":301,"./modules/es6.parse-float":302,"./modules/es6.parse-int":303,"./modules/es6.promise":304,"./modules/es6.reflect.apply":305,"./modules/es6.reflect.construct":306,"./modules/es6.reflect.define-property":307,"./modules/es6.reflect.delete-property":308,"./modules/es6.reflect.enumerate":309,"./modules/es6.reflect.get":312,"./modules/es6.reflect.get-own-property-descriptor":310,"./modules/es6.reflect.get-prototype-of":311,"./modules/es6.reflect.has":313,"./modules/es6.reflect.is-extensible":314,"./modules/es6.reflect.own-keys":315,"./modules/es6.reflect.prevent-extensions":316,"./modules/es6.reflect.set":318,"./modules/es6.reflect.set-prototype-of":317,"./modules/es6.regexp.constructor":319,"./modules/es6.regexp.exec":320,"./modules/es6.regexp.flags":321,"./modules/es6.regexp.match":322,"./modules/es6.regexp.replace":323,"./modules/es6.regexp.search":324,"./modules/es6.regexp.split":325,"./modules/es6.regexp.to-string":326,"./modules/es6.set":327,"./modules/es6.string.anchor":328,"./modules/es6.string.big":329,"./modules/es6.string.blink":330,"./modules/es6.string.bold":331,"./modules/es6.string.code-point-at":332,"./modules/es6.string.ends-with":333,"./modules/es6.string.fixed":334,"./modules/es6.string.fontcolor":335,"./modules/es6.string.fontsize":336,"./modules/es6.string.from-code-point":337,"./modules/es6.string.includes":338,"./modules/es6.string.italics":339,"./modules/es6.string.iterator":340,"./modules/es6.string.link":341,"./modules/es6.string.raw":342,"./modules/es6.string.repeat":343,"./modules/es6.string.small":344,"./modules/es6.string.starts-with":345,"./modules/es6.string.strike":346,"./modules/es6.string.sub":347,"./modules/es6.string.sup":348,"./modules/es6.string.trim":349,"./modules/es6.symbol":350,"./modules/es6.typed.array-buffer":351,"./modules/es6.typed.data-view":352,"./modules/es6.typed.float32-array":353,"./modules/es6.typed.float64-array":354,"./modules/es6.typed.int16-array":355,"./modules/es6.typed.int32-array":356,"./modules/es6.typed.int8-array":357,"./modules/es6.typed.uint16-array":358,"./modules/es6.typed.uint32-array":359,"./modules/es6.typed.uint8-array":360,"./modules/es6.typed.uint8-clamped-array":361,"./modules/es6.weak-map":362,"./modules/es6.weak-set":363,"./modules/es7.array.flat-map":364,"./modules/es7.array.flatten":365,"./modules/es7.array.includes":366,"./modules/es7.asap":367,"./modules/es7.error.is-error":368,"./modules/es7.global":369,"./modules/es7.map.from":370,"./modules/es7.map.of":371,"./modules/es7.map.to-json":372,"./modules/es7.math.clamp":373,"./modules/es7.math.deg-per-rad":374,"./modules/es7.math.degrees":375,"./modules/es7.math.fscale":376,"./modules/es7.math.iaddh":377,"./modules/es7.math.imulh":378,"./modules/es7.math.isubh":379,"./modules/es7.math.rad-per-deg":380,"./modules/es7.math.radians":381,"./modules/es7.math.scale":382,"./modules/es7.math.signbit":383,"./modules/es7.math.umulh":384,"./modules/es7.object.define-getter":385,"./modules/es7.object.define-setter":386,"./modules/es7.object.entries":387,"./modules/es7.object.get-own-property-descriptors":388,"./modules/es7.object.lookup-getter":389,"./modules/es7.object.lookup-setter":390,"./modules/es7.object.values":391,"./modules/es7.observable":392,"./modules/es7.promise.finally":393,"./modules/es7.promise.try":394,"./modules/es7.reflect.define-metadata":395,"./modules/es7.reflect.delete-metadata":396,"./modules/es7.reflect.get-metadata":398,"./modules/es7.reflect.get-metadata-keys":397,"./modules/es7.reflect.get-own-metadata":400,"./modules/es7.reflect.get-own-metadata-keys":399,"./modules/es7.reflect.has-metadata":401,"./modules/es7.reflect.has-own-metadata":402,"./modules/es7.reflect.metadata":403,"./modules/es7.set.from":404,"./modules/es7.set.of":405,"./modules/es7.set.to-json":406,"./modules/es7.string.at":407,"./modules/es7.string.match-all":408,"./modules/es7.string.pad-end":409,"./modules/es7.string.pad-start":410,"./modules/es7.string.trim-left":411,"./modules/es7.string.trim-right":412,"./modules/es7.symbol.async-iterator":413,"./modules/es7.symbol.observable":414,"./modules/es7.system.global":415,"./modules/es7.weak-map.from":416,"./modules/es7.weak-map.of":417,"./modules/es7.weak-set.from":418,"./modules/es7.weak-set.of":419,"./modules/web.dom.iterable":420,"./modules/web.immediate":421,"./modules/web.timers":422}],424:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require("./runtime");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

},{"./runtime":425}],425:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);

},{}],426:[function(require,module,exports){
var get = require('./underscore-get');

module.exports = {
    get: get
}
},{"./underscore-get":427}],427:[function(require,module,exports){
module.exports = function get(obj, desc, value) {
  var arr = desc ? desc.split(".") : [];

  while (arr.length && obj) {
    var comp = arr.shift();
    var match = new RegExp("(.+)\\[([0-9]*)\\]").exec(comp);

    // handle arrays
    if ((match !== null) && (match.length == 3)) {
      var arrayData = {
        arrName: match[1],
        arrIndex: match[2]
      };
      if (obj[arrayData.arrName] !== undefined) {
        obj = obj[arrayData.arrName][arrayData.arrIndex];
      } else {
        obj = undefined;
      }

      continue;
    }

    obj = obj[comp];
  }

  if (typeof value !== 'undefined') {
    if (obj === undefined) {
      return value;
    }
  }

  return obj;
}
},{}],428:[function(require,module,exports){
"use strict";

angular.module('app').constant('ROUTES', function () {
    return {
        SEARCH: '/search',
        PASSENGERS: '/passengers',
        BOOKING_SERVICES: '/booking-services',
        SEAT_SELECT: '/seat-select',
        CONFIRM_ORDER: '/confirm-order',
        PRIVATE_PROFILE: '/private/profile',
        PRIVATE_PASSWORD: '/private/password',
        PRIVATE_PASSENGERS: '/private/passengers',
        PRIVATE_ORDERS: '/private/orders',
        PRIVATE_ORDER: '/private/order/:pnrOrTicketNumber/:lastName',
        PRIVATE_BANK_DETAILS: '/private/bank-details',
        PRIVATE_PAYMENTS: '/private/payments',
        RESET_FORGET_PASSWORD: '/reset-forget-password',
        ACTIVATE_ACCOUNT: '/activate-account',
        EXCHANGE: '/exchange',
        REFUND: '/refund',
        SCHEDULE: '/schedule',
        SEARCH_ORDER: '/search-order',
        SEARCH_ORDER_WITH_PARAMS: '/search-order/:pnrOrTicketNumber/:lastName',
        ADD_SERVICES: '/add-services',
        PRIVACY_POLICY: '/privacy-policy',
        UNSUBSCRIBE_EMAIL: '/unsubscribe-email',
        UNSUBSCRIBE_PHONE: '/unsubscribe-phone',
        PAYMENT_VARIANTS: '/payment-variants',
        CONFIRM_BOOKING: '/confirm-booking',
        REMOVE_PROFILE_CONFIRM: '/remove-profile-confirm'
    };
}());

angular.module('app').config(['$routeProvider', 'ROUTES', function ($routeProvider, ROUTES) {

    if (o2context.bookingEnabled) {

        $routeProvider.when(ROUTES.SEARCH, {
            templateUrl: 'screens/search/search.html',
            controller: 'SearchScreenController',
            controllerAs: 'vm',
            isBookingStep: true
        }).when(ROUTES.PASSENGERS, {
            templateUrl: 'screens/passengers/passengers.html',
            controller: 'PassengersScreenController',
            controllerAs: 'vm',
            isBookingStep: true
        }).when(ROUTES.BOOKING_SERVICES, {
            templateUrl: 'screens/booking-services/booking-services.html',
            controller: 'BookingServicesScreenController',
            controllerAs: 'vm',
            isBookingStep: true
        }).when(ROUTES.PRIVATE_PROFILE, {
            templateUrl: 'screens/private-profile/private-profile.html',
            controller: 'PrivateProfileScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.PRIVATE_PASSWORD, {
            templateUrl: 'screens/private-password/private-password.html',
            controller: 'PrivatePasswordScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.PRIVATE_PAYMENTS, {
            templateUrl: 'screens/private-payments/private-payments.html',
            controller: 'PrivatePaymentsScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.PRIVATE_PASSENGERS, {
            templateUrl: 'screens/private-passengers/private-passengers.html',
            controller: 'PrivatePassengersScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.PRIVATE_ORDERS, {
            templateUrl: 'screens/private-orders/private-orders.html',
            controller: 'PrivateOrdersScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.PRIVATE_ORDER, {
            templateUrl: 'screens/private-order/private-order.html',
            controller: 'PrivateOrderScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.PRIVATE_BANK_DETAILS, {
            templateUrl: 'screens/private-bank-details/private-bank-details.html',
            controller: 'PrivateBankDetailsScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.RESET_FORGET_PASSWORD, {
            templateUrl: 'screens/reset-forget-password/reset-forget-password.html',
            controller: 'ResetForgetPasswordScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.ACTIVATE_ACCOUNT, {
            templateUrl: 'screens/activate-account/activate-account.html',
            controller: 'ActivateAccountScreenController',
            controllerAs: 'vm'
        }).when(ROUTES.SCHEDULE, {
            templateUrl: 'screens/schedule/schedule.html',
            controller: 'ScheduleScreenController',
            controllerAs: 'vm'
        });
    }

    $routeProvider.when(ROUTES.SEARCH_ORDER, {
        templateUrl: 'screens/search-order/search-order.html',
        controller: 'SearchOrderScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.SEARCH_ORDER_WITH_PARAMS, {
        templateUrl: 'screens/search-order/search-order.html',
        controller: 'SearchOrderScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.EXCHANGE, {
        templateUrl: 'screens/exchange/exchange.html',
        controller: 'ExchangeScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.REFUND, {
        templateUrl: 'screens/refund/refund.html',
        controller: 'RefundScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.CONFIRM_ORDER, {
        templateUrl: 'screens/confirm-order/confirm-order.html',
        controller: 'ConfirmOrderScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.ADD_SERVICES, {
        templateUrl: 'screens/add-services/add-services.html',
        controller: 'AddServicesScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.PRIVACY_POLICY, {
        templateUrl: 'screens/privacy-policy/privacy-policy.html',
        controller: 'PrivacyPolicyScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.UNSUBSCRIBE_EMAIL, {
        templateUrl: 'screens/unsubscribe-email/unsubscribe-email.html',
        controller: 'UnsubscribeEmailScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.UNSUBSCRIBE_PHONE, {
        templateUrl: 'screens/unsubscribe-phone/unsubscribe-phone.html',
        controller: 'UnsubscribePhoneScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.PAYMENT_VARIANTS, {
        templateUrl: 'screens/payment-variants/payment-variants.html',
        controller: 'PaymentVariantsScreenController',
        controllerAs: 'vm',
        isBookingStep: true
    }).when(ROUTES.CONFIRM_BOOKING, {
        templateUrl: 'screens/confirm-booking/confirm-booking.html',
        controller: 'ConfirmBookingScreenController',
        controllerAs: 'vm',
        isBookingStep: true
    }).when(ROUTES.REMOVE_PROFILE_CONFIRM, {
        templateUrl: 'screens/remove-profile-confirm/remove-profile-confirm.html',
        controller: 'RemoveProfileConfirmScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.SEAT_SELECT, {
        templateUrl: 'screens/seat-select/seat-select.html',
        controller: 'SeatSelectScreenController',
        controllerAs: 'vm',
        isBookingStep: true
    }).otherwise({
        redirectTo: o2context.bookingEnabled ? ROUTES.SEARCH : ROUTES.SEARCH_ORDER
    });
}]);

},{}],429:[function(require,module,exports){
"use strict";

angular.module('app').constant('DOC_CODE', {
    RussianForeignPassport: 'PSP',
    RussianInternalPassport: 'ПС',
    NationalPassport: 'NP',
    RussianBirthCertificate: 'SR'
});

},{}],430:[function(require,module,exports){
"use strict";

require('babel-polyfill');

angular.module('app', ['ngRoute', 'ngSanitize', 'moment-picker', 'ui.mask', 'ox', 'ui.select', 'ngTouch', 'duScroll', 'ngCookies', 'webskyUtils']);

require('./app.constants');
require('./services');
require('./filters');
require('./datepicker.conf');

require('./ROUTES');

require('./components');
require('./modals');
require('./screens');

angular.module('app').config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
}]);

angular.module('app').run(['appInit', function (appInit) {
    appInit();
}]);

},{"./ROUTES":428,"./app.constants":429,"./components":484,"./datepicker.conf":535,"./filters":539,"./modals":541,"./screens":601,"./services":626,"babel-polyfill":1}],431:[function(require,module,exports){
"use strict";

angular.module('app').component('airlineLogo', {
    templateUrl: 'components/airline-logo/airline-logo.html',
    controller: ['backend', AirlineLogoController],
    controllerAs: 'vm',
    bindings: {
        code: '<'
    }
});

function AirlineLogoController(backend) {
    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');
    var airlineCode = vm.code;

    vm.loading = true;

    vm.handleLoad = handleLoad;

    if (externalStorageUrl) {
        vm.logoImagePath = externalStorageUrl + '/img/content/airline-logo/' + airlineCode + '.svg';
    } else {
        vm.logoImagePath = './themes/websky/assets/static/img/content/airline-logo/' + airlineCode + '.svg';
    }

    function handleLoad(success) {
        vm.loading = false;
        vm.success = success;
    }
}

},{}],432:[function(require,module,exports){
"use strict";

angular.module('app').component('appBanner', {
    templateUrl: 'components/app-banner/app-banner.html',
    controller: ['$sce', 'backend', AppBannerController],
    controllerAs: 'vm',
    bindings: {
        code: '@'
    }
});

function AppBannerController($sce, backend) {

    var vm = this;
    var bannerConfig = backend.getBannerByCode(vm.code);
    if (bannerConfig.htmlContent) {
        vm.bannerHtmlContent = $sce.trustAsHtml(bannerConfig.htmlContent);
    } else if (bannerConfig.title && bannerConfig.imagePathDesktop && bannerConfig.imagePathMobile) {
        vm.title = bannerConfig.title;
        vm.imagePathDesktop = bannerConfig.imagePathDesktop;
        vm.imagePathMobile = bannerConfig.imagePathMobile;
        if (bannerConfig.url) vm.url = bannerConfig.url;
    }
}

},{}],433:[function(require,module,exports){
"use strict";

angular.module('app').component('appFooter', {
    templateUrl: 'components/app-footer/app-footer.html',
    controller: ['$sce', 'backend', AppFooterController],
    controllerAs: 'vm'
});

function AppFooterController($sce, backend) {

    var vm = this;
    vm.loading = true;

    backend.ready.then(function () {
        vm.loading = false;
        vm.footerAliasHtml = o2context.oxyNoCover ? '' : $sce.trustAsHtml(backend.getAlias('web.footer'));
    });
}

},{}],434:[function(require,module,exports){
"use strict";

angular.module('app').component('appHeaderCurrency', {
    templateUrl: 'components/app-header-currency/app-header-currency.html',
    controller: ['utils', '$timeout', '$window', '$element', AppHeaderCurrencyController],
    controllerAs: 'vm',
    bindings: {
        'currentCurrency': '<',
        'availableCurrencies': '<',
        'onSelect': '&'
    }
});

function AppHeaderCurrencyController(utils, $timeout, $window, $element) {

    var vm = this;
    vm.getUnicodeCurrencySign = utils.getUnicodeCurrencySign;
    vm.switchDrop = switchDrop;

    function switchDrop() {
        vm.showDrop = !vm.showDrop;
        $timeout(function () {
            if (vm.showDrop) {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            }
        });
    }

    function checkOutsideClick(event) {
        if (vm.showDrop && !isChildNode(event.target)) {
            switchDrop();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }
}

},{}],435:[function(require,module,exports){
"use strict";

angular.module('app').component('appHeaderLanguage', {
    templateUrl: 'components/app-header-language/app-header-language.html',
    controller: ['$timeout', '$window', '$element', AppHeaderLanguageController],
    controllerAs: 'vm',
    bindings: {
        'currentLanguage': '<',
        'availableLanguages': '<',
        'onSelect': '&'
    }
});

function AppHeaderLanguageController($timeout, $window, $element) {

    var vm = this;
    vm.switchDrop = switchDrop;

    function switchDrop() {
        vm.showDrop = !vm.showDrop;
        $timeout(function () {
            if (vm.showDrop) {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            }
        });
    }

    function checkOutsideClick(event) {
        if (vm.showDrop && !isChildNode(event.target)) {
            switchDrop();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }
}

},{}],436:[function(require,module,exports){
"use strict";

angular.module('app').component('appHeaderPrivate', {
    templateUrl: 'components/app-header-private/app-header-private.html',
    controller: ['$timeout', '$window', '$element', 'modalTools', AppHeaderPrivateController],
    controllerAs: 'vm',
    bindings: {
        'authoriseCustomer': '<',
        'availablePrivateNavItems': '<items',
        'onSelect': '&'
    }
});

function AppHeaderPrivateController($timeout, $window, $element, modalTools) {

    var vm = this;

    vm.switchDrop = switchDrop;

    function switchDrop() {
        if (!vm.authoriseCustomer) {
            modalTools.openHandler('popup-login');
        } else {
            vm.showDrop = !vm.showDrop;
            $timeout(function () {
                if (vm.showDrop) {
                    $window.document.documentElement.addEventListener('click', checkOutsideClick);
                } else {
                    $window.document.documentElement.removeEventListener('click', checkOutsideClick);
                }
            });
        }
    }

    function checkOutsideClick(event) {
        if (vm.showDrop && !isChildNode(event.target)) {
            switchDrop();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }
}

},{}],437:[function(require,module,exports){
"use strict";

angular.module('app').component('appHeader', {
    templateUrl: 'components/app-header/app-header.html',
    controller: ['$window', '$location', '$sce', '$timeout', 'backend', 'utils', 'redirect', 'modalTools', AppHeaderController],
    controllerAs: 'vm'
});

function AppHeaderController($window, $location, $sce, $timeout, backend, utils, redirect, modalTools) {

    var vm = this;
    var path = $location.path();

    vm.currencyChangeHandler = currencyChangeHandler;
    vm.languageChangeHandler = languageChangeHandler;
    vm.getUnicodeCurrencySign = utils.getUnicodeCurrencySign;
    vm.privateItemClickHandler = privateItemClickHandler;
    vm.privateHeaderClickHandler = privateHeaderClickHandler;

    vm.isPrivateScreen = path.indexOf('private') !== -1;
    vm.isBookingStep = redirect.isBookingStep();
    vm.activeSection = vm.isPrivateScreen ? 0 : 1;

    backend.ready.then(function () {
        var langs = backend.getParam('site.langs');

        vm.headerAliasHtml = o2context.oxyNoCover ? '' : $sce.trustAsHtml(backend.getAlias('web.header'));

        vm.loading = false;
        vm.availableLanguages = langs.split(',').map(function (lang) {
            var code = lang.trim();
            return {
                code: code,
                title: backend.getAliasWithPrefix('web.langNameShort.', code)
            };
        });
        vm.currentLanguage = backend.sessionParams.lang;
        vm.currentCurrency = backend.sessionParams.currency;
        vm.availableCurrencies = backend.sessionParams.availableCurrencies;
    });

    backend.addOrderInfoListener(function (orderInfo) {
        vm.orderInfo = orderInfo;
    }, false, true);

    backend.addAuthoriseCustomerListener(function (authoriseCustomer) {
        vm.authoriseCustomer = authoriseCustomer;
        vm.availablePrivateNavItems = generateAvailablePrivateNavItems(vm.authoriseCustomer, vm.isPrivateScreen);
    });

    function privateItemClickHandler(code) {
        if (code === 'returnToBooking') {
            redirect.goToLastBookingStep();
        } else if (code === 'privateOrders') {
            redirect.goToPrivateOrders();
        } else if (code === 'privatePassengers') {
            redirect.goToPrivatePassengers();
        } else if (code === 'privateProfile') {
            redirect.goToPrivateProfile();
        } else if (code === 'privatePassword') {
            redirect.goToPrivatePassword();
        } else if (code === 'privatePayments') {
            redirect.goToPrivatePayments();
        } else if (code === 'gotoAdminPanel') {
            $window.location = './admin';
        } else if (code === 'gotoAdminPanelRequests') {
            $window.location = './admin-panel/#/requests';
        } else if (code === 'logout') {
            logoutHandler();
        }
    }

    function privateHeaderClickHandler() {
        vm.activeSection = 0;
        if (!vm.authoriseCustomer) {
            modalTools.openHandler('popup-login');
        }
    }

    function logoutHandler() {
        backend.logout().then(function () {
            if (vm.isPrivateScreen) {
                redirect.goToStart();
                return;
            }
        });
    }

    function currencyChangeHandler(newCurrency) {
        if (vm.currentCurrency !== newCurrency) {
            vm.currentCurrency = newCurrency;
            changeCurrency();
        }
    }

    function languageChangeHandler(newLanguage) {
        if (vm.currentLanguage !== newLanguage) {
            vm.currentLanguage = newLanguage;
            changeLanguage();
        }
    }

    function changeCurrency() {
        vm.loading = true;
        backend.switchCurrency(vm.currentCurrency).then(function () {
            reloadPage(vm.currentLanguage);
        }, function (resp) {
            vm.loading = false;
            vm.currentLanguage = backend.sessionParams.lang;
            vm.currentCurrency = backend.sessionParams.currency;
            vm.errorMessage = resp.error;
            $timeout(function () {
                vm.errorMessage = false;
            }, 20000);
        });
    }

    function changeLanguage() {
        vm.loading = true;
        backend.switchLanguage(vm.currentLanguage).then(function () {
            reloadPage(vm.currentLanguage);
        }, function (resp) {
            vm.loading = false;
            vm.currentLanguage = backend.sessionParams.lang;
            vm.currentCurrency = backend.sessionParams.currency;
            vm.errorMessage = resp.error;
            $timeout(function () {
                vm.errorMessage = false;
            }, 20000);
        });
    }

    function reloadPage(newLang) {
        var getParamLang = utils.getParamFromLocation('lang');
        if (getParamLang && getParamLang !== newLang) {
            $window.location.search = '?lang=' + newLang;
        } else {
            $window.location.reload();
        }
    }

    function generateAvailablePrivateNavItems(authoriseCustomer, isPrivateScreen) {
        var list = [];
        if (authoriseCustomer) {
            if (isPrivateScreen) {
                list.push({
                    code: 'returnToBooking',
                    title: backend.getAlias('web.buttons.returnToBooking')
                });
            }
            list.push({
                code: 'privateOrders',
                title: backend.getAlias('web.steps.privateOrders')
            });
            list.push({
                code: 'privatePassengers',
                title: backend.getAlias('web.steps.privatePassengers')
            });
            list.push({
                code: 'privateProfile',
                title: backend.getAlias('web.steps.privateProfile')
            });
            list.push({
                code: 'privatePassword',
                title: backend.getAlias('web.steps.privatePassword')
            });
            if (authoriseCustomer.role === 'sysAdmin' || authoriseCustomer.role === 'siteAdmin' || authoriseCustomer.role === 'siteOper') {
                list.push({
                    code: 'gotoAdminPanel',
                    title: backend.getAlias('web.buttons.gotoAdminPanel')
                });
            }
            if (authoriseCustomer.role === 'scanOper') {
                list.push({
                    code: 'gotoAdminPanelRequests',
                    title: backend.getAlias('web.buttons.gotoAdminPanelRequests')
                });
            }

            list.push({
                code: 'logout',
                title: backend.getAlias('web.buttons.logout')
            });
        }

        return list;
    }
}

},{}],438:[function(require,module,exports){
"use strict";

angular.module('app').component('appLoader', {
    templateUrl: 'components/app-loader/app-loader.html'
});

},{}],439:[function(require,module,exports){
"use strict";

angular.module('app').component('appModals', {
    templateUrl: 'components/app-modals/app-modals.html',
    controller: ['modalTools', '$scope', 'backend', AppModalsController],
    controllerAs: 'vm'
});

function AppModalsController(modalTools, $scope, backend) {

    var vm = this;

    vm.activeModal = false;

    backend.ready.then(function () {
        if (o2context.showLoginPopup && !backend.sessionParams.authoriseCustomer) {
            modalTools.openHandler('popup-login');
        }
    });

    modalTools.setGlobalListener(function (modalCode) {
        vm.activeModal = modalCode;
        $scope.safeApply();
    });

    $scope.safeApply = function (fn) {
        var phase = this.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && typeof fn === 'function') {
                fn();
            }
        } else {
            this.$apply(fn);
        }
    };
}

},{}],440:[function(require,module,exports){
"use strict";

angular.module('app').component('bookingStepsSelect', {
    templateUrl: 'components/booking-steps-select/booking-steps-select.html',
    controller: ['$location', '$rootScope', 'ROUTES', 'backend', BookingStepsSelectController],
    controllerAs: 'vm'
});

function BookingStepsSelectController($location, $rootScope, ROUTES, backend) {

    var vm = this;

    vm.stepsList = generateSteps();
    vm.handleClick = handleClick;

    $rootScope.$watch('selectVariantStepActive', function (selectVariantStepActive) {
        if (selectVariantStepActive && $location.path() === ROUTES.SEARCH) {
            vm.stepsList[0].active = false;
            vm.stepsList[1].disabled = false;
            vm.stepsList[1].active = true;
        }
    });

    function generateSteps() {
        var steps = [{
            code: 'SEARCH',
            alternativeUrl: ROUTES.SEARCH,
            url: backend.getAlias('web.site.firstStepUrl'),
            title: backend.getAlias('web.steps.search')
        }, {
            code: 'VARIANT_SELECT',
            url: ROUTES.SEARCH,
            title: backend.getAlias('web.steps.selectVariant')
        }, {
            code: 'PASSENGERS',
            url: ROUTES.PASSENGERS,
            title: backend.getAlias('web.steps.passengers')
        }, {
            code: 'BOOKING_SERVICES',
            url: ROUTES.BOOKING_SERVICES,
            alternativeUrl: ROUTES.SEAT_SELECT,
            title: backend.getAlias('web.steps.extraServices')
        }, {
            code: 'CONFIRM_BOOKING',
            url: ROUTES.CONFIRM_BOOKING,
            title: backend.getAlias('web.steps.confirmBooking')
        }, {
            code: 'PAYMENT_VARIANTS',
            url: ROUTES.PAYMENT_VARIANTS,
            title: backend.getAlias('web.steps.payment')
        }, {
            code: 'CONFIRM_ORDER',
            url: ROUTES.CONFIRM_ORDER,
            title: backend.getAlias('web.steps.order')
        }];
        var currentFlag = false;
        steps.forEach(function (step) {
            if (currentFlag) {
                step.disabled = true;
            }
            if ($location.path() === step.url || $location.path() === step.alternativeUrl) {
                currentFlag = true;
                step.active = true;
            }
        });
        return steps;
    }

    function handleClick(step) {
        if (!step.active && !step.disabled) {
            $location.path(step.url);
        }
    }
}

},{}],441:[function(require,module,exports){
"use strict";

angular.module('app').component('brandProp', {
    templateUrl: 'components/brand-prop/brand-prop.html',
    controllerAs: 'vm',
    bindings: {
        propValue: '=value',
        currency: '=currency'
    }
});

},{}],442:[function(require,module,exports){
"use strict";

angular.module('app').component('brandPropsInfo', {
    templateUrl: 'components/brand-props-info/brand-props-info.html',
    controllerAs: 'vm',
    bindings: {
        brandName: '=',
        brandAvailableProps: '=',
        brandPaidProps: '=',
        brandUnavailableProps: '='
    }
});

},{}],443:[function(require,module,exports){
"use strict";

angular.module('app').component('captcha', {
    templateUrl: 'components/captcha/captcha.html',
    controller: [CaptchaController],
    controllerAs: 'vm',
    bindings: {
        autoInit: '='
    }
});

function CaptchaController() {

    var vm = this;
    vm.reload = reload;

    if (vm.autoInit) {
        vm.reload();
    }

    function reload() {
        vm.timestamp = new Date().getTime();
    }
}

},{}],444:[function(require,module,exports){
"use strict";

angular.module('app').component('cartWidget', {
    templateUrl: 'components/cart-widget/cart-widget.html',
    controller: ['$scope', 'backend', '$timeout', '$window', '$element', CartWidgetController],
    controllerAs: 'vm',
    bindings: {
        'orderInfo': '<order'
    }
});

function CartWidgetController($scope, backend, $timeout, $window, $element) {

    var vm = this;

    vm.removeSelectedExtraServicesByFlight = removeSelectedExtraServicesByFlight;
    vm.removeEditableExtraServicesByPassenger = removeEditableExtraServicesByPassenger;
    vm.removeEditableExtraServicesForAllPassengers = removeEditableExtraServicesForAllPassengers;
    vm.removeEditableAeroexpress = removeEditableAeroexpress;
    vm.switchDrop = switchDrop;

    vm.showFlightDetail = -1;

    $scope.$watch('vm.orderInfo', function () {
        vm.selectedExtraServicesByFlights = generateSelectedExtraServicesByFlights(vm.orderInfo.plainFlights, vm.orderInfo.editableExtraServicesHeap);
        vm.selectedExtraServicesByPassengers = generateSelectedExtraServicesByPassengers(vm.orderInfo.passengers, vm.orderInfo.editableExtraServicesHeap);

        var selectedAeroexpressByFares = {};
        if (vm.orderInfo.editableExtraServicesHeap) {
            var orderAeItems = vm.orderInfo.editableExtraServicesHeap.filter(function (item) {
                return item.groupCode === 'aeroexpress';
            });
            if (orderAeItems.length) {
                orderAeItems.forEach(function (item) {
                    if (!selectedAeroexpressByFares[item.fare.fare_type]) {
                        selectedAeroexpressByFares[item.fare.fare_type] = {
                            count: 1,
                            totalPrice: item.fare.cost,
                            currency: item.fare.currency
                        };
                    } else {
                        selectedAeroexpressByFares[item.fare.fare_type].count += 1;
                        selectedAeroexpressByFares[item.fare.fare_type].totalPrice = Big(selectedAeroexpressByFares[item.fare.fare_type].totalPrice).plus(item.fare.cost).toFixed(2);
                    }
                });
                vm.selectedAeroexpress = _.keys(selectedAeroexpressByFares).map(function (fareType) {
                    return {
                        fareType: fareType,
                        count: selectedAeroexpressByFares[fareType].count,
                        totalPrice: selectedAeroexpressByFares[fareType].totalPrice,
                        currency: selectedAeroexpressByFares[fareType].currency
                    };
                });
            }
        }
    });

    function switchDrop() {
        vm.showDrop = !vm.showDrop;
        $timeout(function () {
            if (vm.showDrop) {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            }
        });
    }

    function checkOutsideClick(event) {
        if (vm.showDrop && !isChildNode(event.target)) {
            switchDrop();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }

    function generateSelectedExtraServicesByFlights(flights, editableExtraServicesHeap) {
        return flights.map(function (flight) {
            var groupedFlightServices = [];
            (editableExtraServicesHeap || []).forEach(function (serviceItem) {
                if (serviceItem.segmentId === flight.id) {
                    var groupedFlightService = _.findWhere(groupedFlightServices, { groupCode: serviceItem.groupCode });
                    if (groupedFlightService) {
                        groupedFlightService.count = groupedFlightService.count + (serviceItem.amount || 1);
                        groupedFlightService.totalPrice = Big(groupedFlightService.totalPrice).plus(serviceItem.totalPrice || serviceItem.price).toFixed(2);
                    } else {
                        groupedFlightServices.push({
                            groupCode: serviceItem.groupCode,
                            code: serviceItem.productCode ? 'insuranceOnline' : serviceItem.groupCode,
                            totalPrice: serviceItem.totalPrice || serviceItem.price,
                            currency: serviceItem.currency,
                            count: serviceItem.amount || 1
                        });
                    }
                }
            });
            return groupedFlightServices;
        });
    }
    function generateSelectedExtraServicesByPassengers(passengers, editableExtraServicesHeap) {
        return passengers.map(function (passenger) {
            var groupedPassengerServices = [];
            (editableExtraServicesHeap || []).forEach(function (serviceItem) {
                if ((serviceItem.passengerId === passenger.id || serviceItem.firstName === passenger.firstName && serviceItem.lastName === passenger.lastName && serviceItem.dateOfBirth === passenger.dateOfBirth) && (serviceItem.segmentId === null || serviceItem.segmentId === undefined)) {
                    var groupedPassengerService = _.findWhere(groupedPassengerServices, { groupCode: serviceItem.groupCode });
                    var totalPrice = serviceItem.totalPrice || serviceItem.price || serviceItem.fare && serviceItem.fare.cost;
                    if (groupedPassengerService) {
                        groupedPassengerService.count = groupedPassengerService.count + (serviceItem.amount || 1);
                        groupedPassengerService.totalPrice = Big(groupedPassengerService.totalPrice).plus(totalPrice).toFixed(2);
                    } else {
                        groupedPassengerServices.push({
                            groupCode: serviceItem.groupCode,
                            code: serviceItem.productCode ? 'insuranceOnline' : serviceItem.groupCode,
                            totalPrice: totalPrice,
                            currency: serviceItem.currency || serviceItem.fare && serviceItem.fare.currency,
                            count: serviceItem.amount || 1
                        });
                    }
                }
            });
            return groupedPassengerServices;
        });
    }

    function removeSelectedExtraServicesByFlight(code, flightNum) {
        backend.removeExtraService({
            code: code,
            segment_id: vm.orderInfo.plainFlights[flightNum].id
        });
    }

    function removeEditableExtraServicesByPassenger(code, paxNum) {
        backend.removeExtraService({
            code: code,
            passenger_id: vm.orderInfo.passengers[paxNum].id
        });
    }

    function removeEditableExtraServicesForAllPassengers(code) {
        backend.removeExtraService({ code: code });
    }

    function removeEditableAeroexpress(index) {
        backend.removeExtraService({
            code: 'aeroexpress',
            fare_type: vm.selectedAeroexpress[index].fareType
        });
    }
}

},{}],445:[function(require,module,exports){
"use strict";

angular.module('app').directive('checkPassword', ['backend', function (backend) {
    return {
        require: 'ngModel',
        link: function link(scope, elm, attrs, ctrl) {

            ctrl.$parsers.unshift(validate);

            function validate(value) {

                if (!value) {
                    ctrl.$setValidity('pattern', true);
                    return value;
                }

                var passwordRegexp = new RegExp(backend.getParam('site.passwordRegexp'));
                var forbiddenPasswordSequencesRegexp = new RegExp(backend.getParam('site.forbiddenPasswordSequencesRegexp'), 'i');

                if (passwordRegexp.test(value) && (!backend.getParam('site.enableStrongPasswordPoliticsForPhysic') || forbiddenPasswordSequencesRegexp.test(value))) {
                    ctrl.$setValidity('pattern', true);
                    return value;
                } else {
                    ctrl.$setValidity('pattern', false);
                    return null;
                }
            }
        }
    };
}]);

},{}],446:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('cityPicker', {
    templateUrl: 'components/city-picker/city-picker.html',
    controller: ['$element', '$timeout', '$scope', 'utils', 'backend', CityPickerController],
    controllerAs: 'vm',
    bindings: {
        placeholder: '@placeholder',
        pickerindex: '@pickerindex',
        role: '@role',
        selectedItem: '=selected',
        excludeCity: '=exclude',
        dependCity: '=depend',
        submitTouched: '='
    }
});

function CityPickerController($element, $timeout, $scope, utils, backend) {

    var vm = this;
    var CITIES_COUNT_LIMIT = 7;
    var CITIES_COUNT_FULL_LIST_LIMIT = 100;

    var oldDependCityCode = void 0;

    vm.filteredList = [];
    vm.hoverIndex = -1;

    vm.openHandler = openHandler;
    vm.focusHandler = focusHandler;
    vm.blurHandler = blurHandler;
    vm.closeHandler = closeHandler;
    vm.substrChange = substrChange;
    vm.hoverHandler = hoverHandler;
    vm.keydownHandler = keydownHandler;
    vm.selectHandler = selectHandler;
    vm.highlightSubstr = highlightSubstr;

    backend.ready.then(function () {

        vm.localNamePropName = backend.sessionParams.localNamePropName;
        vm.citiesList = backend.getDependenceCitiesList(vm.role);
        vm.localCountryNamePropName = 'countryName' + utils.capitalize(backend.sessionParams.lang);

        $scope.$watch('vm.selectedItem', function (newSelectedItem) {
            if (!newSelectedItem) {
                vm.searchSubstr = '';
            }
        });
        $scope.$watch('vm.dependCity', function (newDependCity) {
            var newDependCityCode = newDependCity && newDependCity.cityCode;
            if (newDependCityCode != oldDependCityCode) {
                if (newDependCityCode) {
                    backend.getDependenceCitiesListForCity(vm.role, newDependCityCode).then(function (resp) {
                        if (resp[vm.role] && resp[vm.role].length) {
                            vm.citiesList = [backend.generateLegacyCityObject(vm.dependCity)].concat((0, _toConsumableArray3.default)(resp[vm.role]));
                        }
                    });
                } else {
                    vm.citiesList = backend.getDependenceCitiesList(vm.role);
                }
                oldDependCityCode = newDependCityCode;
            }
        });
    });

    function openHandler() {
        $element.find('input')[0].focus();
    }

    function focusHandler() {
        var $input = $element.find('input');
        $input.removeAttr('readonly');
        vm.submitTouched = false;
        vm.active = true;
        if (vm.selectedItem) {
            vm.searchSubstr = vm.selectedItem.portName || vm.selectedItem.cityName;
            $timeout(function () {
                $input[0].setSelectionRange(0, $input[0].value.length);
            });
        }
        vm.filteredList = getDefaultCitiesList();
    }

    function blurHandler() {
        $timeout(closeHandler, 250);
    }

    function closeHandler() {
        vm.active = false;
    }

    function substrChange() {
        if (vm.searchSubstr) {
            vm.filteredList = generateItemsByCitiesList(utils.filterCitiesList(angular.copy(vm.citiesList), vm.searchSubstr, backend.sessionParams.lang, backend.sessionParams.localNamePropName, false, CITIES_COUNT_LIMIT));
        } else {
            vm.filteredList = getDefaultCitiesList();
            vm.selectedItem = false;
        }
    }
    function getDefaultCitiesList() {
        if (backend.getParam('site.isCompany')) {
            return generateItemsByCitiesList(utils.filterCitiesList(angular.copy(vm.citiesList), vm.searchSubstr, backend.sessionParams.lang, backend.sessionParams.localNamePropName, false, CITIES_COUNT_FULL_LIST_LIMIT));
        } else {
            return [];
        }
    }

    function hoverHandler(itemNum) {
        vm.hoverIndex = itemNum;
    }

    function keydownHandler(e) {

        if (vm.active && vm.filteredList && vm.filteredList.length) {
            if (e.key === 'Enter') {

                if (vm.hoverIndex === -1) {
                    vm.hoverIndex = 0;
                }
                if (vm.filteredList[vm.hoverIndex]) {
                    selectHandler(vm.filteredList[vm.hoverIndex]);
                }
                e.preventDefault();
                return false;
            } else if (e.key === 'Escape') {

                $element.find('input')[0].blur();
                vm.searchSubstr = '';
                vm.filteredList = [];
            } else if (e.key === 'ArrowDown') {

                if (vm.hoverIndex === -1 || vm.hoverIndex >= vm.filteredList.length - 1) {
                    vm.hoverIndex = 0;
                } else {
                    vm.hoverIndex++;
                }
            } else if (e.key === 'ArrowUp') {

                if (vm.hoverIndex < 1) {
                    vm.hoverIndex = vm.filteredList.length - 1;
                } else {
                    vm.hoverIndex--;
                }
            } else if (e.key === 'Tab') {

                if (vm.filteredList[vm.hoverIndex]) {
                    selectHandler(vm.filteredList[vm.hoverIndex]);
                } else if (vm.searchSubstr && vm.filteredList[0]) {
                    selectHandler(vm.filteredList[0]);
                }
            }
        }
    }

    function selectHandler(item) {
        vm.selectedItem = angular.copy(item);
        if (item) {
            vm.searchSubstr = item.portName || item.cityName;
        }
        vm.filteredList = [];
        if (vm.excludeCity && item.cityCode === vm.excludeCity.cityCode) {
            vm.excludeCity = false;
        }
        vm.active = false;
    }

    function highlightSubstr(str) {
        if (!vm.searchSubstr || !str) {
            return str;
        }
        var strUp = str.toUpperCase(),
            searchSubstrUp = vm.searchSubstr.toUpperCase();
        if (strUp.indexOf(searchSubstrUp) !== 0) {
            return str;
        } else {
            return '<strong>' + str.substr(0, vm.searchSubstr.length) + '</strong>' + str.substr(vm.searchSubstr.length);
        }
    }

    function generateItemsByCitiesList(cities) {
        var items = [];
        cities.forEach(function (city) {
            if (!city.hasRelevantAirportOnly) {
                items.push({
                    cityName: city[vm.localNamePropName],
                    countryName: city[vm.localCountryNamePropName],
                    cityCode: city.codeEn,
                    popular: city.popular
                });
            }
            if (city.airports) {
                city.airports.forEach(function (airport) {
                    if ((!city.hasRelevantAirportOnly || airport.relevant) && (airport[vm.localNamePropName] !== city[vm.localNamePropName] || airport.codeEn !== city.codeEn)) {
                        items.push({
                            isChild: !city.hasRelevantAirportOnly,
                            isPortNameContainCityName: airport[vm.localNamePropName].indexOf(city[vm.localNamePropName]) !== -1,
                            cityName: city[vm.localNamePropName],
                            portName: airport[vm.localNamePropName],
                            countryName: city[vm.localCountryNamePropName],
                            cityCode: city.codeEn,
                            portCode: airport.codeEn,
                            popular: city.popular
                        });
                    }
                });
            }
        });
        return items;
    }
}

},{"babel-runtime/helpers/toConsumableArray":11}],447:[function(require,module,exports){
"use strict";

angular.module('app').directive('cleanDocumentNumber', ['utils', function (utils) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elem, attrs, ctrl) {

            if (!ctrl) {
                return;
            }

            ctrl.$parsers.push(utils.formatDocumentNumber);

            jQuery(elem).on('input', function () {
                var selectionStart = this.selectionStart,
                    selectionEnd = this.selectionEnd;
                this.value = utils.formatDocumentNumber(this.value);
                if (utils.getInternetExplorerVersion() !== 11) {
                    this.setSelectionRange(selectionStart, selectionEnd);
                }
            });
        }
    };
}]);

},{}],448:[function(require,module,exports){
"use strict";

angular.module('app').directive('cleanOnlyNumber', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elem, attrs, ngModel) {
            var formatNumber = function formatNumber(val) {
                return val.replace(/\D/g, '');
            };
            ngModel.$parsers.push(formatNumber);
            jQuery(elem).on('input', function () {
                this.value = formatNumber(this.value);
            });
        }
    };
}]);

},{}],449:[function(require,module,exports){
"use strict";

angular.module('app').directive('cleanSearchOrderParamLastName', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            validatePattern: "<"
        },
        link: function link(scope, element, attrs, ngModel) {

            var re = new RegExp(scope.validatePattern);

            element.on("keydown", function (event) {
                if (event.keyCode === 32) {
                    var spaceCount = (ngModel.$modelValue || '').split(' ').length - 1;
                    if (spaceCount) {
                        event.preventDefault();
                        return false;
                    }
                }
            });

            ngModel.$parsers.push(function (input) {
                if (typeof input === 'number') {
                    input = input.toString();
                }
                var output = (input || '').toUpperCase();
                ngModel.$setValidity('pattern', re.test(output));
                return output;
            });
        }
    };
}]);

},{}],450:[function(require,module,exports){
"use strict";

angular.module('app').directive('cleanSearchOrderParam', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            validatePattern: "<"
        },
        link: function link(scope, element, attrs, ngModel) {

            var re = new RegExp(scope.validatePattern);

            element.on("keydown", function (event) {
                if (event.keyCode === 32) {
                    event.preventDefault();
                    return false;
                }
            });

            ngModel.$parsers.push(function (input) {
                if (typeof input === 'number') {
                    input = input.toString();
                }
                var output = (input || '').toUpperCase();
                ngModel.$setValidity('pattern', re.test(output));
                return output;
            });
        }
    };
}]);

},{}],451:[function(require,module,exports){
"use strict";

angular.module('app').component('cookieWarning', {
    templateUrl: 'components/cookie-warning/cookie-warning.html',
    controller: ['$window', '$location', CookieWarningController],
    controllerAs: 'vm'
});

function CookieWarningController($window, $location) {

    var vm = this;

    vm.active = (!$window.localStorage || !$window.localStorage.oxygen_hide_cookie_warning) && $location.path() !== '/privacy-policy';

    vm.close = close;

    function close() {
        vm.active = false;
        if ($window.localStorage) {
            $window.localStorage.oxygen_hide_cookie_warning = true;
        }
    }
}

},{}],452:[function(require,module,exports){
"use strict";

angular.module('app').directive('customScroll', function () {
    return {
        link: function link(scope, element) {
            element.mCustomScrollbar();
        }
    };
});

},{}],453:[function(require,module,exports){
"use strict";

angular.module('app').directive('dropdownPicker', ['$timeout', 'backend', 'utils', function ($timeout, backend, utils) {
    function link(scope, element) {
        $('.js-dropdown', element).mCustomScrollbar();
    }

    function dropdownPickerController($scope, $element) {
        backend.ready.then(function () {
            $scope.localNamePropName = backend.sessionParams.localNamePropName;
            $scope.options = $scope.options || [];
            $scope.filteredOptions = $scope.options.slice(0); //clone array
            $scope.optionKey = $scope.optionKey || '';
            $scope.selected = '';
        });

        $scope.$watch('options', function (newVal) {
            $scope.filteredOptions = newVal.slice(0); //clone array
        });

        $scope.$watch('selected', function (newVal) {
            $scope.$emit('dropdownPickerSelected', newVal);
        });

        $scope.searchFocus = function () {
            delete $scope.searchSubstr;

            $scope.active = true;
        };

        $scope.searchBlur = function (event) {
            var bluredBySelectCity = !!(event.relatedTarget && $.contains($element[0], event.relatedTarget));

            if (utils.isKonqueror() || utils.isPresto() || utils.getInternetExplorerVersion() === 11 || utils.isKitKat()) {
                $timeout(function () {
                    $scope.active = false;
                }, 300);
            } else if (!bluredBySelectCity) {
                $scope.active = false;
            }
        };

        $scope.dropClick = function () {
            $('input[type="text"]', $element).focus();
        };

        $scope.optionClick = function (optionValue) {
            $scope.searchSubstr = $scope.optionKey.length > 0 ? optionValue[$scope.optionKey] : optionValue;
            $scope.selected = optionValue;
            $scope.active = false;
        };

        $scope.substrChange = function () {
            $scope.filteredOptions = $scope.options.filter(function (itemCur) {
                var item = $scope.optionKey.length > 0 ? itemCur[$scope.optionKey] : itemCur;
                var str = $scope.searchSubstr.toLowerCase();

                return item.toLowerCase().indexOf(str) !== -1;
            });

            if ($scope.filteredOptions.length === 1) {
                //$scope.selectedCity = $scope.filteredCitiesList[0];
                //$scope.active = false;
            }
        };
    }

    return {
        link: link,
        controller: ['$scope', '$element', dropdownPickerController],
        scope: {
            options: '<',
            optionKey: '@',
            submitKey: '@',
            placeholder: '@',
            pickerindex: '@',
            role: '@',
            selected: '<'
        },
        restrict: 'E',
        templateUrl: 'components/dropdown-picker/dropdown-picker.html'
    };
}]);

},{}],454:[function(require,module,exports){
"use strict";

angular.module('app').directive('dynamicParentPadding', function () {
    return {
        link: function link(scope, element) {
            element[0].parentElement.style.paddingTop = element[0].offsetHeight + 'px';
        }
    };
});

},{}],455:[function(require,module,exports){
"use strict";

angular.module('app').directive('errorHighlight', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elem, attrs, ngModel) {
            var oldState = false,
                newState = false;
            /**
             * Вешаем обработчики:  select - выбор конкретного элемента,
             *                      activate - раскрытие списка,
             *                      close - закрытие списка
             */
            if (scope.$select) {
                scope.$on('uis:select', highlight);
                scope.$on('uis:activate', function () {
                    $timeout(function () {
                        ngModel.focused = true;
                        highlight();
                    });
                });
                scope.$on('uis:close', function () {
                    $timeout(function () {
                        ngModel.focused = false;
                        highlight();
                    });
                });
            } else {

                elem.on('focus', function () {
                    $timeout(function () {
                        ngModel.focused = true;
                    });
                });

                elem.on('blur', function () {
                    $timeout(function () {
                        ngModel.focused = false;
                    });
                });

                elem.on('blur', highlight);

                ngModel.$parsers.push(function (value) {
                    $timeout(highlight);
                    return value;
                });
            }

            /**
             * Вотчер на сабмит формы
             */
            attrs.$observe('errorHighlight', highlight);

            /**
             * Проверка валидность введенных данных
             */
            function highlight() {
                newState = getState();
                if (newState !== oldState) {
                    ngModel.errorHighlight = newState;
                    if (scope.$select) {
                        elem.children('.selectize-input').toggleClass('textInp_error');
                    } else {
                        elem.toggleClass('textInp_error', newState);
                    }
                    oldState = newState;
                }
            }

            function getState() {
                /**
                 * Т.к. получаемый атрибут является строкой, преобразуем его в булево значение
                 */
                if (typeof attrs.errorHighlight === 'string') {
                    attrs.errorHighlight = attrs.errorHighlight === 'false' ? !attrs.errorHighlight : !!attrs.errorHighlight;
                }
                return !!(ngModel.$invalid && attrs.errorHighlight);
            }
        }
    };
}]);

},{}],456:[function(require,module,exports){
"use strict";

angular.module('app').component('errorMessageSensitive', {
    templateUrl: 'components/error-message-sensitive/error-message-sensitive.html',
    controller: ['backend', ErrorMessageController],
    controllerAs: 'vm',
    bindings: {
        control: '<',
        formatAlias: '<'
    }
});

function ErrorMessageController(backend) {

    var vm = this;
    vm.hasAlias = backend.hasAlias;
}

},{}],457:[function(require,module,exports){
"use strict";

angular.module('app').component('errorMessage', {
    templateUrl: 'components/error-message/error-message.html',
    controllerAs: 'vm',
    bindings: {
        control: '<',
        prefix: '@',
        formatAlias: '<',
        requiredAlias: '<'
    }
});

},{}],458:[function(require,module,exports){
"use strict";

angular.module('app').component('esAeroexpress', {
    templateUrl: 'components/es-aeroexpress/es-aeroexpress.html',
    controller: ['$scope', 'backend', AeroexpressController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        forcedOpenRfisc: '=',
        locked: '<'
    }
});

function AeroexpressController($scope, backend) {

    var vm = this;

    vm.switchService = switchService;

    $scope.$watch('vm.forcedOpenRfisc', function () {
        if (vm.forcedOpenRfisc === 'aeroexpress') {
            vm.service.active = true;
        }
    });

    backend.addOrderInfoListener(function (orderInfo) {

        vm.orderInfo = orderInfo;

        if (orderInfo) {
            if (orderInfo.passengers) {

                vm.orderInfo.passengers.forEach(function (passenger) {
                    var orderAeroexpressService = _.findWhere(orderInfo.all_extra_services, { code: 'aeroexpress' });
                    var orderAeroexpressItem = void 0;
                    if (_.findWhere(vm.service.documents, { code: passenger.documentCode })) {
                        passenger.aeroexpressDocumentType = passenger.documentCode;
                        passenger.aeroexpressDocumentNumber = passenger.documentNumber;
                    }
                    if (orderAeroexpressService && orderAeroexpressService.items && orderAeroexpressService.items.length) {
                        orderAeroexpressItem = _.findWhere(orderAeroexpressService.items, {
                            firstName: passenger.firstName,
                            lastName: passenger.lastName
                        });
                        if (orderAeroexpressItem) {
                            passenger.aeroexpressDocumentType = orderAeroexpressItem.documentType;
                            passenger.aeroexpressDocumentNumber = orderAeroexpressItem.documentNumber;
                        }
                    }
                });
            }
        }
    }, false, true);

    function switchService() {
        if (!vm.locked) {
            vm.service.active = !vm.service.active;
        }
    }
}

},{}],459:[function(require,module,exports){
"use strict";

angular.module('app').component('esBaggage', {
    templateUrl: 'components/es-baggage/es-baggage.html',
    controller: ['backend', 'utils', '$window', BaggageController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        locked: '<'
    }
});

function BaggageController(backend, utils, $window) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    vm.suffixCount = utils.suffixCount;

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/' + vm.service.code;
    } else {
        vm.imagesPath = $window.o2context.staticWebContentRoot + '/themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';

    vm.showPopupForCard = -1;

    vm.$onInit = function () {
        if (vm.service.active && vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        }
    };

    vm.switchService = switchService;
    vm.hideCardPopup = hideCardPopup;

    backend.addOrderInfoListener(function (orderInfo) {
        vm.orderInfo = orderInfo;
    }, false, true);

    function switchService() {
        if (vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        } else {
            vm.service.active = !vm.service.active;
        }
    }

    function hideCardPopup() {
        vm.showPopupForCard = -1;
        if (vm.service.cards.length === 1) {
            vm.service.active = false;
        }
    }
}

},{}],460:[function(require,module,exports){
"use strict";

angular.module('app').component('esCommon', {
    templateUrl: 'components/es-common/es-common.html',
    controller: ['backend', CommonController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        locked: '<'
    }
});

function CommonController(backend) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/' + vm.service.code;
    } else {
        vm.imagesPath = './themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';

    vm.showPopupForCard = -1;

    vm.$onInit = function () {
        if (vm.service.active && vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        }
    };

    vm.switchService = switchService;
    vm.hideCardPopup = hideCardPopup;

    backend.addOrderInfoListener(function (orderInfo) {
        vm.orderInfo = orderInfo;
    }, false, true);

    function switchService() {
        if (vm.service.bulkAdd) {
            if (!vm.locked) {
                var code = vm.service.code;

                if (vm.service.editablePrice) {
                    backend.removeExtraService({ code: code });
                } else {
                    backend.modifyExtraService({ code: code });
                }
            }
        } else if (vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        } else {
            vm.service.active = !vm.service.active;
        }
    }

    function hideCardPopup() {
        vm.showPopupForCard = -1;
        if (vm.service.cards.length === 1) {
            vm.service.active = false;
        }
    }
}

},{}],461:[function(require,module,exports){
"use strict";

angular.module('app').component('esInsurance', {
    templateUrl: 'components/es-insurance/es-insurance.html',
    controller: ['backend', '$window', '$scope', InsuranceController],
    controllerAs: 'vm',
    bindings: {
        service: '<',
        locked: '<',
        submitTouched: '<',
        forcedOpenRfisc: '='
    }
});

function InsuranceController(backend, $window, $scope) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');
    vm.switchDropMobileState = switchDropMobileState;
    vm.removeInsurance = removeInsurance;
    vm.openInsurance = openInsurance;

    vm.hasAlias = backend.hasAlias;

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/' + vm.service.code;
    } else {
        vm.imagesPath = $window.o2context.staticWebContentRoot + '/themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.serviceIconCode = vm.service.code + '-head-icon';

    $scope.$watch('vm.forcedOpenRfisc', function () {
        if (vm.forcedOpenRfisc) {
            vm.service.cards.forEach(function (card, cardNum) {
                if (card.ins + '.' + card.tins + '.' + card.productCode === vm.forcedOpenRfisc) {
                    vm.showPopupForCard = cardNum;
                    vm.forcedOpenRfisc = false;
                }
            });
        }
    });

    vm.selectedSubgroupCode = vm.service.structure && vm.service.structure.subgroups && vm.service.structure.subgroups[0] && vm.service.structure.subgroups[0].code;

    vm.showPopupForCard = -1;

    vm.$onInit = function () {
        var storedBegDone = readBegDoneFromStorage();
        vm.checkboxBegDone = vm.service.cards.map(function (serviceCard, serviceCardNum) {
            var hasCheckboxBeg = serviceCard.items && serviceCard.items[0] && serviceCard.items[0].customProperties && serviceCard.items[0].customProperties.checkboxBeg;
            return !hasCheckboxBeg || storedBegDone && storedBegDone[serviceCardNum];
        });
        writeBegDoneToStorage();
    };

    vm.switchService = switchService;
    vm.hideCardPopup = hideCardPopup;

    backend.addOrderInfoListener(function (orderInfo) {
        vm.orderInfo = orderInfo;
    }, false, true);

    function switchService() {
        if (vm.service.cards.length === 1) {
            vm.service.active = !vm.service.active;
        } else {
            vm.service.active = !vm.service.active;
        }
    }

    function removeInsurance(cardNum, event) {
        if (vm.service.cards[cardNum].alreadySelectedPrice) {
            backend.removeExtraService(getInsuranceSubmitParams(vm.service.cards[cardNum].items[0]));
        }
        vm.checkboxBegDone[cardNum] = true;
        writeBegDoneToStorage();
        event.preventDefault();
    }

    function openInsurance(cardNum, event) {
        vm.showPopupForCard = cardNum;
        vm.checkboxBegDone[cardNum] = true;
        writeBegDoneToStorage();
        event.preventDefault();
    }

    function switchDropMobileState() {
        vm.dropState = !vm.dropState;
    }

    function hideCardPopup() {
        vm.showPopupForCard = -1;
    }

    function getInsuranceSubmitParams(item) {
        var params = {
            code: 'insurance',
            ins: item.ins,
            tins: item.tins
        };
        if (vm.service.onlineMode) {
            params.code = 'insuranceOnline';
            params.productCode = item.productCode;
        }
        return params;
    }

    function writeBegDoneToStorage() {
        if ($window.localStorage) {
            $window.localStorage.websky_ins_beg_done = JSON.stringify(vm.checkboxBegDone);
        }
    }

    function readBegDoneFromStorage() {
        var begTex = $window.localStorage && $window.localStorage.websky_ins_beg_done;
        return begTex ? JSON.parse(begTex) : false;
    }
}

},{}],462:[function(require,module,exports){
"use strict";

angular.module('app').component('esMeal', {
    templateUrl: 'components/es-meal/es-meal.html',
    controller: ['backend', '$window', MealController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        locked: '<'
    }
});

function MealController(backend, $window) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/' + vm.service.code;
    } else {
        vm.imagesPath = $window.o2context.staticWebContentRoot + '/themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';

    vm.showPopupForCard = -1;
    vm.selectedSubgroupCode = false;

    vm.$onInit = function () {
        if (vm.service.active && vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        }
    };

    vm.switchService = switchService;
    vm.hideCardPopup = hideCardPopup;

    backend.addOrderInfoListener(function (orderInfo) {
        vm.orderInfo = orderInfo;
    }, false, true);

    function switchService() {
        if (vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        } else {
            vm.service.active = !vm.service.active;
        }
    }

    function hideCardPopup() {
        vm.showPopupForCard = -1;
        if (vm.service.cards.length === 1) {
            vm.service.active = false;
        }
    }
}

},{}],463:[function(require,module,exports){
"use strict";

angular.module('app').component('esSeatLink', {
    templateUrl: 'components/es-seat-link/es-seat-link.html',
    controller: ['$scope', 'backend', 'redirect', SeatLinkController],
    controllerAs: 'vm',
    bindings: {
        service: '<',
        orderInfo: '<',
        locked: '<'
    }
});

function SeatLinkController($scope, backend, redirect) {

    var vm = this;

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';
    vm.openSeatSelect = redirect.goToSeatSelect;

    $scope.$watch('vm.service', function () {
        vm.unavailableBecauseOfCheckIn = vm.service.unavailableBecauseOfCheckInBySegments && vm.service.unavailableBecauseOfCheckInBySegments.every(function (flight) {
            return flight;
        });
    });

    backend.addOrderInfoListener(function (orderInfo) {
        vm.orderInfo = orderInfo;
    }, false, true);
}

},{}],464:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('esSeat', {
    templateUrl: 'components/es-seat/es-seat.html',
    controller: ['backend', 'utils', SeatController],
    controllerAs: 'vm',
    bindings: {
        service: '<',
        locked: '<'
    }
});

function SeatController(backend, utils) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    vm.seatSelectHandler = seatSelectHandler;
    vm.selectPassenger = selectPassenger;
    vm.switchFlight = switchFlight;
    vm.removeSeatHandler = removeSeatHandler;
    vm.hasAlias = backend.hasAlias;

    backend.addOrderInfoListener(function (orderInfo) {

        vm.orderInfo = orderInfo;

        updatePlainFlightSteps();

        vm.seatsByFlightPassengers = vm.plainFlightSteps.map(function (flight) {
            return vm.orderInfo.passengers.map(function (pax) {
                var paxFlightSeats = _.findWhere(vm.orderInfo.allExtraServicesHeap, {
                    segmentId: flight.id,
                    groupCode: 'seat',
                    passengerId: pax.id
                });
                return paxFlightSeats || false;
            });
        });

        vm.costByFlights = vm.plainFlightSteps.map(function (flight) {
            var totalByFlight = 0;
            var currency = void 0;
            (vm.orderInfo.editableExtraServicesHeap || []).filter(function (item) {
                return item.segmentId === flight.id && item.groupCode === 'seat';
            }).forEach(function (item) {
                if (item.totalPrice) {
                    totalByFlight = Big(totalByFlight).plus(item.totalPrice).toFixed(2);
                }
                if (!currency) {
                    currency = item.currency;
                }
            });
            return {
                value: totalByFlight,
                currency: currency
            };
        });
    }, false, true);

    vm.$onInit = function () {
        selectFirstAvailablePassengerFlight();
        vm.fullPageLayout = backend.getParam('extraServices.seatMapFullPageLayout');
        vm.showLegendFooter = backend.hasAlias('web.extraServices.seat.legendFooter') && backend.getAlias('web.extraServices.seat.legendFooter') !== '';
    };

    function updatePlainFlightSteps() {
        vm.plainFlightSteps = vm.orderInfo.plainFlights.map(function (flight, flightNum) {
            return (0, _extends3.default)({}, flight, {
                orderFlightNum: flightNum
            });
        }).filter(function (flight) {
            if (vm.service.svcs.some(function (svc) {
                return svc.segmentId === flight.id;
            })) {
                return true;
            }
            if (vm.service.unavailableBecauseOfCheckInBySegments && vm.service.unavailableBecauseOfCheckInBySegments[flight.orderFlightNum]) {
                return true;
            }
            return false;
        });
    }

    function selectPassenger(paxNum) {
        vm.selectedPassenger = paxNum;
        updateSeatMap();
    }

    function switchFlight(delta) {
        vm.selectedFlight = vm.selectedFlight + delta;
        vm.selectedPassenger = utils.getFirstAvailableSvcsPassenger(vm.service.svcs, vm.orderInfo, vm.plainFlightSteps[vm.selectedFlight].orderFlightNum);
        updateSeatMap(true);
    }

    function seatSelectHandler(chair, rowNumber) {
        if (!vm.locked) {
            if (chair.available) {
                vm.modifyError = false;
                backend.modifyExtraService({
                    code: 'seat',
                    passenger_id: vm.orderInfo.passengers[vm.selectedPassenger].id,
                    segment_id: vm.plainFlightSteps[vm.selectedFlight].id,
                    value: rowNumber + chair.number,
                    subgroup: vm.service.commonSubgroup,
                    rfisc: chair.rfisc || ''
                }).then(updateSeatMap, function (resp) {
                    if (resp.error) {
                        vm.modifyError = resp.error;
                    }
                });
            }
        }
    }

    function selectFirstAvailablePassengerFlight() {
        vm.selectedFlight = 0;
        vm.selectedPassenger = utils.getFirstAvailableSvcsPassenger(vm.service.svcs, vm.orderInfo, vm.plainFlightSteps[vm.selectedFlight].orderFlightNum);
        updateSeatMap();
    }

    function updateSeatMap(fullRedraw) {
        if (vm.selectedPassenger !== -1 && vm.selectedFlight !== -1) {
            vm.loadingSeatMap = true;
            vm.seatMapError = false;
            if (fullRedraw) {
                vm.seatMap = false;
            }
            backend.seatMap(vm.orderInfo.passengers[vm.selectedPassenger].id, vm.plainFlightSteps[vm.selectedFlight].id, o2context.debug ? '/seat-map/aircraft-schemes' : externalStorageUrl + '/seat-map/aircraft-schemes').then(function (resp) {
                vm.seatMap = reformatSeatMap(resp, vm.seatsByFlightPassengers[vm.selectedFlight], vm.selectedPassenger);
                vm.loadingSeatMap = false;
            }, function (resp) {
                vm.seatMapError = resp.error;
                vm.loadingSeatMap = false;
            });
        }
    }

    function getSeatMapLegendGroupsConfig() {
        try {
            var resultObj = JSON.parse(backend.getParam('extraServices.seatMapLegendGroupsConfig'));
            return resultObj.groups || [];
        } catch (err) {
            console.log('extraServices.seatMapLegendGroupsConfig: ', err);
            return [];
        }
    }

    function reformatSeatMap(data, seatsByPassengers, selectedPassenger) {
        var seatMapLegendMode = backend.getParam('extraServices.seatMapLegendMode') || 'RFISC_AND_CHARACTERISTICS';

        var seatMapLegendGroupsConfig = getSeatMapLegendGroupsConfig();

        var legend = [];
        var seatsByOrderPassengers = seatsByPassengers.filter(function (paxSeat, paxNum) {
            return paxNum !== selectedPassenger;
        }).map(function (paxSeat) {
            return paxSeat.value;
        });
        var seatActivePassenger = seatsByPassengers[selectedPassenger] && seatsByPassengers[selectedPassenger].value;

        var getLegendIndex = function getLegendIndex(item) {
            if (item.rfisc) {
                if (seatMapLegendMode === 'CUSTOM_GROUPS') {
                    var itemSVC = _.findWhere(data.svcs, { rfisc: item.rfisc });
                    if (itemSVC && itemSVC.customProperties && itemSVC.customProperties.legendGroup) {
                        return _.findIndex(legend, function (l) {
                            return l.legendGroup.code === itemSVC.customProperties.legendGroup;
                        });
                    }
                } else if (seatMapLegendMode === 'PRICE') {
                    return _.findIndex(legend, function (l) {
                        return l.cost === item.cost;
                    });
                } else if (seatMapLegendMode === 'RFISC') {
                    return _.findIndex(legend, function (l) {
                        return l.rfisc === item.rfisc;
                    });
                } else if (seatMapLegendMode === 'RFISC_AND_CHARACTERISTICS') {
                    return _.findIndex(legend, function (l) {
                        return l.rfisc === item.rfisc && (l.seatCharacteristics === item.seatCharacteristics || !l.seatCharacteristics && !item.seatCharacteristics);
                    });
                }
            }
            return -1;
        };

        var legendPriceSorter = function legendPriceSorter(a, b) {
            var A = Big(a.cost);
            var B = Big(b.cost);
            if (A.lt(B)) {
                return -1;
            } else if (A.gt(B)) {
                return 1;
            } else {
                return 0;
            }
        };

        if (data.svcs && data.decks) {

            if (seatMapLegendMode === 'CUSTOM_GROUPS') {

                seatMapLegendGroupsConfig.forEach(function (legendGroup) {

                    var groupCurrency = false;
                    var groupPrice = false;
                    var minPrice = false;
                    var maxPrice = false;

                    data.svcs.forEach(function (svc) {
                        var customProperties = svc.customProperties,
                            cost = svc.cost,
                            currency = svc.currency;

                        if (svc.hasChairs && customProperties && customProperties.legendGroup) {
                            if (customProperties.legendGroup === legendGroup.code) {
                                if (!groupCurrency) {
                                    groupCurrency = currency;
                                }

                                if (!minPrice) {
                                    minPrice = cost;
                                } else if (Big(cost).lt(Big(minPrice))) {
                                    minPrice = cost;
                                }

                                if (!maxPrice) {
                                    maxPrice = cost;
                                } else if (Big(cost).gt(Big(maxPrice))) {
                                    maxPrice = cost;
                                }
                            }
                        }
                    });

                    if (minPrice === maxPrice) {
                        groupPrice = minPrice;
                        minPrice = false;
                        maxPrice = false;
                    }

                    if (!legendGroup.showMaxPrice) {
                        maxPrice = false;
                    }

                    var aliasCode = 'web.extraServices.seatMapLegend.' + legendGroup.code;
                    legend.push({ aliasCode: aliasCode, legendGroup: legendGroup, minPrice: minPrice, maxPrice: maxPrice, cost: groupPrice, currency: groupCurrency });
                });
            } else if (seatMapLegendMode === 'PRICE') {
                data.svcs.forEach(function (svc) {
                    var cost = svc.cost,
                        currency = svc.currency;

                    if (svc.hasChairs && !_.findWhere(legend, { cost: cost })) {
                        var aliasCode = 'web.extraServices.seatMapLegend.' + cost;
                        var colorCode = Big(cost).toFixed(0) + '_' + currency;
                        legend.push({ aliasCode: aliasCode, cost: cost, currency: currency, colorCode: colorCode });
                    }
                });
                legend.sort(legendPriceSorter);
            } else if (seatMapLegendMode === 'RFISC') {
                data.svcs.forEach(function (svc) {
                    var rfisc = svc.rfisc,
                        cost = svc.cost,
                        currency = svc.currency;

                    if (svc.hasChairs && !_.findWhere(legend, { rfisc: rfisc })) {
                        var aliasCode = 'web.extraServices.seatMapLegend.' + rfisc;
                        legend.push({ aliasCode: aliasCode, rfisc: rfisc, cost: cost, currency: currency });
                    }
                });
            } else if (seatMapLegendMode === 'RFISC_AND_CHARACTERISTICS') {
                data.svcs.forEach(function (svc) {
                    if (svc.hasChairs) {
                        var cost = svc.cost,
                            currency = svc.currency,
                            rfisc = svc.rfisc,
                            seatCharacteristics = svc.seatCharacteristics;

                        var aliasCode = 'web.extraServices.seatMapLegend.' + rfisc;
                        if (seatCharacteristics) {
                            aliasCode += '.' + seatCharacteristics;
                        }
                        legend.push({ aliasCode: aliasCode, cost: cost, currency: currency, rfisc: rfisc, seatCharacteristics: seatCharacteristics });
                    }
                });
            }

            data.legend = legend;

            data.decks.forEach(function (deck) {
                var maxRowSeatsCount = 0;
                if (deck.cabins) {
                    deck.cabins.forEach(function (cabin) {
                        if (cabin.rows) {
                            cabin.rows.forEach(function (row) {
                                if (row.chairs) {
                                    if (row.chairs.length > maxRowSeatsCount) {
                                        maxRowSeatsCount = row.chairs.length;
                                    }
                                    row.chairs.forEach(function (item) {
                                        item.legendIndex = getLegendIndex(item);
                                        if (utils.hasInList(seatsByOrderPassengers, '' + row.number + item.number)) {
                                            item.selectedByOrderPassenger = true;
                                        }
                                        if (seatActivePassenger === '' + row.number + item.number) {
                                            item.selectedByActivePassenger = true;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                deck.maxRowSeatsCount = maxRowSeatsCount;
            });
        }
        return data;
    }

    function removeSeatHandler(paxNum) {
        if (!vm.locked) {
            vm.modifyError = false;
            backend.removeExtraService({
                code: 'seat',
                passenger_id: vm.orderInfo.passengers[paxNum].id,
                segment_id: vm.plainFlightSteps[vm.selectedFlight].id
            }).then(updateSeatMap, function (resp) {
                if (resp.error) {
                    vm.modifyError = resp.error;
                }
            });
        }
    }
}

},{"babel-runtime/helpers/extends":9}],465:[function(require,module,exports){
"use strict";

angular.module('app').component('esSmsNotification', {
    templateUrl: 'components/es-sms-notification/es-sms-notification.html',
    controller: ['backend', SmsNotificationController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        locked: '=locked'
    }
});

function SmsNotificationController(backend) {

    var vm = this;

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';

    vm.switchService = switchService;

    backend.addOrderInfoListener(function (orderInfo) {

        vm.orderInfo = orderInfo;
    }, false, true);

    function switchService() {
        vm.service.active = !vm.service.active;
    }
}

},{}],466:[function(require,module,exports){
"use strict";

angular.module('app').component('exchangeFlightSelect', {
    templateUrl: 'components/exchange-flight-select/exchange-flight-select.html',
    controller: ['backend', ExchangeFlightSelectController],
    controllerAs: 'vm',
    bindings: {
        num: '<',
        chains: '<',
        orderFlight: '<',
        selectedChain: '<',
        newDate: '<',
        descPassCountStr: '<',
        select: '<',
        openBrandDetails: '<'
    }
});

function ExchangeFlightSelectController(backend) {

    var vm = this;

    vm.flightDetailClick = flightDetailClick;
    vm.getBrandName = backend.getBrandName;

    function flightDetailClick(event, flight) {
        vm.flightDetail = flight;
        event.stopPropagation();
        return false;
    }
}

},{}],467:[function(require,module,exports){
"use strict";

angular.module('app').component('exchangePriceSelect', {
    templateUrl: 'components/exchange-price-select/exchange-price-select.html',
    controller: [ExchangePriceSelectController],
    controllerAs: 'vm',
    bindings: {
        brands: '<',
        exchangeVariants: '<',
        selectedChains: '<',
        selectedVariant: '<',
        select: '<'
    }
});

function ExchangePriceSelectController() {

    var vm = this;

    vm.openCompare = openCompare;

    function openCompare(code) {
        vm.showCompare = true;
        vm.activeCompareBrand = code;
    }
}

},{}],468:[function(require,module,exports){
"use strict";

angular.module('app').component('exchangeRequestForm', {
    templateUrl: 'components/exchange-request-form/exchange-request-form.html',
    controller: ['backend', '$scope', 'redirect', ExchangeRequestFormController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<',
        exchangeAvailability: '<',
        exchangeUnavailabilityReason: '<',
        flightsNearingForbidden: '<',
        submit: '<',
        openBrandDetails: '<',
        showSwitch: '<',
        useSegmentsChain: '<',
        formOpened: '='
    }
});

function ExchangeRequestFormController(backend, $scope, redirect) {

    var vm = this;

    vm.submitHandler = submitHandler;
    vm.selectPaxHandler = selectPaxHandler;
    vm.openOrder = redirect.goToSearchOrder;

    vm.showFlightDetail = -1;

    vm.$onInit = function () {
        vm.selectedState = vm.orderInfo.plainFlights.map(function () {
            return vm.orderInfo.passengers.map(function () {
                return false;
            });
        });
        vm.flights = vm.useSegmentsChain ? vm.orderInfo.flights : vm.orderInfo.plainFlights;
        vm.hasSelectedChildrenWithoutAdults = vm.orderInfo.plainFlights.map(function () {
            return false;
        });
        vm.hasUnselectedChildrenWithoutAdults = vm.orderInfo.plainFlights.map(function () {
            return false;
        });
        vm.isAdultPassengerFlight = vm.orderInfo.plainFlights.map(function (flight) {
            return vm.orderInfo.passengers.map(function (passenger) {
                var dateOfBirthMoment = moment(passenger.dateOfBirth, 'DD.MM.YYYY');
                var flightMoment = moment(flight.date, 'DD.MM.YYYY');
                var yearsDiff = flightMoment.diff(dateOfBirthMoment, 'years', false);
                var isAdult = yearsDiff >= 18;
                return isAdult;
            });
        });
        vm.newDate = vm.orderInfo.plainFlights.map(function () {
            return false;
        });
        $scope.$watch('vm.newDate', function () {
            checkSelected();
            updateBookingLimitsByFlight();
        }, true);
        backend.routeAvailabilityAdvanced(vm.orderInfo.plainFlights.map(function (flight) {
            return {
                cityA: flight.origincity,
                portA: flight.originport,
                cityB: flight.destinationcity,
                portB: flight.destinationport
            };
        })).then(function (resp) {
            vm.datesWithoutFlights = resp.map(function (data) {
                if (data.note === 'NO_INFORMATION_FOR_DIRECTION' && backend.getParam('search.disableAllDatesIfNoInformationForDirection')) {
                    return generateDatesWithoutFlightsList();
                } else {
                    return data.unavailableDates;
                }
            });
        });
        vm.orderExchangePossible = checkOrderExchangePossible(vm.exchangeAvailability, vm.flightsNearingForbidden);
    };

    function updateBookingLimitsByFlight() {
        vm.bookingLimitsByFlight = vm.flights.map(function (flight, flightNum) {
            var limits = backend.getSoftBookingLimits();
            if (flightNum > 0 && vm.newDate[flightNum - 1]) {
                limits.min = moment(vm.newDate[flightNum - 1], 'DD.MM.YYYY').add(1, 'days');
            }
            if (flightNum < vm.flights.length - 1 && vm.newDate[flightNum + 1]) {
                limits.max = moment(vm.newDate[flightNum + 1], 'DD.MM.YYYY').add(-1, 'days');
            }
            return limits;
        });
    }

    function submitHandler() {
        if (vm.validSelectedPassengerSegments) {
            if (vm.useSegmentsChain) {
                vm.submit(getSelectedPassengerSegmentChains());
            } else {
                vm.submit(getSelectedPassengerSegments());
            }
        }
    }

    function selectPaxHandler(flightNum) {
        vm.hasSelectedChildrenWithoutAdults[flightNum] = checkChildrenWithoutAdults(flightNum, true);
        vm.hasUnselectedChildrenWithoutAdults[flightNum] = checkChildrenWithoutAdults(flightNum, false);
        checkSelected();
    }

    function checkOrderExchangePossible(exchangeAvailability, flightsNearingForbidden) {
        var isPossible = false;
        flightsNearingForbidden.forEach(function (isFlightForbidden, flightNum) {
            if (!isFlightForbidden && exchangeAvailability[flightNum] && exchangeAvailability[flightNum].some(function (available) {
                return available === true;
            })) {
                isPossible = true;
            }
        });
        return isPossible;
    }

    function checkSelected() {
        var hasSelected = vm.useSegmentsChain ? Boolean(getSelectedPassengerSegmentChains().length) : Boolean(getSelectedPassengerSegments().length);
        vm.validSelectedPassengerSegments = hasSelected && vm.hasSelectedChildrenWithoutAdults.every(function (hasError) {
            return !hasError;
        }) && vm.hasUnselectedChildrenWithoutAdults.every(function (hasError) {
            return !hasError;
        });
    }

    function checkChildrenWithoutAdults(flightNum, isSelected) {
        var childCount = vm.orderInfo.passengers.filter(function (pax, paxNum) {
            return checkChild(pax) && vm.selectedState[flightNum][paxNum] === isSelected;
        }).length;
        var adultCount = vm.orderInfo.passengers.filter(function (pax, paxNum) {
            return vm.isAdultPassengerFlight[flightNum][paxNum] && vm.selectedState[flightNum][paxNum] === isSelected;
        }).length;
        if (childCount && !adultCount) {
            return true;
        } else {
            return false;
        }
    }

    function checkChild(pax) {
        return pax.categoryType === 'CHILD';
    }

    function getSelectedPassengerSegments() {
        var selectedPassengerSegments = [];
        vm.orderInfo.plainFlights.forEach(function (flight, flightNum) {
            if (vm.newDate[flightNum]) {
                vm.orderInfo.passengers.forEach(function (pax, paxNum) {
                    if (vm.selectedState[flightNum][paxNum]) {
                        selectedPassengerSegments.push({
                            passengerId: pax.id,
                            segmentId: flight.id,
                            date: vm.newDate[flightNum]
                        });
                        if (pax.child) {
                            selectedPassengerSegments.push({
                                passengerId: pax.child.id,
                                segmentId: flight.id,
                                date: vm.newDate[flightNum]
                            });
                        }
                    }
                });
            }
        });
        return selectedPassengerSegments;
    }

    function getSelectedPassengerSegmentChains() {
        var selectedPassengerSegmentChains = [];
        vm.orderInfo.flights.forEach(function (flight, flightNum) {
            if (vm.newDate[flightNum]) {
                vm.orderInfo.passengers.forEach(function (pax, paxNum) {
                    if (vm.selectedState[flightNum][paxNum]) {
                        selectedPassengerSegmentChains.push({
                            passengerId: pax.id,
                            chainId: flight.chainId,
                            date: vm.newDate[flightNum]
                        });
                        if (pax.child) {
                            selectedPassengerSegmentChains.push({
                                passengerId: pax.child.id,
                                chainId: flight.chainId,
                                date: vm.newDate[flightNum]
                            });
                        }
                    }
                });
            }
        });
        return selectedPassengerSegmentChains;
    }

    function generateDatesWithoutFlightsList() {
        var list = [];
        var bookingLimits = backend.getSoftBookingLimits();
        var date = moment(bookingLimits.min);
        while (date.isSameOrBefore(bookingLimits.max)) {
            list.push(date.format('DD.MM.YYYY'));
            date.add(1, 'days');
        }
        return list;
    }
}

},{}],469:[function(require,module,exports){
"use strict";

angular.module('app').component('extraServicesList', {
    templateUrl: 'components/extra-services-list/extra-services-list.html',
    controller: ['utils', ExtraServicesListController],
    controllerAs: 'vm',
    bindings: {
        es: '=es',
        list: '=list',
        locked: '=locked',
        submitTouched: '<'
    }
});

function ExtraServicesListController(utils) {

    var vm = this;
    vm.isCommonService = utils.isCommonServiceCode;
}

},{}],470:[function(require,module,exports){
"use strict";

angular.module('app').component('extraServicesRefundList', {
    templateUrl: 'components/extra-services-refund-list/extra-services-refund-list.html',
    controllerAs: 'vm',
    bindings: {
        svcsForRefundTitles: '=svcs',
        extraServicesSumm: '=sum',
        currency: '=currency',
        orderPrices: '=prices'
    }
});

},{}],471:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('facilitiesDocumentsUpload', {
    templateUrl: 'components/facilities-documents-upload/facilities-documents-upload.html',
    controller: ['$element', '$timeout', '$scope', 'backend', 'utils', FacilitiesDocumentsUploadController],
    controllerAs: 'vm',
    bindings: {
        config: '<',
        categoryId: '<',
        passengerIndex: '<',
        uploadedFiles: '<',
        onSuccessUpload: '&',
        hasPassengersWithoutScannedDocs: '<',
        submitButtonHover: '<'
    }
});

function FacilitiesDocumentsUploadController($element, $timeout, $scope, backend, utils) {

    var vm = this;

    vm.handleUploadConfirm = handleUploadConfirm;
    vm.handleUploadClick = handleUploadClick;
    vm.handleSelectFiles = handleSelectFiles;
    vm.handleRemoveFile = handleRemoveFile;

    vm.acceptedFileTypes = vm.config.allowedScannedDocExtensions.map(function (ext) {
        return '.' + ext;
    }).join(', ');

    var maxScannedDocSize = vm.config.maxScannedDocSizeMb * Math.pow(2, 20);

    $scope.$watch('vm.uploadedFiles', function () {
        $timeout(function () {
            if (vm.uploadedFiles && vm.uploadedFiles[0]) {
                vm.facilitiesAgreementClicked = true;
            }
        });
    });

    function handleUploadClick() {
        if (vm.uploadedFiles.length >= vm.config.maxScannedDocs) {
            return;
        }
        if (vm.selectedFiles && vm.selectedFiles[0] || vm.uploadedFiles && vm.uploadedFiles[0]) {
            handleUploadConfirm();
        } else {
            vm.showConfirmPopup = true;
        }
    }

    function handleUploadConfirm() {
        $timeout(function () {
            var inp = $element.find('input[type="file"]');
            inp.click();
        });
        vm.showConfirmPopup = false;
    }

    function handleSelectFiles() {

        if (vm.selectedFiles.length > vm.config.maxScannedDocs) {
            vm.showFormatErrorPopup = true;
            return;
        }

        vm.selectedFilesState = [].concat((0, _toConsumableArray3.default)(vm.selectedFiles)).filter(function (file) {
            var nameParts = file.name.split('.');
            var extension = nameParts && nameParts.length >= 2 && nameParts[nameParts.length - 1] && nameParts[nameParts.length - 1].toLowerCase();
            return file.size <= maxScannedDocSize && extension && utils.hasInList(vm.config.allowedScannedDocExtensions, extension);
        }).map(function (file) {
            return {
                file: file,
                name: file.name,
                status: 'upload'
            };
        });

        if (vm.selectedFiles.length !== vm.selectedFilesState.length) {
            vm.showFormatErrorPopup = true;
        }

        vm.selectedFilesState.forEach(function (fileState) {
            uploadFile(fileState.file, fileState.name, function (status) {
                fileState.status = status;
                if (status === 'success') {
                    vm.onSuccessUpload();
                }
            });
        });
    }

    function uploadFile(file, name, cb) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            backend.uploadScannedDoc(vm.passengerIndex, name, String(reader.result).replace(/data:(image|application)\/(\S+);base64/, '')).then(function () {
                cb('success');
            }, function () {
                cb('fail');
            });
        };
        reader.onerror = function (error) {
            cb('fail');
            console.log('Error: ', error);
        };
    }

    function handleRemoveFile(fileIndex) {
        backend.removeScannedDoc(vm.passengerIndex, fileIndex).then(vm.onSuccessUpload);
    }
}

},{"babel-runtime/helpers/toConsumableArray":11}],472:[function(require,module,exports){
"use strict";

angular.module('app').directive('fareGroupsVariantsSortSwitch', ['$document', function ($document) {

    function link(scope, element) {
        $document.on('click', function (event) {
            if (element.find(event.target).length) {
                scope.active = !scope.active;
            } else {
                scope.active = false;
            }
            scope.$apply();
        });
    }

    function variantsSortSwitchController($scope) {

        if ($scope.oneway) {
            $scope.types = ['price', 'flighttime', 'departuretime', 'arrivaltime'];
        } else {
            $scope.types = ['price', 'flighttime_0', 'flighttime_1', 'departuretime_0', 'departuretime_1', 'arrivaltime_0', 'arrivaltime_1'];
        }

        $scope.select = function (type) {
            $scope.selected = type;
        };
    }

    return {
        link: link,
        controller: ['$scope', variantsSortSwitchController],
        scope: {
            selected: '=selected',
            oneway: '=oneway'
        },
        restrict: 'E',
        templateUrl: 'components/fare-groups-variants-sort-switch/fare-groups-variants-sort-switch.html'
    };
}]);

},{}],473:[function(require,module,exports){
"use strict";

angular.module('app').directive('fileread', [function () {
    return {
        require: "ngModel",
        link: function postLink(scope, elem, attrs, ngModel) {
            elem.on("change", function () {
                ngModel.$setViewValue(elem[0].files);
            });
        }
    };
}]);

},{}],474:[function(require,module,exports){
"use strict";

angular.module('app').component('flightDatePicker', {
    templateUrl: 'components/flight-date-picker/flight-date-picker.html',
    controller: ['$element', '$timeout', '$window', '$scope', 'backend', 'utils', FlightDatePickerController],
    controllerAs: 'vm',
    bindings: {
        placeholder: '@',
        pickerindex: '@',
        role: '@',
        selected: '=',
        opposite: '=',
        limits: '<',
        datesWithoutFlights: '<',
        datePrices: '<',
        onSwitchMonth: '&',
        submitTouched: '='
    }
});

function FlightDatePickerController($element, $timeout, $window, $scope, backend, utils) {

    var vm = this;

    vm.openHandler = openHandler;
    vm.closeHandler = closeHandler;
    vm.clearHandler = clearHandler;
    vm.dayCellClickHandler = dayCellClickHandler;
    vm.switchMonthHandler = switchMonthHandler;
    vm.keydownHandler = keydownHandler;

    vm.weekdays = moment.weekdaysMin(true);

    $scope.$watch('vm.datePrices', function () {
        vm.hasDatePrices = !!_.keys(vm.datePrices).length;
        updateCalendar(vm.monthTables && vm.monthTables[0] && vm.monthTables[0].firstDay);
    }, true);

    function openHandler() {
        if (!vm.active) {
            updateCalendar();
            vm.submitTouched = false;
            vm.active = true;
            $timeout(function () {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            });
        }
    }

    function closeHandler() {
        if (vm.active) {
            vm.active = false;
            $timeout(function () {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            });
        }
    }

    function clearHandler() {
        vm.selected = false;
        closeHandler();
    }

    function dayCellClickHandler(day) {
        if (day.available) {
            vm.selected = day.value;
            var selectedMoment = moment(vm.selected, 'DD.MM.YYYY');
            var oppositeMoment = vm.opposite && moment(vm.opposite, 'DD.MM.YYYY');
            if (oppositeMoment && ((vm.role === 'there' || vm.role === 'from') && selectedMoment.isAfter(oppositeMoment) || (vm.role === 'back' || vm.role === 'to') && selectedMoment.isBefore(oppositeMoment))) {
                vm.opposite = vm.selected;
            }
            closeHandler();
        }
    }

    function switchMonthHandler(delta) {
        updateCalendar(vm.monthTables[0].firstDay.add(delta, 'month'));
        vm.onSwitchMonth({ $date: vm.monthTables[0].firstDay.format('DD.MM.YYYY') });
    }

    function keydownHandler(event) {
        if (event.key === 'Tab' || event.key === 'Escape') {
            closeHandler();
        }
    }

    function updateCalendar(startMoment) {
        vm.monthTables = generateMonthTables(vm.limits, vm.selected, vm.opposite, startMoment);
    }

    function generateMonthTables(limits, selected, opposite, startMoment) {

        var todayMoment = moment(backend.sessionParams.todayDate, 'DD.MM.YYYY');
        var selectedMoment = selected && moment(selected, 'DD.MM.YYYY');
        var oppositeMoment = opposite && moment(opposite, 'DD.MM.YYYY');
        startMoment = startMoment || moment.utc(selectedMoment || oppositeMoment || limits.min);
        var currentMoment = moment([startMoment.year(), startMoment.month()]);
        var result = [];

        for (var month = 0; month < 2; month++) {
            var monthRows = [];
            var monthName = currentMoment.format('MMMM, YYYY');
            var firstDay = angular.copy(currentMoment);

            while (checkMonthDelta(currentMoment.month(), startMoment.month(), month)) {
                var weekDayCells = [];
                for (var day = 0; day < 7; day++) {
                    if (currentMoment.weekday() === day && checkMonthDelta(currentMoment.month(), startMoment.month(), month)) {
                        var value = currentMoment.format('DD.MM.YYYY');
                        weekDayCells.push({
                            label: currentMoment.format('D'),
                            value: value,
                            available: isDateAvailable(currentMoment, limits),
                            today: currentMoment.isSame(todayMoment),
                            selected: selectedMoment && currentMoment.isSame(selectedMoment),
                            opposite: oppositeMoment && currentMoment.isSame(oppositeMoment),
                            interval: isDateInInterval(currentMoment, selectedMoment, oppositeMoment),
                            price: vm.datePrices && vm.datePrices[value],
                            withoutFlights: vm.datesWithoutFlights && utils.hasInList(vm.datesWithoutFlights, currentMoment.format('DD.MM.YYYY'))
                        });
                        currentMoment.add(1, 'days');
                    } else {
                        weekDayCells.push({ empty: true });
                    }
                }
                monthRows.push(weekDayCells);
            }

            result.push({
                monthRows: monthRows,
                monthName: monthName,
                firstDay: firstDay,
                firstDayAvailable: isDateAvailable(firstDay, limits),
                lastDayAvailable: isDateAvailable(currentMoment, limits)
            });
        }

        return result;
    }

    function isDateAvailable(date, limits) {
        var min = limits.min.utcOffset('-12:00').format('YYYY-MM-DD');
        var max = limits.max.utcOffset('+12:00').format('YYYY-MM-DD');
        return moment(date.format('YYYY-MM-DD')).isSameOrBefore(max, 'day') && moment(date.format('YYYY-MM-DD')).isSameOrAfter(min, 'day');
    }

    function isDateInInterval(date, a, b) {
        if (!a || !b) {
            return false;
        }
        if (a.isBefore(b)) {
            return date.isAfter(a) && date.isBefore(b);
        } else if (b.isBefore(a)) {
            return date.isAfter(b) && date.isBefore(a);
        } else {
            return false;
        }
    }

    function checkMonthDelta(currentMonth, startMonth, delta) {
        // Продолжаем пока текущий месяц на delta позже начала
        var limit = startMonth + delta;
        if (limit >= 12) {
            limit -= 12;
        }
        return currentMonth === limit;
    }

    function checkOutsideClick(event) {
        if (vm.active && !isChildNode(event.target)) {
            closeHandler();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }
}

},{}],475:[function(require,module,exports){
"use strict";

angular.module('app').component('flightRoad', {
    templateUrl: 'components/flight-road/flight-road.html',
    controller: [flightRoadController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order'
    }
});

function flightRoadController() {

    var vm = this;

    vm.openBrandDetails = openBrandDetails;
    vm.closeBrandDetails = closeBrandDetails;

    function openBrandDetails(code) {
        vm.brandDetailsCode = code;
    }

    function closeBrandDetails() {
        vm.brandDetailsCode = false;
    }
}

},{}],476:[function(require,module,exports){
"use strict";

angular.module('app').directive('formSubmitErrorHighlight', ['$timeout', '$window', function ($timeout, $window) {
    return {
        restrict: 'A',
        link: function link(scope, elem) {
            elem.on('submit', function () {
                if (elem.hasClass('ng-invalid')) {
                    $timeout(function () {
                        var firstErrorElement = elem.find('.textInp_error:first'),
                            offset = firstErrorElement.offset(),
                            padding = 100;
                        firstErrorElement.focus();
                        $window.scrollTo(0, offset.top - padding);
                    });
                }
            });
        }
    };
}]);

},{}],477:[function(require,module,exports){
"use strict";

angular.module('app').component('geoMarkerCode', {
    templateUrl: 'components/geo-marker-code/geo-marker-code.html',
    controller: [GeoMarkerController],
    controllerAs: 'vm',
    bindings: {
        prefix: '@prefix',
        key: '@key',
        city: '<',
        port: '<'
    }
});

function GeoMarkerController() {}

},{}],478:[function(require,module,exports){
"use strict";

angular.module('app').component('geoMarkerWrapper', {
    templateUrl: 'components/geo-marker-wrapper/geo-marker-wrapper.html',
    controller: ['$rootScope', GeoMarkerWrapperController],
    controllerAs: 'vm',
    bindings: {
        prefix: '@prefix',
        key: '@key',
        cityinfo: '=cityinfo'
    }
});

function GeoMarkerWrapperController($rootScope) {

    var vm = this;

    vm.getCityName = getCityName;
    vm.getCityCode = getCityCode;
    vm.getPortName = getPortName;
    vm.getPortCode = getPortCode;

    function getCityName(cityinfo) {
        if (cityinfo) {
            return cityinfo[$rootScope.localNamePropName];
        }
    }

    function getCityCode(cityinfo) {
        if (cityinfo) {
            return cityinfo.codeEn;
        }
    }

    function getPortName(cityinfo) {
        if (cityinfo) {
            return getPort(cityinfo)[$rootScope.localNamePropName];
        }
    }

    function getPortCode(cityinfo) {
        if (cityinfo) {
            return getPort(cityinfo).codeEn;
        }
    }

    function getPort(cityinfo) {
        var i = void 0;
        if (cityinfo) {
            if (cityinfo.airports) {
                for (i = 0; i < cityinfo.airports.length; i++) {
                    if (cityinfo.airports[i].selected) {
                        return cityinfo.airports[i];
                    }
                }
            }
            return cityinfo;
        }
    }
}

},{}],479:[function(require,module,exports){
"use strict";

angular.module('app').component('geoMarker', {
    templateUrl: 'components/geo-marker/geo-marker.html',
    controller: [GeoMarkerController],
    controllerAs: 'vm',
    bindings: {
        prefix: '@prefix',
        key: '@key',
        cityName: '=cityname',
        city: '=city',
        portName: '=portname',
        port: '=port'
    }
});

function GeoMarkerController() {}

},{}],480:[function(require,module,exports){
"use strict";

angular.module('app').component('geoWarning', {
    templateUrl: 'components/geo-warning/geo-warning.html',
    controller: ['$rootScope', '$scope', '$cookies', 'backend', 'geo', GeoWarningController],
    controllerAs: 'vm'
});

function GeoWarningController($rootScope, $scope, $cookies, backend, geo) {
    var vm = this;

    vm.countryByIpCookie = $cookies.get('COUNTRY_BY_IP');
    vm.userCountryIsoCode = '';
    vm.userCountry = '';

    vm.close = close;
    vm.agree = agree;
    vm.disAgree = disAgree;

    backend.ready.then(function () {
        $scope.localNamePropName = backend.sessionParams.localNamePropName;
    });

    geo().init().then(function (geoAutodetectData) {
        vm.userCountryIsoCode = geoAutodetectData.userCountryIsoCode;
        vm.userCountry = geoAutodetectData.userCountry;
        vm.active = isActive();

        $scope.$apply();
    }).catch(function (err) {
        // eslint-disable-next-line
        console.error(err);

        var now = new Date();
        var exp = new Date(now.getFullYear() + 10, now.getMonth(), now.getDate());

        $cookies.put('COUNTRY_BY_IP', 'ERROR', exp);
    });

    function close() {
        vm.active = false;
    }

    function agree() {
        vm.close();

        geo().confirmCountryDetection({
            isoCode: vm.userCountryIsoCode,
            userAgreed: true,
            detectedAutomatically: true
        });
    }

    function disAgree() {
        vm.close();
    }

    function isActive() {
        return typeof vm.countryByIpCookie === 'undefined';
    }
}

},{}],481:[function(require,module,exports){
"use strict";

angular.module('app').component('groupedServicesList', {
    templateUrl: 'components/grouped-services-list/grouped-services-list.html',
    controller: ['utils', 'backend', GroupedServicesListController],
    controllerAs: 'vm',
    bindings: {
        mode: '@mode',
        orderInfo: '=order'
    }
});

function GroupedServicesListController(utils, backend) {

    var vm = this;

    vm.suffixCount = utils.suffixCount;
    vm.isCommonService = utils.isCommonServiceCode;
    vm.getAffectedFlightsByIds = getAffectedFlightsByIds;
    vm.removeService = removeService;

    function getAffectedFlightsByIds(affectedSegmentIds) {
        return affectedSegmentIds.map(function (id) {
            return _.findWhere(vm.orderInfo.plainFlights, { id: id });
        });
    }

    function removeService(serviceCode, item, passenger_id, segment_id) {
        if (serviceCode == 'insurance' && item.productCode) {
            serviceCode = 'insuranceOnline';
        }
        backend.removeExtraService({
            code: serviceCode,
            passenger_id: passenger_id,
            segment_id: segment_id,
            subgroup: item.subgroupCode,
            rfisc: item.rfisc
        }, false, true);
    }
}

},{}],482:[function(require,module,exports){
"use strict";

angular.module('app').directive('hideOnError', function () {
    return {
        link: function link(scope, element) {
            element.bind('error', function () {
                element[0].style.display = 'none';
            });
        }
    };
});

},{}],483:[function(require,module,exports){
"use strict";

angular.module('app').directive('iincheck', ['iinUtils', 'backend', function (iinUtils, backend) {
    return {
        require: 'ngModel',
        scope: {
            pax: '=iincheck'
        },
        link: function link(scope, elm, attrs, ctrl) {
            if (!ctrl) {
                return;
            }

            ctrl.$parsers.unshift(validate);
            ctrl.$formatters.unshift(validate);

            function validate(value) {
                var isValid = !value || (scope.pax ? iinUtils.isValidIinForPax(value, scope.pax.gender, scope.pax.dateOfBirth) : iinUtils.isValidIin(value));
                ctrl.$setValidity('iincheck', isValid);
                if (isValid) {
                    delete ctrl.$error.customMessage;
                } else {
                    ctrl.$error.customMessage = backend.getAliasDynamic('web.extraServices.insurance.invalidIinMessage');
                }
                return value;
            }
        }
    };
}]);

},{}],484:[function(require,module,exports){
"use strict";

require('./app-header/appHeader');
require('./app-header-currency/appHeaderCurrency');
require('./app-header-language/appHeaderLanguage');
require('./app-header-private/appHeaderPrivate');
require('./app-footer/appFooter');
require('./app-loader/appLoader');
require('./app-modals/appModals');

require('./modal-loader/modalLoader');

require('./search-schedule-form/searchScheduleForm');
require('./info-box/infoBox');
require('./search-mono-brand-cartesian-variants/searchMonoBrandCartesianVariants');
require('./search-pricing-route-and-mono-brand-variants/searchPricingRouteAndMonoBrandVariants');
require('./search-variants/searchVariants');
require('./search-fare-group-variants/searchFareGroupVariants');
require('./search-ffp-variants/searchFfpVariants');
require('./search-schedule-variants/searchScheduleVariants');
require('./selected-variant/selectedVariant');
require('./dropdown-picker/dropdownPicker');

require('./error-highlight/errorHighlight');
require('./form-submit-error-highlight/formSubmitErrorHighlight');
require('./error-message/errorMessage');
require('./error-message-sensitive/errorMessageSensitive');
require('./info-message/infoMessage');

require('./clean-document-number/cleanDocumentNumber');
require('./clean-search-order-param/cleanSearchOrderParam');
require('./clean-search-order-param-last-name/cleanSearchOrderParamLastName');

require('./variants-sort-switch/variantsSortSwitch');
require('./fare-groups-variants-sort-switch/fareGroupsVariantsSortSwitch');
require('./cart-widget/cartWidget');
require('./order/order');
require('./order-prices/orderPrices');
require('./order-billing/orderBilling');
require('./order-passenger-documents/orderPassengerDocuments');
require('./flight-road/flightRoad');
require('./order-ffp-prices/orderFfpPrices');
require('./modal-link/modalLink');
require('./custom-scroll/customScroll');
require('./captcha/captcha');
require('./recaptcha/recaptcha');
require('./brand-prop/brandProp');
require('./seat-map-base/seatMapBase');
require('./seat-map-error/seatMapError');
require('./seat-map-svg/seatMapSvg');
require('./seat-map-svg-legend-chair/seatMapSvgLegendChair');
require('./extra-services-refund-list/extraServicesRefundList');
require('./grouped-services-list/groupedServicesList');

require('./extra-services-list/extraServicesList');

require('./payment-variant-select/paymentVariantSelect');
require('./payment-system-images/paymentSystemImages');
require('./payment-frame/paymentFrame');

require('./ui-select-custom/uiSelectCustom');
require('./route-desc/routeDesc');
require('./route-desc-cart-widget/routeDescCartWidget');
require('./route-desc-short/routeDescShort');

require('./geo-marker/geoMarker');
require('./geo-marker-wrapper/geoMarkerWrapper');
require('./geo-marker-code/geoMarkerCode');

require('./separate-order-passengers-list/separateOrderPassengersList');
require('./brand-props-info/brandPropsInfo');
require('./ui-select-main-page/uiSelectMainPage');
require('./private-profile-menu/privateProfileMenu');
require('./payment-card/paymentCard');
require('./segment-prices-calendar/segmentPricesCalendar');
require('./smart-button/smartButton');
require('./svg-sprite-icon/svgSpriteIcon');

require('./search-form/searchForm');
require('./city-picker/cityPicker');
require('./passenger-calc/passengerCalc');
require('./passenger-calc-line/passengerCalcLine');
require('./flight-date-picker/flightDatePicker');
require('./passenger-type-select/passengerTypeSelect');

require('./es-common/esCommon');
require('./es-baggage/esBaggage');
require('./es-seat/esSeat');
require('./es-seat-link/esSeatLink');
require('./es-meal/esMeal');
require('./es-insurance/esInsurance');
require('./es-aeroexpress/esAeroexpress');
require('./es-sms-notification/esSmsNotification');
require('./service-picker/servicePicker');

require('./exchange-flight-select/exchangeFlightSelect');
require('./exchange-request-form/exchangeRequestForm');
require('./exchange-price-select/exchangePriceSelect');

require('./search-order-redirect-form/searchOrderRedirectForm');

require('./hide-on-error/hideOnError');
require('./private-passenger-form/privatePassengerForm');
require('./private-passenger-document/privatePassengerDocument');
require('./facilities-documents-upload/facilitiesDocumentsUpload');
require('./fileread/fileread');
require('./sms-notification-select-form/smsNotificationSelectForm');
require('./popup-insurance-select/popupInsuranceSelect');

require('./dynamic-parent-padding/dynamicParentPadding');

require('./airline-logo/airlineLogo');
require('./booking-steps-select/bookingStepsSelect');
require('./price-chart-by-day/priceChartByDay');

require('./geo-warning/geoWarning');
require('./cookie-warning/cookieWarning');

require('./iincheck/iincheck');
require('./smart-captcha/smartCaptcha');

require('./app-banner/appBanner');
require('./check-password/checkPassword');
require('./personal-wheelchair-select/personalWheelchairSelect');
require('./clean-only-number/cleanOnlyNumber');

},{"./airline-logo/airlineLogo":431,"./app-banner/appBanner":432,"./app-footer/appFooter":433,"./app-header-currency/appHeaderCurrency":434,"./app-header-language/appHeaderLanguage":435,"./app-header-private/appHeaderPrivate":436,"./app-header/appHeader":437,"./app-loader/appLoader":438,"./app-modals/appModals":439,"./booking-steps-select/bookingStepsSelect":440,"./brand-prop/brandProp":441,"./brand-props-info/brandPropsInfo":442,"./captcha/captcha":443,"./cart-widget/cartWidget":444,"./check-password/checkPassword":445,"./city-picker/cityPicker":446,"./clean-document-number/cleanDocumentNumber":447,"./clean-only-number/cleanOnlyNumber":448,"./clean-search-order-param-last-name/cleanSearchOrderParamLastName":449,"./clean-search-order-param/cleanSearchOrderParam":450,"./cookie-warning/cookieWarning":451,"./custom-scroll/customScroll":452,"./dropdown-picker/dropdownPicker":453,"./dynamic-parent-padding/dynamicParentPadding":454,"./error-highlight/errorHighlight":455,"./error-message-sensitive/errorMessageSensitive":456,"./error-message/errorMessage":457,"./es-aeroexpress/esAeroexpress":458,"./es-baggage/esBaggage":459,"./es-common/esCommon":460,"./es-insurance/esInsurance":461,"./es-meal/esMeal":462,"./es-seat-link/esSeatLink":463,"./es-seat/esSeat":464,"./es-sms-notification/esSmsNotification":465,"./exchange-flight-select/exchangeFlightSelect":466,"./exchange-price-select/exchangePriceSelect":467,"./exchange-request-form/exchangeRequestForm":468,"./extra-services-list/extraServicesList":469,"./extra-services-refund-list/extraServicesRefundList":470,"./facilities-documents-upload/facilitiesDocumentsUpload":471,"./fare-groups-variants-sort-switch/fareGroupsVariantsSortSwitch":472,"./fileread/fileread":473,"./flight-date-picker/flightDatePicker":474,"./flight-road/flightRoad":475,"./form-submit-error-highlight/formSubmitErrorHighlight":476,"./geo-marker-code/geoMarkerCode":477,"./geo-marker-wrapper/geoMarkerWrapper":478,"./geo-marker/geoMarker":479,"./geo-warning/geoWarning":480,"./grouped-services-list/groupedServicesList":481,"./hide-on-error/hideOnError":482,"./iincheck/iincheck":483,"./info-box/infoBox":485,"./info-message/infoMessage":486,"./modal-link/modalLink":487,"./modal-loader/modalLoader":488,"./order-billing/orderBilling":489,"./order-ffp-prices/orderFfpPrices":490,"./order-passenger-documents/orderPassengerDocuments":491,"./order-prices/orderPrices":492,"./order/order":493,"./passenger-calc-line/passengerCalcLine":494,"./passenger-calc/passengerCalc":495,"./passenger-type-select/passengerTypeSelect":496,"./payment-card/paymentCard":497,"./payment-frame/paymentFrame":498,"./payment-system-images/paymentSystemImages":499,"./payment-variant-select/paymentVariantSelect":500,"./personal-wheelchair-select/personalWheelchairSelect":501,"./popup-insurance-select/popupInsuranceSelect":502,"./price-chart-by-day/priceChartByDay":503,"./private-passenger-document/privatePassengerDocument":504,"./private-passenger-form/privatePassengerForm":505,"./private-profile-menu/privateProfileMenu":506,"./recaptcha/recaptcha":507,"./route-desc-cart-widget/routeDescCartWidget":508,"./route-desc-short/routeDescShort":509,"./route-desc/routeDesc":510,"./search-fare-group-variants/searchFareGroupVariants":511,"./search-ffp-variants/searchFfpVariants":512,"./search-form/searchForm":513,"./search-mono-brand-cartesian-variants/searchMonoBrandCartesianVariants":514,"./search-order-redirect-form/searchOrderRedirectForm":515,"./search-pricing-route-and-mono-brand-variants/searchPricingRouteAndMonoBrandVariants":516,"./search-schedule-form/searchScheduleForm":517,"./search-schedule-variants/searchScheduleVariants":518,"./search-variants/searchVariants":519,"./seat-map-base/seatMapBase":520,"./seat-map-error/seatMapError":521,"./seat-map-svg-legend-chair/seatMapSvgLegendChair":522,"./seat-map-svg/seatMapSvg":523,"./segment-prices-calendar/segmentPricesCalendar":524,"./selected-variant/selectedVariant":525,"./separate-order-passengers-list/separateOrderPassengersList":526,"./service-picker/servicePicker":527,"./smart-button/smartButton":528,"./smart-captcha/smartCaptcha":529,"./sms-notification-select-form/smsNotificationSelectForm":530,"./svg-sprite-icon/svgSpriteIcon":531,"./ui-select-custom/uiSelectCustom":532,"./ui-select-main-page/uiSelectMainPage":533,"./variants-sort-switch/variantsSortSwitch":534}],485:[function(require,module,exports){
"use strict";

angular.module('app').component('infoBox', {
    templateUrl: 'components/info-box/info-box.html',
    controller: [function () {}],
    controllerAs: 'vm',
    bindings: {
        val: '='
    }
});

},{}],486:[function(require,module,exports){
"use strict";

angular.module('app').component('infoMessage', {
    templateUrl: 'components/info-message/info-message.html',
    controllerAs: 'vm',
    bindings: {
        control: '=control',
        formatAlias: '='
    }
});

},{}],487:[function(require,module,exports){
"use strict";

angular.module('app').directive('modalLink', ['modalTools', function (modalTools) {
    return {
        restrict: 'A',
        scope: {
            modalLink: '@'
        },
        link: function link($scope, element) {
            element.bind('click', function (event) {
                event.preventDefault();
                modalTools.openHandler($scope.modalLink, element);
            });
        }
    };
}]);

},{}],488:[function(require,module,exports){
"use strict";

angular.module('app').directive('modalLoader', ['backend', function (backend) {

    function link(scope, element) {
        var alias = backend.getAlias('web.modalLoader');
        element.html('<div class="modalLoaderWrap">' + alias + '</div>');
    }

    return {
        link: link,
        restrict: 'E',
        templateUrl: 'components/modal-loader/modal-loader.html'
    };
}]);

},{}],489:[function(require,module,exports){
"use strict";

angular.module('app').component('orderBilling', {
    templateUrl: 'components/order-billing/order-billing.html',
    controller: ['$scope', 'backend', OrderBillingController],
    controllerAs: 'vm',
    bindings: {
        mode: '@mode',
        label: '@',
        orderInfo: '<order',
        onlyAddServices: '<'
    }
});

function OrderBillingController($scope, backend) {

    var vm = this;
    vm.dropState = backend.getParam('site.expandOrderPricesAccordion');
    $scope.$watch('vm.orderInfo', function (orderInfo) {
        if (orderInfo[vm.mode]) {
            vm.extraServicesPricesList = _.keys(orderInfo[vm.mode].totalExtraServiceByGroup).map(function (groupCode) {
                return {
                    groupCode: groupCode,
                    value: orderInfo[vm.mode].totalExtraServiceByGroup[groupCode],
                    currency: orderInfo[vm.mode].currency
                };
            });
        }
    });
}

},{}],490:[function(require,module,exports){
"use strict";

angular.module('app').component('orderFfpPrices', {
    templateUrl: 'components/order-ffp-prices/order-ffp-prices.html',
    controller: [OrderPricesController],
    controllerAs: 'vm',
    bindings: {
        ffpSumm: '=summ',
        ffpBonus: '=bonus'
    }
});

function OrderPricesController() {}

},{}],491:[function(require,module,exports){
"use strict";

angular.module('app').component('orderPassengerDocuments', {
    templateUrl: 'components/order-passenger-documents/order-passenger-documents.html',
    controller: ['$scope', 'ffpTools', orderPassengerDocumentsController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        ffpBonus: '=bonus'
    }
});

function orderPassengerDocumentsController($scope, ffpTools) {

    var vm = this;
    vm.openInfantParentModal = openInfantParentModal;
    vm.tryCropBonusCardFullToShort = ffpTools.tryCropBonusCardFullToShort;
    vm.showInfantParentModalForPax = -1;

    $scope.$watch('vm.orderInfo', function (orderInfo) {
        vm.btnInfantParentShow = checkInfantParentBtn(orderInfo);
    });

    function openInfantParentModal(paxId) {
        vm.showInfantParentModalForPax = paxId;
    }

    function checkInfantParentBtn(orderInfo) {
        var currentMoment = moment.utc(o2context.serverDateTime);
        return orderInfo && orderInfo.passengers && orderInfo.passengers.length && orderInfo.passengers.filter(function (pax) {
            return pax.categoryType === 'ADULT';
        }).length > 1 && orderInfo.plainFlights.some(function (flight) {
            var flightMoment = moment.utc(flight.departureDateTimeUTC);
            return flightMoment.isAfter(currentMoment);
        }) && orderInfo.header && orderInfo.header.status && orderInfo.header.status === 'paid';
    }
}

},{}],492:[function(require,module,exports){
"use strict";

angular.module('app').component('orderPrices', {
    templateUrl: 'components/order-prices/order-prices.html',
    controller: [OrderPricesController],
    controllerAs: 'vm',
    bindings: {
        mode: '@mode',
        orderInfo: '=order'
    }
});

function OrderPricesController() {}

},{}],493:[function(require,module,exports){
"use strict";

angular.module('app').component('order', {
    templateUrl: 'components/order/order.html',
    controller: ['$scope', '$window', '$timeout', '$location', 'backend', 'utils', 'redirect', 'modalTools', 'uniqueTabIdGenerator', OrderController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '='
    }
});

function OrderController($scope, $window, $timeout, $location, backend, utils, redirect, modalTools, uniqueTabIdGenerator) {

    var vm = this;
    var path = $location.path();

    vm.loading = true;
    vm.errorMessage = false;
    vm.fatalError = false;
    vm.choosePayMethodFailMsg = false;
    vm.tabId = uniqueTabIdGenerator();
    vm.openExchange = redirect.goToExchange;
    vm.openRefund = redirect.goToRefund;
    vm.openAddServices = redirect.goToAddServices;
    vm.suffixCount = utils.suffixCount;

    vm.retryPayment = retryPayment;
    vm.bindOrder = bindOrder;
    vm.clearSession = clearSession;
    vm.newBooking = newBooking;

    vm.isPrivateScreen = path.indexOf('private') !== -1;

    $scope.$on('popupChoosePayMethodChoosePayMethodFailMsg', function (event, data) {
        vm.choosePayMethodFailMsg = data;
    });

    $scope.$on('popupChoosePayMethodPending', function (event, data) {
        vm.popupChoosePayMethodPending = data;
    });

    vm.$onInit = function () {

        var waitPaymentStarted = false;

        if (vm.orderInfo.hasFailedServices) {
            openRemovedServicesWarningByOrder();
        } else {
            if (vm.orderInfo.paymentRedirectTo) {
                vm.showPaymentFrame = true;
            } else if (vm.orderInfo.canCheckPaymentStatus) {
                startWaitPaymentLoop();
                waitPaymentStarted = true;
            }
        }

        if (!waitPaymentStarted) {
            vm.loading = false;
        }

        if (backend.getParam('ffp.enable') && (vm.orderInfo.hasBonusCard || vm.orderInfo.ffpSumm)) {
            backend.ffpBonus().then(function (resp) {
                vm.ffpBonus = resp.total || 0;
            });
        }

        backend.addOrderInfoListener(function (orderInfo) {
            vm.orderInfo = orderInfo;
            vm.orderServicesLoading = false;
        });

        backend.addExtraServiceListener(function (state) {
            vm.modifyServicesLoading = !state;
            vm.orderServicesLoading = true;
        });

        backend.addExtraServiceErrorListener(function (resp) {
            vm.errorMessage = resp.error;
            vm.modifyServicesLoading = false;
            vm.orderServicesLoading = false;
        });
    };

    $scope.$watch('vm.orderInfo', function (orderInfo) {
        vm.btnFfpPopupShow = checkShowFfpBtn(orderInfo);
    });

    function openRemovedServicesWarningByOrder() {
        $timeout(function () {
            modalTools.openHandler('popup-removed-services-warning-by-order', false, {
                submitCallback: function submitCallback() {
                    if (vm.orderInfo.paymentRedirectTo) {
                        vm.showPaymentFrame = true;
                    }
                    vm.ignoreFailedServices = true;
                },

                disableOutsideCloseClick: true
            });
        });
    }

    function startWaitPaymentLoop() {
        backend.waitPayment(vm.orderInfo.header.regnum, vm.orderInfo.header.lastName).then(function () {
            $window.location = './order?pnr=' + vm.orderInfo.header.regnum + '&lastName=' + vm.orderInfo.header.lastName + '&result=success';
            return;
        }, function () {
            vm.loading = false;
        });
    }

    function retryPayment(removeInsuranceAeroexpress) {
        vm.loading = true;
        backend.retryRegister(removeInsuranceAeroexpress).then(function (resp) {
            if (resp.pnr && resp.lastName) {
                $window.location = './order?pnr=' + resp.pnr + '&lastName=' + resp.lastName;
            } else if (resp.eraseAeroexpressBecauseOfCurrency || resp.eraseInsuranceBecauseOfCurrency) {
                modalTools.openHandler('popup-change-currency-error', false, {
                    eraseAeroexpressBecauseOfCurrency: resp.eraseAeroexpressBecauseOfCurrency,
                    eraseInsuranceBecauseOfCurrency: resp.eraseInsuranceBecauseOfCurrency,
                    mode: 'retryRegister',
                    submitCallback: retryPayment
                });
            }
            vm.loading = false;
        }, function (resp) {
            vm.loading = false;
            vm.fatalError = resp.error;
        });
    }
    function bindOrder() {
        if (!vm.orderInfo.header || !vm.orderInfo.header.regnum || !vm.orderInfo.header.lastName) {
            return;
        }
        vm.loading = true;
        backend.bindOrder(vm.orderInfo.header.regnum, vm.orderInfo.header.lastName).then(function () {
            vm.loading = false;
            vm.orderInfo.bindAlowed = false;
            vm.showBindOrderSuccessMessage = true;
            $timeout(function () {
                vm.showBindOrderSuccessMessage = false;
            }, 10000);
        }, function () {
            vm.loading = false;
            vm.showBindOrderFailMessage = true;
            $timeout(function () {
                vm.showBindOrderFailMessage = false;
            }, 10000);
        });
    }

    function clearSession() {
        backend.clearSession().finally(goToFirstStepWithReload);
    }

    function newBooking() {
        backend.clearLastSearchParams().then(backend.clearOrderFromSession).finally(goToFirstStepWithReload);
    }

    function goToFirstStepWithReload() {
        $window.location = backend.getAlias('web.site.firstStepUrl');
    }

    function checkShowFfpBtn(orderInfo) {
        var allowBonusCard = backend.getParam('passengers.allowBonusCard') && !orderInfo.ffpSumm;
        var allowBonusCardsForChildren = backend.getParam('passengers.allowBonusCardsForChildren') && !orderInfo.ffpSumm;
        var hasPassengersWithoutFfpCard = orderInfo.passengers.some(function (passenger) {
            return !passenger.bonusCard && (!utils.checkIsPassengerChildForBonusCard(passenger) && allowBonusCard || utils.checkIsPassengerChildForBonusCard(passenger) && allowBonusCardsForChildren);
        });
        if (allowBonusCard && orderInfo && orderInfo.passengers && orderInfo.passengers.length && orderInfo.header && orderInfo.header.status && hasPassengersWithoutFfpCard && orderInfo.header.status !== 'ticket_returned' && orderInfo.header.status !== 'cancelled' && orderInfo.header.status !== 'being_paid' && orderInfo.header.status !== 'booked') {
            return true;
        }
        return false;
    }
}

},{}],494:[function(require,module,exports){
"use strict";

angular.module('app').component('passengerCalcLine', {
    templateUrl: 'components/passenger-calc-line/passenger-calc-line.html',
    controller: ['$timeout', '$window', '$element', 'backend', PassengerCalcLineController],
    controllerAs: 'vm',
    bindings: {
        role: '<',
        searchGroupId: '<',
        count: '<',
        canPlus: '<',
        canMinus: '<',
        onChange: '&'
    }
});

function PassengerCalcLineController($timeout, $window, $element, backend) {

    var vm = this;

    vm.increase = increase;
    vm.decrease = decrease;

    vm.$onInit = function () {
        var disabledMessageAlias = 'web.searchForm.passengerCategoryDisabledMessage.' + vm.searchGroupId + '.' + vm.role;
        if (!vm.canMinus && !vm.canPlus && backend.hasAlias(disabledMessageAlias)) {
            vm.showDisabledMessage = true;
        } else {
            vm.showDisabledMessage = false;
        }
    };

    function increase() {
        if (vm.canPlus) {
            vm.onChange({ $delta: +1 });
            var icreaseMessageAlias = 'web.searchForm.passengerCategoryIcreaseMessage.' + vm.searchGroupId + '.' + vm.role;
            if (backend.hasAlias(icreaseMessageAlias) && !vm.showIcreaseMessage) {
                switchIcreaseMessage();
            }
        }
    }

    function decrease() {
        if (vm.canMinus) {
            vm.onChange({ $delta: -1 });
        }
    }

    function switchIcreaseMessage() {
        vm.showIcreaseMessage = !vm.showIcreaseMessage;
        $timeout(function () {
            if (vm.showIcreaseMessage) {
                $window.document.documentElement.addEventListener('click', checkOutsidePlusClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsidePlusClick);
            }
        });
    }

    function checkOutsidePlusClick(event) {
        if (vm.showIcreaseMessage && !isChildPlusNode(event.target)) {
            switchIcreaseMessage();
        }
    }

    function isChildPlusNode(node) {
        return jQuery('a.passenger-count__plus', $element[0])[0].contains(node);
    }
}

},{}],495:[function(require,module,exports){
"use strict";

angular.module('app').component('passengerCalc', {
    templateUrl: 'components/passenger-calc/passenger-calc.html',
    controller: ['$window', '$scope', '$timeout', '$element', 'utils', 'backend', PasssengerCalcController],
    controllerAs: 'vm',
    bindings: {
        searchGroupConfig: '<',
        countByCategories: '=',
        isBusiness: '=business',
        error: '='
    }
});

function PasssengerCalcController($window, $scope, $timeout, $element, utils, backend) {

    var vm = this;

    vm.switchState = switchState;
    vm.changeCountHandler = changeCountHandler;

    $scope.$watch('vm.countByCategories', function () {
        updateTotalPassCountStr();
        updateErrorState();
    });

    vm.showFlightClass = backend.getParam('search.searchVariantsMode') === 'PRICING_ROUTE_SIMPLE' && !backend.getParam('pricing.useFareGroup');

    function updateTotalPassCountStr() {
        vm.totalPassCountStr = utils.suffixCount(getTotalPassCount(), backend.getAlias('web.searchForm.passengerCalcTotal'));
    }

    function updateErrorState() {
        vm.error = getErrorState();
    }

    function getErrorState() {
        var _vm$searchGroupConfig = vm.searchGroupConfig,
            conditions = _vm$searchGroupConfig.conditions,
            id = _vm$searchGroupConfig.id;

        if (!checkValidStateBySeatsCount()) {
            return 'invalidBySeatsCout';
        }
        for (var i = 0; i < conditions.length; i++) {
            if (checkValidStateByCondition(conditions[i])) {
                return false;
            }
        }
        return 'invalidBySearchGroupConditions.' + id;
    }

    function checkValidStateByCondition(condition) {
        var total = getTotalPassCount();
        if (condition.total && (total < condition.total.min || total > condition.total.max)) {
            return false;
        }
        return true;
    }

    function checkValidStateBySeatsCount() {
        var totalWithSeats = getTotalPassCountWithSeats();
        var totalWithoutSeats = getTotalPassCountWithoutSeats();
        return totalWithSeats >= totalWithoutSeats;
    }

    function switchState() {
        vm.active = !vm.active;
        $timeout(function () {
            if (vm.active) {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            }
        });
    }

    function changeCountHandler(categoryState, delta) {
        categoryState.val = categoryState.val + delta;
        categoryState.canMinus = categoryState.val > categoryState.total.min;
        categoryState.canPlus = categoryState.val < categoryState.total.max;
        updateTotalPassCountStr();
        updateErrorState();
    }

    function getTotalPassCount() {
        var totalPassCount = 0;
        vm.countByCategories.forEach(function (categoryState) {
            totalPassCount += categoryState.val;
        });
        return totalPassCount;
    }

    function getTotalPassCountWithoutSeats() {
        var totalPassCount = 0;
        vm.countByCategories.forEach(function (categoryState) {
            if (categoryState.frontEndType === 'INFANT_WITHOUT_SEAT') {
                totalPassCount += categoryState.val;
            }
        });
        return totalPassCount;
    }

    function getTotalPassCountWithSeats() {
        var totalPassCount = 0;
        vm.countByCategories.forEach(function (categoryState) {
            if (categoryState.frontEndType === 'ADULT' || categoryState.frontEndType === 'RETIREE' || categoryState.frontEndType === 'YOUNG_ADULT') {
                totalPassCount += categoryState.val;
            }
        });
        return totalPassCount;
    }

    function checkOutsideClick(event) {
        if (vm.active && !isChildNode(event.target)) {
            switchState();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }
}

},{}],496:[function(require,module,exports){
"use strict";

angular.module('app').component('passengerTypeSelect', {
    templateUrl: 'components/passenger-type-select/passenger-type-select.html',
    controller: ['$window', '$timeout', '$element', PassengerTypeSelectController],
    controllerAs: 'vm',
    bindings: {
        options: '<',
        selected: '<',
        onSelect: '&'
    }
});

function PassengerTypeSelectController($window, $timeout, $element) {
    var vm = this;

    vm.switchState = switchState;
    vm.selectHandler = selectHandler;

    function selectHandler(option) {
        vm.onSelect({ $option: option });
        switchState();
    }

    function switchState() {
        vm.active = !vm.active;
        $timeout(function () {
            if (vm.active) {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            }
        });
    }

    function checkOutsideClick(event) {
        if (vm.active && !isChildNode(event.target)) {
            switchState();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }
}

},{}],497:[function(require,module,exports){
"use strict";

angular.module('app').component('paymentCard', {
    templateUrl: 'components/payment-card/payment-card.html',
    controllerAs: 'vm',
    controller: ['$scope', PaymentCardController],
    bindings: {
        'paymentSystem': '<',
        'expired': '<',
        'validThrough': '<',
        'cardNumber': '<'
    }
});

function PaymentCardController() {
    var vm = this;

    vm.getIPS = getIPS;

    var iconPrefix = './themes/websky/assets/static/img/content/';

    function getIPS(ipsType) {
        if (ipsType === 'VI') return {
            name: 'visa',
            icon: iconPrefix + '/visa.svg'
        };

        if (ipsType === 'CA') return {
            name: 'mastercard',
            icon: iconPrefix + '/mc.svg'
        };

        if (ipsType === 'VE') return {
            name: 'visa electron',
            icon: iconPrefix + '/visaelectron.svg'
        };

        if (ipsType === 'CE') return {
            name: 'mastercard electronic',
            icon: iconPrefix + '/mc-e.svg'
        };

        if (ipsType === 'EU') return {
            name: 'maestro',
            icon: iconPrefix + '/maestro.svg'
        };

        if (ipsType === 'DC') return {
            name: 'diners',
            icon: iconPrefix + '/diners.svg'
        };

        if (ipsType === 'JC') return {
            name: 'jcb',
            icon: iconPrefix + '/jcb.svg'
        };

        if (ipsType === 'AX') return {
            name: 'american express',
            icon: iconPrefix + '/ae.svg'
        };

        if (ipsType === 'MR') return {
            name: 'Mir',
            icon: iconPrefix + '/mir.svg'
        };

        if (ipsType === 'UP') return {
            name: 'union pay',
            icon: iconPrefix + '/unionpay.svg'
        };
    }
}

},{}],498:[function(require,module,exports){
"use strict";

angular.module('app').component('paymentFrame', {
    templateUrl: 'components/payment-frame/payment-frame.html',
    controller: ['$window', '$sce', '$anchorScroll', '$scope', PaymentFrameController],
    controllerAs: 'vm',
    bindings: {
        url: '=url'
    }
});

function PaymentFrameController($window, $sce, $anchorScroll, $scope) {

    var vm = this;

    vm.loading = true;
    vm.frameLoadHandler = FrameLoadHandler;
    vm.trustedUrl = $sce.trustAsResourceUrl(vm.url);
    vm.frameOpened = true;

    function FrameLoadHandler(event) {
        // Разблокируем экран по первой загрузке
        unlock();
        try {
            // Если hostname фрэйма и страницы совпали - пора закрыть фрэйм и обновить заказ.
            if (this.contentWindow.location.hostname === $window.location.hostname) {
                vm.frameOpened = false;
                vm.loading = true;
                $window.location = this.contentWindow.location;
                $scope.$apply();
            }
        } catch (e) {
            // Ошибка доступа к this.contentWindow.location
            console.info("paymentFrame load err: ", e, event);
        }
    }

    function unlock() {
        if (vm.loading) {
            $anchorScroll('invoiceHeader');
        }
        vm.loading = false;
        $scope.$apply();
    }
}

},{}],499:[function(require,module,exports){
"use strict";

angular.module('app').component('paymentSystemImages', {
    templateUrl: 'components/payment-system-images/payment-system-images.html',
    controller: [function () {}]
});

},{}],500:[function(require,module,exports){
"use strict";

angular.module('app').component('paymentVariantSelect', {
    templateUrl: 'components/payment-variant-select/payment-variant-select.html',
    controller: ['$scope', 'backend', PaymentVariantSelectController],
    controllerAs: 'vm',
    bindings: {
        paymentVariants: '<variants',
        selected: '=',
        saveNewCard: '=',
        changeHandler: '<',
        hidden: '<'
    }
});

function PaymentVariantSelectController($scope, backend) {

    var vm = this;

    vm.hasNotEmptyAlias = hasNotEmptyAlias;
    vm.generateAliasPrefix = generateAliasPrefix;
    vm.generateCssPrefix = generateCssPrefix;

    $scope.$watch('vm.paymentVariants', function (newPaymentVariants) {
        vm.selected = -1;
        newPaymentVariants.forEach(function (variant, num) {
            if (variant.defaultSelected) {
                vm.selected = num;
            }
        });
    });

    backend.addAuthoriseCustomerListener(function (authoriseCustomer) {
        vm.authoriseCustomer = authoriseCustomer;
    });

    function hasNotEmptyAlias(code) {
        return backend.hasAlias(code) && backend.getAlias(code, true) !== '';
    }

    function generateCssPrefix(variant) {
        if (variant.paymentForm === variant.paymentType) {
            return variant.paymentForm;
        } else {
            return variant.paymentForm + '_' + variant.paymentType;
        }
    }

    function generateAliasPrefix(variant) {
        if (variant.paymentForm === variant.paymentType) {
            if (variant.paymentForm === 'plastic_card' && vm.paymentVariants.filter(function (variant) {
                return !!variant.savedCard;
            }).length) {
                // Особый алайс для новой карты, когда есть уже сохраненные
                return 'plastic_card_new';
            }
            return variant.paymentForm;
        } else {
            return variant.paymentForm + '.' + variant.paymentType;
        }
    }
}

},{}],501:[function(require,module,exports){
"use strict";

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('personalWheelchairSelect', {
    templateUrl: 'components/personal-wheelchair-select/personal-wheelchair-select.html',
    controller: ['$scope', 'backend', PersonalWheelchairSelectController],
    controllerAs: 'vm',
    bindings: {
        selected: '=?',
        ssrCode: '=?',
        ssrText: '=?',
        baseForm: '<',
        submitTouched: '<'
    }
});

function PersonalWheelchairSelectController($scope, backend) {

    var vm = this;
    vm.batteryTypes = backend.getPersonalWheelchairBatteryTypes();
    $scope.$watchGroup(['vm.batteryType', 'vm.batteryCount', 'vm.batteryCapacity', 'vm.selected'], function () {
        if (vm.selected) {
            if (vm.batteryType && vm.batteryCapacity && vm.batteryCount) {
                var _vm$batteryType = vm.batteryType,
                    ssrCode = _vm$batteryType.ssrCode,
                    unCode = _vm$batteryType.unCode,
                    additionalCode = _vm$batteryType.additionalCode,
                    eachCapacityLimit = _vm$batteryType.eachCapacityLimit,
                    singleCapacityLimit = _vm$batteryType.singleCapacityLimit,
                    countLimit = _vm$batteryType.countLimit;

                vm.ssrCode = ssrCode;
                vm.ssrText = ssrCode + ' BATTERY ' + unCode + ' ' + additionalCode + ' ' + vm.batteryCount + 'X' + vm.batteryCapacity + 'WH';
                vm.hasCapacityLimitViolation = eachCapacityLimit && vm.batteryCount && vm.batteryCapacity && Number(vm.batteryCount) > 1 && eachCapacityLimit < Number(vm.batteryCapacity) || singleCapacityLimit && vm.batteryCapacity && Number(vm.batteryCount) === 1 && singleCapacityLimit < Number(vm.batteryCapacity) || countLimit && vm.batteryCount && countLimit < Number(vm.batteryCount);
            } else if (vm.ssrCode && vm.ssrText && vm.ssrText.indexOf('BATTERY') === 0) {
                var orderSsrText = vm.ssrText;
                // eslint-disable-next-line

                var _orderSsrText$split = orderSsrText.split(' '),
                    _orderSsrText$split2 = (0, _slicedToArray3.default)(_orderSsrText$split, 4),
                    firstText = _orderSsrText$split2[0],
                    _unCode = _orderSsrText$split2[1],
                    _additionalCode = _orderSsrText$split2[2],
                    countAndCapacity = _orderSsrText$split2[3];

                var _countAndCapacity$rep = countAndCapacity.replace('WH', '').split('X'),
                    _countAndCapacity$rep2 = (0, _slicedToArray3.default)(_countAndCapacity$rep, 2),
                    batteryCount = _countAndCapacity$rep2[0],
                    batteryCapacity = _countAndCapacity$rep2[1];

                vm.batteryCount = batteryCount;
                vm.batteryCapacity = batteryCapacity;
                vm.batteryTypes.forEach(function (bt) {
                    if (bt.ssrCode === vm.ssrCode && bt.unCode === _unCode && bt.additionalCode === _additionalCode) {
                        vm.batteryType = bt;
                    }
                });
                vm.ssrText = vm.ssrCode + ' BATTERY ' + _unCode + ' ' + _additionalCode + ' ' + vm.batteryCount + 'X' + vm.batteryCapacity + 'WH';
            } else {
                delete vm.ssrCode;
                delete vm.ssrText;
                delete vm.hasCapacityLimitViolation;
            }
        }
    });
}

},{"babel-runtime/helpers/slicedToArray":10}],502:[function(require,module,exports){
"use strict";

angular.module('app').component('popupInsuranceSelect', {
    templateUrl: 'components/popup-insurance-select/popup-insurance-select.html',
    controller: [popupInsuranceController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        locked: '=locked'
    }
});

function popupInsuranceController() {}

},{}],503:[function(require,module,exports){
"use strict";

angular.module('app').component('priceChartByDay', {
    templateUrl: 'components/price-chart-by-day/price-chart-by-day.html',
    controller: ['backend', priceChartByDayController],
    controllerAs: 'vm',
    bindings: {
        arrival: '<',
        departure: '<',
        date: '=',
        limits: '<',
        onSelectDate: '&'
    }
});

function priceChartByDayController(backend) {

    var vm = this;

    vm.switchMonthHandler = switchMonthHandler;

    vm.$onInit = function () {
        updateMonthDayList();
    };

    backend.ready.then(function () {
        vm.currentCurrency = backend.sessionParams.currency;
    });

    function getPointCode(point) {
        var code = false;
        if (point.airports) {
            point.airports.forEach(function (port) {
                if (port.selected) {
                    code = port.codeEn;
                }
            });
        }
        if (!code) {
            code = point.codeEn;
        }
        return code;
    }

    function updateMonthDayList() {
        var dateParts = vm.date.split('.');
        var month = dateParts[1] * 1;
        var year = dateParts[2] * 1;

        vm.monthDayList = [];
        vm.placemarkList = [];

        backend.searchMonthPeriod({
            departure: getPointCode(vm.departure),
            arrival: getPointCode(vm.arrival),
            month: month,
            year: year
        }).then(function (list) {
            var datePrices = {};
            var maxPrice = 0;
            list.forEach(function (item) {
                datePrices[item.date] = item.price;
                if (Big(item.price).gt(maxPrice)) {
                    maxPrice = item.price;
                }
            });
            if (maxPrice) {
                var roundCeiling = getRoundCeiling(maxPrice);
                var twoThirds = getRoundCeiling(Big(roundCeiling).div(3).times(2));
                var twoThirdsRelative = Big(twoThirds).times(100).div(roundCeiling).round();
                var oneThirds = getRoundCeiling(Big(roundCeiling).div(3));
                var oneThirdsRelative = Big(oneThirds).times(100).div(roundCeiling).round();
                vm.placemarkList = [{ relativePrice: '100%', price: roundCeiling }, { relativePrice: twoThirdsRelative + '%', price: twoThirds }, { relativePrice: oneThirdsRelative + '%', price: oneThirds }];
                vm.monthDayList = generateMonthDayList(vm.date, datePrices, roundCeiling, vm.limits);
            }
        });
    }

    function getRoundCeiling(maxPrice) {
        var maxPriceStr = new Big(maxPrice).round().toString();
        var firstTwoDigit = maxPriceStr.substr(0, 2) * 1;
        var lastDigit = maxPriceStr.substr(2);
        var hasNoneZeroLastDigit = false;
        var decimalPower = maxPriceStr.length;
        for (var i = 0; i < lastDigit.length; i++) {
            if (lastDigit[i] !== '0') {
                hasNoneZeroLastDigit = true;
            }
        }
        if (hasNoneZeroLastDigit) {
            firstTwoDigit = firstTwoDigit + 1;
        }
        return Big(firstTwoDigit).times(Big(10).pow(decimalPower - 2)).round().toString();
    }

    function generateMonthDayList(date, datePrices, roundCeiling, limits) {
        var startMoment = moment(date, 'DD.MM.YYYY');
        var currentMoment = moment([startMoment.year(), startMoment.month()]);
        var weekend = moment(moment - weekend);
        var result = [];
        while (currentMoment.month() === startMoment.month()) {
            var value = currentMoment.format('DD.MM.YYYY');
            var dayRecord = {
                value: value,
                available: isDateAvailable(currentMoment, limits),
                labelDayMonth: currentMoment.format('D'),
                labelDayWeek: currentMoment.format('dd'),
                dayWeek: currentMoment.format('d'),
                monthName: currentMoment.format('MMMM, YYYY')
            };
            if (datePrices && datePrices[value]) {
                dayRecord.price = datePrices[value];
                var relativePrice = Big(dayRecord.price).times(100).div(roundCeiling).round().toString();
                dayRecord.relativePrice = relativePrice + '%';
            }
            result.push(dayRecord);
            currentMoment.add(1, 'days');
        }
        return result;
    }

    function switchMonthHandler(delta) {
        vm.date = moment(vm.date, 'DD.MM.YYYY').add(delta, 'month').format('DD.MM.YYYY');
        updateMonthDayList();
    }

    function isDateAvailable(date, limits) {
        var min = limits.min.utcOffset('-12:00').format('YYYY-MM-DD');
        var max = limits.max.utcOffset('+12:00').format('YYYY-MM-DD');
        return moment(date.format('YYYY-MM-DD')).isSameOrBefore(max, 'day') && moment(date.format('YYYY-MM-DD')).isSameOrAfter(min, 'day');
    }
}

},{}],504:[function(require,module,exports){
"use strict";

angular.module('app').component('privatePassengerDocument', {
    templateUrl: 'components/private-passenger-document/private-passenger-document.html',
    controller: ['backend', 'utils', '$scope', 'DOC_CODE', PrivatePassengerDocumentController],
    controllerAs: 'vm',
    bindings: {
        document: '=',
        nationality: '<',
        availableDocuments: '<',
        selectedDocuments: '<',
        submitTouched: '<',
        onRemove: '&'
    }
});

function PrivatePassengerDocumentController(backend, utils, $scope, DOC_CODE) {

    var vm = this;
    var documentsNumberRegex = utils.getDocumentsNumberRegex();

    vm.isAlreadySelectedDocumentType = isAlreadySelectedDocumentType;
    vm.documentTypeChangeHandler = documentTypeChangeHandler;
    vm.getExpiryByDocType = getExpiryByDocType;

    $scope.$watch('vm.nationality', updateDocumentNumberRegex);
    vm.localNamePropName = backend.sessionParams.localNamePropName;

    function isAlreadySelectedDocumentType(doc) {
        return !vm.selectedDocuments.some(function (selectedDoc) {
            return selectedDoc.documentType === doc.code;
        });
    }

    function documentTypeChangeHandler() {
        updateDocumentNumberRegex();
    }

    function updateDocumentNumberRegex() {
        if (vm.document.documentType === DOC_CODE.RussianBirthCertificate && vm.nationality === 'RU') {
            vm.documentNumberRegex = backend.getParam('passengers.RU_SR_Regexp');
        } else if (documentsNumberRegex[vm.document.documentType]) {
            vm.documentNumberRegex = documentsNumberRegex[vm.document.documentType];
        } else {
            vm.documentNumberRegex = '^(.*)$';
        }
    }

    function getExpiryByDocType(type) {
        var expiry = void 0;
        vm.availableDocuments.forEach(function (doc) {
            if (doc.code === type) {
                expiry = doc.expiry;
            }
        });
        return expiry;
    }
}

},{}],505:[function(require,module,exports){
"use strict";

angular.module('app').component('privatePassengerForm', {
    templateUrl: 'components/private-passenger-form/private-passenger-form.html',
    controller: ['backend', 'utils', '$timeout', PrivatePassengerFormController],
    controllerAs: 'vm',
    bindings: {
        passenger: '=',
        nameRegexps: '<',
        documentsList: '<',
        onDelete: '&',
        onSubmit: '&'
    }
});

function PrivatePassengerFormController(backend, utils, $timeout) {
    var vm = this;
    vm.switchDetails = switchDetails;
    vm.nationalityChangeHandler = nationalityChangeHandler;
    vm.saveHandler = saveHandler;
    vm.nameChangeHandler = nameChangeHandler;
    vm.nameEnChangeHandler = nameEnChangeHandler;

    vm.submitTouched = false;
    vm.countriesList = backend.getCountriesList();
    vm.localNamePropName = backend.sessionParams.localNamePropName;
    vm.genderList = [{ name: backend.getAlias('web.privatePassengers.genderFemale'), code: 'FEMALE' }, { name: backend.getAlias('web.privatePassengers.genderMale'), code: 'MALE' }];
    vm.todayDate = backend.sessionParams.todayDate;

    vm.allowBonusCard = backend.getParam('passengers.allowBonusCard');

    updateAvailableDocuments();

    function switchDetails() {
        vm.passenger.openedState = !vm.passenger.openedState;
    }

    function updateAvailableDocuments() {
        vm.availableDocuments = getAvailableDocuments(vm.passenger, vm.documentsList);
    }

    function nationalityChangeHandler() {
        updateAvailableDocuments();
    }

    function saveHandler() {
        vm.submitTouched = true;
        if (vm.passengerForm.$invalid) {
            return false;
        } else {
            vm.onSubmit();
        }
    }

    function getAvailableDocuments(passenger, documentsList) {
        return documentsList.filter(function (doc) {
            return !doc.notAllow || !passenger.data.nationality || passenger.data.nationality === 'RU' && doc.notAllow !== 'russian' || passenger.data.nationality !== 'RU' && doc.notAllow !== 'foreign';
        });
    }

    function clearCustomError(fieldCode) {
        var form = vm.passengerForm;
        if (fieldCode && form[fieldCode] && form[fieldCode].$error.customMessage) {
            form[fieldCode].$setValidity('customMessage', true);
            $timeout(function () {
                jQuery('form[name="vm.passengerForm"] input[name="' + fieldCode + '"]').trigger('blur');
            });
        }
    }

    function nameChangeHandler() {
        var _vm$passenger$data = vm.passenger.data,
            firstName = _vm$passenger$data.firstName,
            lastName = _vm$passenger$data.lastName; //// OS-2042 and OS-2474

        var form = vm.passengerForm;
        if (firstName && lastName) {
            var isFullNameValid = utils.checkSirenaPassengerFullName(lastName, firstName);
            var isFullNameValidLength = utils.checkSirenaPassengerFullNameLength(lastName, firstName);

            if (!isFullNameValid) {
                form.lastName.$setValidity('customMessage', false);
                form.firstName.$setValidity('customMessage', false);
                form.lastName.$error.customMessage = backend.getAlias('web.messages.passengerFullNameErrorFormat');
                form.firstName.$error.customMessage = backend.getAlias('web.messages.passengerFullNameErrorFormat');
            } else if (!isFullNameValidLength) {
                form.lastName.$setValidity('customMessage', false);
                form.firstName.$setValidity('customMessage', false);
                form.lastName.$error.customMessage = backend.getAlias('web.messages.passengerFullNameOverflow');
                form.firstName.$error.customMessage = backend.getAlias('web.messages.passengerFullNameOverflow');
            } else {
                clearCustomError('lastName');
                clearCustomError('firstName');
            }
        }
    }

    function nameEnChangeHandler() {
        var _vm$passenger$data2 = vm.passenger.data,
            firstNameEn = _vm$passenger$data2.firstNameEn,
            lastNameEn = _vm$passenger$data2.lastNameEn;

        var form = vm.passengerForm;
        if (firstNameEn && lastNameEn) {
            var isFullNameValid = utils.checkSirenaPassengerFullName(lastNameEn, firstNameEn);
            var isFullNameValidLength = utils.checkSirenaPassengerFullNameLength(lastNameEn, firstNameEn);

            if (!isFullNameValid) {
                form.lastNameEn.$setValidity('customMessage', false);
                form.firstNameEn.$setValidity('customMessage', false);
                form.lastNameEn.$error.customMessage = backend.getAlias('web.messages.passengerFullNameErrorFormat');
                form.firstNameEn.$error.customMessage = backend.getAlias('web.messages.passengerFullNameErrorFormat');
            } else if (!isFullNameValidLength) {
                form.lastNameEn.$setValidity('customMessage', false);
                form.firstNameEn.$setValidity('customMessage', false);
                form.lastNameEn.$error.customMessage = backend.getAlias('web.messages.passengerFullNameOverflow');
                form.firstNameEn.$error.customMessage = backend.getAlias('web.messages.passengerFullNameOverflow');
            } else {
                clearCustomError('lastNameEn');
                clearCustomError('firstNameEn');
            }
        }
    }
}

},{}],506:[function(require,module,exports){
"use strict";

angular.module('app').component('privateProfileMenu', {
    templateUrl: 'components/private-profile-menu/private-profile-menu.html',
    controller: ['backend', 'redirect', privateProfileMenuController],
    controllerAs: 'vm',
    bindings: {
        'activeOption': '@'
    }
});

function privateProfileMenuController(backend, redirect) {
    var vm = this;

    vm.stepsOpenedChangeState = stepsOpenedChangeState;

    vm.stepsOpened = false;
    vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;

    if (!vm.authoriseCustomer) {
        redirect.goToStart();

        return;
    }

    function stepsOpenedChangeState() {
        vm.stepsOpened = !vm.stepsOpened;
    }
}

},{}],507:[function(require,module,exports){
"use strict";

angular.module('app').component('recaptcha', {
    templateUrl: 'components/recaptcha/recaptcha.html',
    controller: ['$window', 'backend', RecaptchaController],
    controllerAs: 'vm',
    bindings: {
        token: '='
    }
});

function RecaptchaController($window, backend) {

    var vm = this;
    $window.grecaptcha.render('recaptchaContainer', {
        sitekey: backend.applicationConstants.recaptchaPublicKey,
        callback: function callback(captchaText) {
            vm.token = captchaText;
        }
    });
}

},{}],508:[function(require,module,exports){
"use strict";

angular.module('app').component('routeDescCartWidget', {
    templateUrl: 'components/route-desc-cart-widget/route-desc-cart-widget.html',
    controller: ['utils', RouteDescCartWidgetController],
    controllerAs: 'vm',
    bindings: {
        segments: '=',
        plainFlights: '=flights'
    }
});

function RouteDescCartWidgetController(utils) {

    var vm = this;
    vm.advancedMode = utils.isAdvancedRoute(vm.segments);
}

},{}],509:[function(require,module,exports){
"use strict";

angular.module('app').component('routeDescShort', {
    templateUrl: 'components/route-desc-short/route-desc-short.html',
    controller: ['utils', RouteDescController],
    controllerAs: 'vm',
    bindings: {
        segments: '=',
        plainFlights: '=flights',
        passCountStr: '<'
    }
});

function RouteDescController(utils) {

    var vm = this;
    vm.advancedMode = utils.isAdvancedRoute(vm.segments);
}

},{}],510:[function(require,module,exports){
"use strict";

angular.module('app').component('routeDesc', {
    templateUrl: 'components/route-desc/route-desc.html',
    controller: ['utils', RouteDescController],
    controllerAs: 'vm',
    bindings: {
        segments: '=',
        plainFlights: '=flights'
    }
});

function RouteDescController(utils) {

    var vm = this;
    vm.advancedMode = utils.isAdvancedRoute(vm.segments);
}

},{}],511:[function(require,module,exports){
"use strict";

angular.module('app').component('searchFareGroupVariants', {
    templateUrl: 'components/search-fare-group-variants/search-fare-group-variants.html',
    controller: ['utils', SearchVariantsController],
    controllerAs: 'vm',
    bindings: {
        searchResult: '=result',
        searchResultPeriod: '=period',
        loadingPeriodVariants: '=loading',
        resubmit: '=resubmit',
        bookingLimits: '=limits',
        searchParams: '=params',
        selectVariant: '=select'
    }
});

function SearchVariantsController(utils) {

    var vm = this;

    vm.suffixCount = utils.suffixCount;
    vm.resetDate = resetDate;
    vm.checkResetDate = checkResetDate;

    function resetDate(segNum, newDate, daysCount) {
        var searchParams = vm.searchParams,
            date = searchParams.segments[0].date;
        if (!checkResetDate(0, newDate, daysCount)) {
            return;
        }
        if (!newDate && daysCount) {
            newDate = moment(date, 'DD.MM.YYYY').add(daysCount, 'days').format('DD.MM.YYYY');
        }
        searchParams.segments[0].date = newDate;
        vm.resubmit(searchParams);
    }

    function checkResetDate(segNum, newDate, daysCount) {
        var newMoment = void 0;
        if (newDate) {
            newMoment = moment(newDate, 'DD.MM.YYYY');
        } else if (!newDate && daysCount) {
            newMoment = moment(vm.searchParams.segments[0].date, 'DD.MM.YYYY').add(daysCount, 'days');
        }
        if (newMoment.isBefore(vm.bookingLimits.min)) {
            return false;
        }
        if (newMoment.isAfter(vm.bookingLimits.max)) {
            return false;
        }
        return true;
    }
}

},{}],512:[function(require,module,exports){
"use strict";

angular.module('app').component('searchFfpVariants', {
    templateUrl: 'components/search-ffp-variants/search-ffp-variants.html',
    controller: ['$anchorScroll', 'utils', SearchFfpVariantsController],
    controllerAs: 'vm',
    bindings: {
        searchResult: '=result',
        searchResultPeriod: '=period',
        searchParams: '=params',
        resubmit: '=resubmit',
        bookingLimits: '=limits',
        selectVariant: '=select'
    }
});

function SearchFfpVariantsController($anchorScroll, utils) {

    var vm = this;

    vm.resetDate = resetDate;
    vm.checkResetDate = checkResetDate;
    vm.scrollToSegment = scrollToSegment;
    vm.suffixCount = utils.suffixCount;
    vm.openCompareFfp = openCompareFfp;

    function resetDate(segNum, newDate, daysCount) {
        var searchParams = vm.searchParams,
            date = searchParams.segments[segNum].date;
        if (!checkResetDate(segNum, newDate, daysCount)) {
            return;
        }
        if (!newDate && daysCount) {
            newDate = moment(date, 'DD.MM.YYYY').add(daysCount, 'days').format('DD.MM.YYYY');
        }
        searchParams.segments[segNum].date = newDate;
        vm.resubmit(searchParams);
    }

    function checkResetDate(segNum, newDate, daysCount) {
        var newMoment = void 0,
            otherMoment = void 0;
        if (newDate) {
            newMoment = moment(newDate, 'DD.MM.YYYY');
        } else if (!newDate && daysCount) {
            newMoment = moment(vm.searchParams.segments[segNum].date, 'DD.MM.YYYY').add(daysCount, 'days');
        }
        if (newMoment.isBefore(vm.bookingLimits.min)) {
            return false;
        }
        if (newMoment.isAfter(vm.bookingLimits.max)) {
            return false;
        }
        if (segNum === 0 && vm.searchParams.segments[1]) {
            otherMoment = moment(vm.searchParams.segments[1].date, 'DD.MM.YYYY');
            if (newMoment.isAfter(otherMoment)) {
                return false;
            }
        } else if (segNum === 1) {
            otherMoment = moment(vm.searchParams.segments[0].date, 'DD.MM.YYYY');
            if (newMoment.isBefore(otherMoment)) {
                return false;
            }
        }
        return true;
    }

    function scrollToSegment(num) {
        $anchorScroll('segment_' + num);
    }

    function openCompareFfp(type) {
        vm.showCompare = true;
        vm.activeCompareFareGroup = type;
    }
}

},{}],513:[function(require,module,exports){
"use strict";

angular.module('app').component('searchForm', {
    templateUrl: 'components/search-form/search-form.html',
    controller: ['$scope', '$q', '$window', 'backend', 'utils', SearchFormController],
    controllerAs: 'vm',
    bindings: {
        submit: '<',
        change: '<',
        showSwitch: '<switch',
        formOpened: '<opened',
        bookingLimits: '<limits',
        nearestDates: '=nearest',
        searchResultError: '<error',
        lsp: '<',
        ffp: '=',
        ffpLoginError: '=',
        updateParams: '='
    }
});

function SearchFormController($scope, $q, $window, backend, utils) {

    var vm = this;

    vm.switchGeoPoints = switchGeoPoints;
    vm.submitHandler = submitHandler;
    vm.getDescPassCountStr = getDescPassCountStr;
    vm.updateParams = updateParams;
    vm.selectNearestDate = selectNearestDate;
    vm.activatePromo = activatePromo;
    vm.activateFFP = activateFFP;
    vm.deactivatePromo = deactivatePromo;
    vm.deactivateFFP = deactivateFFP;
    vm.switchToAdvancedRoute = switchToAdvancedRoute;
    vm.switchToSimpleRoute = switchToSimpleRoute;
    vm.addAdvancedSegment = addAdvancedSegment;
    vm.removeAdvancedSegment = removeAdvancedSegment;
    vm.changeSearchGroup = changeSearchGroup;
    vm.updateMonthPeriodPartially = updateMonthPeriodPartially;

    vm.simpleRoute = true;
    vm.segCount = 1;
    vm.routeAvailabilityParams = {};

    $window.generateWebskyDeeplink = generateWebskyDeeplink;

    $scope.$watchGroup(['vm.originGeoPoint', 'vm.destinationGeoPoint', 'vm.thereDate', 'vm.backDate', 'vm.selectedSearchGroup', 'vm.simpleRoute'], vm.change);

    $scope.$watchGroup(['vm.originGeoPoint', 'vm.destinationGeoPoint'], updateCities);

    $scope.$watch('vm.advancedSegments', advancedRouteChangeHandler, true);
    $scope.$watch('vm.selectedPassengers', vm.change, true);

    $scope.$watchGroup(['vm.originGeoPoint', 'vm.destinationGeoPoint', 'vm.thereDate', 'vm.backDate'], routeChangeHandler);

    backend.ready.then(function () {

        var searchGroupsConfig = backend.getSearchGroupsConfig();

        vm.searchGroupsList = generateSearchGroupsList(searchGroupsConfig);
        vm.searchGroupsIndex = generateSearchGroupsIndex(searchGroupsConfig);
        vm.selectedSearchGroup = vm.searchGroupsList[0];
        resetSelectedPassengers();

        if (o2context.externalSearchParams && checkExternalSearchParams(o2context.externalSearchParams)) {
            setupExternalSearchParams(o2context.externalSearchParams);
        } else if (vm.lsp) {
            setupLastSearchParams(vm.lsp);
        }
    });

    function generateSearchGroupsIndex(searchGroupsConfig) {
        var index = {};
        searchGroupsConfig.forEach(function (searchGroup) {
            index[searchGroup.id] = searchGroup;
        });
        return index;
    }

    function generateSearchGroupsList(searchGroupsConfig) {
        return searchGroupsConfig.map(function (searchGroup) {
            return searchGroup.id;
        });
    }

    function checkExternalSearchParams(esp) {
        var segCount = esp.segmentsCount * 1;
        var i = void 0;
        if (!segCount || segCount < 1 || segCount > 2) {
            return false;
        }
        for (i = 0; i < segCount; i++) {
            if (!moment(esp['date[' + i + ']'], 'DD.MM.YYYY').isValid()) {
                return false;
            }
            if (!backend.getCityByCode(esp['origin-city-code[' + i + ']'])) {
                return false;
            }
            if (!backend.getCityByCode(esp['destination-city-code[' + i + ']'])) {
                return false;
            }
        }
        return true;
    }

    function setupExternalSearchParams(esp) {

        vm.segCount = esp.segmentsCount * 1;

        vm.simpleRoute = !(vm.segCount > 2 || esp['origin-city-code[1]'] && esp['origin-city-code[1]'] !== esp['destination-city-code[0]']);

        vm.thereDate = esp['date[0]'];

        vm.originGeoPoint = backend.getGeoPointByCodes([esp['origin-city-code[0]'], esp['origin-port-code[0]']]);
        vm.destinationGeoPoint = backend.getGeoPointByCodes([esp['destination-city-code[0]'], esp['destination-port-code[0]']]);
        updateCities();

        if (esp['date[1]']) {
            vm.backDate = esp['date[1]'];
        }

        if (!vm.simpleRoute) {
            vm.advancedSegments = generateAdvancedSegmentsByExternalSearchParams(esp);
        }

        if (esp.searchGroupId) {
            vm.selectedSearchGroup = esp.searchGroupId;
            resetSelectedPassengers();
        } else {
            console.error('You use deprecated API! Parameter searchGroupId is required!');
        }

        var legacyNames = {
            adultsAmount: 'count-aaa',
            retireesAmount: 'count-cpa',
            youngAdultsAmount: 'count-mla',
            childrenAmount: 'count-rbg',
            infantsWithoutSeatAmount: 'count-rmg',
            infantsWithSeatAmount: 'count-rvg'
        };

        vm.selectedPassengers.forEach(function (categoryState) {
            var paramName = categoryState.id + 'Count';
            var paramNameOld = categoryState.id + 'Amount';
            var legacyParamName = legacyNames[paramNameOld];
            var paramValue = Number(esp[paramName] || esp[paramNameOld] || esp[legacyParamName]);
            if (paramValue) {
                categoryState.val = paramValue;
                categoryState.canMinus = categoryState.val > categoryState.total.min;
                categoryState.canPlus = categoryState.val < categoryState.total.max;
                if (!esp[paramName] && esp[legacyParamName]) {
                    console.error('You use deprecated API! Please rename parameter: ' + legacyParamName + ' => ' + paramName);
                }
                if (!esp[paramName] && esp[paramNameOld]) {
                    console.error('You use deprecated API! Please rename parameter: ' + paramNameOld + ' => ' + paramName);
                }
            }
        });

        if (esp.promoCode) {
            vm.promoActive = true;
            vm.promoCode = esp.promoCode;
        } else if (esp.cardNumber && esp.cardPassword) {
            vm.ffpActive = true;
            vm.ffpCardNumber = esp.cardNumber;
            vm.ffpCardPassword = esp.cardPassword;
        }

        submitHandler();
    }

    function generateWebskyDeeplink() {
        if (vm.searchForm.$valid) {
            var esp = generateExternalSearchParams();
            var newBookingLink = '' + $window.location.origin + $window.location.pathname + '?';
            newBookingLink += _.keys(esp).map(function (paramName) {
                return paramName + '=' + esp[paramName];
            }).join('&');
            return newBookingLink;
        } else {
            return 'empty form';
        }
    }

    function generateExternalSearchParams() {

        var esp = {};

        esp.segmentsCount = vm.segCount;

        esp['origin-city-code[0]'] = vm.originGeoPoint.cityCode;
        if (vm.originGeoPoint.portCode) {
            esp['origin-port-code[0]'] = vm.originGeoPoint.portCode;
        }

        esp['destination-city-code[0]'] = vm.destinationGeoPoint.cityCode;
        if (vm.destinationGeoPoint.portCode) {
            esp['destination-port-code[0]'] = vm.destinationGeoPoint.portCode;
        }

        esp['date[0]'] = vm.thereDate;

        if (vm.backDate) {
            esp['date[1]'] = vm.backDate;
            esp['origin-city-code[1]'] = vm.destinationGeoPoint.cityCode;
            if (vm.destinationGeoPoint.portCode) {
                esp['origin-port-code[1]'] = vm.destinationGeoPoint.portCode;
            }
            esp['destination-city-code[1]'] = vm.originGeoPoint.cityCode;
            if (vm.originGeoPoint.portCode) {
                esp['destination-port-code[1]'] = vm.originGeoPoint.portCode;
            }
        }

        esp.searchGroupId = vm.selectedSearchGroup;

        vm.selectedPassengers.forEach(function (categoryState) {
            var paramName = categoryState.id + 'Count';
            esp[paramName] = categoryState.val;
        });

        if (vm.promoCode) {
            esp.promoCode = vm.promoCode;
        } else if (vm.ffpCardNumber && vm.ffpCardPassword) {
            vm.ffpCardNumber = esp.cardNumber;
            vm.ffpCardPassword = esp.cardPassword;
        }

        return esp;
    }

    function generateAdvancedSegmentsByExternalSearchParams(esp) {
        var advancedSegments = [];
        for (var i = 0; i < esp.segmentsCount * 1; i++) {
            advancedSegments.push({
                date: esp['date[' + i + ']'],
                originGeoPoint: backend.getGeoPointByCodes([esp['origin-city-code[' + i + ']'], esp['origin-port-code[' + i + ']']]),
                originCity: backend.getCityByCode(esp['origin-city-code[' + i + ']']),
                destinationGeoPoint: backend.getGeoPointByCodes([esp['destination-city-code[' + i + ']'], esp['destination-port-code[' + i + ']']]),
                destinationCity: backend.getCityByCode(esp['destination-city-code[' + i + ']'])
            });
        }
        return advancedSegments;
    }

    function setupLastSearchParams(lsp) {

        vm.simpleRoute = lsp.segmentsCount === 1 || lsp.segmentsCount === 2 && lsp.originCodes[1] === lsp.destinationCodes[0] && lsp.originCodes[0] === lsp.destinationCodes[1];

        vm.segCount = lsp.segmentsCount;
        vm.thereDate = lsp.dates[0];
        vm.originCity = backend.getCityByCode(lsp.originCodes[0]);
        vm.destinationCity = backend.getCityByCode(lsp.destinationCodes[0]);

        vm.originGeoPoint = backend.getGeoPointByCodes([lsp.originCodes[0]]);
        vm.destinationGeoPoint = backend.getGeoPointByCodes([lsp.destinationCodes[0]]);

        if (lsp.dates[1]) {
            vm.backDate = lsp.dates[1];
        }

        if (!vm.simpleRoute) {
            vm.advancedSegments = generateAdvancedSegmentsByLastSearchParams(lsp);
        }

        vm.isBusiness = lsp.business;

        if (lsp.searchGroupId) {
            vm.selectedSearchGroup = lsp.searchGroupId;
            resetSelectedPassengers();
        }

        vm.selectedPassengers.forEach(function (categoryState) {
            if (lsp[categoryState.id + 'Count']) {
                categoryState.val = lsp[categoryState.id + 'Count'];
                categoryState.canMinus = categoryState.val > categoryState.total.min;
                categoryState.canPlus = categoryState.val < categoryState.total.max;
            }
        });

        if (lsp.promoCode) {
            vm.promoActive = true;
            vm.promoCode = lsp.promoCode;
        }

        submitHandler();
    }

    function generateAdvancedSegmentsByLastSearchParams(lsp) {
        var advancedSegments = [];
        for (var i = 0; i < lsp.segmentsCount; i++) {
            advancedSegments.push({
                date: lsp.dates[i],
                originGeoPoint: backend.getGeoPointByCodes([lsp.originCodes[i]]),
                originCity: backend.getCityByCode(lsp.originCodes[i]),
                destinationGeoPoint: backend.getGeoPointByCodes([lsp.destinationCodes[i]]),
                destinationCity: backend.getCityByCode(lsp.destinationCodes[i])
            });
        }
        return advancedSegments;
    }

    function switchGeoPoints() {
        var destinationGeoPoint = vm.destinationGeoPoint;
        var originGeoPoint = vm.originGeoPoint;
        vm.destinationGeoPoint = originGeoPoint;
        vm.originGeoPoint = destinationGeoPoint;
    }

    function checkSimpleRoute() {
        return vm.originGeoPoint && vm.destinationGeoPoint && vm.thereDate;
    }

    function checkAdvancedRoute() {
        for (var i = 0; i < vm.advancedSegments.length; i++) {
            if (!vm.advancedSegments[i].originGeoPoint || !vm.advancedSegments[i].destinationGeoPoint || !vm.advancedSegments[i].date) {
                return false;
            }
        }
        return true;
    }

    function submitHandler() {
        vm.submitTouched = true;
        if (!vm.ffpActive && (vm.ffpCardNumber || vm.ffpCardPassword)) {
            deactivateFFP();
            return;
        }
        if (vm.simpleRoute && checkSimpleRoute() || !vm.simpleRoute && checkAdvancedRoute()) {
            if (vm.searchForm.$valid) {
                submitSearch();
                vm.submitTouched = false;
            } else {
                console.log('invalid form: ', vm.searchForm.$error);
            }
        }
        return false;
    }

    function submitSearch() {

        var searchParams = {
            searchGroupId: vm.selectedSearchGroup,
            passengers: vm.selectedPassengers.map(function (_ref) {
                var id = _ref.id,
                    val = _ref.val;
                return { id: id, count: val };
            })
        };

        if (vm.simpleRoute) {

            searchParams.segments = [{
                date: vm.thereDate,
                origin: vm.originCity,
                destination: vm.destinationCity
            }];

            vm.segCount = vm.backDate ? 2 : 1;

            if (vm.segCount == 2) {
                searchParams.segments.push({
                    date: vm.backDate,
                    origin: vm.destinationCity,
                    destination: vm.originCity
                });
            }
        } else {
            searchParams.segments = vm.advancedSegments.map(function (advancedSegment) {
                return {
                    date: advancedSegment.date,
                    origin: advancedSegment.originCity,
                    destination: advancedSegment.destinationCity
                };
            });
        }

        if (vm.isBusiness) {
            searchParams.business = true;
        }

        if (vm.promoActive) {
            if (vm.promoCode) {
                searchParams.promoCode = vm.promoCode;
            } else {
                vm.promoActive = false;
            }
        }

        if (vm.ffpActive) {
            if (vm.ffpCardNumber && vm.ffpCardPassword) {
                searchParams.ffpCardNumber = vm.ffpCardNumber;
                searchParams.ffpCardPassword = vm.ffpCardPassword;
            } else {
                vm.ffpActive = false;
            }
        }

        vm.submit(angular.copy(searchParams));
    }

    function updateCities() {
        vm.originCity = backend.generateLegacyCityObject(vm.originGeoPoint);
        vm.destinationCity = backend.generateLegacyCityObject(vm.destinationGeoPoint);
    }

    function getDescPassCountStr() {
        var result = '';
        for (var i = 0; i < vm.selectedPassengers.length; i++) {
            if (vm.selectedPassengers[i].val) {
                if (result !== '') {
                    result += ', ';
                }
                result += '' + utils.suffixCount(vm.selectedPassengers[i].val, backend.getAliasWithPrefix('web.passengerCategories.', vm.selectedPassengers[i].id));
            }
        }
        return result;
    }

    function updateParams(searchParams) {
        if (searchParams) {

            if (searchParams.segments) {
                vm.segCount = searchParams.segments.length;
                vm.thereDate = searchParams.segments[0].date;
                vm.backDate = searchParams.segments[1] ? searchParams.segments[1].date : '';
                vm.originGeoPoint = backend.getGeoPointByLegacyCityObject(searchParams.segments[0].origin);
                vm.destinationGeoPoint = backend.getGeoPointByLegacyCityObject(searchParams.segments[0].destination);
            }

            if (searchParams.searchGroupId) {
                vm.selectedSearchGroup = searchParams.searchGroupId;
                resetSelectedPassengers();
            }

            if (searchParams.passengers) {
                vm.selectedPassengers.forEach(function (categoryState) {
                    var categoryOldState = _.findWhere(searchParams.passengers, { id: categoryState.id });
                    if (categoryOldState && categoryOldState.count !== categoryState.val) {
                        categoryState.val = categoryOldState.count;
                        categoryState.canMinus = categoryState.val > categoryState.total.min;
                        categoryState.canPlus = categoryState.val < categoryState.total.max;
                    }
                });
            }
        }
    }

    function selectNearestDate(segId, date) {
        if (vm.simpleRoute) {
            if (segId === 0) {
                vm.thereDate = date;
            } else if (segId === 1) {
                vm.backDate = date;
            }
        } else if (vm.advancedSegments[segId]) {
            vm.advancedSegments[segId].date = date;
        }
        vm.nearestDates = vm.nearestDates.filter(function (nearestDate) {
            return nearestDate.segId !== segId;
        });
        if (!vm.nearestDates.length) {
            vm.nearestDates = false;
        }
    }

    function advancedRouteChangeHandler(newAdvancedSegments, oldAdvancedSegments) {

        if (vm.advancedSegments && hasAdvancedRouteChanges(newAdvancedSegments, oldAdvancedSegments)) {

            vm.advancedSegments.forEach(function (advancedSegment) {
                advancedSegment.originCity = backend.generateLegacyCityObject(advancedSegment.originGeoPoint);
                advancedSegment.destinationCity = backend.generateLegacyCityObject(advancedSegment.destinationGeoPoint);
            });

            vm.datesWithoutFlights = false;
            backend.routeAvailabilityAdvanced(vm.advancedSegments.map(function (advancedSegment) {
                return {
                    cityA: advancedSegment.originGeoPoint && advancedSegment.originGeoPoint.cityCode,
                    portA: advancedSegment.originGeoPoint && advancedSegment.originGeoPoint.portCode,
                    cityB: advancedSegment.destinationGeoPoint && advancedSegment.destinationGeoPoint.cityCode,
                    portB: advancedSegment.destinationGeoPoint && advancedSegment.destinationGeoPoint.portCode
                };
            })).then(function (resp) {
                vm.datesWithoutFlightsAdvancedRoute = resp.map(function (data) {

                    if (data.note === 'NO_INFORMATION_FOR_DIRECTION' && backend.getParam('search.disableAllDatesIfNoInformationForDirection')) {
                        return generateDatesWithoutFlightsList();
                    } else {
                        return data.unavailableDates;
                    }
                });
            });
        }

        if (newAdvancedSegments) {
            vm.advancedRouteDateLimits = generateAdvancedRouteDateLimits(vm.bookingLimits, newAdvancedSegments);
        }
    }

    function generateAdvancedRouteDateLimits(bookingLimits, advancedSegments) {
        return advancedSegments.map(function (advancedSegment, advancedSegmentNum) {
            var prevSegmentMoment = advancedSegments[advancedSegmentNum - 1] && advancedSegments[advancedSegmentNum - 1].date && moment(advancedSegments[advancedSegmentNum - 1].date, 'DD.MM.YYYY').add(+1, 'days');
            var nextSegmentMoment = advancedSegments[advancedSegmentNum + 1] && advancedSegments[advancedSegmentNum + 1].date && moment(advancedSegments[advancedSegmentNum + 1].date, 'DD.MM.YYYY');
            return {
                min: prevSegmentMoment || bookingLimits.min,
                max: nextSegmentMoment || bookingLimits.max
            };
        });
    }

    function hasAdvancedRouteChanges(newRoute, oldRoute) {
        if (!newRoute && oldRoute || newRoute && !oldRoute || newRoute.length !== oldRoute.length) {
            return true;
        } else {
            for (var i = 0; i < newRoute.length; i++) {
                if (!newRoute[i].originGeoPoint && oldRoute[i].originGeoPoint || newRoute[i].originGeoPoint && !oldRoute[i].originGeoPoint || newRoute[i].originGeoPoint && oldRoute[i].originGeoPoint && (newRoute[i].originGeoPoint.cityCode !== oldRoute[i].originGeoPoint.cityCode || newRoute[i].originGeoPoint.portCode !== oldRoute[i].originGeoPoint.portCode)) {
                    return true;
                }
                if (!newRoute[i].destinationGeoPoint && oldRoute[i].destinationGeoPoint || newRoute[i].destinationGeoPoint && !oldRoute[i].destinationGeoPoint || newRoute[i].destinationGeoPoint && oldRoute[i].destinationGeoPoint && (newRoute[i].destinationGeoPoint.cityCode !== oldRoute[i].destinationGeoPoint.cityCode || newRoute[i].destinationGeoPoint.portCode !== oldRoute[i].destinationGeoPoint.portCode)) {
                    return true;
                }
            }
        }
        return false;
    }

    function routeChangeHandler() {
        var newCityA = void 0,
            newPortA = void 0,
            newCityB = void 0,
            newPortB = void 0;
        vm.searchResultError = false;
        if (vm.originGeoPoint) {
            newCityA = vm.originGeoPoint.cityCode;
            newPortA = vm.originGeoPoint.portCode;
        }
        if (vm.destinationGeoPoint) {
            newCityB = vm.destinationGeoPoint.cityCode;
            newPortB = vm.destinationGeoPoint.portCode;
        }
        if (newCityA && newCityB && (newCityA !== vm.routeAvailabilityParams.cityA || newPortA !== vm.routeAvailabilityParams.portA || newCityB !== vm.routeAvailabilityParams.cityB || newPortB !== vm.routeAvailabilityParams.portB)) {
            vm.routeAvailabilityParams = {
                cityA: newCityA,
                cityB: newCityB,
                portB: newPortB,
                portA: newPortA
            };
            vm.datesWithoutFlights = false;
            vm.datePrices = [{}, {}];
            backend.routeAvailability(vm.routeAvailabilityParams).then(function (resp) {
                vm.datesWithoutFlights = resp.map(function (data) {

                    if (data.note === 'NO_INFORMATION_FOR_DIRECTION' && backend.getParam('search.disableAllDatesIfNoInformationForDirection')) {
                        return generateDatesWithoutFlightsList();
                    } else {
                        return data.unavailableDates;
                    }
                });
            });
        }
        updateMonthPeriod();
    }

    function updateMonthPeriod() {
        if (vm.originGeoPoint && vm.destinationGeoPoint) {
            var pointA = vm.originGeoPoint.portCode || vm.originGeoPoint.cityCode;
            var pointB = vm.destinationGeoPoint.portCode || vm.destinationGeoPoint.cityCode;
            var dateA = vm.thereDate || backend.sessionParams.todayDate;
            var dateB = vm.backDate || backend.sessionParams.todayDate;
            var paramsList = [generateMonthPeriodParams(pointA, pointB, dateA, 0), generateMonthPeriodParams(pointA, pointB, dateA, 1), generateMonthPeriodParams(pointB, pointA, dateB, 0), generateMonthPeriodParams(pointB, pointA, dateB, 1)];
            $q.all(paramsList.map(function (params) {
                return backend.searchMonthPeriod(params);
            })).then(function (resp) {
                extendDatePrices(0, resp[0]);
                extendDatePrices(0, resp[1]);
                extendDatePrices(1, resp[2]);
                extendDatePrices(1, resp[3]);
            });
        }
    }

    function updateMonthPeriodPartially(segNum, date) {
        if (vm.originGeoPoint && vm.destinationGeoPoint) {
            var pointA = void 0;
            var pointB = void 0;
            if (segNum) {
                pointA = vm.destinationGeoPoint.portCode || vm.destinationGeoPoint.cityCode;
                pointB = vm.originGeoPoint.portCode || vm.originGeoPoint.cityCode;
            } else {
                pointA = vm.originGeoPoint.portCode || vm.originGeoPoint.cityCode;
                pointB = vm.destinationGeoPoint.portCode || vm.destinationGeoPoint.cityCode;
            }
            var paramsList = [generateMonthPeriodParams(pointA, pointB, date, 0), generateMonthPeriodParams(pointA, pointB, date, 1)];
            $q.all(paramsList.map(function (params) {
                return backend.searchMonthPeriod(params);
            })).then(function (resp) {
                extendDatePrices(segNum, resp[0]);
                extendDatePrices(segNum, resp[1]);
            });
        }
    }

    function generateMonthPeriodParams(departure, arrival, date, delta) {
        var dateParts = date.split('.');
        var month = dateParts[1] * 1;
        var year = dateParts[2] * 1;
        if (delta) {
            if (month + delta > 12) {
                month = month + delta - 12;
                year = year + 1;
            } else {
                month = month + delta;
            }
        }
        return {
            departure: departure,
            arrival: arrival,
            month: month,
            year: year
        };
    }

    function extendDatePrices(segNum, list) {
        list.forEach(function (item) {
            vm.datePrices[segNum][item.date] = item.price;
        });
    }

    function generateDatesWithoutFlightsList() {
        var list = [];
        var date = moment(vm.bookingLimits.min);
        while (date.isSameOrBefore(vm.bookingLimits.max)) {
            list.push(date.format('DD.MM.YYYY'));
            date.add(1, 'days');
        }
        return list;
    }

    function activatePromo() {
        vm.promoActive = true;
        deactivateFFP();
    }

    function activateFFP() {
        vm.ffpActive = true;
        deactivatePromo();
    }

    function deactivatePromo() {
        vm.promoActive = false;
        vm.promoCode = '';
    }

    function deactivateFFP() {
        vm.ffpActive = false;
        vm.ffpCardNumber = '';
        vm.ffpCardPassword = '';
    }

    function switchToAdvancedRoute() {
        vm.simpleRoute = false;
        if (!vm.advancedSegments) {
            vm.advancedSegments = initAdvancedSegments();
        } else {
            updateAdvancedSegments();
        }
    }

    function switchToSimpleRoute() {
        vm.simpleRoute = true;
        vm.originGeoPoint = vm.advancedSegments[0].originGeoPoint;
        vm.destinationGeoPoint = vm.advancedSegments[0].destinationGeoPoint;
        vm.thereDate = vm.advancedSegments[0].date;
        if (vm.advancedSegments[1] && vm.advancedSegments[1].date && vm.advancedSegments[0].destinationGeoPoint.cityCode === vm.advancedSegments[1].originGeoPoint.cityCode) {
            vm.backDate = vm.advancedSegments[1].date;
        } else {
            vm.backDate = false;
        }
    }

    function addAdvancedSegment() {
        vm.advancedSegments.push({
            originGeoPoint: vm.advancedSegments[vm.advancedSegments.length - 1].destinationGeoPoint,
            destinationGeoPoint: false,
            date: false
        });
    }

    function removeAdvancedSegment() {
        vm.advancedSegments.splice(vm.advancedSegments.length - 1, 1);
    }

    function initAdvancedSegments() {
        return [{
            originGeoPoint: vm.originGeoPoint,
            destinationGeoPoint: vm.destinationGeoPoint,
            date: vm.thereDate
        }, {
            originGeoPoint: vm.destinationGeoPoint,
            destinationGeoPoint: vm.originGeoPoint,
            date: vm.backDate
        }];
    }

    function updateAdvancedSegments() {
        vm.advancedSegments[0].originGeoPoint = vm.originGeoPoint;
        vm.advancedSegments[0].destinationGeoPoint = vm.destinationGeoPoint;
        vm.advancedSegments[0].date = vm.thereDate;
        if (vm.backDate) {
            if (!vm.advancedSegments[1]) {
                vm.advancedSegments[1] = {};
            }
            vm.advancedSegments[1].originGeoPoint = vm.destinationGeoPoint;
            vm.advancedSegments[1].destinationGeoPoint = vm.originGeoPoint;
            vm.advancedSegments[1].date = vm.backDate;
        }
    }

    function changeSearchGroup(searchGroup) {
        vm.selectedSearchGroup = searchGroup;
        resetSelectedPassengers();
    }

    function resetSelectedPassengers() {
        var config = vm.searchGroupsIndex[vm.selectedSearchGroup];
        vm.selectedPassengers = config.categories.map(function (category) {
            return {
                id: category.id,
                frontEndType: category.frontEndType,
                val: category.total.min,
                total: category.total,
                canMinus: false,
                canPlus: category.total.max > category.total.min
            };
        });
    }
}

},{}],514:[function(require,module,exports){
"use strict";

angular.module('app').component('searchMonoBrandCartesianVariants', {
    templateUrl: 'components/search-mono-brand-cartesian-variants/search-mono-brand-cartesian-variants.html',
    controller: ['oxyScroll', 'modalTools', 'utils', 'backend', SearchVariantsController],
    controllerAs: 'vm',
    bindings: {
        searchResult: '=result',
        searchResultPeriod: '=period',
        loadingPeriodVariants: '=loading',
        searchParams: '=params',
        resubmit: '=resubmit',
        bookingLimits: '=limits',
        selectVariant: '=select'
    }
});

function SearchVariantsController(oxyScroll, modalTools, utils, backend) {

    var vm = this;

    vm.resetDate = resetDate;
    vm.checkResetDate = checkResetDate;
    vm.scrollToSegment = scrollToSegment;
    vm.suffixCount = utils.suffixCount;
    vm.openCompare = openCompare;
    vm.mobileFlightRowChangeHandler = mobileFlightRowChangeHandler;
    vm.infoBoxGetText = infoBoxGetText;
    vm.generateAddedCitiesMessage = generateAddedCitiesMessage;
    vm.generateReplacedCitiesMessage = generateReplacedCitiesMessage;
    vm.choosedFlag = false;

    if (vm.searchResult && vm.searchResult.segmentRows) {
        vm.selectedFlightRow = vm.searchParams.segments.map(function (segment, segmentNum) {
            return vm.searchResult.segmentRows[segmentNum].length === 1 ? 0 : -1;
        });
        updateResultCities();
    }

    /**
     *
     * @param params {object}
     * @param params.segNum {number}
     * @param params.availableSeats {number}
     * @param params.brandsCompatibleState {string}
     * @param params.comparedDateTimeDisable {string}
     */
    function infoBoxGetText(params) {

        params = params || {};

        var availableSeats = params.availableSeats,
            segNum = params.segNum,
            brandsCompatibleState = params.brandsCompatibleState,
            comparedDateTimeDisable = params.comparedDateTimeDisable,
            availableLabel = backend.getAlias('web.searchResult.available'),
            seatLabel = backend.getAlias('web.seat.label'),
            brandsNotCompatibleLabel = backend.getAlias('web.searchResult.brandsNotCompatible'),
            flightTimesNotCompatibleLabel = backend.getAlias('web.searchResult.flightTimesNotCompatible'),
            lowAvailabilityAlertThreshold = backend.getParam('search.lowAvailabilityAlertThreshold');

        if (availableSeats <= lowAvailabilityAlertThreshold && segNum === 0 || availableSeats <= lowAvailabilityAlertThreshold && segNum === 1 && brandsCompatibleState && !comparedDateTimeDisable) {
            return availableLabel + ' ' + vm.suffixCount(availableSeats, seatLabel);
        }

        if (segNum === 1 && !brandsCompatibleState) {
            return brandsNotCompatibleLabel;
        }

        if (segNum === 1 && brandsCompatibleState && comparedDateTimeDisable) {
            return flightTimesNotCompatibleLabel;
        }
    }

    function resetDate(segNum, newDate, daysCount) {
        var searchParams = vm.searchParams,
            date = searchParams.segments[segNum].date;
        if (!checkResetDate(segNum, newDate, daysCount)) {
            return;
        }
        if (!newDate && daysCount) {
            newDate = moment(date, 'DD.MM.YYYY').add(daysCount, 'days').format('DD.MM.YYYY');
        }
        searchParams.segments[segNum].date = newDate;
        vm.resubmit(searchParams);
    }

    function checkResetDate(segNum, newDate, daysCount) {
        var newMoment = void 0,
            otherMoment = void 0;
        if (newDate) {
            newMoment = moment(newDate, 'DD.MM.YYYY');
        } else if (!newDate && daysCount) {
            newMoment = moment(vm.searchParams.segments[segNum].date, 'DD.MM.YYYY').add(daysCount, 'days');
        }
        if (newMoment.isBefore(vm.bookingLimits.min, 'day')) {
            return false;
        }
        if (newMoment.isAfter(vm.bookingLimits.max, 'day')) {
            return false;
        }
        if (segNum === 0 && vm.searchParams.segments[1]) {
            otherMoment = moment(vm.searchParams.segments[1].date, 'DD.MM.YYYY');
            if (newMoment.isAfter(otherMoment, 'day')) {
                return false;
            }
        } else if (segNum === 1) {
            otherMoment = moment(vm.searchParams.segments[0].date, 'DD.MM.YYYY');
            if (newMoment.isBefore(otherMoment, 'day')) {
                return false;
            }
        }
        return true;
    }

    function scrollToSegment(num) {
        oxyScroll.scrollToAnchor('segment_' + num);
    }

    function openCompare(code) {
        vm.showCompare = true;
        vm.activeCompareBrand = code;
    }

    function mobileFlightRowChangeHandler(num) {
        oxyScroll.scrollToAnchor('brandsOverview_' + num);
    }

    function updateResultCities() {
        var searchCitiesBySegments = vm.searchParams.segments.map(function (searchParamsSegment) {
            return {
                origin: searchParamsSegment.origin.codeEn,
                destination: searchParamsSegment.destination.codeEn
            };
        });
        var resultCitiesBySegments = vm.searchResult.segmentRows.map(function (segmentRowFlights, segNum) {
            var origin = [];
            var destination = [];
            segmentRowFlights.forEach(function (segmentRowFlight) {
                if (!origin.includes(segmentRowFlight.flightsInfo.origincity)) {
                    origin.push(segmentRowFlight.flightsInfo.origincity);
                }
                if (!destination.includes(segmentRowFlight.flightsInfo.destinationcity)) {
                    destination.push(segmentRowFlight.flightsInfo.destinationcity);
                }
            });
            var resultCitiesBySegment = { origin: origin, destination: destination };
            if (!origin.includes(searchCitiesBySegments[segNum].origin) || !destination.includes(searchCitiesBySegments[segNum].destination)) {
                var replacedCities = [];
                if (origin[0] !== searchCitiesBySegments[segNum].origin) {
                    replacedCities.push({
                        from: searchCitiesBySegments[segNum].origin,
                        to: origin[0]
                    });
                }
                if (destination[0] !== searchCitiesBySegments[segNum].destination) {
                    replacedCities.push({
                        from: searchCitiesBySegments[segNum].destination,
                        to: destination[0]
                    });
                }
                resultCitiesBySegment.replacedCities = replacedCities;
            } else if (origin.length > 1 || destination.length > 1) {
                var addedCities = [];
                origin.forEach(function (cityCode) {
                    if (cityCode !== searchCitiesBySegments[segNum].origin) {
                        addedCities.push(cityCode);
                    }
                });
                destination.forEach(function (cityCode) {
                    if (cityCode !== searchCitiesBySegments[segNum].destination) {
                        addedCities.push(cityCode);
                    }
                });
                resultCitiesBySegment.addedCities = addedCities;
            }
            return resultCitiesBySegment;
        });
        vm.resultCities = resultCitiesBySegments;
    }

    function getCityName(code) {
        var city = backend.getCityByCode(code);
        return city['name' + utils.capitalize(o2context.lang)];
    }

    function generateAddedCitiesMessage(addedCitiesList) {
        var addedCityText = backend.getAlias('web.searchResult.segmentRemark.addedCity');
        var addedCitiesText = backend.getAlias('web.searchResult.segmentRemark.addedCities');
        var cityNames = addedCitiesList.map(getCityName).join(', ');
        return '<p>' + (addedCitiesList.length > 1 ? addedCitiesText : addedCityText) + ' ' + cityNames + '</p>';
    }

    function generateReplacedCitiesMessage(replacedCitiesList) {
        var replacedCityStartText = backend.getAlias('web.searchResult.segmentRemark.replacedCityStart');
        var replacedCityEndText = backend.getAlias('web.searchResult.segmentRemark.replacedCityEnd');
        return replacedCitiesList.map(function (replacedCities) {
            return '<p>' + replacedCityStartText + ' ' + getCityName(replacedCities.from) + ' ' + replacedCityEndText + ' ' + getCityName(replacedCities.to) + '</p>';
        }).join('');
    }
}

},{}],515:[function(require,module,exports){
"use strict";

angular.module('app').component('searchOrderRedirectForm', {
    templateUrl: 'components/search-order-redirect-form/search-order-redirect-form.html',
    controller: ['$element', '$timeout', '$sce', SearchOrderRedirectFormController],
    controllerAs: 'vm',
    bindings: {
        passengers: '<',
        submit: '='
    }
});

function SearchOrderRedirectFormController($element, $timeout, $sce) {

    var vm = this;

    vm.submit = function (url) {
        vm.engineUrl = $sce.trustAsResourceUrl(url);
        $timeout(function () {
            $element.find('#searchOrderRedirectForm').submit();
        });
    };
}

},{}],516:[function(require,module,exports){
"use strict";

angular.module('app').component('searchPricingRouteAndMonoBrandVariants', {
    templateUrl: 'components/search-pricing-route-and-mono-brand-variants/search-pricing-route-and-mono-brand-variants.html',
    controller: ['oxyScroll', 'modalTools', 'utils', SearchVariantsController],
    controllerAs: 'vm',
    bindings: {
        searchResult: '=result',
        searchResultPeriod: '=period',
        searchParams: '=params',
        resubmit: '=resubmit',
        bookingLimits: '=limits',
        selectVariant: '=select'
    }
});

function SearchVariantsController(oxyScroll, modalTools, utils) {

    var vm = this;

    vm.resetDate = resetDate;
    vm.checkResetDate = checkResetDate;
    vm.scrollToSegment = scrollToSegment;
    vm.suffixCount = utils.suffixCount;
    vm.openCompare = openCompare;
    vm.mobileFlightRowChangeHandler = mobileFlightRowChangeHandler;

    function resetDate(segNum, newDate, daysCount) {
        var searchParams = vm.searchParams,
            date = searchParams.segments[segNum].date;
        if (!checkResetDate(segNum, newDate, daysCount)) {
            return;
        }
        if (!newDate && daysCount) {
            newDate = moment(date, 'DD.MM.YYYY').add(daysCount, 'days').format('DD.MM.YYYY');
        }
        searchParams.segments[segNum].date = newDate;
        vm.resubmit(searchParams);
    }

    function checkResetDate(segNum, newDate, daysCount) {
        var newMoment = void 0,
            otherMoment = void 0;
        if (newDate) {
            newMoment = moment(newDate, 'DD.MM.YYYY');
        } else if (!newDate && daysCount) {
            newMoment = moment(vm.searchParams.segments[segNum].date, 'DD.MM.YYYY').add(daysCount, 'days');
        }
        if (newMoment.isBefore(vm.bookingLimits.min)) {
            return false;
        }
        if (newMoment.isAfter(vm.bookingLimits.max)) {
            return false;
        }
        if (segNum === 0 && vm.searchParams.segments[1]) {
            otherMoment = moment(vm.searchParams.segments[1].date, 'DD.MM.YYYY');
            if (newMoment.isAfter(otherMoment)) {
                return false;
            }
        } else if (segNum === 1) {
            otherMoment = moment(vm.searchParams.segments[0].date, 'DD.MM.YYYY');
            if (newMoment.isBefore(otherMoment)) {
                return false;
            }
        }
        return true;
    }

    function scrollToSegment(num) {
        oxyScroll.scrollToAnchor('segment_' + num);
    }

    function openCompare(code) {
        vm.showCompare = true;
        vm.activeCompareBrand = code;
    }

    function mobileFlightRowChangeHandler(num) {
        oxyScroll.scrollToAnchor('brandsOverview_' + num);
    }
}

},{}],517:[function(require,module,exports){
"use strict";

angular.module('app').component('searchScheduleForm', {
    templateUrl: 'components/search-schedule-form/search-schedule-form.html',
    controller: ['$window', 'backend', SearchScheduleFormController],
    controllerAs: 'vm',
    bindings: {
        submit: '=',
        showSwitch: '=switch',
        formOpened: '=opened',
        bookingLimits: '=limits',
        searchResultError: '=error'
    }
});

function SearchScheduleFormController($window, backend) {

    var vm = this;

    vm.formOpened = true;
    vm.switchGeoPoints = switchGeoPoints;
    vm.submitHandler = submitHandler;

    backend.ready.then(function () {
        setupExternalSearchScheduleParams();
    });

    function setupExternalSearchScheduleParams() {
        var esp = o2context.externalSearchScheduleParams;
        if (esp) {
            vm.fromDate = esp['from-date'];
            vm.toDate = esp['to-date'];
            vm.originGeoPoint = backend.getGeoPointByCodes([esp['origin-city-code'], esp['origin-port-code']]);
            vm.destinationGeoPoint = backend.getGeoPointByCodes([esp['destination-city-code'], esp['destination-port-code']]);
            submitHandler();
        }
    }

    function switchGeoPoints() {
        var destinationGeoPoint = vm.destinationGeoPoint;
        var originGeoPoint = vm.originGeoPoint;
        vm.destinationGeoPoint = originGeoPoint;
        vm.originGeoPoint = destinationGeoPoint;
    }

    function submitHandler() {
        vm.submitTouched = true;
        if (vm.destinationGeoPoint && vm.originGeoPoint) {
            var searchParams = {
                departure: vm.originGeoPoint,
                arrival: vm.destinationGeoPoint
            };
            if (vm.fromDate) {
                searchParams.fromDate = vm.fromDate;
            }
            if (vm.toDate) {
                searchParams.toDate = vm.toDate;
            }
            vm.submit(searchParams);
            vm.submitTouched = false;
        }
    }
}

},{}],518:[function(require,module,exports){
"use strict";

angular.module('app').component('searchScheduleVariants', {
    templateUrl: 'components/search-schedule-variants/search-schedule-variants.html',
    controller: ['utils', 'backend', SearchScheduleVariantsController],
    controllerAs: 'vm',
    bindings: {
        scheduleFlights: '=flights',
        searchParams: '=params',
        selectedDate: '=selected'
    }
});

function SearchScheduleVariantsController(utils, backend) {

    var vm = this,
        todayDate = backend.sessionParams.todayDate,
        firstPeriodDate = getFirstPeriodDate(vm.searchParams.fromDate, todayDate, vm.scheduleFlights),
        lastPeriodDate = getLastPeriodDate(vm.searchParams.toDate, vm.scheduleFlights);

    vm.selectFlightDate = selectFlightDate;
    vm.checkActiveFlightDay = checkActiveFlightDay;
    vm.checkIsDateInPast = checkIsDateInPast;
    vm.gotoNextWeek = gotoNextWeek;
    vm.gotoPrevWeek = gotoPrevWeek;
    vm.canGotoPrevWeek = false;
    vm.canGotoNextWeek = true;
    vm.weekDaysList = getWeekDaysList();
    vm.currentWeekDates = getCurrentWeekDates(firstPeriodDate);

    function selectFlightDate(scheduleRowNum, date) {
        vm.selectedScheduleRowNum = scheduleRowNum;
        vm.selectedDate = date;
    }

    function deselectFlightDate() {
        delete vm.selectedScheduleRowNum;
        delete vm.selectedDate;
    }

    function gotoNextWeek() {
        if (vm.canGotoNextWeek) {
            vm.currentWeekDates = getCurrentWeekDates(moment(vm.currentWeekDates[0].date, 'DD.MM.YYYY').add(7, 'days').format('DD.MM.YYYY'));
            updateCanGotoWeeks();
            deselectFlightDate();
        }
    }

    function gotoPrevWeek() {
        if (vm.canGotoPrevWeek) {
            vm.currentWeekDates = getCurrentWeekDates(moment(vm.currentWeekDates[0].date, 'DD.MM.YYYY').add(-7, 'days').format('DD.MM.YYYY'));
            updateCanGotoWeeks();
            deselectFlightDate();
        }
    }

    function updateCanGotoWeeks() {
        vm.canGotoPrevWeek = moment(vm.currentWeekDates[0].date, 'DD.MM.YYYY').isAfter(moment(firstPeriodDate, 'DD.MM.YYYY'));
        vm.canGotoNextWeek = moment(vm.currentWeekDates[6].date, 'DD.MM.YYYY').isBefore(moment(lastPeriodDate, 'DD.MM.YYYY'));
    }

    function getWeekDaysList() {
        /* eslint-disable */
        var localeData = moment.localeData(),
            weekdaysAll = localeData._weekdaysMin;
        /* eslint-enable */
        return ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map(function (code, num) {
            return {
                code: code,
                name: weekdaysAll[num === 6 ? 0 : num + 1]
            };
        });
    }

    function getCurrentWeekDates(firstWeekDate) {
        var i = 0;
        var date = moment(firstWeekDate, 'DD.MM.YYYY'),
            list = [];
        while (i < 7) {
            list.push({
                date: date.format('DD.MM.YYYY'),
                label: date.format('D MMM'),
                year: date.format('YYYY')
            });
            date.add(1, 'days');
            i++;
        }
        return list;
    }

    function getFirstPeriodDate(fromDate, todayDate, scheduleFlights) {
        var firstPeriodDate = void 0,
            minBeginDate = void 0;
        var scheduleBeginDates = [];
        if (fromDate) {
            firstPeriodDate = fromDate;
        } else {
            scheduleFlights.forEach(function (scheduleRow) {
                scheduleRow.flights.forEach(function (flight) {
                    scheduleBeginDates.push(flight.begin_date);
                });
            });
            minBeginDate = utils.getMinDateFromList(scheduleBeginDates);
            if (utils.compareStringDate(minBeginDate, todayDate) === 1) {
                firstPeriodDate = minBeginDate;
            } else {
                firstPeriodDate = todayDate;
            }
        }
        return moment(firstPeriodDate, 'DD.MM.YYYY').startOf('week').format('DD.MM.YYYY');
    }

    function getLastPeriodDate(toDate, scheduleFlights) {
        var lastPeriodDate = void 0;
        var scheduleEndDates = [];
        if (toDate) {
            lastPeriodDate = toDate;
        } else {
            scheduleFlights.forEach(function (scheduleRow) {
                scheduleRow.flights.forEach(function (flight) {
                    scheduleEndDates.push(flight.end_date);
                });
            });
            lastPeriodDate = utils.getMaxDateFromList(scheduleEndDates);
        }
        return moment(lastPeriodDate, 'DD.MM.YYYY').endOf('week').format('DD.MM.YYYY');
    }

    function checkActiveFlightDay(weekDaysStr, weekDaynum, currentDate, flightBeginDate, flightEndDate) {
        return weekDaysStr.indexOf('' + (weekDaynum + 1)) !== -1 && utils.isDateInPeriod(currentDate, flightBeginDate, flightEndDate);
    }

    function checkIsDateInPast(date) {
        return utils.compareStringDate(todayDate, date) > 0;
    }
}

},{}],519:[function(require,module,exports){
"use strict";

angular.module('app').component('searchVariants', {
    templateUrl: 'components/search-variants/search-variants.html',
    controller: ['utils', SearchVariantsController],
    controllerAs: 'vm',
    bindings: {
        searchResult: '=result',
        searchParams: '=params',
        selectVariant: '=select'
    }
});

function SearchVariantsController(utils) {

    var vm = this;

    vm.suffixCount = utils.suffixCount;
}

},{}],520:[function(require,module,exports){
"use strict";

angular.module('app').component('seatMapBase', {
    templateUrl: 'components/seat-map-base/seat-map-base.html',
    controller: ['utils', 'backend', '$scope', SeatMapBaseController],
    controllerAs: 'vm',
    bindings: {
        decks: '<',
        onSeatSelect: '&',
        svcs: '<',
        legend: '<'
    }
});

function SeatMapBaseController(utils, backend, $scope) {

    var vm = this;

    vm.getSeatCssPropertiesClasses = getSeatCssPropertiesClasses;
    vm.getSeatCssGroupClasses = getSeatCssGroupClasses;
    vm.getRowSeatsUniqueCssPropertiesClasses = getRowSeatsUniqueCssPropertiesClasses;
    vm.seatClickHandler = seatClickHandler;
    vm.seatSelectHandler = seatSelectHandler;
    vm.resetHover = resetHover;
    vm.hasAlias = backend.hasAlias;

    $scope.$watch('vm.decks', resetHover);

    function resetHover() {
        vm.hoverRow = -1;
        vm.hoverCell = -1;
        vm.hoverDeck = -1;
        vm.hoverCabin = -1;
    }

    function seatClickHandler(seat, cellNum, rowNum, cabinNum, deckNum) {
        if (!seat.selectedByActivePassenger && !seat.selectedByOrderPassenger && seat.available) {
            vm.hoverRow = rowNum;
            vm.hoverCell = cellNum;
            vm.hoverCabin = cabinNum;
            vm.hoverDeck = deckNum;
        }
    }

    function seatSelectHandler(seat, rowNumber) {
        if (utils.hasInList(seat.properties, 'E')) {
            vm.emergencyExitSeatSubmitCallback = function () {
                vm.onSeatSelect({ $seat: seat, $rowNumber: rowNumber });
            };
            vm.showEmergencyExitSeatWarning = true;
        } else {
            vm.onSeatSelect({ $seat: seat, $rowNumber: rowNumber });
        }
        resetHover();
    }

    function getSeatCssPropertiesClasses(seat) {
        var str = '';
        if (seat && seat.properties) {
            seat.properties.forEach(function (prop) {
                str += ' seat-prop-' + prop;
            });
        }
        return str;
    }

    function getSeatCssGroupClasses(cell) {

        var legendIndex = cell.legendIndex;

        if (cell.available && !cell.rfisc) {
            legendIndex = 0;
        }

        if (legendIndex != -1) {
            if (vm.legend[legendIndex] && vm.legend[legendIndex].colorCode) {
                return 'seat-map__seat_color-code_' + vm.legend[legendIndex].colorCode;
            } else {
                return 'seat-map__seat_color-group_' + legendIndex;
            }
        }
        return '';
    }

    function getRowSeatsUniqueCssPropertiesClasses(seats) {
        var props = [];
        var str = '';
        seats.forEach(function (seat) {
            if (seat && seat.properties) {
                seat.properties.forEach(function (prop) {
                    if (!utils.hasInList(props, prop)) {
                        props.push(prop);
                    }
                });
            }
        });
        props.forEach(function (prop) {
            str += ' row-has-seat-prop-' + prop;
        });
        return str;
    }
}

},{}],521:[function(require,module,exports){
"use strict";

angular.module('app').component('seatMapError', {
    templateUrl: 'components/seat-map-error/seat-map-error.html',
    controller: [SeatMapErrorController],
    controllerAs: 'vm',
    bindings: {
        code: '<'
    }
});

function SeatMapErrorController() {}

},{}],522:[function(require,module,exports){
"use strict";

angular.module('app').component('seatMapSvgLegendChair', {
    templateUrl: 'components/seat-map-svg-legend-chair/seat-map-svg-legend-chair.html',
    controllerAs: 'vm',
    bindings: {
        code: '<'
    }
});

},{}],523:[function(require,module,exports){
"use strict";

angular.module('app').component('seatMapSvg', {
    templateUrl: 'components/seat-map-svg/seat-map-svg.html',
    controller: ['$window', '$sce', '$timeout', '$element', 'backend', 'utils', SeatMapController],
    controllerAs: 'vm',
    bindings: {
        activeDeckNum: '=',
        updatePlaces: '=update',
        decks: '<',
        images: '<',
        locked: '<',
        svcs: '<',
        onSeatSelect: '&'
    }
});

function SeatMapController($window, $sce, $timeout, $element, backend, utils) {

    var tooltipOffset = 6;
    var vm = this;
    var seatMapLegendMode = backend.getParam('extraServices.seatMapLegendMode');
    vm.updatePlaces = updatePlaces;

    vm.$onInit = function () {
        initPlaces();
        if (vm.activeDeckNum === undefined || !vm.decks[vm.activeDeckNum]) {
            vm.activeDeckNum = 0;
        }
    };

    function initPlaces() {

        vm.deckList = vm.decks.map(function (deck, deckNum) {
            return {
                svg: $sce.trustAsHtml(vm.images[deckNum]),
                code: deck.code
            };
        });

        $timeout(function () {
            vm.decks.forEach(function (deck, deckNum) {
                deck.cabins.forEach(function (cabin, cabinNum) {
                    cabin.rows.forEach(function (row, rowNum) {
                        row.chairs.forEach(function (chair, chairNum) {
                            if (chair.number) {
                                var placeNumber = row.number + chair.number;
                                var placeBlock = $element.find('#seat-' + placeNumber);
                                if (!placeBlock.length) {
                                    // eslint-disable-next-line
                                    console.error('Place ' + placeNumber + ' not found in SVG');
                                } else {
                                    if (!vm.locked) {
                                        placeBlock.on('click', function () {
                                            var updatedChair = vm.decks[deckNum].cabins[cabinNum].rows[rowNum].chairs[chairNum];
                                            if (updatedChair.available && !updatedChair.selected) {
                                                vm.onSeatSelect({ $seat: chair, $rowNumber: row.number });
                                            }
                                        });
                                        placeBlock.on('mouseover', function () {
                                            var updatedChair = vm.decks[deckNum].cabins[cabinNum].rows[rowNum].chairs[chairNum];
                                            if (updatedChair.available && !updatedChair.selected) {

                                                var placeRect = placeBlock[0].getBoundingClientRect();
                                                var isEmergencyExit = updatedChair.properties.includes('E');

                                                vm.tooltipContent = placeNumber;
                                                if (updatedChair.cost && updatedChair.currency) {
                                                    vm.tooltipContent += ' &ndash; ' + utils.formatPrice({
                                                        value: updatedChair.cost,
                                                        currency: updatedChair.currency
                                                    });
                                                }
                                                if (isEmergencyExit) {
                                                    vm.tooltipContent += backend.getAlias('web.extraServices.seat.emergencySeatLabel');
                                                }

                                                $timeout(function () {
                                                    var tooltipBlock = $element.find('#seatMapTooltip');
                                                    if (tooltipBlock[0]) {
                                                        var tooltipRect = tooltipBlock[0].getBoundingClientRect();
                                                        vm.tooltipAlignBottom = placeRect.top < $window.innerHeight / 2;
                                                        vm.tooltipPosition = {
                                                            top: vm.tooltipAlignBottom ? Math.round(placeRect.top + placeRect.height + tooltipOffset) + 'px' : Math.round(placeRect.top - tooltipRect.height - tooltipOffset) + 'px',
                                                            left: Math.round(placeRect.left - tooltipRect.width / 2 + placeRect.width / 2) + 'px'
                                                        };
                                                    }
                                                });
                                            }
                                        });
                                        placeBlock.on('mouseout', function () {
                                            vm.tooltipContent = false;
                                        });
                                    }
                                }
                            }
                        });
                    });
                });
            });
            updatePlaces();
            var lostSeats = $element.find('[id]:not(.seat-map__place)').filter(function (i, ele) {
                return ele.id && ele.id.indexOf('seat-') === 0;
            });
            lostSeats.each(markAsUnavailable);
        });
    }

    function updatePlaces() {
        var allPropsList = [];
        vm.decks.forEach(function (deck) {
            deck.cabins.forEach(function (cabin) {
                cabin.rows.forEach(function (row) {
                    row.chairs.forEach(function (chair) {
                        if (chair.number) {
                            var placeNumber = row.number + chair.number;
                            var placeBlock = $element.find('#seat-' + placeNumber);
                            if (placeBlock[0]) {
                                placeBlock[0].setAttribute('class', generatePlaceCssClasses(chair));
                            }
                            if (chair.properties) {
                                chair.properties.forEach(function (prop) {
                                    if (!utils.hasInList(allPropsList, prop)) {
                                        allPropsList.push(prop);
                                    }
                                });
                            }
                        }
                    });
                });
            });
        });
        vm.allPropsList = allPropsList;
    }

    function markAsUnavailable(i, seat) {
        seat.setAttribute('class', 'seat-map__place seat-map__place_unavailable');
    }

    function generatePlaceCssClasses(place) {
        var list = ['seat-map__place'];
        if (place.selected) {
            list.push('seat-map__place_selected');
        }
        if (place.cost && seatMapLegendMode === 'PRICE') {
            list.push('seat-map__place_color-code_' + Big(place.cost).toFixed(0) + '_' + place.currency);
        }
        if (place.legendIndex !== undefined && seatMapLegendMode === 'RFISC') {
            list.push('seat-map__place_color-group_' + place.legendIndex);
        }
        if (place.available && !vm.locked) {
            list.push('seat-map__place_available');
            if (!place.rfisc) {
                list.push('seat-map__place_available-without-rfisc');
            }
        } else {
            list.push('seat-map__place_unavailable');
        }
        return list.join(' ');
    }
}

},{}],524:[function(require,module,exports){
"use strict";

angular.module('app').component('segmentPricesCalendar', {
    templateUrl: 'components/segment-prices-calendar/segment-prices-calendar.html',
    controller: ['$element', '$scope', SegmentPricesCalendarController],
    controllerAs: 'vm',
    bindings: {
        cells: '<',
        segNum: '<',
        resetDate: '<',
        checkResetDate: '<',
        loading: '<',
        activeDate: '<'

    }
});

function SegmentPricesCalendarController($element, $scope) {

    var vm = this,
        scrollContainer = $element.find('div.selectDateScroll_js');

    vm.scrollRight = scrollRight;
    vm.scrollLeft = scrollLeft;
    vm.canScrollRight = true;
    vm.canScrollLeft = false;

    scrollContainer.on('scroll', scrollHandler);

    function scrollHandler() {
        var scrollLeft = scrollContainer[0].scrollLeft,
            scrollWidth = scrollContainer[0].scrollWidth,
            clientWidth = scrollContainer[0].clientWidth,
            scrollRight = scrollWidth - clientWidth - scrollLeft;
        vm.canScrollRight = scrollRight !== 0;
        vm.canScrollLeft = scrollLeft !== 0;
        $scope.$apply();
    }

    function scrollRight() {
        var item = $element.find('div.item');
        var newScrollPosition = scrollContainer[0].scrollLeft + item[0].offsetWidth;
        if (newScrollPosition > scrollContainer[0].scrollWidth) {
            newScrollPosition = scrollContainer[0].scrollWidth;
        }
        jQuery(scrollContainer).animate({ scrollLeft: newScrollPosition });
    }

    function scrollLeft() {
        var item = $element.find('div.item');
        var newScrollPosition = scrollContainer[0].scrollLeft - item[0].offsetWidth;
        if (newScrollPosition < 0) {
            newScrollPosition = 0;
        }
        jQuery(scrollContainer).animate({ scrollLeft: newScrollPosition });
    }
}

},{}],525:[function(require,module,exports){
"use strict";

angular.module('app').component('selectedVariant', {
    templateUrl: 'components/selected-variant/selected-variant.html',
    controller: ['backend', '$scope', SelectedVariantController],
    controllerAs: 'vm',
    bindings: {
        promoCode: '<',
        selectedVariantsInfo: '=info',
        pricingVariant: '=pricing'
    }
});

function SelectedVariantController(backend, $scope) {

    var vm = this;

    vm.hasAlias = backend.hasAlias;

    $scope.$watch('vm.pricingVariant', function () {

        updateRoundTripDiscount();

        if (backend.getParam('ffp.enable')) {
            vm.ffpBonus = 0;
            backend.ffpBonus().then(function (resp) {
                vm.ffpBonus = resp.total || 0;
            });
        }

        if (backend.getParam('search.expandSelectedVariantPassengerCategories')) {
            vm.passDropOpened = vm.pricingVariant.passengerCategories.map(function () {
                return true;
            });
        }
    });

    function updateRoundTripDiscount() {
        vm.roundTripDiscount = false;
        if (vm.selectedVariantsInfo && vm.selectedVariantsInfo.length === 2 && vm.selectedVariantsInfo[0].price && vm.selectedVariantsInfo[1].price && vm.pricingVariant && vm.pricingVariant.totalPrice) {
            var roundTripDiscount = Big(vm.selectedVariantsInfo[1].price).plus(vm.selectedVariantsInfo[0].price).minus(vm.pricingVariant.totalPrice);
            if (roundTripDiscount.gt(0)) {
                vm.roundTripDiscount = roundTripDiscount.toFixed(2);
            } else if (roundTripDiscount.lt(0)) {
                backend.sendErrorReport('CONFIG_ERROR', 'Summ of prices by segments less than total price', JSON.stringify({
                    selectedVariantsInfo: vm.selectedVariantsInfo,
                    pricingVariant: vm.pricingVariant
                }));
            }
        }
    }
}

},{}],526:[function(require,module,exports){
"use strict";

angular.module('app').component('separateOrderPassengersList', {
    templateUrl: 'components/separate-order-passengers-list/separate-order-passengers-list.html',
    controller: [SeparateOrderPassengersListController],
    controllerAs: 'vm',
    bindings: {
        passengers: '='
    }
});

function SeparateOrderPassengersListController() {}

},{}],527:[function(require,module,exports){
"use strict";

angular.module('app').component('servicePicker', {
    templateUrl: 'components/service-picker/service-picker.html',
    controller: [ServicePickerController],
    controllerAs: 'vm',
    bindings: {
        count: '=',
        limit: '=',
        onIncrease: '&',
        onDecrease: '&',
        locked: '='
    }
});

function ServicePickerController() {
    var vm = this;

    vm.increase = increase;
    vm.decrease = decrease;

    updateState();

    function increase() {
        if (vm.canPlus) {
            updateState();
            vm.onIncrease();
        }
    }

    function decrease() {
        if (vm.canMinus) {
            updateState();
            vm.onDecrease();
        }
    }

    function updateState() {
        if (!vm.count) {
            vm.count = 0;
        }

        vm.canPlus = vm.count < vm.limit;
        vm.canMinus = vm.count > 0;
    }
}

},{}],528:[function(require,module,exports){
"use strict";

angular.module('app').component('smartButton', {
    templateUrl: 'components/smart-button/smart-button.html',
    controller: [function () {}],
    controllerAs: 'vm',
    bindings: {
        content: '<',
        prefix: '@',
        loading: '<',
        locked: '<'
    }
});

},{}],529:[function(require,module,exports){
"use strict";

angular.module('app').component('smartCaptcha', {
    templateUrl: 'components/smart-captcha/smart-captcha.html',
    controller: ['$window', 'backend', CaptchaController],
    controllerAs: 'vm',
    bindings: {
        token: '='
    }
});

function CaptchaController($window, backend) {

    var vm = this;

    $window.smartCaptcha.render('smartCaptchaContainer', {
        sitekey: backend.applicationConstants.recaptchaPublicKey,
        callback: function callback(captchaText) {
            vm.token = captchaText;
        }
    });
}

},{}],530:[function(require,module,exports){
"use strict";

angular.module('app').component('smsNotificationSelectForm', {
    templateUrl: 'components/sms-notification-select-form/sms-notification-select-form.html',
    controller: ['$scope', 'backend', 'utils', SmsNotificationSelectFormController],
    controllerAs: 'vm',
    bindings: {
        service: '<',
        locked: '<',
        orderInfo: '<order'
    }
});

function SmsNotificationSelectFormController($scope, backend, utils) {

    var vm = this;
    var addServiceAfterUpdatePhone = false;

    vm.showModalForPax = -1;
    vm.openModal = openModal;
    vm.addServiceByPassenger = addServiceByPassenger;
    vm.removeServiceByPassenger = removeServiceByPassenger;
    vm.updatePhone = updatePhone;

    $scope.$watch('vm.orderInfo', function () {
        vm.passengerPhones = vm.orderInfo.passengers.map(function (passenger) {
            return passenger.phone;
        });
        vm.svcsByPassenger = utils.groupSvcsByPassenger(vm.service.svcs, vm.orderInfo);
    });

    $scope.$watch('vm.service', function () {
        vm.svcsByPassenger = utils.groupSvcsByPassenger(vm.service.svcs, vm.orderInfo);
    });

    function addServiceByPassenger(passengerNum) {
        if (vm.passengerPhones[passengerNum]) {
            addServiceByPassengerHandler(passengerNum);
        } else {
            vm.showModalForPax = passengerNum;
            addServiceAfterUpdatePhone = true;
        }
    }

    function addServiceByPassengerHandler(passengerNum) {
        if (!vm.locked && !backend.checkServiceRemovalProhibited(vm.service.code, passengerNum)) {
            backend.modifyExtraService({
                code: vm.service.code,
                passenger_id: vm.orderInfo.passengers[passengerNum].id,
                subgroup: vm.svcsByPassenger[passengerNum].subgroupCode,
                rfisc: vm.svcsByPassenger[passengerNum].rfisc
            });
        }
    }

    function removeServiceByPassenger(passengerNum) {
        var item = vm.svcsByPassenger[passengerNum];
        if (!vm.locked && !backend.checkServiceRemovalProhibited(vm.service.code, passengerNum)) {
            backend.removeExtraService({
                code: vm.service.code,
                passenger_id: vm.orderInfo.passengers[passengerNum].id,
                subgroup: item.subgroupCode,
                rfisc: item.rfisc
            }).then(function () {
                if (!vm.orderInfo.header || vm.orderInfo.header.status !== 'paid') {
                    updatePhone(passengerNum, false);
                }
            });
        }
    }

    function openModal(passengerNum) {
        vm.showModalForPax = passengerNum;
    }

    function updatePhone(passengerNum, phone) {
        vm.loading = true;
        backend.updatePassengerPhone(vm.orderInfo.passengers[passengerNum].id, phone).then(function () {
            vm.passengerPhones[passengerNum] = phone;
            vm.showModalForPax = -1;
            vm.loading = false;
            if (addServiceAfterUpdatePhone) {
                addServiceAfterUpdatePhone = false;
                addServiceByPassengerHandler(passengerNum);
            }
        }, function (resp) {
            vm.showModalForPax = -1;
            vm.errorMessage = resp.error;
            vm.loading = false;
            addServiceAfterUpdatePhone = false;
        });
    }
}

},{}],531:[function(require,module,exports){
"use strict";

angular.module('app').component('svgSpriteIcon', {
    templateUrl: 'components/svg-sprite-icon/svg-sprite-icon.html',
    controller: ['$sce', SvgIconController],
    controllerAs: 'vm',
    bindings: {
        code: '@',
        prefix: '@'
    }
});

function SvgIconController($sce) {
    var vm = this;

    vm.$onInit = function () {
        vm.svgTag = generateSvgTag();
    };

    function generateSvgTag() {
        // We use dirty solution because IE11
        return $sce.trustAsHtml('\n            <svg class="svg-sprite-icon svg-' + vm.code + ' ' + (vm.prefix || '') + '">\n                <use xlink:href="#' + vm.code + '"></use>\n            </svg>\n        ');
    }
}

},{}],532:[function(require,module,exports){
"use strict";

angular.module('app').directive('uiSelectCustom', ['$timeout', function ($timeout) {
    return {
        require: 'uiSelect',
        restrict: 'A',
        link: function link($scope, element, attrs, ctrl) {

            /**
             * Смена елемента по табуляции
             */
            changeElementByTabEvent();

            function changeElementByTabEvent() {
                var autoopen = true;

                angular.element(ctrl.focusser).on('focus', function () {
                    if (autoopen) {
                        ctrl.activate();
                    }
                });

                $scope.$on('uis:closeAll', function () {
                    ctrl.close();
                });

                //Дизейблим autoopen, когда выбранный элемент активирован
                $scope.$on('uis:activate', function () {
                    autoopen = false;
                });

                $scope.$on('uis:close', function () {
                    //Чтобы focusser после закрытия не выполнял re-activate
                    autoopen = false;
                    //250ms специально для IE
                    $timeout(function () {
                        autoopen = true;
                    }, 250);
                });
            }
        }
    };
}]);

},{}],533:[function(require,module,exports){
"use strict";

angular.module('app').directive('uiSelectMainPage', ['$window', function ($window) {
    return {
        restrict: 'A',
        require: 'uiSelect',
        link: function link(scope) {
            scope.$on('uis:activate', function () {
                angular.element($window.document.getElementById('searchFormCountContainer')).toggleClass('focus-counts');
            });
            scope.$on('uis:close', function () {
                angular.element($window.document.getElementById('searchFormCountContainer')).toggleClass('focus-counts');
            });
        }
    };
}]);

},{}],534:[function(require,module,exports){
"use strict";

angular.module('app').directive('variantsSortSwitch', ['$document', function ($document) {

    function link(scope, element) {
        $document.on('click', function (event) {
            if (element.find(event.target).length) {
                scope.active = !scope.active;
            } else {
                scope.active = false;
            }
            scope.$apply();
        });
    }

    function variantsSortSwitchController($scope) {

        $scope.types = ['flighttime', 'price', 'departuretime', 'arrivaltime'];

        $scope.select = function (type) {
            $scope.selected = type;
        };
    }

    return {
        link: link,
        controller: ['$scope', variantsSortSwitchController],
        scope: {
            selected: '=selected'
        },
        restrict: 'E',
        templateUrl: 'components/variants-sort-switch/variants-sort-switch.html'
    };
}]);

},{}],535:[function(require,module,exports){
"use strict";

var momentLang = o2context.lang;

if (momentLang === 'hy') {
    momentLang = 'hy-am';
}

moment.locale(momentLang);

moment.updateLocale(momentLang, { week: { dow: 1, doy: 4 } });

angular.module('app').config(['momentPickerProvider', function (momentPickerProvider) {

    if (momentLang === 'ru') {
        moment.updateLocale('ru', {
            months: {
                format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
                standalone: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_')
            }
        });
    }
    if (momentLang === 'uz') {
        moment.updateLocale('uz', {
            weekdays: {
                format: 'yakshanba_dushanba_seshanba_chorshanba_payshanba_juma_shanba'.split('_'),
                standalone: 'yakshanba_dushanba_seshanba_chorshanba_payshanba_juma_shanba'.split('_')
            },
            weekdaysMin: 'Yak_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
            months: {
                format: 'YANVAR_FEVRAL_MART_APREL_MAY_IYUN_IYUL_AVGUST_SENTABR_OKTABR_NOYABR_DEKABR'.split('_'),
                standalone: 'YANVAR_FEVRAL_MART_APREL_MAY_IYUN_IYUL_AVGUST_SENTABR_OKTABR_NOYABR_DEKABR'.split('_')
            }
        });
    }

    momentPickerProvider.options({
        locale: momentLang,
        format: 'DD.MM.YYYY',
        minView: 'month',
        maxView: 'month',
        today: true,
        keyboard: true,
        autoclose: true,
        leftArrow: '<div class="datepicker-arrow datepicker-arrow_left"><svg><use xlink:href="#corner-arrow"></use></svg></div>',
        rightArrow: '<div class="datepicker-arrow datepicker-arrow_right"><svg><use xlink:href="#corner-arrow"></use></svg></div>'
    });
}]);

},{}],536:[function(require,module,exports){
"use strict";

angular.module('app').filter('cropToInitials', function () {
    return function (fullName) {
        return (fullName || '').trim().split(' ').map(function (word) {
            return word[0].toUpperCase() + '.';
        }).join('');
    };
});

},{}],537:[function(require,module,exports){
"use strict";

angular.module('app').filter('dateOfBirth', function () {
    return function (input) {
        return moment(input, 'DD.MM.YYYY').format('D MMM, YYYY');
    };
});

},{}],538:[function(require,module,exports){
"use strict";

angular.module('app').filter('flightPlanDescription', function () {
    return function (flights) {
        return flights.map(function (flight) {
            return flight.origincityName + ' - ' + flight.destinationcityName + ' ' + flight.departuretime + ' ' + flight.departuredate;
        }).join(' / ');
    };
});

},{}],539:[function(require,module,exports){
"use strict";

require('./dateOfBirth');
require('./sortByCost');
require('./cropToInitials');
require('./flightPlanDescription');

},{"./cropToInitials":536,"./dateOfBirth":537,"./flightPlanDescription":538,"./sortByCost":540}],540:[function(require,module,exports){
"use strict";

angular.module('app').filter('sortByCost', function () {
    return function (list) {
        return list.sort(function (a, b) {
            var A = Big(a.cost);
            var B = Big(b.cost);
            if (A.gt(B)) {
                return 1;
            } else if (A.lt(B)) {
                return -1;
            } else {
                return 0;
            }
        });
    };
});

},{}],541:[function(require,module,exports){
"use strict";

require('./popup-login/popupLogin');
require('./popup-registration/popupRegistration');
require('./popup-reset-password/popupResetPassword');
require('./popup-resend-activation-mail/popupResendActivationMail');
require('./popup-flight-detail/popupFlightDetail');
require('./popup-order-flight-detail/popupOrderFlightDetail');
require('./popup-remark/popupRemark');
require('./popup-alias/popupAlias');
require('./popup-compare/popupCompare');
require('./popup-compare-ffp/popupCompareFfp');
require('./popup-cancel-order/popupCancelOrder');
require('./popup-aeroexpress-schedule/popupAeroexpressSchedule');
require('./popup-aeroexpress-fares/popupAeroexpressFares');
require('./popup-session-inactive/popupSessionInactive');
require('./popup-cancel-session/popupCancelSession');
require('./popup-exchange-extra-services-refund/popupExchangeExtraServicesRefund');
require('./popup-captcha-required/popupCaptchaRequired');
require('./popup-confirm-passenger-names/popupConfirmPassengerNames');
require('./popup-removed-services-warning/popupRemovedServicesWarning');
require('./popup-removed-services-warning-by-order/popupRemovedServicesWarningByOrder');
require('./popup-confirm-remove-private-passenger/popupConfirmRemovePrivatePassenger');
require('./popup-cancel-conflict-services/popupCancelConflictServices');
require('./popup-detailedprice/popupDetailedprice');
require('./popup-issue-tickets/popupIssueTickets');
require('./popup-intermodal/popupIntermodal');
require('./popup-order-email-required/popupOrderEmailRequired');
require('./popup-send-receipt/popupSendReceipt');
require('./popup-fare-group-description/popupFareGroupDescription');
require('./popup-change-currency-error/popupChangeCurrencyError');
require('./popup-aeroexpress-refund/popupAeroexpressRefund');
require('./popup-confirm-delete-profile/popupConfirmDeleteProfile');
require('./popup-delete-card/popupDeleteCard');
require('./popup-choose-pay-method/popupChoosePayMethod');
require('./popup-geo-choose-country/popupGeoChooseCountry');
require('./popup-geo-choose-country-with-chooser/popupGeoChooseCountryWithChooser');
require('./popup-emergency-exit-seat-warning/popupEmergencyExitSeatWarning');
require('./popup-ynao-discount-select/popupYnaoDiscountSelect');
require('./popup-meal/popupMeal');
require('./popup-baggage/popupBaggage');
require('./popup-brand/popupBrand');
require('./popup-contacts-required/popupContactsRequired');
require('./popup-error-goto-search/popupErrorGotoSearch');
require('./popup-promo-codes-discount/popupPromoCodesDiscount');
require('./popup-facilities-documents-upload-confirm/popupFacilitiesDocumentsUploadConfirm');
require('./popup-scanned-docs-search-group-warning/popupScannedDocsSearchGroupWarning');
require('./popup-facilities-documents-format-error/popupFacilitiesDocumentsFormatError');
require('./popup-sms-notification/popupSmsNotification');
require('./popup-common-service/popupCommonService');
require('./popup-insurance/popupInsurance');
require('./popup-ae-service/popupAeService');
require('./popup-iin-editor/popupIinEditor');
require('./popup-ffp-edit/popupFfpEdit');
require('./popup-infant-parent/popupInfantParent');

},{"./popup-ae-service/popupAeService":542,"./popup-aeroexpress-fares/popupAeroexpressFares":543,"./popup-aeroexpress-refund/popupAeroexpressRefund":544,"./popup-aeroexpress-schedule/popupAeroexpressSchedule":545,"./popup-alias/popupAlias":546,"./popup-baggage/popupBaggage":547,"./popup-brand/popupBrand":548,"./popup-cancel-conflict-services/popupCancelConflictServices":549,"./popup-cancel-order/popupCancelOrder":550,"./popup-cancel-session/popupCancelSession":551,"./popup-captcha-required/popupCaptchaRequired":552,"./popup-change-currency-error/popupChangeCurrencyError":553,"./popup-choose-pay-method/popupChoosePayMethod":554,"./popup-common-service/popupCommonService":555,"./popup-compare-ffp/popupCompareFfp":556,"./popup-compare/popupCompare":557,"./popup-confirm-delete-profile/popupConfirmDeleteProfile":558,"./popup-confirm-passenger-names/popupConfirmPassengerNames":559,"./popup-confirm-remove-private-passenger/popupConfirmRemovePrivatePassenger":560,"./popup-contacts-required/popupContactsRequired":561,"./popup-delete-card/popupDeleteCard":562,"./popup-detailedprice/popupDetailedprice":563,"./popup-emergency-exit-seat-warning/popupEmergencyExitSeatWarning":564,"./popup-error-goto-search/popupErrorGotoSearch":565,"./popup-exchange-extra-services-refund/popupExchangeExtraServicesRefund":566,"./popup-facilities-documents-format-error/popupFacilitiesDocumentsFormatError":567,"./popup-facilities-documents-upload-confirm/popupFacilitiesDocumentsUploadConfirm":568,"./popup-fare-group-description/popupFareGroupDescription":569,"./popup-ffp-edit/popupFfpEdit":570,"./popup-flight-detail/popupFlightDetail":571,"./popup-geo-choose-country-with-chooser/popupGeoChooseCountryWithChooser":572,"./popup-geo-choose-country/popupGeoChooseCountry":573,"./popup-iin-editor/popupIinEditor":574,"./popup-infant-parent/popupInfantParent":575,"./popup-insurance/popupInsurance":576,"./popup-intermodal/popupIntermodal":577,"./popup-issue-tickets/popupIssueTickets":578,"./popup-login/popupLogin":579,"./popup-meal/popupMeal":580,"./popup-order-email-required/popupOrderEmailRequired":581,"./popup-order-flight-detail/popupOrderFlightDetail":582,"./popup-promo-codes-discount/popupPromoCodesDiscount":583,"./popup-registration/popupRegistration":584,"./popup-remark/popupRemark":585,"./popup-removed-services-warning-by-order/popupRemovedServicesWarningByOrder":586,"./popup-removed-services-warning/popupRemovedServicesWarning":587,"./popup-resend-activation-mail/popupResendActivationMail":588,"./popup-reset-password/popupResetPassword":589,"./popup-scanned-docs-search-group-warning/popupScannedDocsSearchGroupWarning":590,"./popup-send-receipt/popupSendReceipt":591,"./popup-session-inactive/popupSessionInactive":592,"./popup-sms-notification/popupSmsNotification":593,"./popup-ynao-discount-select/popupYnaoDiscountSelect":594}],542:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('popupAeService', {
    templateUrl: 'modals/popup-ae-service/popup-ae-service.html',
    controller: ['$scope', '$timeout', 'backend', 'utils', PopupAeServiceController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        items: '<',
        ticketCountLimit: '<',
        autoSelectByOpen: '<',
        autoSelectMinAge: '<',
        onClose: '&',
        locked: '<'
    }
});

function PopupAeServiceController($scope, $timeout, backend, utils) {

    var vm = this;
    vm.closeHandler = closeHandler;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;
    vm.changeDateHandler = changeDateHandler;

    vm.$onInit = function () {

        cardDataUpdate();

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, 'aeroexpress');

        utils.addViewedServiceItem('aeroexpress');

        if (vm.autoSelectByOpen && !hasBeenViewed) {

            var autoSelectItemsParams = [];

            vm.availableAeByFareRoutesList.forEach(function (availableAeItem, index) {
                if (availableAeItem.selectedDate && !availableAeItem.dateVariants[availableAeItem.selectedDate].alreadySelectedCount) {
                    var aeMoment = moment(availableAeItem.selectedDate, 'DD.MM.YYYY');
                    var paxListForDate = vm.orderInfo.passengers.filter(function (pax) {
                        var yearsDiff = aeMoment.diff(moment(pax.dateOfBirth, 'DD.MM.YYYY'), 'years', false);
                        return yearsDiff >= vm.autoSelectMinAge;
                    });
                    autoSelectItemsParams.push({
                        index: index,
                        count: paxListForDate.length > vm.ticketCountLimit ? vm.ticketCountLimit : paxListForDate.length
                    });
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params.index, params.count, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params.index, params.count, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watchGroup(['vm.card', 'vm.orderInfo'], cardDataUpdate);

    function changeDateHandler(item, index) {
        var dateVariants = item.dateVariants,
            dateVariantsList = item.dateVariantsList,
            selectedDate = item.selectedDate;


        var reqParamsList = [];

        var tmpSelectedCount = 0;

        dateVariantsList.forEach(function (dateVariantCode) {
            var dateVariant = dateVariants[dateVariantCode];
            var date = dateVariant.date;

            if (dateVariant.alreadySelectedCount && date !== selectedDate) {
                tmpSelectedCount = dateVariant.alreadySelectedCount;
                reqParamsList.push((0, _extends3.default)({}, item, {
                    selectedDate: date
                }));
            }
        });

        if (reqParamsList.length && tmpSelectedCount) {
            vm.autoRemoveLoader = true;
            var queue = false;
            reqParamsList.forEach(function (params) {
                if (!queue) {
                    queue = serviceClearHandler(params, false);
                } else {
                    queue = queue.then(function () {
                        return serviceClearHandler(params, true);
                    });
                }
            });
            queue = queue.then(function () {
                vm.autoRemoveLoader = false;
                vm.autoSelectLoader = true;
                return serviceCountChangeHandler(index, tmpSelectedCount, false, true);
            });
            queue.finally(function () {
                vm.autoSelectLoader = false;
            });
        }
    }

    function cardDataUpdate() {

        var availableAeByFareRoutes = {};

        vm.items.forEach(function (item) {
            var fare = item.fare,
                departure_code = item.departure_code,
                arrival_code = item.arrival_code,
                date = item.date,
                cost = item.cost,
                currency = item.currency,
                preferredDate = item.preferredDate;


            var fareRouteCode = departure_code + '_' + arrival_code + '_' + fare;

            var orderAeItems = getOrderAeItemsByParams(fare, date, departure_code, arrival_code);

            if (!availableAeByFareRoutes[fareRouteCode]) {
                var dateVariants = {};
                dateVariants[date] = {
                    date: date,
                    cost: cost,
                    currency: currency,
                    preferredDate: preferredDate,
                    alreadySelectedCount: orderAeItems.length
                };
                availableAeByFareRoutes[fareRouteCode] = {
                    fare: fare,
                    departure_code: departure_code,
                    arrival_code: arrival_code,
                    dateVariants: dateVariants
                };
            } else {
                availableAeByFareRoutes[fareRouteCode].dateVariants[date] = {
                    date: date,
                    cost: cost,
                    currency: currency,
                    preferredDate: preferredDate,
                    alreadySelectedCount: orderAeItems.length
                };
            }

            if (preferredDate && !availableAeByFareRoutes[fareRouteCode].selectedDate || orderAeItems.length) {
                availableAeByFareRoutes[fareRouteCode].selectedDate = date;
            }
        });

        vm.availableAeByFareRoutesList = _.keys(availableAeByFareRoutes).map(function (fareRouteCode) {
            return (0, _extends3.default)({}, availableAeByFareRoutes[fareRouteCode], {
                dateVariantsList: _.keys(availableAeByFareRoutes[fareRouteCode].dateVariants)
            });
        });
    }

    function getOrderAeItemsByParams(fare_type, departure_date, departure_code, arrival_code) {
        var result = [];
        if (!vm.orderInfo.editableExtraServicesHeap) {
            return result;
        }
        var orderAeItems = vm.orderInfo.editableExtraServicesHeap.filter(function (item) {
            return item.groupCode === 'aeroexpress';
        });
        if (!orderAeItems.length) {
            return result;
        }
        orderAeItems.forEach(function (item) {

            if (item.fare.fare_type === fare_type && item.departure_date === departure_date && item.departure_code === departure_code && item.arrival_code === arrival_code) {
                result.push(item);
            }
        });
        return result;
    }

    function serviceCountChangeHandler(index, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var item = vm.availableAeByFareRoutesList[index];
        var params = {
            code: 'aeroexpress',
            departure_code: item.departure_code,
            arrival_code: item.arrival_code,
            date: item.selectedDate,
            fare_type: item.fare,
            count: item.dateVariants[item.selectedDate].alreadySelectedCount + delta
        };
        if ((!vm.locked || useStream) && params.count >= 0 && params.count <= vm.ticketCountLimit) {
            return backend.modifyExtraService(params, preventUpdate);
        }
    }

    function serviceClearHandler(item) {
        var useStream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var params = {
            code: 'aeroexpress',
            departure_code: item.departure_code,
            arrival_code: item.arrival_code,
            date: item.selectedDate,
            fare_type: item.fare,
            count: 0
        };
        if (!vm.locked || useStream) {
            return backend.modifyExtraService(params, true);
        }
    }

    function closeHandler() {
        vm.onClose();
    }
}

},{"babel-runtime/helpers/extends":9}],543:[function(require,module,exports){
"use strict";

angular.module('app').component('popupAeroexpressFares', {
    templateUrl: 'modals/popup-aeroexpress-fares/popup-aeroexpress-fares.html',
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        faresList: '<'
    }
});

},{}],544:[function(require,module,exports){
"use strict";

angular.module('app').component('popupAeroexpressRefund', {
    templateUrl: 'modals/popup-aeroexpress-refund/popup-aeroexpress-refund.html',
    controller: ['$route', '$timeout', 'backend', 'modalTools', PopupAeroexpressRefundController],
    controllerAs: 'vm'
});

function PopupAeroexpressRefundController($route, $timeout, backend, modalTools) {

    var vm = this;

    vm.close = modalTools.closeHandler;
    vm.submitRefund = submitRefund;

    function submitRefund() {
        vm.loading = true;
        backend.aeroexpressRefund(vm.id).then(function () {
            $route.reload();
            vm.close();
        }, function (resp) {
            vm.errorMessage = resp.error;
            vm.loading = false;
        });
    }

    modalTools.setOpenListener('popup-aeroexpress-refund', function (link) {
        $timeout(function () {
            vm.loading = false;
            vm.errorMessage = false;
            vm.id = link.attr('data-id');
            vm.cost = link.attr('data-cost');
            vm.currency = link.attr('data-currency');
        });
    });
}

},{}],545:[function(require,module,exports){
"use strict";

angular.module('app').component('popupAeroexpressSchedule', {
    templateUrl: 'modals/popup-aeroexpress-schedule/popup-aeroexpress-schedule.html',
    controller: ['backend', 'utils', PopupAeroexpressScheduleController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        service: '<'
    }
});

function PopupAeroexpressScheduleController(backend, utils) {

    var vm = this;

    vm.switchRoute = switchRoute;
    vm.changeDateHandler = changeDateHandler;

    vm.$onInit = updateState;

    function updateState() {
        vm.loading = true;
        if (!vm.selectedRouteCode) {
            vm.selectedRouteCode = vm.service.routesList[0];
        }
        var selectedRoute = vm.service.routes[vm.selectedRouteCode];
        if (!vm.selectedDate || !utils.hasInList(selectedRoute.dateVariantsList, vm.selectedDate)) {
            vm.selectedDate = selectedRoute.dateVariantsList[0];
        }
        backend.aeroexpressSchedule({
            date: vm.selectedDate,
            arrival: selectedRoute.arrival_code,
            departure: selectedRoute.departure_code
        }).then(function (resp) {
            vm.loading = false;
            vm.schedule = resp.schedule;
        }, function () {
            vm.loading = false;
        });
    }

    function switchRoute(routeCode) {
        if (vm.selectedRouteCode !== routeCode) {
            vm.selectedRouteCode = routeCode;
            updateState();
        }
    }

    function changeDateHandler() {
        updateState();
    }
}

},{}],546:[function(require,module,exports){
"use strict";

angular.module('app').component('popupAlias', {
    templateUrl: 'modals/popup-alias/popup-alias.html',
    controller: ['$timeout', 'modalTools', PopupAliasController],
    controllerAs: 'vm'
});

function PopupAliasController($timeout, modalTools) {

    var vm = this;
    vm.close = modalTools.closeHandler;

    modalTools.setOpenListener('popup-alias', function (link) {
        $timeout(function () {
            vm.code = link.attr('data-popup-alias');
            vm.cssCode = link.attr('data-popup-alias-css-code') || '';
        });
    });
}

},{}],547:[function(require,module,exports){
"use strict";

angular.module('app').component('popupBaggage', {
    templateUrl: 'modals/popup-baggage/popup-baggage.html',
    controller: ['$window', '$scope', '$timeout', 'utils', 'backend', PopupBaggageController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        serviceIconCode: '<',
        card: '<',
        onClose: '&',
        locked: '<'
    }
});

function PopupBaggageController($window, $scope, $timeout, utils, backend) {

    var vm = this;
    vm.suffixCount = utils.suffixCount;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;

    vm.$onInit = function () {

        cardDataUpdate();

        var autoSelect = vm.card && vm.card.svcs && vm.card.svcs[0] && vm.card.svcs[0].customProperties && vm.card.svcs[0].customProperties.autoSelect;

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        utils.addViewedServiceItem(vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        if (hasBeenViewed) {
            return;
        } else if (autoSelect === 'first-pax') {

            var autoSelectItemsParams = [];
            var firstPassengerId = vm.orderInfo.passengers[0].id;

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount && params.passengerId === firstPassengerId) {
                    autoSelectItemsParams.push(params);
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectFirstPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectFirstPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        } else if (autoSelect === 'all-pax') {

            var _autoSelectItemsParams = [];

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount) {
                    _autoSelectItemsParams.push(params);
                }
            });

            if (_autoSelectItemsParams.length) {
                vm.autoSelectAllPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    _autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === _autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectAllPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watch('vm.card', cardDataUpdate);

    function cardDataUpdate() {
        vm.svcsByFlightPassenger = utils.groupSvcsByFlightPassenger(vm.card.svcs, vm.orderInfo);
        vm.selectedFlight = vm.selectedFlight || utils.getFirstAvailableSvcsFlight(vm.card.svcs, vm.orderInfo);
    }

    function serviceCountChangeHandler(svc, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var alreadySelectedCount = svc.alreadySelectedCount || 0;
        if ((!vm.locked || useStream) && (delta < 0 && alreadySelectedCount > 0 || delta > 0 && alreadySelectedCount < svc.limit)) {
            return backend.modifyExtraService({
                code: svc.groupCode,
                passenger_id: svc.passengerId,
                segment_id: svc.segmentId,
                subgroup: svc.subgroupCode,
                amount: alreadySelectedCount + delta,
                rfisc: svc.rfisc
            }, preventUpdate);
        }
    }
}

},{}],548:[function(require,module,exports){
"use strict";

angular.module('app').component('popupBrand', {
    templateUrl: 'modals/popup-brand/popup-brand.html',
    controller: ['backend', PopupCompareController],
    controllerAs: 'vm',
    bindings: {
        code: '<',
        onClose: '&'
    }
});

function PopupCompareController(backend) {

    var vm = this;
    var brandConfig = backend.getBrandConfig();

    vm.$onInit = function () {

        if (vm.code) {
            vm.brand = _.findWhere(brandConfig, { code: vm.code });
        }

        vm.currency = backend.sessionParams.currency;
    };
}

},{}],549:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCancelConflictServices', {
    templateUrl: 'modals/popup-cancel-conflict-services/popup-cancel-conflict-services.html',
    controller: ['backend', 'modalTools', PopupCancelConflictServicesController],
    controllerAs: 'vm'
});

function PopupCancelConflictServicesController(backend, modalTools) {

    var vm = this;
    var submitCallback = false;

    vm.close = close;
    vm.submit = submit;

    modalTools.setOpenListener('popup-cancel-conflict-services', function (link, params) {
        if (params) {
            submitCallback = params.submitCallback;
            vm.paymentForm = params.paymentForm;
            vm.aeroexpress = params.aeroexpress;
            vm.insurance = params.insurance;
        }
    });

    function submit() {
        if (submitCallback) {
            backend.eraseConflictServices({
                aeroexpress: vm.aeroexpress,
                insurance: vm.insurance
            }).then(submitCallback);
        }
        close();
    }

    function close() {
        modalTools.closeHandler();
    }
}

},{}],550:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCancelOrder', {
    templateUrl: 'modals/popup-cancel-order/popup-cancel-order.html',
    controller: ['$route', 'backend', PopupCancelOrderController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&'
    }
});

function PopupCancelOrderController($route, backend) {

    var vm = this;

    vm.submitCancel = submitCancel;

    function submitCancel() {
        vm.submitLoading = true;
        backend.cancelOrder().then(function () {
            vm.submitLoading = false;
            vm.onClose();
            $route.reload();
        }, function () {
            vm.submitLoading = false;
        });
    }
}

},{}],551:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCancelSession', {
    templateUrl: 'modals/popup-cancel-session/popup-cancel-session.html',
    controller: ['$window', 'modalTools', PopupCancelSessionController],
    controllerAs: 'vm'
});

function PopupCancelSessionController($window, modalTools) {

    var vm = this;

    vm.reload = reload;

    modalTools.setOpenListener('popup-cancel-session', function (link, params) {
        vm.isParallelSession = params.isParallelSession;
    });

    function reload() {
        modalTools.closeHandler();
        $window.location = "./";
    }
}

},{}],552:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCaptchaRequired', {
    templateUrl: 'modals/popup-captcha-required/popup-captcha-required.html',
    controller: ['$timeout', '$window', 'backend', 'modalTools', PopupCaptchaRequiredController],
    controllerAs: 'vm'
});

function PopupCaptchaRequiredController($timeout, $window, backend, modalTools) {

    var vm = this;
    var submitCallback = false,
        rejectCallback = false;

    vm.loading = true;
    vm.close = close;
    vm.submit = submit;

    modalTools.setOpenListener('popup-captcha-required', function (link, params) {
        vm.captchaText = '';
        $timeout(function () {
            jQuery('#popupCaptchaRequired a.captcha-link').trigger('click');
            jQuery('#popupCaptchaRequired input[name="captcha"]').focus();
        });
        submitCallback = params && params.submitCallback;
        rejectCallback = params && params.rejectCallback;
        vm.captchaError = params && params.captchaError;
    });

    backend.ready.then(function () {
        vm.loading = false;
    });

    function submit() {
        vm.submitTouched = true;
        if (vm.captchaForm.$valid && submitCallback) {
            submitCallback(vm.captchaText);
            modalTools.closeHandler();
        }
    }

    function close() {
        if (rejectCallback) {
            rejectCallback();
        }
        modalTools.closeHandler();
    }
}

},{}],553:[function(require,module,exports){
"use strict";

angular.module('app').component('popupChangeCurrencyError', {
    templateUrl: 'modals/popup-change-currency-error/popup-change-currency-error.html',
    controller: ['modalTools', PopupChangeCurrencyErrorController],
    controllerAs: 'vm'
});

function PopupChangeCurrencyErrorController(modalTools) {

    var vm = this;
    var submitCallback = false;

    vm.close = modalTools.closeHandler;
    vm.submit = submit;

    modalTools.setOpenListener('popup-change-currency-error', function (link, params) {
        if (params) {
            submitCallback = params.submitCallback;
            vm.eraseAeroexpressBecauseOfCurrency = params.eraseAeroexpressBecauseOfCurrency;
            vm.eraseInsuranceBecauseOfCurrency = params.eraseInsuranceBecauseOfCurrency;
            vm.mode = params.mode;
        }
    });

    function submit() {
        if (submitCallback) {
            submitCallback(true);
            vm.close();
        }
    }
}

},{}],554:[function(require,module,exports){
"use strict";

angular.module('app').component('popupChoosePayMethod', {
    templateUrl: 'modals/popup-choose-pay-method/popup-choose-pay-method.html',
    controller: ['$rootScope', '$window', 'backend', PopupChoosePayMethod],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<',
        onClose: '&'
    }
});

function PopupChoosePayMethod($rootScope, $window, backend) {
    var vm = this;

    vm.choosePayMethodFailMsg = false;
    vm.choosePayMethodPending = false;

    vm.paymentVariants = _.filter(vm.orderInfo.possiblePaymentVariants, function (item) {
        return !item.defaultSelected;
    });

    vm.submit = submit;
    vm.paymentVariantChangeHandler = paymentVariantChangeHandler;

    function submit() {

        var orderEmail = vm.orderInfo.email;
        var selectedPaymentVariant = vm.paymentVariants[vm.selectedPaymentVariantIndex];

        vm.choosePayMethodPending = true;
        $rootScope.$broadcast('popupChoosePayMethodPending', vm.choosePayMethodPending);

        vm.choosePayMethodFailMsg = false;
        $rootScope.$broadcast('popupChoosePayMethodChoosePayMethodFailMsg', vm.choosePayMethodFailMsg);

        backend.changePayMethod(selectedPaymentVariant.paymentForm, selectedPaymentVariant.paymentType, orderEmail, {
            save_new_card: vm.saveNewCard,
            card_token: selectedPaymentVariant.savedCard && selectedPaymentVariant.savedCard.token
        }).then(function () {
            $window.location = './order';
        }).catch(function (data) {
            vm.choosePayMethodPending = false;
            $rootScope.$broadcast('popupChoosePayMethodPending', vm.choosePayMethodPending);

            vm.choosePayMethodFailMsg = data.error;
            $rootScope.$broadcast('popupChoosePayMethodChoosePayMethodFailMsg', vm.choosePayMethodFailMsg);
        });

        vm.onClose();
    }

    function paymentVariantChangeHandler(newVariantIndex) {
        vm.selectedPaymentVariantIndex = newVariantIndex;
    }
}

},{}],555:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCommonService', {
    templateUrl: 'modals/popup-common-service/popup-common-service.html',
    controller: ['$scope', '$timeout', 'utils', 'backend', PopupCommonServiceController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        serviceIconCode: '<',
        card: '<',
        cardCode: '<',
        cardValue: '<',
        onClose: '&',
        locked: '<'
    }
});

function PopupCommonServiceController($scope, $timeout, utils, backend) {

    var vm = this;
    vm.suffixCount = utils.suffixCount;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;
    vm.closeHandler = closeHandler;

    vm.$onInit = function () {

        cardDataUpdate();

        vm.hasAdded = false;
        vm.hasRemoved = false;

        var autoSelect = vm.card && vm.card.svcs && vm.card.svcs[0] && vm.card.svcs[0].customProperties && vm.card.svcs[0].customProperties.autoSelect;

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        utils.addViewedServiceItem(vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        if (hasBeenViewed) {
            return;
        } else if (autoSelect === 'first-pax') {

            var autoSelectItemsParams = [];
            var firstPassengerId = vm.orderInfo.passengers[0].id;

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount && params.passengerId === firstPassengerId) {
                    autoSelectItemsParams.push(params);
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectFirstPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectFirstPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        } else if (autoSelect === 'all-pax') {

            var _autoSelectItemsParams = [];

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount) {
                    _autoSelectItemsParams.push(params);
                }
            });

            if (_autoSelectItemsParams.length) {
                vm.autoSelectAllPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    _autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === _autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectAllPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watch('vm.card', cardDataUpdate);

    function cardDataUpdate() {
        var svcsByFlightPassenger = utils.groupSvcsByFlightPassenger(vm.card.svcs, vm.orderInfo, vm.cardValue);
        if (svcsByFlightPassenger) {
            svcsByFlightPassenger.forEach(function (svcsByPassenger) {
                if (svcsByPassenger) {
                    svcsByPassenger.forEach(function (svc) {
                        if (vm.cardValue && svc) {
                            if (vm.cardValue === svc.alreadySelectedValue) {
                                svc.alreadySelectedCountByCardValue = svc.alreadySelectedCount;
                            } else {
                                svc.alreadySelectedCountByCardValue = 0;
                            }
                        }
                    });
                }
            });
        }
        vm.svcsByFlightPassenger = svcsByFlightPassenger;
        vm.selectedFlight = vm.selectedFlight || utils.getFirstAvailableSvcsFlight(vm.card.svcs, vm.orderInfo);
    }

    function serviceCountChangeHandler(svc, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var alreadySelectedCount = svc.alreadySelectedCount || 0;
        if ((!vm.locked || useStream) && (delta < 0 && alreadySelectedCount > 0 || delta > 0 && alreadySelectedCount < svc.limit)) {
            if (delta > 0) {
                vm.hasAdded = true;
            }
            if (delta < 0) {
                vm.hasRemoved = true;
            }
            var params = {
                code: svc.groupCode,
                passenger_id: svc.passengerId,
                segment_id: svc.segmentId,
                subgroup: svc.subgroupCode,
                amount: alreadySelectedCount + delta,
                rfisc: svc.rfisc
            };
            if (vm.cardValue) {
                params.value = vm.cardValue;
            }
            return backend.modifyExtraService(params, preventUpdate);
        }
    }

    function closeHandler() {

        if (vm.hasAdded) {
            // TODO
        }

        if (vm.hasRemoved) {
            // TODO
        }

        vm.onClose();
    }
}

},{}],556:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCompareFfp', {
    templateUrl: 'modals/popup-compare-ffp/popup-compare-ffp.html',
    controller: ['backend', PopupCompareFfpController],
    controllerAs: 'vm',
    bindings: {
        selectedFareGroupCode: '<active',
        fareGroupList: '<',
        onClose: '&'
    }
});

function PopupCompareFfpController(backend) {
    var vm = this;

    vm.$onInit = function () {
        if (vm.fareGroupList) {
            vm.fareGroupPropsTable = getFareGroupPropsTable(vm.fareGroupList);
        }

        vm.activeMobileViewFareGroup = vm.selectedFareGroupCode || vm.fareGroupList[0].type;
        vm.currency = backend.sessionParams.currency;
    };

    function getFareGroupPropsTable(fareGroupList) {
        var propsList = [];
        fareGroupList.forEach(function (fareGroup) {
            if (fareGroup.properties) {
                fareGroup.properties.forEach(function (prop) {
                    if (!_.findWhere(propsList, { code: prop.code })) {
                        propsList.push({
                            code: prop.code,
                            iconCode: prop.iconCode || false,
                            name: prop.name
                        });
                    }
                });
            }
        });
        return propsList.map(function (prop) {
            return {
                code: prop.code,
                iconCode: prop.iconCode,
                name: prop.name,
                values: fareGroupList.map(function (fareGroup) {
                    return _.findWhere(fareGroup.properties, { code: prop.code });
                })
            };
        });
    }
}

},{}],557:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCompare', {
    templateUrl: 'modals/popup-compare/popup-compare.html',
    controller: ['backend', PopupCompareController],
    controllerAs: 'vm',
    bindings: {
        selectedBrandCode: '<active',
        brandsList: '<',
        onClose: '&'
    }
});

function PopupCompareController(backend) {

    var vm = this;

    vm.$onInit = function () {

        if (vm.brandsList) {
            vm.brandsPropsTable = getBrandsPropsTable(vm.brandsList);
        }

        vm.activeMobileViewBrand = vm.selectedBrandCode || vm.brandsList[0].code;
        vm.currency = backend.sessionParams.currency;
    };

    function getBrandsPropsTable(brandsList) {
        var propsList = [];
        brandsList.forEach(function (brand) {
            brand.props.forEach(function (prop) {
                if (!_.findWhere(propsList, { code: prop.code })) {
                    propsList.push({
                        code: prop.code,
                        iconCode: prop.iconCode || false,
                        name: prop.name
                    });
                }
            });
        });
        return propsList.map(function (prop) {
            return {
                code: prop.code,
                iconCode: prop.iconCode,
                name: prop.name,
                values: brandsList.map(function (brand) {
                    return _.findWhere(brand.props, { code: prop.code });
                })
            };
        });
    }
}

},{}],558:[function(require,module,exports){
"use strict";

angular.module('app').component('popupConfirmDeleteProfile', {
    templateUrl: 'modals/popup-confirm-delete-profile/popup-confirm-delete-profile.html',
    controller: [PopupConfirmDeleteProfileController],
    controllerAs: 'vm',
    bindings: {
        submitHandler: '<',
        deleteProfileRequestSent: '<',
        onClose: '&'
    }
});

function PopupConfirmDeleteProfileController() {}

},{}],559:[function(require,module,exports){
"use strict";

angular.module('app').component('popupConfirmPassengerNames', {
    templateUrl: 'modals/popup-confirm-passenger-names/popup-confirm-passenger-names.html',
    controller: ['backend', PopupConfirmPassengerNamesController],
    controllerAs: 'vm',
    bindings: {
        emptyPatronymicPassengers: '<',
        confirmPassengers: '<',
        getDocumentTypeNameByCode: '<',
        submitHandler: '<',
        onClose: '&'
    }
});

function PopupConfirmPassengerNamesController(backend) {

    var vm = this;

    vm.submit = submit;
    vm.getCountryLocalNameByCode = backend.getCountryLocalNameByCode;

    function submit() {
        vm.submitHandler(true);
        vm.onClose();
    }
}

},{}],560:[function(require,module,exports){
"use strict";

angular.module('app').component('popupConfirmRemovePrivatePassenger', {
    templateUrl: 'modals/popup-confirm-remove-private-passenger/popup-confirm-remove-private-passenger.html',
    controller: [PopupConfirmRemovePrivatePassengerController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        onSubmit: '&'
    }
});

function PopupConfirmRemovePrivatePassengerController() {}

},{}],561:[function(require,module,exports){
"use strict";

angular.module('app').component('popupContactsRequired', {
    templateUrl: 'modals/popup-contacts-required/popup-contacts-required.html',
    controller: ['backend', PopupContactsRequiredController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        contactsOwnerVariants: '<',
        onSubmit: '&'
    }
});

function PopupContactsRequiredController(backend) {

    var vm = this;

    vm.submitHandler = submitHandler;
    vm.contactsOwnerSelectHandler = contactsOwnerSelectHandler;

    vm.$onInit = function () {
        if (!vm.contactsOwnerVariants && backend.sessionParams.authoriseCustomer) {
            vm.newEmail = backend.sessionParams.authoriseCustomer.email || '';
            vm.newPhone = backend.sessionParams.authoriseCustomer.phone || '';
        }
    };

    function submitHandler() {
        vm.submitTouched = true;
        if (vm.contactsForm.$valid) {
            var contacts = {
                email: vm.newEmail,
                phone: vm.newPhone
            };
            if (vm.contactsOwner !== -1) {
                contacts.contactsPassengerId = vm.contactsOwner;
            }
            vm.onSubmit({ $contacts: contacts });
        }
    }

    function contactsOwnerSelectHandler(pax) {
        vm.contactsOwnerSelected = true;
        vm.newPhone = pax.phone;
        vm.newEmail = pax.email;
    }
}

},{}],562:[function(require,module,exports){
"use strict";

angular.module('app').component('popupDeleteCard', {
    templateUrl: 'modals/popup-delete-card/popup-delete-card.html',
    controller: ['$scope', '$rootScope', 'backend', PopupDeleteCard],
    controllerAs: 'vm',
    bindings: {
        card: '<',
        onClose: '&'
    }
});

function PopupDeleteCard($scope, $rootScope, backend) {
    var vm = this;

    vm.submit = submit;

    function submit() {
        //todo: $scope.$emit почему-то не срабатывает внутри then или catch, но $rootScope.$broadCast отрабатывает
        $rootScope.$broadcast('removePaymentCardLoading', true);

        backend.removePaymentCard(vm.card.token).then(function (data) {
            if (data.err) {
                $rootScope.$broadcast('removePaymentCardError', data.err);
            } else {
                $rootScope.$broadcast('removePaymentCardSuccess');
            }

            $rootScope.$broadcast('removePaymentCardLoading', false);
        }).catch(function (err) {
            $rootScope.$broadcast('removePaymentCardError', err);
            $rootScope.$broadcast('removePaymentCardLoading', false);
        });

        vm.close();
    }
}

},{}],563:[function(require,module,exports){
"use strict";

angular.module('app').component('popupDetailedprice', {
    templateUrl: 'modals/popup-detailedprice/popup-detailedprice.html',
    controller: ['backend', 'modalTools', PopupDetailedpriceController],
    controllerAs: 'vm'
});

function PopupDetailedpriceController(backend, modalTools) {

    var vm = this;

    vm.close = modalTools.closeHandler;

    vm.orderInfo = backend.getOrderInfo();
}

},{}],564:[function(require,module,exports){
"use strict";

angular.module('app').component('popupEmergencyExitSeatWarning', {
    templateUrl: 'modals/popup-emergency-exit-seat-warning/popup-emergency-exit-seat-warning.html',
    controller: ['backend', PopupEmergencyExitWarningController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        onSubmit: '&',
        passenger: '<'
    }
});

function PopupEmergencyExitWarningController(backend) {

    var vm = this;

    vm.submitHandler = submitHandler;
    vm.orderInfo = backend.getOrderInfo();

    function submitHandler() {
        vm.onSubmit();
        vm.onClose();
    }
}

},{}],565:[function(require,module,exports){
"use strict";

angular.module('app').component('popupErrorGotoSearch', {
    templateUrl: 'modals/popup-error-goto-search/popup-error-goto-search.html',
    controller: ['$window', PopupErrorGotoSearchController],
    controllerAs: 'vm',
    bindings: {
        errorAlias: '<'
    }
});

function PopupErrorGotoSearchController($window) {

    var vm = this;

    vm.reload = reload;

    function reload() {
        $window.location = "./";
    }
}

},{}],566:[function(require,module,exports){
"use strict";

angular.module('app').component('popupExchangeExtraServicesRefund', {
    templateUrl: 'modals/popup-exchange-extra-services-refund/popup-exchange-extra-services-refund.html',
    controller: [PopupExchangeExtraServicesRefundController],
    controllerAs: 'vm',
    bindings: {
        agree: '=agree',
        selectedVariant: '=variant',
        orderPrices: '=prices',
        onClose: '&'
    }
});

function PopupExchangeExtraServicesRefundController() {}

},{}],567:[function(require,module,exports){
"use strict";

angular.module('app').component('popupFacilitiesDocumentsFormatError', {
    templateUrl: 'modals/popup-facilities-documents-format-error/popup-facilities-documents-format-error.html',
    controller: ['redirect', PopupFacilitiesDocumentsFormatErrorController],
    controllerAs: 'vm',
    bindings: {
        categoryId: '<',
        onClose: '&'
    }
});

function PopupFacilitiesDocumentsFormatErrorController() {}

},{}],568:[function(require,module,exports){
"use strict";

angular.module('app').component('popupFacilitiesDocumentsUploadConfirm', {
    templateUrl: 'modals/popup-facilities-documents-upload-confirm/popup-facilities-documents-upload-confirm.html',
    controller: [PopupFacilitiesDocumentsUploadConfirmController],
    controllerAs: 'vm',
    bindings: {
        categoryId: '<',
        onConfirm: '&',
        onClose: '&'
    }
});

function PopupFacilitiesDocumentsUploadConfirmController() {}

},{}],569:[function(require,module,exports){
"use strict";

angular.module('app').component('popupFareGroupDescription', {
    templateUrl: 'modals/popup-fare-group-description/popup-fare-group-description.html',
    controller: ['$sce', PopupFareGroupDescriptionController],
    controllerAs: 'vm',
    bindings: {
        fareGroupDescription: '=desc',
        onClose: '&'
    }
});

function PopupFareGroupDescriptionController($sce) {

    var vm = this;

    vm.$onInit = function () {
        vm.fareGroupDescriptionHTML = $sce.trustAsHtml(vm.fareGroupDescription);
    };
}

},{}],570:[function(require,module,exports){
"use strict";

angular.module('app').component('popupFfpEdit', {
    templateUrl: 'modals/popup-ffp-edit/popup-ffp-edit.html',
    controller: ['$scope', 'backend', 'utils', 'ffpTools', PopupFfpEditController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        orderInfo: '<order'
    }
});

function PopupFfpEditController($scope, backend, utils, ffpTools) {
    var vm = this;
    vm.submitSave = submitSave;
    vm.updateFfpEditHasValues = updateFfpEditHasValues;
    vm.checkShowBonusCard = checkShowBonusCard;
    vm.ffpCardNumberChangeHandler = ffpCardNumberChangeHandler;
    vm.ffpMemberTypeChangeHandler = ffpMemberTypeChangeHandler;
    vm.bonusCardShortChangeHandler = bonusCardShortChangeHandler;

    vm.ffpMemberTypes = ffpTools.getFfpMemberTypes();
    var defaultSelectedFfpMemberType = ffpTools.getDefaultSelectedFfpMemberType();
    console.log('defaultSelectedFfpMemberType: ', defaultSelectedFfpMemberType);

    $scope.$watch('vm.orderInfo', function () {
        vm.ffpCardNumber = vm.orderInfo.passengers.map(function (passenger) {
            return passenger.bonusCard || '';
        });
        if (vm.ffpMemberTypes) {
            vm.ffpMemberType = vm.orderInfo.passengers.map(function (passenger) {
                var ffpMemberType = ffpTools.detectFfpMemberType(passenger.bonusCard || '');
                if (ffpMemberType && ffpMemberType.code) {
                    return ffpMemberType.code;
                } else if (defaultSelectedFfpMemberType && defaultSelectedFfpMemberType.code) {
                    return defaultSelectedFfpMemberType.code;
                }
            });
            vm.ffpCardNumberShort = vm.orderInfo.passengers.map(function (passenger) {
                var ffpMemberType = ffpTools.detectFfpMemberType(passenger.bonusCard || '');
                if (ffpMemberType && ffpMemberType.code) {
                    return ffpTools.generateBonusCardShort(passenger.bonusCard || '', ffpMemberType);
                } else {
                    return '';
                }
            });
            updateBonusShortRegex();
        }
        updateFfpEditHasValues();
    });

    vm.allowBonusCardsForChildren = backend.getParam('passengers.allowBonusCardsForChildren');

    function submitSave() {
        vm.submitTouched = true;
        var ffpEditHasValues = vm.ffpCardNumber.some(function (cardNumber) {
            return !!cardNumber;
        });
        if (vm.ffpEditForm.$valid && ffpEditHasValues && !vm.submitLoading) {
            vm.submitLoading = true;
            backend.addFfpCards(vm.orderInfo.passengers.map(function (pax, paxNum) {
                return {
                    id: pax.id,
                    ffpCardNumber: pax.bonusCard ? false : vm.ffpCardNumber[paxNum]
                };
            }).filter(function (card) {
                return !!card.ffpCardNumber;
            })).then(function (resp) {
                if (resp.addFfpResult) {
                    backend.updateOrderInfo(true).then(function () {
                        vm.addFfpResultByPassengers = vm.orderInfo.passengers.map(function (pax) {
                            return resp.addFfpResult[pax.id] || false;
                        });
                    });
                }
                vm.submitLoading = false;
            }, function () {
                vm.submitLoading = false;
            });
        } else {
            console.log('invalid form: ', vm.ffpEditForm.$error);
        }
    }

    function updateFfpEditHasValues() {
        vm.ffpEditHasValues = vm.ffpCardNumber.some(function (cardNumber, paxNum) {
            return !!cardNumber && vm.orderInfo.passengers[paxNum].bonusCard !== cardNumber;
        });
    }

    function checkShowBonusCard(passenger) {
        var allowBonusCard = backend.getParam('passengers.allowBonusCard') && !vm.orderInfo.ffpSumm;
        var allowBonusCardsForChildren = backend.getParam('passengers.allowBonusCardsForChildren') && !vm.orderInfo.ffpSumm;
        return !utils.checkIsPassengerChildForBonusCard(passenger) && allowBonusCard || utils.checkIsPassengerChildForBonusCard(passenger) && allowBonusCardsForChildren;
    }

    function ffpCardNumberChangeHandler() {
        updateFfpEditHasValues();
    }

    function ffpMemberTypeChangeHandler(num) {
        updateBonusCardFull(num);
        updateBonusShortRegex();
    }

    function bonusCardShortChangeHandler(num) {
        updateBonusCardFull(num);
    }

    function updateBonusShortRegex() {
        if (vm.ffpMemberTypes) {
            vm.bonusCardShortRegex = vm.ffpMemberType.map(ffpTools.getFfpMemberTypeCardNoRegex);
        }
    }

    function updateBonusCardFull(num) {
        var bonusCardFull = '';
        var bonusCardShort = vm.ffpCardNumberShort[num];

        if (bonusCardShort && vm.ffpEditForm['ffpCardNumberShort[' + num + ']'].$valid) {
            var zeros = '';
            var ffpMemberTypePrefix = ffpTools.getFfpMemberTypePrefix(vm.ffpMemberType[num]);
            var ffpMemberTypeFullLength = ffpTools.getFfpMemberTypeFullLength(vm.ffpMemberType[num]);
            var zerosCount = ffpMemberTypeFullLength - ffpMemberTypePrefix.length - bonusCardShort.length;
            for (var i = 0; i < zerosCount; i++) {
                zeros += '0';
            }
            bonusCardFull = ffpMemberTypePrefix + zeros + bonusCardShort;
        }
        vm.ffpCardNumber[num] = bonusCardFull;
        updateFfpEditHasValues();
    }
}

},{}],571:[function(require,module,exports){
"use strict";

angular.module('app').component('popupFlightDetail', {
    templateUrl: 'modals/popup-flight-detail/popup-flight-detail.html',
    controller: ['utils', 'watchman', PopupFlightDetailController],
    controllerAs: 'vm',
    bindings: {
        flightDetail: '=detail',
        onClose: '&'
    }
});

function PopupFlightDetailController(utils, watchman) {

    var vm = this;
    vm.suffixCount = utils.suffixCount;

    watchman.notifyUserInterfaceEvent({
        name: 'flight-details',
        data: { type: 'booking' }
    });
}

},{}],572:[function(require,module,exports){
"use strict";

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('popupGeoChooseCountryWithChooser', {
    templateUrl: 'modals/popup-geo-choose-country-with-chooser/popup-geo-choose-country-with-chooser.html',
    controller: ['$scope', 'backend', 'modalTools', 'geo', PopupGeoChooseCountryWithChooser],
    controllerAs: 'vm'
});

function PopupGeoChooseCountryWithChooser($scope, backend, modalTools, geo) {
    var submit = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(typeof vm.selectedCountry.iso === 'undefined' || vm.selectedCountry.iso.length === 0)) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:

                            vm.submitting = true;

                            vm.close();

                            geo().confirmCountryDetection({
                                isoCode: vm.selectedCountry.iso,
                                userAgreed: true,
                                detectedAutomatically: false
                            }).then(function () {
                                vm.submitSucsessfull = true;
                                vm.submitting = false;
                            }).catch(function () {
                                vm.submitting = false;
                            });

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function submit() {
            return _ref.apply(this, arguments);
        };
    }();

    var vm = this;

    vm.userCountry = '';
    vm.userCountryIsoCode = '';
    vm.countriesList = '';
    vm.selectedCountry = '';
    vm.submitting = false;
    vm.submitSucsessfull = false;

    vm.submit = submit;
    vm.close = modalTools.closeHandler;

    vm.$onInit = function () {
        $scope.localNamePropName = backend.sessionParams.localNamePropName;
        vm.userCountry = geo().getUserCountry();
        vm.userCountryIsoCode = geo().getUserCountryIsoCode();
        vm.countriesList = geo().getCountriesList();
    };

    $scope.$on('countriesListChange', function (event, data) {
        vm.countriesList = data;
    });

    $scope.$on('dropdownPickerSelected', function (event, value) {
        if (value && value.length === 0) return;

        vm.selectedCountry = value;
    });

    $scope.$on('userCountryByAutoDetectChange', function (event, data) {
        vm.userCountry = data.userCountry;
        vm.userCountryIsoCode = data.userCountryIsoCode;

        $scope.$apply();
    });
}

},{"babel-runtime/helpers/asyncToGenerator":8,"babel-runtime/regenerator":12}],573:[function(require,module,exports){
"use strict";

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('popupGeoChooseCountry', {
    templateUrl: 'modals/popup-geo-choose-country/popup-geo-choose-country.html',
    controller: ['$scope', 'modalTools', 'backend', 'geo', PopupGeoChooseCountry],
    controllerAs: 'vm'
});

function PopupGeoChooseCountry($scope, modalTools, backend, geo) {
    var submit = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            vm.submitting = true;

                            vm.close();

                            geo().confirmCountryDetection({
                                isoCode: vm.userCountryIsoCode,
                                userAgreed: true,
                                detectedAutomatically: true
                            }).then(function () {
                                vm.submitting = false;
                                vm.submitSucsessfull = true;
                            }).catch(function () {
                                vm.submitting = false;
                            });

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function submit() {
            return _ref.apply(this, arguments);
        };
    }();

    var vm = this;

    vm.userCountry = '';
    vm.userCountryIsoCode = '';
    vm.submitting = false;
    vm.submitSucsessfull = false;
    vm.goToNextStepEvent = false;

    vm.submit = submit;
    vm.close = modalTools.closeHandler;

    vm.$onInit = function () {
        $scope.localNamePropName = backend.sessionParams.localNamePropName;
        vm.userCountry = geo().getUserCountry();
        vm.userCountryIsoCode = geo().getUserCountryIsoCode();
    };

    $scope.$on('userCountryByAutoDetectChange', function (event, data) {
        vm.userCountry = data.userCountry;
        vm.userCountryIsoCode = data.userCountryIsoCode;
        $scope.$apply();
    });
}

},{"babel-runtime/helpers/asyncToGenerator":8,"babel-runtime/regenerator":12}],574:[function(require,module,exports){
"use strict";

angular.module('app').component('popupIinEditor', {
    templateUrl: 'modals/popup-iin-editor/popup-iin-editor.html',
    controller: ['iinUtils', 'backend', PopupIinEditorController],
    controllerAs: 'vm',
    bindings: {
        passenger: '<',
        passengers: '<',
        onClose: '&',
        onSubmit: '&'
    }
});

function PopupIinEditorController(iinUtils, backend) {

    var vm = this;

    vm.submitHandler = submitHandler;

    vm.$onInit = function () {
        vm.isAdult = checkAdult(vm.passenger);
        if (vm.isAdult) {
            initIIN(vm.passenger);
        } else if (vm.passenger.parentId !== undefined) {
            vm.parentPassenger = _.findWhere(vm.passengers, { id: vm.passenger.parentId });
            var selfIIN = getIINByPax(vm.passenger);
            if (selfIIN) {
                vm.iin = selfIIN;
            } else {
                initIIN(vm.parentPassenger);
            }
        }
        jQuery('#popupIinEditor input[name="iin"]').focus();
    };

    function initIIN(pax) {
        var paxIIN = getIINByPax(pax);
        if (paxIIN) {
            vm.iin = paxIIN;
        } else {
            var dateOfBirth = pax.dateOfBirth,
                gender = pax.gender;

            vm.iin = iinUtils.getIinStart(dateOfBirth, gender);
        }
    }

    function getIINByPax(pax) {
        return pax.documentCodeDiscount == 'IDN' && pax.documentNumberDiscount ? pax.documentNumberDiscount : false;
    }

    function checkAdult(passenger) {
        var age = moment(backend.sessionParams.todayDate, 'DD.MM.YYYY').diff(moment(passenger.dateOfBirth, 'DD.MM.YYYY'), 'years');
        return age >= 18;
    }

    function submitHandler() {
        vm.submitTouched = true;
        if (vm.iinForm.$valid && vm.iin !== vm.passenger.documentNumberDiscount) {
            vm.onSubmit({ '$iin': vm.iin });
        }
    }
}

},{}],575:[function(require,module,exports){
"use strict";

angular.module('app').component('popupInfantParent', {
    templateUrl: 'modals/popup-infant-parent/popup-infant-parent.html',
    controller: ['backend', PopupInfantParentController],
    controllerAs: 'vm',
    bindings: {
        infantId: '<',
        orderInfo: '<order',
        onClose: '&'
    }
});

function PopupInfantParentController(backend) {

    var vm = this;

    vm.submitSave = submitSave;

    vm.orderInfo.passengers.forEach(function (pax) {
        if (pax.id === vm.infantId) {
            vm.infant = pax;
        }
    });

    vm.availableParents = vm.orderInfo.passengers.filter(canToBePassengerParent);

    function canToBePassengerParent(pax) {
        if (pax.child && pax.child.id === vm.infantId) {
            return false;
        }
        if (pax.categoryType !== 'ADULT') {
            return false;
        }
        var dateOfBirthMoment = moment(pax.dateOfBirth, 'DD.MM.YYYY');
        for (var i = 0; i < vm.orderInfo.plainFlights.length; i++) {
            var flightMoment = moment(vm.orderInfo.plainFlights[i].date, 'DD.MM.YYYY');
            var minAge = backend.getParam('site.minAgeToBePassengerParent');
            var yearsDiff = flightMoment.diff(dateOfBirthMoment, 'years', false);
            if (yearsDiff < minAge) {
                return false;
            }
        }
        return true;
    }

    function submitSave() {
        if (vm.parentId !== undefined) {
            vm.loading = true;
            vm.errorMessage = false;
            var modifyParentParams = { parentId: vm.parentId };
            if (checkParentAlreadyEngaged(vm.parentId)) {
                modifyParentParams.swapParentId = getParentId(vm.infantId);
            } else {
                modifyParentParams.infantId = vm.infantId;
            }
            backend.modifyParent(modifyParentParams).then(function () {
                vm.showSuccessMessage = true;
                backend.updateOrderInfo();
                vm.loading = false;
            }, function (resp) {
                vm.errorMessage = resp.error;
                vm.loading = false;
            });
        }
    }

    function getParentId(infantId) {
        for (var i = 0; i < vm.orderInfo.passengers.length; i++) {
            var pax = vm.orderInfo.passengers[i];
            if (pax.id === infantId) {
                return pax.parentId;
            }
        }
    }

    function checkParentAlreadyEngaged(parentId) {
        return vm.orderInfo.passengers.some(function (pax) {
            return pax.id === parentId && pax.child;
        });
    }
}

},{}],576:[function(require,module,exports){
"use strict";

angular.module('app').component('popupInsurance', {
    templateUrl: 'modals/popup-insurance/popup-insurance.html',
    controller: ['$timeout', '$q', '$scope', 'utils', 'backend', PopupInsuranceController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        serviceIconCode: '<',
        onlineMode: '<',
        card: '<',
        onClose: '&',
        locked: '<'
    }
});

function PopupInsuranceController($timeout, $q, $scope, utils, backend) {

    var vm = this;
    vm.suffixCount = utils.suffixCount;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;
    vm.switchFlight = switchFlight;
    vm.openIinModal = openIinModal;
    vm.showIinModalForPax = -1;

    vm.$onInit = function () {

        cardDataUpdate();

        vm.hasAdded = false;
        vm.hasRemoved = false;

        var autoSelect = vm.card && vm.card.items && vm.card.items[0] && vm.card.items[0].customProperties && vm.card.items[0].customProperties.autoSelect;

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, 'insuranceOnline_' + vm.card.items[0].ins + '-' + vm.card.items[0].tins + '-' + vm.card.items[0].productCode);

        utils.addViewedServiceItem('insuranceOnline_' + vm.card.items[0].ins + '-' + vm.card.items[0].tins + '-' + vm.card.items[0].productCode);

        if (hasBeenViewed) {
            return;
        } else if (autoSelect === 'first-pax') {

            var autoSelectItemsParams = [];
            var firstPassengerId = vm.orderInfo.passengers[0].id;

            vm.card.items.forEach(function (params) {
                if (params.alreadySelectedPrice) {
                    params.alreadySelectedCount = 1;
                }
                if (!params.alreadySelectedCount && params.passengerId === firstPassengerId) {
                    autoSelectItemsParams.push(params);
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectFirstPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectFirstPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        } else if (autoSelect === 'all-pax') {

            var _autoSelectItemsParams = [];

            vm.card.items.forEach(function (params) {
                if (params.alreadySelectedPrice) {
                    params.alreadySelectedCount = 1;
                }
                if (!params.alreadySelectedCount) {
                    _autoSelectItemsParams.push(params);
                }
            });

            if (_autoSelectItemsParams.length) {
                vm.autoSelectAllPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    _autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === _autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectAllPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watch('vm.card', cardDataUpdate);

    function cardDataUpdate() {
        if (vm.card.items[0].segmentId === null || vm.card.items[0].segmentId === undefined) {
            vm.itemsByPassenger = utils.groupInsuranceItemsPassengers(vm.card.items, vm.orderInfo);
            vm.itemsByFlightPassenger = false;
            vm.selectedFlight = false;
        } else {
            vm.itemsByFlightPassenger = utils.groupInsuranceItemsFlightPassengers(vm.card.items, vm.orderInfo);
            vm.selectedFlight = vm.selectedFlight || utils.getFirstAvailableSvcsFlight(vm.card.items, vm.orderInfo);
            vm.itemsByPassenger = vm.itemsByFlightPassenger[vm.selectedFlight];
        }
    }

    function switchFlight(flightNum) {
        vm.selectedFlight = flightNum;
        vm.itemsByPassenger = vm.itemsByFlightPassenger[flightNum];
    }

    function openIinModal(paxNum) {
        vm.showIinModalForPax = paxNum;
        vm.saveIinHandler = function (iin) {
            vm.loadingSaveIin = true;
            backend.modifyPassenger({
                additionalDocumentType: 'ИИН',
                additionalDocumentNumber: iin,
                index: paxNum
            }).then(function () {
                vm.loadingSaveIin = false;
                vm.orderInfo.passengers[paxNum].documentCodeDiscount = 'IDN';
                vm.orderInfo.passengers[paxNum].documentNumberDiscount = iin;
                vm.showIinModalForPax = -1;
            }, function () {
                vm.loadingSaveIin = false;
                vm.showIinModalForPax = -1;
            });
        };
        vm.closeIinHandler = function () {
            vm.showIinModalForPax = -1;
        };
    }

    function serviceCountChangeHandler(item, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var alreadySelectedCount = item.alreadySelectedCount || 0;
        if (!vm.locked || useStream) {
            if (item.passengerId) {
                var pax = _.findWhere(vm.orderInfo.passengers, { id: item.passengerId });
                var paxNum = _.findIndex(vm.orderInfo.passengers, { id: item.passengerId });
                if (pax && pax.nationalityCode === 'KZ' && // && TODO for OS-2156
                !pax.documentNumberDiscount) {
                    vm.showIinModalForPax = paxNum;
                    return $q(function (resolve, reject) {
                        vm.saveIinHandler = function (iin) {
                            vm.loadingSaveIin = true;
                            backend.modifyPassenger({
                                additionalDocumentType: 'ИИН',
                                additionalDocumentNumber: iin,
                                index: paxNum
                            }).then(function () {
                                vm.loadingSaveIin = false;
                                pax.documentCodeDiscount = 'IDN';
                                pax.documentNumberDiscount = iin;
                                vm.showIinModalForPax = -1;
                                resolve();
                            }, function () {
                                vm.loadingSaveIin = false;
                                vm.showIinModalForPax = -1;
                                reject();
                            });
                        };
                        vm.closeIinHandler = function () {
                            vm.showIinModalForPax = -1;
                            reject();
                        };
                    }).then(function () {
                        serviceCountChangeHandler(item, delta, preventUpdate, useStream);
                    });
                }
            }
            if (delta > 0) {
                vm.hasAdded = true;
            }
            if (delta < 0) {
                vm.hasRemoved = true;
            }
            if (delta < 0 && alreadySelectedCount > 0) {
                return backend.removeExtraService(getInsuranceSubmitParams(item), preventUpdate);
            }
            if (delta > 0 && (item.limit === undefined || alreadySelectedCount < item.limit)) {
                return backend.modifyExtraService(getInsuranceSubmitParams(item), preventUpdate);
            }
        }
    }

    function getInsuranceSubmitParams(item) {
        var params = {
            code: 'insurance',
            ins: item.ins,
            tins: item.tins
        };
        if (item.passengerId) {
            params.passenger_id = item.passengerId;
        }
        if (item.segmentId) {
            params.segment_id = item.segmentId;
        }
        if (vm.onlineMode) {
            params.code = 'insuranceOnline';
            params.productCode = item.productCode;
        }
        return params;
    }
}

},{}],577:[function(require,module,exports){
"use strict";

angular.module('app').component('popupIntermodal', {
    templateUrl: 'modals/popup-intermodal/popup-intermodal.html',
    controller: [PopupIntermodalController],
    controllerAs: 'vm',
    bindings: {
        list: '=list',
        onClose: '&'
    }
});

function PopupIntermodalController() {}

},{}],578:[function(require,module,exports){
"use strict";

angular.module('app').component('popupIssueTickets', {
    templateUrl: 'modals/popup-issue-tickets/popup-issue-tickets.html',
    controller: ['$window', '$timeout', 'backend', PopupIssueTicketsController],
    controllerAs: 'vm',
    bindings: {
        mode: '=mode',
        onClose: '&'
    }
});

function PopupIssueTicketsController($window, $timeout, backend) {

    var vm = this;

    vm.close = close;
    vm.submitConfirm = submitConfirm;
    vm.loading = true;

    vm.$onInit = function () {
        delete vm.issueInfo;
        delete vm.errorMessage;
        vm.loading = true;
        backend.requestIssueTickets(vm.mode).then(function (resp) {
            vm.issueInfo = resp;
            vm.loading = false;
            $timeout(function () {
                jQuery('#popupIssueTickets input[name="num"]').focus();
            });
        }, errorCallback);
    };

    function close() {
        backend.cancelIssueTickets(vm.mode);
        vm.onClose();
    }

    function submitConfirm() {
        vm.submitTouched = true;
        delete vm.errorMessage;
        if (vm.issueForm.$valid) {
            vm.loading = true;
            backend.confirmIssueTickets(vm.mode, vm.issueInfo).then(submitConfirmCallback, errorCallback);
        }
    }

    function submitConfirmCallback() {
        vm.loading = false;
        vm.onClose();
        $window.location.reload();
    }

    function errorCallback(resp) {
        vm.loading = false;
        vm.errorMessage = resp.error;
    }
}

},{}],579:[function(require,module,exports){
"use strict";

angular.module('app').component('popupLogin', {
    templateUrl: 'modals/popup-login/popup-login.html',
    controller: ['$timeout', 'backend', 'redirect', 'modalTools', PopupLoginController],
    controllerAs: 'vm'
});

function PopupLoginController($timeout, backend, redirect, modalTools) {

    var vm = this;

    vm.close = modalTools.closeHandler;
    vm.submitLogin = submitLogin;

    modalTools.setOpenListener('popup-login', function (link) {
        delete vm.errorMessage;
        if (link) {
            $timeout(function () {
                var login = link.attr('data-login');
                if (login) {
                    vm.loginData = { login: login };
                    jQuery('#popupLogin input[name="password"]').focus();
                } else {
                    jQuery('#popupLogin input[name="login"]').focus();
                }
            });
        }
    });

    function submitLogin() {
        vm.submitTouched = true;
        if (vm.loginForm.$valid) {
            vm.loading = true;
            backend.login(vm.loginData).then(function () {
                vm.close();
                if (redirect.isResetForgetPasswordScreen() || redirect.isActivateAccountScreen()) {
                    redirect.goToPrivateProfile();
                }
                vm.loading = false;
            }, function (resp) {
                vm.errorMessage = resp.error;
                vm.loading = false;
            });
        }
    }
}

},{}],580:[function(require,module,exports){
"use strict";

angular.module('app').component('popupMeal', {
    templateUrl: 'modals/popup-meal/popup-meal.html',
    controller: ['$scope', 'utils', 'backend', PopupMealController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        serviceIconCode: '<',
        card: '<',
        onClose: '&',
        locked: '<'
    }
});

function PopupMealController($scope, utils, backend) {

    var vm = this;
    vm.suffixCount = utils.suffixCount;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;

    $scope.$watch('vm.card', function () {
        vm.svcsByFlightPassenger = utils.groupSvcsByFlightPassenger(vm.card.svcs, vm.orderInfo);
        vm.selectedFlight = vm.selectedFlight || utils.getFirstAvailableSvcsFlight(vm.card.svcs, vm.orderInfo);
    });

    function serviceCountChangeHandler(svc, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var alreadySelectedCount = svc.alreadySelectedCount || 0;
        if ((!vm.locked || useStream) && (delta < 0 && alreadySelectedCount > 0 || delta > 0 && alreadySelectedCount < svc.limit)) {
            backend.modifyExtraService({
                code: svc.groupCode,
                passenger_id: svc.passengerId,
                segment_id: svc.segmentId,
                subgroup: svc.subgroupCode,
                amount: alreadySelectedCount + delta,
                rfisc: svc.rfisc
            }, preventUpdate);
        }
    }
}

},{}],581:[function(require,module,exports){
"use strict";

angular.module('app').component('popupOrderEmailRequired', {
    templateUrl: 'modals/popup-order-email-required/popup-order-email-required.html',
    controller: ['backend', 'modalTools', '$timeout', PopupOrderEmailRequiredController],
    controllerAs: 'vm'
});

function PopupOrderEmailRequiredController(backend, modalTools, $timeout) {

    var vm = this;
    var submitCallback = false,
        rejectCallback = false;

    vm.loading = true;
    vm.close = close;
    vm.submit = submit;

    modalTools.setOpenListener('popup-order-email-required', function (link, params) {

        submitCallback = params && params.submitCallback;
        rejectCallback = params && params.rejectCallback;
        vm.phoneRequiredToo = params && params.phoneRequiredToo;

        if (backend.sessionParams.authoriseCustomer) {
            if (backend.sessionParams.authoriseCustomer.email) {
                vm.newEmail = backend.sessionParams.authoriseCustomer.email;
            }
            if (vm.phoneRequiredToo && backend.sessionParams.authoriseCustomer.phone) {
                vm.newPhone = backend.sessionParams.authoriseCustomer.phone;
                $timeout(function () {
                    jQuery('form[name="vm.orderEmailForm"] input[name="phone"]').trigger('change');
                });
            }
        }
    });

    backend.ready.then(function () {
        vm.loading = false;
    });

    function submit() {
        vm.submitTouched = true;
        if (vm.orderEmailForm.$valid && submitCallback) {
            submitCallback(vm.newEmail, vm.newPhone);
            modalTools.closeHandler();
        }
    }

    function close() {
        if (rejectCallback) {
            rejectCallback();
        }
        modalTools.closeHandler();
    }
}

},{}],582:[function(require,module,exports){
"use strict";

angular.module('app').component('popupOrderFlightDetail', {
    templateUrl: 'modals/popup-order-flight-detail/popup-order-flight-detail.html',
    controller: ['watchman', PopupOrderFlightDetailController],
    controllerAs: 'vm',
    bindings: {
        segmentsList: '=segments',
        onClose: '&'
    }
});

function PopupOrderFlightDetailController(watchman) {

    watchman.notifyUserInterfaceEvent({
        name: 'flight-details',
        data: { type: 'order' }
    });
}

},{}],583:[function(require,module,exports){
"use strict";

angular.module('app').component('popupPromoCodesDiscount', {
    templateUrl: 'modals/popup-promo-codes-discount/popup-promo-codes-discount.html',
    controller: ['utils', 'backend', 'redirect', PopupPromoCodesDiscountController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        onConfirm: '&',
        info: '<'
    }
});

function PopupPromoCodesDiscountController(utils, backend) {

    var vm = this;

    vm.$onInit = recalc();

    function recalc() {
        var _vm$info = vm.info,
            totalPriceWithDiscount = _vm$info.totalPriceWithDiscount,
            totalPriceWithoutDiscount = _vm$info.totalPriceWithoutDiscount;

        vm.profit = Big(totalPriceWithoutDiscount.price).minus(totalPriceWithDiscount && totalPriceWithDiscount.price || 0);
        vm.loading = true;
        if (vm.info.notValidatedPassengerIds && vm.info.notValidatedPassengerIds.length) {
            backend.updateOrderInfo().then(function (orderInfo) {
                vm.info.notValidatedPassengers = orderInfo.passengers.filter(function (pax) {
                    return utils.hasInList(vm.info.notValidatedPassengerIds, pax.id);
                });
                vm.loading = false;
            });
        } else {
            vm.loading = false;
        }
    }
}

},{}],584:[function(require,module,exports){
"use strict";

angular.module('app').component('popupRegistration', {
    templateUrl: 'modals/popup-registration/popup-registration.html',
    controller: ['$timeout', '$window', 'backend', 'modalTools', PopupRegistrationController],
    controllerAs: 'vm'
});

function PopupRegistrationController($timeout, $window, backend, modalTools) {

    var vm = this;

    vm.loading = true;
    vm.step = 'FORM';
    vm.close = close;
    vm.submitRegistration = submitRegistration;
    vm.swithcSubmitButtonHoverState = swithcSubmitButtonHoverState;

    modalTools.setOpenListener('popup-registration', function () {
        vm.step = 'FORM';
        vm.submitTouched = false;
        jQuery('#popupRegistration a.captcha-link').trigger('click');
    });

    backend.ready.then(function () {
        vm.loading = false;
        vm.registrationData = {};
        vm.captchaProvider = backend.applicationConstants.captchaProvider;
        vm.captchaEnabled = backend.applicationConstants.captchaEnabled;
    });

    function submitRegistration() {
        vm.submitTouched = true;
        vm.errorMessage = false;
        if (vm.registrationForm.$valid && vm.agree && (vm.registrationData.captcha || !vm.captchaEnabled)) {
            vm.submitLoading = true;
            backend.registration(vm.registrationData).then(function () {
                vm.step = 'SUCCESS';
                vm.submitLoading = false;
            }, function (resp) {
                modalTools.openHandler('popup-registration');
                vm.step = 'FORM';
                vm.errorMessage = resp.error;
                vm.registrationData.captcha = '';
                vm.submitLoading = false;
                $timeout(function () {
                    jQuery('#popupRegistration a.captcha-link').trigger('click');
                });
            });
        }
    }

    function close() {
        modalTools.closeHandler();
        vm.step = 'FORM';
        vm.registrationData.captcha = '';
    }

    function swithcSubmitButtonHoverState() {
        vm.submitButtonHover = !vm.submitButtonHover;
    }
}

},{}],585:[function(require,module,exports){
"use strict";

angular.module('app').component('popupRemark', {
    templateUrl: 'modals/popup-remark/popup-remark.html',
    controller: ['backend', 'modalTools', PopupRemarkController],
    controllerAs: 'vm'
});

function PopupRemarkController(backend, modalTools) {

    var vm = this;
    vm.close = modalTools.closeHandler;
    vm.activePriceNum = 0;

    modalTools.setOpenListener('popup-remark', function (link) {
        var exchangeMode = link.attr('data-exchange-mode');
        vm.loading = true;
        vm.remarkInfo = false;
        backend[exchangeMode ? 'getExchangeRemark' : 'getRemark']().then(function (resp) {
            vm.loading = false;
            vm.remarkInfo = resp;
        }, function () {
            vm.loading = false;
        });
    });
}

},{}],586:[function(require,module,exports){
"use strict";

angular.module('app').component('popupRemovedServicesWarningByOrder', {
    templateUrl: 'modals/popup-removed-services-warning-by-order/popup-removed-services-warning-by-order.html',
    controller: ['modalTools', 'backend', 'utils', PopupRemovedServicesWarningController],
    controllerAs: 'vm'
});

function PopupRemovedServicesWarningController(modalTools, backend, utils) {

    var vm = this;
    var submitCallback = false;

    vm.close = close;
    vm.submit = submit;

    modalTools.setOpenListener('popup-removed-services-warning-by-order', function (link, params) {
        submitCallback = params && params.submitCallback;
        vm.removedServicesByPassengers = initRemovedServicesByPassengers(backend.getOrderInfo());
    });

    function initRemovedServicesByPassengers(orderInfo) {
        var removedServicesByPassengers = {};
        var allRemovedServicesHeap = orderInfo.allExtraServicesHeap.filter(function (item) {
            return item.status === 'REMOVED';
        }).map(function (item) {
            return reformatServiceitem(item, orderInfo.passengers, orderInfo.plainFlights);
        });
        allRemovedServicesHeap.forEach(function (item) {
            var passengerName = item.passengerName,
                routeName = item.routeName,
                groupCode = item.groupCode;

            if (!removedServicesByPassengers[passengerName]) {
                removedServicesByPassengers[passengerName] = {};
            }
            if (!removedServicesByPassengers[passengerName][routeName]) {
                removedServicesByPassengers[passengerName][routeName] = [];
            }
            if (!utils.hasInList(removedServicesByPassengers[passengerName][routeName], groupCode)) {
                removedServicesByPassengers[passengerName][routeName].push(groupCode);
            }
        });
        console.log('removedServicesByPassengers: ', removedServicesByPassengers);
        return removedServicesByPassengers;
    }

    function submit() {
        close();
        if (submitCallback) {
            submitCallback();
        }
    }

    function close() {
        modalTools.closeHandler();
    }

    function reformatServiceitem(item, passengers, flights) {
        if (item.passengerId) {
            var pax = _.findWhere(passengers, { id: item.passengerId });
            item.passengerName = pax.lastName + ' ' + pax.firstName;
        } else if (item.firstName && item.lastName) {
            item.passengerName = item.lastName + ' ' + item.firstName;
        }
        if (item.segmentId) {
            var flight = _.findWhere(flights, { id: item.segmentId });
            item.routeName = flight.company.code_en + '-' + flight.racenumber;
        } else if (item.departure_name && item.arrival_name) {
            item.routeName = item.departure_name + ' - ' + item.arrival_name;
        } else {
            item.routeName = 'common';
        }
        return item;
    }
}

},{}],587:[function(require,module,exports){
"use strict";

angular.module('app').component('popupRemovedServicesWarning', {
    templateUrl: 'modals/popup-removed-services-warning/popup-removed-services-warning.html',
    controller: ['modalTools', 'backend', PopupRemovedServicesWarningController],
    controllerAs: 'vm'
});

function PopupRemovedServicesWarningController(modalTools, backend) {

    var vm = this;
    var submitCallback = false,
        closeCallback = false;

    vm.close = close;
    vm.submit = submit;

    vm.orderInfo = backend.getOrderInfo();

    modalTools.setOpenListener('popup-removed-services-warning', function (link, params) {
        if (params) {
            submitCallback = params.submitCallback;
            closeCallback = params.closeCallback;
            vm.servicesToRemove = params.extraServicesPayment.servicesToRemove.map(reformatServiceitem);
            if (params.extraServicesPayment.servicesToPayFor.length) {
                vm.servicesToPayForBySegments = reformatServicesToPayForBySegments(params.extraServicesPayment.servicesToPayFor);
            }
        }
    });

    function submit() {
        modalTools.closeHandler();
        if (submitCallback) {
            submitCallback();
        }
    }

    function close() {
        modalTools.closeHandler();
        if (closeCallback) {
            closeCallback();
        }
    }

    function reformatServiceitem(item) {
        if (!item.firstName && !item.lastName && item.passengerId) {
            var pax = _.findWhere(vm.orderInfo.passengers, { id: item.passengerId });
            item.firstName = pax.firstName;
            item.lastName = pax.lastName;
        }
        item.title = generateServiceTitle(item);
        if (!item.totalPrice) {
            if (item.price) {
                item.totalPrice = item.price;
            }
            if (item.fare && item.fare.cost && item.fare.currency) {
                item.totalPrice = item.fare.cost;
                item.currency = item.fare.currency;
            }
        }
        return item;
    }

    function generateServiceTitle(item) {
        switch (item.groupCode) {
            case 'insurance':
                {
                    return backend.getAlias('web.extraServices.insurance.header');
                }
            case 'aeroexpress':
                {
                    var aeLabel = backend.getAlias('web.extraServices.aeroexpress.header') + ' / ' + backend.getAlias('web.extraServices.aeroexpress.label.selectedFare') + ' "' + backend.getAliasWithPrefix('web.extraServices.aeroexpress.fareName.', item.fare.fare_type) + '"';
                    if (item.fare.fare_type === 'business') {
                        aeLabel += ', ' + item.departure_date + ' ' + item.departure_time;
                    }
                    return aeLabel;
                }
            default:
                {
                    return item.title;
                }
        }
    }

    function reformatServicesToPayForBySegments(servicesToPayFor) {
        var segments = [];
        servicesToPayFor.forEach(function (item) {
            var segmentLabel = generateSegmentLabel(item);
            var currentSegment = _.findWhere(segments, { label: segmentLabel });
            if (!currentSegment) {
                segments.push({
                    label: segmentLabel,
                    servicesGroupsList: [],
                    servicesByGroups: {}
                });
                currentSegment = segments[segments.length - 1];
            }
            if (!currentSegment.servicesByGroups[item.groupCode]) {
                currentSegment.servicesGroupsList.push(item.groupCode);
                currentSegment.servicesByGroups[item.groupCode] = [];
            }
            currentSegment.servicesByGroups[item.groupCode].push(reformatServiceitem(item));
        });
        return segments;
    }

    function generateSegmentLabel(item) {
        var label = '';
        if (item.segmentId) {
            var flight = _.findWhere(vm.orderInfo.plainFlights, { id: item.segmentId });
            label += flight.origincityName;
            if (flight.originportName && flight.originportName !== flight.origincityName) {
                label += ' / ' + flight.originportName;
            }
            label += ' &mdash; ' + flight.destinationcityName;
            if (flight.destinationportName && flight.destinationportName !== flight.destinationcityName) {
                label += ' / ' + flight.destinationportName;
            }
            label += ' (' + flight.company.code_en + '-' + flight.racenumber + ')';
        } else if (item.departure_name && item.arrival_name) {
            label += item.departure_name + ' &mdash; ' + item.arrival_name;
        }
        return label;
    }
}

},{}],588:[function(require,module,exports){
"use strict";

angular.module('app').component('popupResendActivationMail', {
    templateUrl: 'modals/popup-resend-activation-mail/popup-resend-activation-mail.html',
    controller: ['$timeout', 'backend', 'modalTools', PopupResendActivationMailController],
    controllerAs: 'vm'
});

function PopupResendActivationMailController($timeout, backend, modalTools) {

    var vm = this;

    vm.loading = true;
    vm.step = 'FORM';
    vm.close = close;
    vm.submitResend = submitResend;

    modalTools.setOpenListener('popup-resend-activation-mail', function (link) {
        vm.step = 'FORM';
        jQuery('#popupResendActivationMail a.captcha-link').trigger('click');
        if (link) {
            $timeout(function () {
                var login = link.attr('data-login');
                if (login) {
                    vm.resendActivationMailData = { login: login };
                }
            });
        }
    });

    backend.ready.then(function () {
        vm.loading = false;
        vm.resendActivationMailData = {};
        vm.captchaProvider = backend.applicationConstants.captchaProvider;
        vm.captchaEnabled = backend.applicationConstants.captchaEnabled;
    });

    function submitResend() {
        vm.submitTouched = true;
        if (vm.resendActivationMailForm.$valid && (vm.resendActivationMailData.captcha || !vm.captchaEnabled)) {
            backend.resendActivationMail(vm.resendActivationMailData).then(function () {
                vm.step = 'SUCCESS';
            }, function (resp) {
                modalTools.openHandler('popupResendActivationMail');
                vm.step = 'FORM';
                vm.errorMessage = resp.error;
                vm.resendActivationMailData.captcha = '';
                $timeout(function () {
                    jQuery('#popupResendActivationMail a.captcha-link').trigger('click');
                });
            });
        }
    }

    function close() {
        modalTools.closeHandler();
        vm.step = 'FORM';
        vm.resendActivationMailData.captcha = '';
    }
}

},{}],589:[function(require,module,exports){
"use strict";

angular.module('app').component('popupResetPassword', {
    templateUrl: 'modals/popup-reset-password/popup-reset-password.html',
    controller: ['$timeout', 'backend', 'modalTools', PopupResetPasswordController],
    controllerAs: 'vm'
});

function PopupResetPasswordController($timeout, backend, modalTools) {

    var vm = this;

    vm.loading = true;
    vm.step = 'FORM';
    vm.close = close;
    vm.submitResetPassword = submitResetPassword;

    modalTools.setOpenListener('popup-reset-password', function () {
        vm.step = 'FORM';
        vm.submitTouched = false;
        jQuery('#popupResetPassword a.captcha-link').trigger('click');
    });

    backend.ready.then(function () {
        vm.loading = false;
        vm.resetPasswordData = {};
        vm.captchaProvider = backend.applicationConstants.captchaProvider;
        vm.captchaEnabled = backend.applicationConstants.captchaEnabled;
    });

    function submitResetPassword() {
        vm.submitTouched = true;
        vm.errorMessage = false;
        if (vm.resetPasswordForm.$valid && (vm.resetPasswordData.captcha || !vm.captchaEnabled)) {
            vm.submitLoading = true;
            backend.forgetPassword(vm.resetPasswordData).then(function () {
                vm.step = 'SUCCESS';
                vm.submitLoading = false;
            }, function (resp) {
                modalTools.openHandler('popup-reset-password');
                vm.errorMessage = resp.error;
                vm.resetPasswordData.captcha = '';
                vm.submitLoading = false;
                $timeout(function () {
                    jQuery('#popupResetPassword a.captcha-link').trigger('click');
                });
            });
        }
    }

    function close() {
        modalTools.closeHandler();
        vm.step = 'FORM';
        vm.resetPasswordData.captcha = '';
    }
}

},{}],590:[function(require,module,exports){
"use strict";

angular.module('app').component('popupScannedDocsSearchGroupWarning', {
    templateUrl: 'modals/popup-scanned-docs-search-group-warning/popup-scanned-docs-search-group-warning.html',
    controller: [PopupScannedDocsSearchGroupWarningController],
    controllerAs: 'vm',
    bindings: {
        searchGroup: '<',
        onClose: '&'
    }
});

function PopupScannedDocsSearchGroupWarningController() {}

},{}],591:[function(require,module,exports){
"use strict";

angular.module('app').component('popupSendReceipt', {
    templateUrl: 'modals/popup-send-receipt/popup-send-receipt.html',
    controller: ['$timeout', 'backend', 'utils', PopupSendReceiptController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&'
    }
});

function PopupSendReceiptController($timeout, backend, utils) {

    var vm = this;

    vm.submit = submit;
    vm.addEmailItem = addEmailItem;
    vm.removeEmailItem = removeEmailItem;

    vm.$onInit = function () {
        vm.step = 'FORM';
        vm.submitTouched = false;
        vm.mailingList = getInitialEmails();
    };

    function submit() {
        vm.submitTouched = true;
        if (vm.sendReceiptForm.$valid && !vm.submitLoading) {
            vm.submitLoading = true;
            backend.sendReceipt(vm.mailingList).then(function () {
                vm.submitLoading = false;
                vm.step = 'SUCCESS';
            }, function (resp) {
                vm.submitLoading = false;
                vm.step = 'FORM';
                vm.errorMessage = resp.error;
            });
        }
    }

    function addEmailItem(item) {
        vm.mailingList.push(item);
        $timeout(function () {
            jQuery('#popupSendReceipt input:last').focus();
        });
    }

    function removeEmailItem(num) {
        vm.mailingList.splice(num, 1);
    }

    function getInitialEmails() {
        var list = utils.getOrderUniqueEmails(backend.getOrderInfo());
        if (!list.length) {
            list.push('');
        }
        return list;
    }
}

},{}],592:[function(require,module,exports){
"use strict";

angular.module('app').component('popupSessionInactive', {
    templateUrl: 'modals/popup-session-inactive/popup-session-inactive.html',
    controller: ['$window', '$interval', 'modalTools', 'backend', 'watchman', PopupSessionInactiveController],
    controllerAs: 'vm'
});

function PopupSessionInactiveController($window, $interval, modalTools, backend, watchman) {

    var vm = this;
    var countdownId = void 0;
    vm.reload = reload;
    vm.renew = renew;

    modalTools.setOpenListener('popup-session-inactive', function () {

        vm.timer = backend.sessionParams.alertInactiveTimeout;

        countdownId = $interval(function () {
            if (vm.timer) {
                vm.timer--;
            } else {
                vm.reload();
            }
        }, 1000);
    });

    function reload() {
        $interval.cancel(countdownId);
        watchman.notifyUserInterfaceEvent({
            name: 'clear-session-by-timeout'
        });
        backend.triggerCancelSessionHandler();
    }

    function renew() {
        if (countdownId) {
            $interval.cancel(countdownId);
        }
        backend.lastSearchParams();
        modalTools.closeHandler();
    }
}

},{}],593:[function(require,module,exports){
"use strict";

angular.module('app').component('popupSmsNotification', {
    templateUrl: 'modals/popup-sms-notification/popup-sms-notification.html',
    controller: [PopupSmsNotificationController],
    controllerAs: 'vm',
    bindings: {
        phone: '=',
        oldPhone: '<',
        onClose: '&',
        onSubmit: '&'
    }
});

function PopupSmsNotificationController() {

    var vm = this;

    vm.submitHandler = submitHandler;

    function submitHandler() {
        vm.submitTouched = true;
        if (vm.phoneNumberForm.$valid && vm.phone !== vm.oldPhone) {
            vm.onSubmit({ '$phone': vm.phone });
        }
    }
}

},{}],594:[function(require,module,exports){
"use strict";

angular.module('app').component('popupYnaoDiscountSelect', {
    templateUrl: 'modals/popup-ynao-discount-select/popup-ynao-discount-select.html',
    controller: ['utils', 'backend', 'redirect', PopupYnaoDiscountSelectController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&'
    }
});

function PopupYnaoDiscountSelectController(utils, backend, redirect) {

    var vm = this;

    vm.changeHandler = changeHandler;
    vm.suffixCount = utils.suffixCount;
    vm.calculate = calculate;
    vm.goToBooking = redirect.goToBooking;

    vm.$onInit = recalc();

    function generateAvailable() {
        return vm.orderInfo.plainFlights.map(function (flight) {
            var availablePassengersByFlight = [];
            vm.orderInfo.ynao.availablePassengers.forEach(function (item) {
                item.availableSegmentsFromYnao.forEach(function (flightId) {
                    if (flight.id === flightId) {
                        availablePassengersByFlight.push(item.passengerId);
                    }
                });
                item.availableSegmentsToYnao.forEach(function (flightId) {
                    if (flight.id === flightId) {
                        availablePassengersByFlight.push(item.passengerId);
                    }
                });
            });
            if (availablePassengersByFlight.length) {
                return vm.orderInfo.passengers.map(function (pax) {
                    return utils.hasInList(availablePassengersByFlight, pax.id);
                });
            } else {
                return false;
            }
        });
    }

    function generateSelected() {
        return vm.orderInfo.plainFlights.map(function (flight) {
            return vm.orderInfo.passengers.map(function (pax) {
                return !!_.findWhere(vm.orderInfo.ynao.processedPassengerSegments, {
                    segmentId: flight.id,
                    passengerId: pax.id,
                    success: true
                });
            });
        });
    }

    function generateFails() {
        return vm.orderInfo.plainFlights.map(function (flight) {
            return vm.orderInfo.passengers.map(function (pax) {
                var processedItem = _.findWhere(vm.orderInfo.ynao.processedPassengerSegments, {
                    segmentId: flight.id,
                    passengerId: pax.id,
                    success: false
                });
                return processedItem && processedItem.rejectReason || false;
            });
        });
    }

    function changeHandler(currentFlightNum, currentPassengerNum) {

        var currentPax = void 0;

        vm.orderInfo.ynao.availablePassengers.forEach(function (pax) {
            if (vm.orderInfo.passengers[currentPassengerNum].id === pax.passengerId) {
                currentPax = pax;
            }
        });

        var availableSegmentsFromYnaoByPax = currentPax.availableSegmentsFromYnao;
        var availableSegmentsToYnaoByPax = currentPax.availableSegmentsToYnao;

        var selectedSegmentsByPax = vm.orderInfo.plainFlights.filter(function (flight, flightNum) {
            return vm.selectedByFlightPassengers[flightNum][currentPassengerNum];
        }).map(function (flight) {
            return flight.id;
        });

        var selectedSegmentsFromYnaoByPax = availableSegmentsFromYnaoByPax.filter(function (segId) {
            return utils.hasInList(selectedSegmentsByPax, segId);
        });
        var selectedSegmentsToYnaoByPax = availableSegmentsToYnaoByPax.filter(function (segId) {
            return utils.hasInList(selectedSegmentsByPax, segId);
        });

        // Если среди выбранных сегментов вылета из ЯНАО есть текущий - снимаем выбор всех кроме текущего
        if (utils.hasInList(selectedSegmentsFromYnaoByPax, vm.orderInfo.plainFlights[currentFlightNum].id)) {
            selectedSegmentsFromYnaoByPax.forEach(function (id) {
                if (id !== vm.orderInfo.plainFlights[currentFlightNum].id) {
                    vm.selectedByFlightPassengers[getFlightNumById(id)][currentPassengerNum] = false;
                }
            });
        }
        // Если среди выбранных сегментов прилета в ЯНАО есть текущий - снимаем выбор всех кроме текущего
        if (utils.hasInList(selectedSegmentsToYnaoByPax, vm.orderInfo.plainFlights[currentFlightNum].id)) {
            selectedSegmentsToYnaoByPax.forEach(function (id) {
                if (id !== vm.orderInfo.plainFlights[currentFlightNum].id) {
                    vm.selectedByFlightPassengers[getFlightNumById(id)][currentPassengerNum] = false;
                }
            });
        }

        vm.hasChanges = checkOptionsDiff();
        vm.passengersCount = calcPassengersCount();
        vm.flightsCount = calcFlightsCount();
    }

    function getFlightNumById(id) {
        for (var flightNum = 0; flightNum < vm.orderInfo.plainFlights.length; flightNum++) {
            if (vm.orderInfo.plainFlights[flightNum].id === id) {
                return flightNum;
            }
        }
    }

    function checkOptionsDiff() {
        for (var flightNum = 0; flightNum < vm.orderInfo.plainFlights.length; flightNum++) {
            for (var paxNum = 0; paxNum < vm.orderInfo.passengers.length; paxNum++) {
                if (vm.selectedByFlightPassengersInOrder[flightNum][paxNum] !== vm.selectedByFlightPassengers[flightNum][paxNum]) {
                    return true;
                }
            }
        }
        return false;
    }

    function calcFlightsCount() {
        return vm.orderInfo.plainFlights.filter(function (flight, flightNum) {
            return utils.hasInList(vm.selectedByFlightPassengers[flightNum], true);
        }).length;
    }

    function calcPassengersCount() {
        return vm.orderInfo.passengers.filter(function (pax, paxNum) {
            var paxSelected = false;
            vm.orderInfo.plainFlights.forEach(function (flight, flightNum) {
                if (vm.selectedByFlightPassengers[flightNum][paxNum]) {
                    paxSelected = true;
                }
            });
            return paxSelected;
        }).length;
    }

    function calculate() {
        var passengerSegments = [];
        vm.orderInfo.plainFlights.forEach(function (flight, flightNum) {
            vm.orderInfo.passengers.forEach(function (pax, paxNum) {
                if (vm.selectedByFlightPassengers[flightNum][paxNum]) {
                    passengerSegments.push({
                        passengerId: pax.id,
                        segmentId: flight.id
                    });
                }
            });
        });
        recalc(passengerSegments);
    }

    function recalc(passengerSegments) {
        vm.loading = true;
        vm.errorMessage = false;
        backend.calculateYnaoDiscount(passengerSegments).then(function () {
            backend.updateOrderInfo().then(function (orderInfo) {
                vm.orderInfo = orderInfo;
                vm.availableByFlightPassengers = generateAvailable();
                vm.selectedByFlightPassengers = generateSelected();
                vm.failsByFlightPassengers = generateFails();
                vm.selectedByFlightPassengersInOrder = angular.copy(vm.selectedByFlightPassengers);
                vm.hasChanges = false;
                vm.loading = false;
            });
        }, function (resp) {
            vm.errorMessage = resp.error;
            vm.loading = false;
        });
    }
}

},{}],595:[function(require,module,exports){
"use strict";

angular.module('app').controller('ActivateAccountScreenController', ['backend', 'redirect', function (backend, redirect) {

    var vm = this;
    vm.loading = true;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privateOffice'));
        if (!o2context.registrationIdentityToken) {
            redirect.goToStart();
            return;
        }

        backend.activate(o2context.registrationIdentityToken).then(function () {
            vm.loading = false;
            vm.activateSuccess = true;
        }, function (resp) {
            vm.loading = false;
            vm.activateError = resp.error;
        });
    });
}]);

},{}],596:[function(require,module,exports){
"use strict";

angular.module('app').controller('AddServicesScreenController', ['$scope', '$routeParams', '$window', 'redirect', 'backend', 'utils', 'modalTools', function ($scope, $routeParams, $window, redirect, backend, utils, modalTools) {
    var vm = this;

    vm.loading = true;
    vm.searchOrderLoading = true;
    vm.orderServicesLoading = true;
    vm.esCurrentPage = 1;

    vm.openOrder = redirect.goToSearchOrder;
    vm.submitPayment = submitPayment;
    vm.paymentVariantChangeHandler = paymentVariantChangeHandler;
    vm.reloadPage = reloadPage;
    vm.clearSession = clearSession;
    vm.swithcSubmitButtonHoverState = swithcSubmitButtonHoverState;
    vm.showNextServicesPage = showNextServicesPage;

    backend.ready.then(function () {
        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'addServices'));

        vm.loading = false;

        backend.clearOrderInfoListeners();
        backend.clearUpdateOrderServicesListeners();

        backend.addOrderInfoListener(function (orderInfo) {
            vm.orderInfo = orderInfo;
        });

        backend.addUpdateOrderServicesListener(function (resp) {
            vm.pureServicesList = resp[0];
            vm.orderInfo = resp[1];
            vm.paymentVariants = resp[2];
            vm.isFreePaymentVariants = utils.isFreePaymentVariants(resp[2]);

            if (vm.isFreePaymentVariants) {
                vm.showNeedSelectPaymentFormMesage = false;
            }

            vm.es = utils.reformatAvailableExtraServicesByCards(vm.pureServicesList, vm.orderInfo, vm.es);
            vm.esPagesCount = utils.getAvailableExtraServicesesPagesCount(vm.pureServicesList);
            vm.esList = utils.getAvailableExtraServicesList(vm.pureServicesList, vm.es, vm.esCurrentPage);
            vm.insuranceAgreeText = backend.generateInsuranceAgreeText(vm.orderInfo.editableExtraServicesHeap);

            vm.searchOrderLoading = false;
            vm.orderServicesLoading = false;

            if (backend.getParam('ffp.enable') && (vm.orderInfo.hasBonusCard || vm.orderInfo.ffpSumm)) {
                backend.ffpBonus().then(function (resp) {
                    vm.ffpBonus = resp.total || 0;
                });
            }
        }, function (resp) {
            vm.searchOrderLoading = false;
            vm.orderServicesLoading = false;
            vm.errorMessage = resp.error;
        });

        backend.updateOrderServices(true).then(function () {
            vm.loading = true;

            backend.switchDefaultSelectedServices(vm.esList, vm.es, vm.orderInfo).then(function () {
                vm.loading = false;
            }, function (resp) {
                vm.errorMessage = resp.error;
                vm.loading = false;
            });
        });

        backend.addExtraServiceListener(function (state) {
            vm.modifyServicesLoading = !state;
            vm.orderServicesLoading = true;
        });

        backend.addExtraServiceErrorListener(function (resp, req) {
            if (!req || req.code !== 'seat') {
                vm.modifyServicesError = resp.error;
            }

            vm.modifyServicesLoading = false;
            vm.orderServicesLoading = true;
        });
    });

    function showNextServicesPage() {
        vm.esCurrentPage++;
        vm.esList = utils.getAvailableExtraServicesList(vm.pureServicesList, vm.es, vm.esCurrentPage);
    }

    function submitPayment(contacts, ignoreAgreeAndPaymentVariant) {
        if (vm.modifyServicesLoading || vm.orderServicesLoading) {
            return;
        }
        if (ignoreAgreeAndPaymentVariant) {
            vm.selectedPaymentVariantIndex = 0;
            vm.agree = true;
        }
        if (vm.agree) {
            if (vm.paymentVariants[vm.selectedPaymentVariantIndex]) {
                submitPaymentConfirm(contacts);
            } else {
                vm.showNeedSelectPaymentFormMesage = true;
            }
        }
    }

    function submitPaymentConfirm(contacts, extraServicesToRemoveIds) {

        var selectedPaymentVariant = vm.paymentVariants[vm.selectedPaymentVariantIndex];

        vm.confirmLoading = true;

        if (vm.confirmError) {
            delete vm.confirmError;
        }

        backend.startPaymentForExtraServices(selectedPaymentVariant.paymentForm, selectedPaymentVariant.paymentType, false, contacts, {
            save_new_card: vm.saveNewCard,
            card_token: selectedPaymentVariant.savedCard && selectedPaymentVariant.savedCard.token
        }, extraServicesToRemoveIds).then(function (resp) {
            if (resp.extraServicesPayment && resp.extraServicesPayment.servicesToRemove.length) {
                modalTools.openHandler('popup-removed-services-warning', false, {
                    submitCallback: function submitCallback() {
                        submitPaymentConfirm(contacts, resp.extraServicesToRemoveIds);
                    },
                    closeCallback: function closeCallback() {
                        backend.updateOrderServices(true);
                    },

                    extraServicesPayment: resp.extraServicesPayment,
                    disableOutsideCloseClick: true
                });
            } else if (resp.pnr && resp.lastName) {
                redirect.goToConfirmOrder();
            } else if (resp.eraseAeroexpressBecauseOfCurrency || resp.eraseInsuranceBecauseOfCurrency) {
                modalTools.openHandler('popup-change-currency-error', false, {
                    eraseAeroexpressBecauseOfCurrency: resp.eraseAeroexpressBecauseOfCurrency,
                    eraseInsuranceBecauseOfCurrency: resp.eraseInsuranceBecauseOfCurrency,
                    mode: 'addServices',
                    submitCallback: submitPayment
                });
            }
            vm.confirmLoading = false;
        }, function (resp) {
            if (resp.error === 'web.contactsRequired') {
                vm.showContactsRequiredPopup = true;
                if (resp.canChoosePassenger) {
                    vm.contactsOwnerVariants = generateContactsOwnerVariants();
                } else {
                    vm.contactsOwnerVariants = false;
                }
            } else if (resp.error === 'web.noBookedConfirmedExtraServices') {
                vm.fatalError = resp.error;
            } else {
                vm.confirmError = resp.error;
            }

            vm.confirmLoading = false;
        });
    }

    function generateContactsOwnerVariants() {
        var options = [];
        var CONTACTS_OWNER_MIN_AGE = 18;
        var defaultEmail = backend.sessionParams.authoriseCustomer && backend.sessionParams.authoriseCustomer.email || '';
        var defaultPhone = backend.sessionParams.authoriseCustomer && backend.sessionParams.authoriseCustomer.phone || '';
        vm.orderInfo.passengers.filter(function (pax) {
            var dateOfBirth = moment(pax.dateOfBirth, 'DD.MM.YYYY');
            var todayDate = moment(backend.sessionParams.todayDate, 'DD.MM.YYYY');
            var yearsDiff = todayDate.diff(dateOfBirth, 'years', false);
            return yearsDiff > CONTACTS_OWNER_MIN_AGE;
        }).forEach(function (pax) {
            options.push({
                id: pax.id,
                label: pax.lastName + ' ' + pax.firstName,
                phone: pax.phone || defaultPhone,
                email: pax.email || defaultEmail
            });
        });
        if (!options.length) {
            return false;
        }
        options.push({
            id: -1,
            label: backend.getAlias('web.popupContactsRequired.notOrderPax'),
            phone: defaultPhone,
            email: defaultEmail
        });
        return options;
    }

    function paymentVariantChangeHandler(newVariantIndex) {
        vm.showNeedSelectPaymentFormMesage = false;
        vm.selectedPaymentVariantIndex = newVariantIndex;
        backend.changePaymentForm(vm.paymentVariants[newVariantIndex].paymentForm);
    }

    function reloadPage() {
        $window.location.reload();
        return false;
    }

    function clearSession() {
        backend.clearSession().then(function () {
            redirect.goToSearchOrder();
        });
    }

    function swithcSubmitButtonHoverState() {
        vm.submitButtonHover = !vm.submitButtonHover;
    }
}]);

},{}],597:[function(require,module,exports){
"use strict";

angular.module('app').controller('BookingServicesScreenController', ['$window', 'backend', 'utils', 'redirect', 'watchman', 'oxyScroll', function ($window, backend, utils, redirect, watchman, oxyScroll) {

    var vm = this;

    vm.loading = true;
    vm.orderServicesLoading = true;
    vm.goToConfirmBookingButtonTouched = false;
    vm.esCurrentPage = 1;

    vm.showNextServicesPage = showNextServicesPage;
    vm.openConfirmBooking = openConfirmBooking;

    backend.ready.then(function () {
        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'extraServices'));

        backend.clearOrderInfoListeners();
        backend.clearUpdateOrderServicesListeners();

        backend.addOrderInfoListener(function (orderInfo) {
            if (orderInfo && orderInfo.header && orderInfo.header.regnum && orderInfo.passengers && orderInfo.passengers[0] && orderInfo.passengers[0].lastName) {
                vm.loading = true;
                redirect.goToConfirmOrder();
                return;
            }
            vm.orderInfo = orderInfo;
        });

        backend.addUpdateOrderServicesListener(function (resp) {
            vm.pureServicesList = resp[0];
            vm.orderInfo = resp[1];
            vm.es = utils.reformatAvailableExtraServicesByCards(vm.pureServicesList, vm.orderInfo, vm.es);
            if (vm.pureServicesList.length === 0 || vm.pureServicesList.length === 1 && vm.es.seat) {
                redirect.goToConfirmBooking();
                return;
            }
            vm.esPagesCount = utils.getAvailableExtraServicesesPagesCount(vm.pureServicesList);
            vm.esList = utils.getAvailableExtraServicesList(vm.pureServicesList, vm.es, vm.esCurrentPage);
            vm.loading = false;
            vm.orderServicesLoading = false;
        }, function (resp) {
            vm.loading = false;
            vm.orderServicesLoading = false;
            vm.errorMessage = resp.error;
        });

        backend.updateOrderServices();

        watchman.notifyUserInterfaceEvent({ name: 'add-services-from-booking' });

        backend.addExtraServiceListener(function (state) {
            vm.modifyServicesError = false;
            vm.modifyServicesLoading = !state;
            vm.orderServicesLoading = true;
        });

        backend.addExtraServiceErrorListener(function (resp) {
            vm.modifyServicesError = resp.error;
            vm.modifyServicesLoading = false;
            vm.orderServicesLoading = true;
        });
    });

    function showNextServicesPage() {
        vm.esCurrentPage++;
        vm.esList = utils.getAvailableExtraServicesList(vm.pureServicesList, vm.es, vm.esCurrentPage);
    }

    function openConfirmBooking() {
        vm.goToConfirmBookingButtonTouched = true;
        var insBegDoneText = $window.localStorage && $window.localStorage.websky_ins_beg_done;
        var insBegDone = insBegDoneText ? JSON.parse(insBegDoneText) : false;
        if (insBegDone.length && !insBegDone.every(function (b) {
            return !!b;
        })) {
            vm.es.insurance.active = true;
            oxyScroll.scrollToAnchor('serviceSelect_insurance');
        } else {
            redirect.goToConfirmBooking();
        }
    }
}]);

},{}],598:[function(require,module,exports){
"use strict";

angular.module('app').controller('ConfirmBookingScreenController', ['$q', 'backend', 'redirect', 'modalTools', function ($q, backend, redirect, modalTools) {

    var vm = this;

    vm.loading = true;

    vm.paymentVariantChangeHandler = paymentVariantChangeHandler;
    vm.swithcSubmitButtonHoverState = swithcSubmitButtonHoverState;
    vm.submitPayment = submitPayment;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'order'));
        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;

        backend.clearOrderInfoListeners();

        backend.addOrderInfoListener(function (orderInfo) {
            if (orderInfo.plainFlights && orderInfo.plainFlights.length && orderInfo.passengers && orderInfo.passengers.length) {
                vm.orderInfo = orderInfo;
            } else {
                vm.errorMessage = 'web.messages.emptyOrder';
            }
        });

        if (backend.getParam('payment.showPaymentFormSelect')) {
            backend.updateOrderInfo(true).then(function () {
                vm.loading = false;
            }, function (resp) {
                vm.errorMessage = resp.error;
                vm.loading = false;
            });
        } else {
            $q.all([backend.updateOrderInfo(true), backend.paymentVariants()]).then(function (resp) {
                vm.loading = false;
                vm.orderInfo = resp[0];
                vm.insuranceAgreeText = backend.generateInsuranceAgreeText(vm.orderInfo.editableExtraServicesHeap);
                vm.paymentVariants = resp[1];
            }, function (resp) {
                vm.errorMessage = resp.error;
                vm.loading = false;
            });
        }
    });

    function paymentVariantChangeHandler(newVariantIndex) {
        vm.showNeedSelectPaymentFormMesage = false;
        vm.selectedPaymentVariantIndex = newVariantIndex;
        backend.changePaymentForm(vm.paymentVariants[newVariantIndex].paymentForm);
    }

    function submitPayment() {
        if (vm.agree) {
            if (vm.paymentVariants[vm.selectedPaymentVariantIndex]) {
                if (vm.paymentVariants[vm.selectedPaymentVariantIndex].conflicts_with_aeroexpress || vm.paymentVariants[vm.selectedPaymentVariantIndex].conflicts_with_insurance) {
                    modalTools.openHandler('popup-cancel-conflict-services', false, {
                        paymentForm: vm.paymentVariants[vm.selectedPaymentVariantIndex].paymentForm,
                        aeroexpress: vm.paymentVariants[vm.selectedPaymentVariantIndex].conflicts_with_aeroexpress,
                        insurance: vm.paymentVariants[vm.selectedPaymentVariantIndex].conflicts_with_insurance,
                        submitCallback: submitPaymentHandler
                    });
                } else {
                    submitPaymentHandler();
                }
            } else {
                vm.showNeedSelectPaymentFormMesage = true;
            }
        }
    }

    function submitPaymentHandler(removeInsuranceAeroexpress) {

        var selectedPaymentVariant = vm.paymentVariants[vm.selectedPaymentVariantIndex];

        if (vm.bookingError) {
            delete vm.bookingError;
        }

        vm.loading = true;

        backend.doBookingAndRegisterOrder(selectedPaymentVariant.paymentForm, selectedPaymentVariant.paymentType, removeInsuranceAeroexpress, {
            save_new_card: vm.saveNewCard,
            card_token: selectedPaymentVariant.savedCard && selectedPaymentVariant.savedCard.token
        }).then(function (resp) {
            if (resp.extraServicesPayment && resp.extraServicesPayment.servicesToRemove.length) {
                modalTools.openHandler('popup-removed-services-warning', false, {
                    submitCallback: function submitCallback() {
                        submitPaymentHandler(removeInsuranceAeroexpress, resp.extraServicesToRemoveIds);
                    },
                    closeCallback: function closeCallback() {
                        backend.updateOrderServices(true);
                    },

                    extraServicesPayment: resp.extraServicesPayment,
                    disableOutsideCloseClick: true
                });
            } else if (resp.pnr && resp.lastName) {
                redirect.goToConfirmOrder();
            } else if (resp.eraseAeroexpressBecauseOfCurrency || resp.eraseInsuranceBecauseOfCurrency) {
                modalTools.openHandler('popup-change-currency-error', false, {
                    eraseAeroexpressBecauseOfCurrency: resp.eraseAeroexpressBecauseOfCurrency,
                    eraseInsuranceBecauseOfCurrency: resp.eraseInsuranceBecauseOfCurrency,
                    mode: 'booking',
                    submitCallback: submitPaymentHandler
                });
            }
            vm.loading = false;
        }, function (resp) {
            vm.loading = false;
            if (resp.error === 'web.bookingNoSeatsLeft') {
                vm.bookingErrorGotoSearch = resp.error;
            } else {
                vm.bookingError = resp.error;
            }
        });
    }

    function swithcSubmitButtonHoverState() {
        vm.submitButtonHover = !vm.submitButtonHover;
    }
}]);

},{}],599:[function(require,module,exports){
"use strict";

angular.module('app').controller('ConfirmOrderScreenController', ['backend', 'watchman', function (backend, watchman) {

    var vm = this;
    vm.loading = true;

    watchman.addOrderEventListener(function (orderEvent, orderInfo) {
        if (orderEvent.type === 'ORDER_BOOKED') {
            if (orderInfo.header && orderInfo.header.status === 'booked') {
                if (orderInfo.paymentform === 'cash') {
                    vm.showBookingSuccessMessage = true;
                }
            }
        } else if (orderEvent.type === 'ORDER_PAYMENT_SUCCESSFULLY_FINISHED') {
            vm.showPaidSuccessMessage = true;
        } else if (orderEvent.type === 'ORDER_PAYMENT_FAILED' || orderEvent.type === 'EXTRA_SERVICES_PAYMENT_FAILED' || orderEvent.type === 'EXCHANGE_PAYMENT_FAILED') {
            vm.showPaidFailedMessage = true;
        } else if (orderEvent.type === 'EXCHANGE_REVALIDATION_SUCCESSFULLY_FINISHED') {
            vm.showExchangeRevalidationSuccessfullyFinishedMessage = true;
        } else if (orderEvent.type === 'EXCHANGE_CONFIRM_SUCCESSFULLY_FINISHED') {
            vm.showExchangeConfirmSuccessfullyFinishedMessage = true;
        }
    }, 'websky');

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'order'));
        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;

        backend.updateOrderInfo(true).then(function (orderInfo) {
            vm.orderInfo = orderInfo;
        }, function (resp) {
            vm.errorMessage = resp.error;
        }).finally(function () {
            vm.loading = false;
        });
    });
}]);

},{}],600:[function(require,module,exports){
"use strict";

angular.module('app').controller('ExchangeScreenController', ['backend', 'utils', 'redirect', function (backend, utils, redirect) {

    var vm = this;

    vm.openOrder = redirect.goToSearchOrder;
    vm.clearExchangeVariants = clearExchangeVariants;
    vm.gotoSearchStep = gotoSearchStep;
    vm.searchExchangeVariants = searchExchangeVariants;
    vm.selectFlight = selectFlight;
    vm.selectBrand = selectBrand;
    vm.openBrandDetails = openBrandDetails;
    vm.closeBrandDetails = closeBrandDetails;
    vm.confirmExchange = confirmExchange;
    vm.agreeExtraServicesRefund = agreeExtraServicesRefund;
    vm.swithcSubmitButtonHoverState = swithcSubmitButtonHoverState;
    vm.paymentVariantChangeHandler = paymentVariantChangeHandler;

    vm.loading = true;
    vm.requestFormOpened = true;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'exchange'));
        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
        vm.useSegmentsChain = backend.getParam('site.exchangeConnectingFlightsMode') === 'SEGMENTS_CHAIN';

        backend.clearOrderInfoListeners();

        backend.updateOrderInfo().then(function (orderInfo) {
            orderInfo.passengers.forEach(function (pax) {
                if (pax.parentId && pax.categoryType === 'INFANT_WITHOUT_SEAT') {
                    var parent = _.findWhere(orderInfo.passengers, { id: pax.parentId });
                    parent.child = pax;
                }
            });
            vm.orderInfo = orderInfo;
            vm.flightsNearingForbidden = getFlightsNearingForbidden(vm.orderInfo.plainFlights);
            backend.flownStatus('exchange').then(function (flownStatus) {
                if (vm.useSegmentsChain) {
                    vm.exchangeAvailability = generateExchangeAvailabilityByChain(orderInfo, flownStatus);
                    vm.exchangeUnavailabilityReason = generateExchangeUnavailabilityReasonByChain(orderInfo, flownStatus);
                } else {
                    vm.exchangeAvailability = generateExchangeAvailability(orderInfo, flownStatus);
                    vm.exchangeUnavailabilityReason = generateExchangeUnavailabilityReason(orderInfo, flownStatus);
                }
            }, function (resp) {
                vm.fatalError = resp.error;
            }).finally(function () {
                vm.loading = false;
            });
        }, function (resp) {
            vm.fatalError = resp.error;
            vm.loading = false;
        });

        vm.hasAgree = backend.hasAlias('web.exchange.agree');
        vm.hasSpecialAgree = backend.hasAlias('web.exchange.specialAgree');
    });

    function getFlightsNearingForbidden(plainFlights) {
        var currentMoment = moment.utc(o2context.serverDateTime);
        var hoursLimit = backend.getParam('site.exchangeNearingFlightsForbiddenHoursLimit'); // OS-2146
        return plainFlights.map(function (flight) {
            var flightMoment = moment.utc(flight.departureDateTimeUTC);
            var hoursDiff = flightMoment.diff(currentMoment, 'hours', false);
            return hoursDiff < hoursLimit;
        });
    }

    function clearExchangeVariants() {
        vm.exchangeVariantsBySegments = false;
        vm.selectedVariant = false;
    }

    function gotoSearchStep() {
        clearExchangeVariants();
        vm.requestFormOpened = true;
    }

    function searchExchangeVariants(searchParams) {

        vm.loadingVariants = true;
        clearExchangeVariants();

        backend.exchangeVariants(searchParams).then(function (exchangeVariants) {

            vm.exchangeVariantsBySegments = generateAvailableChainsBySegments(exchangeVariants.segments, searchParams);
            vm.selectedChainBySegments = vm.exchangeVariantsBySegments.map(function () {
                return -1;
            });
            vm.requestFormOpened = false;
        }, function (resp) {
            vm.fatalError = resp.error;
        }).finally(function () {
            vm.loadingVariants = false;
        });
    }

    function selectFlight(segNum, chainNum) {

        var i = 0;
        vm.selectedChainBySegments[segNum] = chainNum;

        while (i < vm.selectedChainBySegments.length) {
            if (vm.selectedChainBySegments[i] === -1) {
                return;
            }
            i++;
        }

        exchangeSelectHandler();
    }

    function selectBrand(code) {
        exchangeSelectHandler(code);
    }

    function closeBrandDetails() {
        vm.brandDetailsCode = false;
    }

    function openBrandDetails(code) {
        vm.brandDetailsCode = code;
    }

    function confirmExchange() {
        if (vm.hasAgree && !vm.agree) {
            return;
        }
        if (vm.hasSpecialAgree && !vm.specialAgree) {
            return;
        }
        if (!vm.paymentVariants[vm.selectedPaymentVariantIndex]) {
            return;
        }
        if (vm.selectedVariant.svcsForRefundTitles && vm.selectedVariant.svcsForRefundTitles.length || vm.orderInfo.prices.totalExtraServiceByGroup.insurance) {
            vm.showExchangeExtraServicesRefund = true;
        } else {
            confirmExchangeHandler();
        }
    }

    function confirmExchangeHandler() {

        var selectedPaymentVariant = vm.paymentVariants[vm.selectedPaymentVariantIndex];
        var paymentForm = selectedPaymentVariant.paymentForm,
            paymentType = selectedPaymentVariant.paymentType,
            savedCard = selectedPaymentVariant.savedCard;

        var params = {
            'payment-form': paymentForm,
            'payment-type': paymentType || paymentForm,
            'save_new_card': vm.saveNewCard,
            'card_token': savedCard && savedCard.token
        };

        if (vm.selectedVariant.extraServicesRefundSumm) {
            params.extraServicesRefundSumm = vm.selectedVariant.extraServicesRefundSumm;
        }

        vm.loadingVariants = true;

        backend.exchangeConfirm(params).then(openConfirmOrder, showErrorMessage).finally(function () {
            vm.loadingVariants = false;
        });
    }

    function agreeExtraServicesRefund() {
        confirmExchangeHandler();
    }

    function openConfirmOrder() {
        redirect.goToConfirmOrder();
    }

    function showErrorMessage(resp) {
        vm.fatalError = resp.error;
    }

    function exchangeSelectHandler(brandCode) {

        vm.loadingSelectedVariant = true;
        vm.exchangeSelectError = false;

        var selectedChains = vm.exchangeVariantsBySegments.map(function (segment, segNum) {
            return segment.chains[vm.selectedChainBySegments[segNum]].chainId;
        });

        backend.exchangeSelect(selectedChains, brandCode).then(function (resp) {
            vm.selectedVariant = resp;
            if (vm.selectedVariant.brands && !vm.brands) {
                vm.brands = generateBrandList(vm.selectedVariant.brands, vm.selectedVariant.currentBrand);
            }
            updatePaymentVariants();
        }, function (resp) {
            if (brandCode) {
                vm.exchangeSelectError = resp.error;
            } else {
                vm.fatalError = resp.error;
            }
        }).finally(function () {
            vm.loadingSelectedVariant = false;
        });
    }

    function updatePaymentVariants() {
        vm.loadingPaymentVariants = true;
        backend.paymentVariants().then(function (resp) {
            vm.paymentVariants = resp;
            vm.loadingPaymentVariants = false;
        }, function (resp) {
            vm.fatalError = resp.error;
            vm.loadingPaymentVariants = false;
        });
    }

    function generateBrandList(sourceBrands, currentBrand) {
        var brandConfig = backend.getBrandConfig();
        var brandList = [];
        if (!currentBrand) {
            brandList.push({
                name: backend.getAlias('web.exchange.variantWithoutBrandLabel'),
                emptyBrand: true,
                cssClass: 'econom_type1'
            });
        }
        sourceBrands.forEach(function (brand) {
            if (brand.available) {
                var brandData = _.findWhere(brandConfig, { code: brand.code });
                if (brandData) {
                    brandList.push(brandData);
                }
            }
        });
        return brandList;
    }

    function generateAvailableChainsBySegments(segments, selectedPassengerSegments) {
        return segments.map(function (segment) {
            var selectedPassengersFilterObject = vm.useSegmentsChain ? { chainId: segment.originalChainId } : { segmentId: segment.originalSegmentId };
            var selectedPassengers = _.where(selectedPassengerSegments, selectedPassengersFilterObject).map(function (item) {
                return _.findWhere(vm.orderInfo.passengers, { id: item.passengerId });
            });

            var newDate = (vm.useSegmentsChain ? _.findWhere(selectedPassengerSegments, { chainId: segment.originalChainId }) : _.findWhere(selectedPassengerSegments, { segmentId: segment.originalSegmentId })).date;

            return {
                chains: _.keys(segment.newSegmentChains).map(function (chainId) {
                    var chain = segment.newSegmentChains[chainId];
                    var landingsAmount = 0;
                    chain.flightsInfo = utils.getFlightsInfo(chain, backend.getAlias('web.connectionsMessage.transfer'), backend.getAlias('web.connectionsMessage.noTransfer'));
                    chain.flights.forEach(function (flight) {
                        if (flight.landingsAmount) {
                            landingsAmount += flight.landingsAmount;
                        }
                    });
                    chain.landingsAmount = landingsAmount;
                    return chain;
                }).sort(function (a, b) {
                    a = a.flights[0].departuretime;
                    b = b.flights[0].departuretime;
                    return utils.compareStringTime(a, b);
                }),
                orderFlight: vm.useSegmentsChain ? _.findWhere(vm.orderInfo.flights, { chainId: segment.originalChainId }).flightsInfo : _.findWhere(vm.orderInfo.plainFlights, { id: segment.originalSegmentId }).flightsInfo,
                newDate: newDate,
                selectedPassengers: selectedPassengers,
                descPassCountStr: getDescPassCountStr(selectedPassengers)
            };
        });
    }

    function generateExchangeAvailability(orderInfo, flownStatus) {
        return orderInfo.plainFlights.map(function (orderFlight) {
            if (_.findWhere(flownStatus.passengerSegments, {
                segmentId: orderFlight.id,
                availabilityInfo: 'AVAILABLE'
            })) {
                return orderInfo.passengers.map(function (orderPassenger) {
                    return !!_.findWhere(flownStatus.passengerSegments, {
                        passengerId: orderPassenger.id,
                        availabilityInfo: 'AVAILABLE'
                    });
                });
            } else {
                return false;
            }
        });
    }

    function generateExchangeAvailabilityByChain(orderInfo, flownStatus) {
        return orderInfo.flights.map(function (orderFlight) {
            if (_.findWhere(flownStatus.passengerSegmentChains, {
                chainId: orderFlight.chainId,
                availabilityInfo: 'AVAILABLE'
            })) {
                return orderInfo.passengers.map(function (orderPassenger) {
                    return !!_.findWhere(flownStatus.passengerSegmentChains, {
                        passengerId: orderPassenger.id,
                        availabilityInfo: 'AVAILABLE'
                    });
                });
            } else {
                return false;
            }
        });
    }

    function generateExchangeUnavailabilityReason(orderInfo, flownStatus) {
        return orderInfo.plainFlights.map(function (orderFlight) {
            return orderInfo.passengers.map(function (orderPassenger) {
                var flownStatusByPassengerSegment = _.findWhere(flownStatus.passengerSegments, {
                    passengerId: orderPassenger.id,
                    segmentId: orderFlight.id
                });
                if (flownStatusByPassengerSegment.availabilityInfo === 'AVAILABLE') {
                    return false;
                } else {
                    return flownStatusByPassengerSegment.availabilityInfo;
                }
            });
        });
    }

    function generateExchangeUnavailabilityReasonByChain(orderInfo, flownStatus) {
        return orderInfo.flights.map(function (orderFlight) {
            return orderInfo.passengers.map(function (orderPassenger) {
                var flownStatusByPassengerSegmentChain = _.findWhere(flownStatus.passengerSegmentChains, {
                    passengerId: orderPassenger.id,
                    chainId: orderFlight.chainId
                });
                if (flownStatusByPassengerSegmentChain.availabilityInfo === 'AVAILABLE') {
                    return false;
                } else {
                    return flownStatusByPassengerSegmentChain.availabilityInfo;
                }
            });
        });
    }

    function getDescPassCountStr(selectedPassengers) {

        var aaaAlias = backend.getAliasWithPrefix('web.passengerCategories.', 'AAA');
        var cpaAlias = backend.getAliasWithPrefix('web.passengerCategories.', 'CPA');
        var mlaAlias = backend.getAliasWithPrefix('web.passengerCategories.', 'MLA');
        var rbgAlias = backend.getAliasWithPrefix('web.passengerCategories.', 'RBG');
        var rmgAlias = backend.getAliasWithPrefix('web.passengerCategories.', 'RMG');
        var rvgAlias = backend.getAliasWithPrefix('web.passengerCategories.', 'RVG');

        var countAAA = 0;
        var countCPA = 0;
        var countMLA = 0;
        var countRBG = 0;
        var countRMG = 0;
        var countRVG = 0;

        selectedPassengers.forEach(function (pax) {
            if (pax.categoryCode === 'AAA') {
                countAAA++;
            }
            if (pax.categoryCode === 'CPA') {
                countCPA++;
            }
            if (pax.categoryCode === 'MLA') {
                countMLA++;
            }
            if (pax.categoryCode === 'RBG') {
                countRBG++;
            }
            if (pax.categoryCode === 'RMG') {
                countRMG++;
            }
            if (pax.categoryCode === 'RVG') {
                countRVG++;
            }
        });

        var result = void 0;

        if (countAAA) {
            result = utils.suffixCount(countAAA, aaaAlias);
        } else if (countCPA) {
            result = utils.suffixCount(countCPA, cpaAlias);
        } else if (countMLA) {
            result = utils.suffixCount(countMLA, mlaAlias);
        }
        if (countRBG) {
            result += ', ' + utils.suffixCount(countRBG, rbgAlias);
        }
        if (countRMG) {
            result += ', ' + utils.suffixCount(countRMG, rmgAlias);
        }
        if (countRVG) {
            result += ', ' + utils.suffixCount(countRVG, rvgAlias);
        }

        return result;
    }

    function swithcSubmitButtonHoverState() {
        vm.submitButtonHover = !vm.submitButtonHover;
    }

    function paymentVariantChangeHandler(newVariantIndex) {
        vm.selectedPaymentVariantIndex = newVariantIndex;
        backend.changePaymentForm(vm.paymentVariants[newVariantIndex].paymentForm);
    }
}]);

},{}],601:[function(require,module,exports){
"use strict";

require('./search/SearchScreenController');
require('./passengers/PassengersScreenController');
require('./seat-select/SeatSelectScreenController');
require('./booking-services/BookingServicesScreenController');
require('./confirm-order/ConfirmOrderScreenController');
require('./private-profile/PrivateProfileScreenController');
require('./private-password/PrivatePasswordScreenController');
require('./private-passengers/PrivatePassengersScreenController');
require('./private-orders/PrivateOrdersScreenController');
require('./private-order/PrivateOrderScreenController');
require('./private-bank-details/PrivateBankDetailsScreenController');
require('./private-payments/PrivatePaymentsScreenController');
require('./reset-forget-password/ResetForgetPasswordScreenController');
require('./activate-account/ActivateAccountScreenController');
require('./exchange/ExchangeScreenController');
require('./refund/RefundScreenController');
require('./schedule/ScheduleScreenController');
require('./search-order/SearchOrderScreenController');
require('./add-services/AddServicesScreenController');
require('./privacy-policy/PrivacyPolicyScreenController');
require('./unsubscribe-email/UnsubscribeEmailScreenController');
require('./unsubscribe-phone/UnsubscribePhoneScreenController');
require('./payment-variants/PaymentVariantsScreenController');
require('./confirm-booking/ConfirmBookingScreenController');
require('./remove-profile-confirm/RemoveProfileConfirmScreenController');

},{"./activate-account/ActivateAccountScreenController":595,"./add-services/AddServicesScreenController":596,"./booking-services/BookingServicesScreenController":597,"./confirm-booking/ConfirmBookingScreenController":598,"./confirm-order/ConfirmOrderScreenController":599,"./exchange/ExchangeScreenController":600,"./passengers/PassengersScreenController":602,"./payment-variants/PaymentVariantsScreenController":603,"./privacy-policy/PrivacyPolicyScreenController":604,"./private-bank-details/PrivateBankDetailsScreenController":605,"./private-order/PrivateOrderScreenController":606,"./private-orders/PrivateOrdersScreenController":607,"./private-passengers/PrivatePassengersScreenController":608,"./private-password/PrivatePasswordScreenController":609,"./private-payments/PrivatePaymentsScreenController":610,"./private-profile/PrivateProfileScreenController":611,"./refund/RefundScreenController":612,"./remove-profile-confirm/RemoveProfileConfirmScreenController":613,"./reset-forget-password/ResetForgetPasswordScreenController":614,"./schedule/ScheduleScreenController":615,"./search-order/SearchOrderScreenController":616,"./search/SearchScreenController":617,"./seat-select/SeatSelectScreenController":618,"./unsubscribe-email/UnsubscribeEmailScreenController":619,"./unsubscribe-phone/UnsubscribePhoneScreenController":620}],602:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').controller('PassengersScreenController', ['$q', '$timeout', '$window', '$rootScope', 'redirect', 'backend', 'utils', 'watchman', 'ymTracker', 'DOC_CODE', function ($q, $timeout, $window, $rootScope, redirect, backend, utils, watchman, ymTracker, DOC_CODE) {

    var vm = this;
    var documentsNumberRegex = utils.getDocumentsNumberRegex();
    var hasSeatSelectStep = true;

    vm.loading = true;
    vm.customer = {};
    vm.documentNumberRegexByPassenger = [];
    vm.firstNameRegexpByPassenger = [];
    vm.lastNameRegexpByPassenger = [];
    vm.documentTypesByPassenger = [];
    vm.rangeBirthByPassenger = [];
    vm.isMobile = isMobile();

    vm.getDescPassCountStr = getDescPassCountStr;
    vm.submitHandler = submitHandler;
    vm.setPrivatePassenger = setPrivatePassenger;
    vm.documentTypeChangeHandler = documentTypeChangeHandler;
    vm.documentNumberChangeHandler = documentNumberChangeHandler;
    vm.additionalDocumentNumberChangeHandler = additionalDocumentNumberChangeHandler;
    vm.documentDateChangeHandler = documentDateChangeHandler;
    vm.nationalityChangeHandler = nationalityChangeHandler;
    vm.genderChangeHandler = genderChangeHandler;
    vm.lastNameBlurHandler = lastNameBlurHandler;
    vm.firstNameBlurHandler = firstNameBlurHandler;
    vm.nameChangeHandler = nameChangeHandler;
    vm.phoneBlurHandler = phoneBlurHandler;
    vm.emailBlurHandler = emailBlurHandler;
    vm.promoCodeChangeHandler = promoCodeChangeHandler;
    vm.bonusCardChangeHandler = bonusCardChangeHandler;
    vm.bonusCardSwitchHandler = bonusCardSwitchHandler;
    vm.checkLogin = checkLogin;
    vm.getExpiryByDocType = getExpiryByDocType;
    vm.hasAlias = backend.hasAlias;
    vm.getOrderCountriesCssClasses = getOrderCountriesCssClasses;
    vm.swithcSubmitButtonHoverState = swithcSubmitButtonHoverState;
    vm.switchSpecialNeed = switchSpecialNeed;
    vm.specialNeedGroupChangeHandler = specialNeedGroupChangeHandler;
    vm.specialNeedGroupSsrRadioSelectHandler = specialNeedGroupSsrRadioSelectHandler;
    vm.dateOfBirthChangeHandler = dateOfBirthChangeHandler;
    vm.closeYnaoDiscountSelectPopup = closeYnaoDiscountSelectPopup;
    vm.closePromoCodesDiscountPopup = closePromoCodesDiscountPopup;
    vm.confirmPromoCodesDiscount = confirmPromoCodesDiscount;
    vm.getDocumentTypeNameByCode = getDocumentTypeNameByCode;
    vm.createAccountSwitchHandler = createAccountSwitchHandler;
    vm.updateScannedDocs = updateScannedDocs;
    vm.parentIndexChangeHandler = parentIndexChangeHandler;
    vm.ffpMemberTypeChangeHandler = ffpMemberTypeChangeHandler;
    vm.bonusCardShortChangeHandler = bonusCardShortChangeHandler;

    o2context.externalSearchParams = false;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'passengers'));
        vm.countriesList = backend.getCountriesList();
        vm.localNamePropName = backend.sessionParams.localNamePropName;
        vm.currentLanguage = backend.sessionParams.lang;
        vm.passangersAlias = [{ name: backend.getAlias('web.privatePassengers.genderMale'), code: 'male' }, { name: backend.getAlias('web.privatePassengers.genderFemale'), code: 'female' }];

        vm.passengerLastNameLatRegexp = backend.applicationConstants.passengerLastNameLatRegexp;
        vm.passengerFirstNameLatRegexp = backend.applicationConstants.passengerFirstNameLatRegexp;

        vm.groupedSpecialNeedSsrs = backend.getGroupedSpecialNeedSsrs();

        initFfpMemberTypes();

        backend.clearOrderInfoListeners();
        backend.addOrderInfoListener(function (orderInfo) {
            if (orderInfo && orderInfo.header && orderInfo.header.regnum && orderInfo.passengers && orderInfo.passengers[0] && orderInfo.passengers[0].lastName) {
                vm.loading = true;
                redirect.goToConfirmOrder();
            }
        });

        $q.all([backend.passengersCheck(), backend.updateOrderInfo()]).then(function (resp) {
            vm.passengersCheck = resp[0];
            vm.orderInfo = resp[1];
            vm.passengersCategoryRules = initPassengersCategoryRules(vm.passengersCheck, vm.countriesList);
            vm.passengersRulesByNum = initPassengersRulesByNum(vm.passengersCheck);
            vm.passengers = initPassengersModel(vm.passengersCheck, vm.orderInfo);
            vm.customer = initCustomerModel(vm.orderInfo, vm.authoriseCustomer);
            updateCustomerFieldsValidation();
            updateAvailableParentsByPassengers();
            selectDefaultParentsByPassengers();
            sendYandexDetail(vm.orderInfo, vm.passengers);

            vm.passengers.forEach(function (pas, num) {
                setDocumentTypesForPassenger(num);
                setRangeBirthForPassenger(num);
                setDocumentNumberRegexForPassenger(num);
                setNamesRegexForPassenger(num);
                updateYnaoDiscountPossible(num);
                pas.personalWheelchairSsrText = getPaxBatterySsrText(pas);
                pas.personalWheelchairSsrCode = getPaxBatterySsrCode(pas);
            });

            updateBonusShortRegex();

            initSpecialNeedGroupSsrs(vm.passengers);

            vm.alertMessages = getAlertMessages(vm.orderInfo);

            backend.addAuthoriseCustomerListener(authoriseCustomerListener);
            vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
            authoriseCustomerListener(vm.authoriseCustomer);

            vm.allowBonusCard = backend.getParam('passengers.allowBonusCard') && !vm.orderInfo.ffpSumm;
            vm.allowBonusCardsForChildren = backend.getParam('passengers.allowBonusCardsForChildren') && !vm.orderInfo.ffpSumm;
            vm.loading = false;
            backend.clearOrderInfoListeners();
            if (vm.passengersCheck.passengers.some(function (paxRules) {
                return paxRules.additionalParameters && paxRules.additionalParameters.haveToUploadScannedDocs;
            })) {
                updateScannedDocs();
            }
            if (backend.getParam('customer.disablePasteContactsFromClipboard')) {
                $timeout(function () {
                    $window.document.querySelector('form[name="vm.customerForm"] input[name="email"]').onpaste = function () {
                        return false;
                    };
                    $window.document.querySelector('form[name="vm.customerForm"] input[name="phone"]').onpaste = function () {
                        return false;
                    };
                });
            }
            vm.personalWheelchairSelected = vm.passengers.map(function (pax) {
                return !!getPaxBatterySsrText(pax);
            });
        }, function (resp) {
            vm.loading = false;
            vm.errorMessage = resp.error;
        });

        backend.setSwitchCurrencyLanguageListener(function () {
            storePassengersData(vm.passengers);
            storeCustomerData(vm.customer);
        });

        utils.clearServicesStatistics();

        vm.passengersAddPageOpenTime = Date.now() - o2context.clientTimeDelta;

        if ($window.localStorage && $window.localStorage.websky_ins_beg_done) {
            localStorage.removeItem('websky_ins_beg_done');
        }
    });

    function authoriseCustomerListener(authoriseCustomer) {
        vm.authoriseCustomer = authoriseCustomer;
        updatePrivatePassengers();
        vm.customer = initCustomerModel(vm.orderInfo, vm.authoriseCustomer);
        updateCustomerFieldsValidation();
    }

    function getPaxBatterySsrText(pax) {
        var result = '';
        if (pax.specialNeeds) {
            pax.specialNeeds.forEach(function (item) {
                if (item.text && item.text.includes('BATTERY')) {
                    result = item.text;
                }
            });
        }
        return result;
    }

    function getPaxBatterySsrCode(pax) {
        var result = '';
        if (pax.specialNeeds) {
            pax.specialNeeds.forEach(function (item) {
                if (item.ssr && item.text && item.text.includes('BATTERY')) {
                    result = item.ssr;
                }
            });
        }
        return result;
    }

    function updateScannedDocs() {
        var uploadedScannedDocsByPassengers = vm.passengers.map(function () {
            return [];
        });
        backend.getScannedDocs().then(function (resp) {
            resp.scannedDocs.forEach(function (_ref) {
                var passengerIndex = _ref.passengerIndex,
                    fileName = _ref.fileName;

                uploadedScannedDocsByPassengers[passengerIndex].push({
                    fileName: fileName,
                    fileIndex: uploadedScannedDocsByPassengers[passengerIndex].length
                });
            });
            vm.uploadedScannedDocsByPassengers = uploadedScannedDocsByPassengers;
            vm.hasPassengersWithoutScannedDocs = uploadedScannedDocsByPassengers.some(function (paxFiles, passengerIndex) {
                return paxFiles.length === 0 && vm.passengersCategoryRules[vm.passengers[passengerIndex].categoryId].additionalParameters && vm.passengersCategoryRules[vm.passengers[passengerIndex].categoryId].additionalParameters.haveToUploadScannedDocs;
            });
        });
    }

    function initPassengersRulesByNum(passengersCheck) {
        var rulesByNum = [];
        passengersCheck.passengers.forEach(function (item) {
            var i = 0;
            var tmpCopy = angular.copy(item);
            delete tmpCopy.count;
            while (i < item.count) {
                rulesByNum.push(tmpCopy);
                i++;
            }
        });
        return rulesByNum;
    }

    function getDefaultDocumentTypeCodeByNumAndNationality(num, nationality) {
        var docItem = void 0;
        if (!nationality) {
            return false;
        }
        if (nationality === 'RU') {
            docItem = _.findWhere(vm.passengersRulesByNum[num].documents, { defaultSelectedRussian: "true" });
        } else {
            docItem = _.findWhere(vm.passengersRulesByNum[num].documents, { defaultSelectedForeign: "true" });
        }
        return docItem && docItem.code;
    }

    function getAlertMessages(orderInfo) {
        var messages = [];
        orderInfo.plainFlights.forEach(function (flight) {
            var destAlias = 'web.alertMessage.passengers.destinationCity.' + flight.destinationcity,
                origAlias = 'web.alertMessage.passengers.originCity.' + flight.origincity;
            if (backend.hasAlias(destAlias)) {
                messages.push(destAlias);
            }
            if (backend.hasAlias(origAlias)) {
                messages.push(origAlias);
            }
        });
        return _.uniq(messages);
    }

    function storePassengersData(data) {
        var passengers = void 0;
        if (data && data.length) {
            passengers = data.map(function (item) {
                return {
                    lastName: item.lastName,
                    firstName: item.firstName,
                    dateOfBirth: item.dateOfBirth,
                    gender: item.gender,
                    nationality: item.nationality,
                    phone: item.phone,
                    email: item.email,
                    documentNumber: item.documentNumber,
                    documentDate: item.documentDate,
                    documentType: item.documentType,
                    categoryId: item.categoryId,
                    type: item.type
                };
            });
            $window.sessionStorage.oxygen_passengers_form_data = angular.toJson(passengers);
        }
    }

    function storeCustomerData(data) {
        $window.sessionStorage.oxygen_customer_form_data = angular.toJson({
            lastName: data.lastName,
            firstName: data.firstName,
            phone: data.phone,
            email: data.email,
            sendSms: data.sendSms,
            sendAdvertisement: data.sendAdvertisement,
            sendEMail: data.sendEMail
        });
    }

    function restorePassengersData() {
        if ($window.sessionStorage.oxygen_passengers_form_data) {
            return angular.fromJson($window.sessionStorage.oxygen_passengers_form_data);
        } else {
            return false;
        }
    }

    function restoreCustomersData() {
        if ($window.sessionStorage.oxygen_customer_form_data) {
            return angular.fromJson($window.sessionStorage.oxygen_customer_form_data);
        } else {
            return false;
        }
    }

    function updateCustomerFieldsValidation() {
        if (!_.isEmpty(vm.customer)) {
            jQuery('form[name="vm.customerForm"] input[type="text"]').trigger('blur');
        }
    }

    function updateAvailableParentsByPassengers() {
        var availableParentsByPassenger = vm.passengers.map(function (pax, paxNum) {
            var resultList = [];
            if (pax.type == 'INFANT_WITHOUT_SEAT') {
                vm.passengers.forEach(function (otherPax, otherPaxNum) {
                    if (paxNum !== otherPaxNum && otherPax.type === 'ADULT' && canToBePassengerParent(otherPax)) {
                        var otherPaxName = otherPax.lastName && otherPax.firstName ? otherPaxNum + 1 + '. ' + otherPax.lastName + ' ' + otherPax.firstName : otherPaxNum + 1 + '. ' + backend.getAliasWithPrefix('web.passengerCategory.', otherPax.categoryId);
                        resultList.push({
                            code: otherPaxNum,
                            name: otherPaxName
                        });
                    }
                });
            }
            return resultList;
        });
        vm.availableParentsByPassenger = availableParentsByPassenger;
    }

    function resetInvalidParentsByPassengers() {
        vm.availableParentsByPassenger.forEach(function (availableParents, paxNum) {
            if (!utils.hasInList(availableParents, vm.passengers[paxNum].parentIndex)) {
                delete vm.passengers[paxNum].parentIndex;
            }
        });
    }

    function selectDefaultParentsByPassengers() {
        vm.availableParentsByPassenger.forEach(function (availableParents, paxNum) {
            if (availableParents.length === 1) {
                vm.passengers[paxNum].parentIndex = availableParents[0].code;
            }
        });
    }

    function canToBePassengerParent(pax) {
        if (!pax.dateOfBirth) {
            return true;
        } else {
            var dateOfBirthMoment = moment(pax.dateOfBirth, 'DD.MM.YYYY');
            for (var i = 0; i < vm.orderInfo.plainFlights.length; i++) {
                var flightMoment = moment(vm.orderInfo.plainFlights[i].date, 'DD.MM.YYYY');
                var minAge = backend.getParam('site.minAgeToBePassengerParent');
                var yearsDiff = flightMoment.diff(dateOfBirthMoment, 'years', false);
                if (yearsDiff < minAge) {
                    return false;
                }
            }
            return true;
        }
    }

    function updatePrivatePassengers() {
        if (vm.authoriseCustomer && vm.passengers) {
            backend.getPrivatePassengers().then(function (resp) {
                vm.availablePrivatePassengers = vm.passengers.map(function (passenger, paxNum) {
                    return resp.passengers.filter(function (privatePassenger) {
                        var dateOfBirth = privatePassenger.dateOfBirth;
                        var _vm$passengersRulesBy = vm.passengersRulesByNum[paxNum],
                            rangeBirthTo = _vm$passengersRulesBy.rangeBirthTo,
                            rangeBirthFrom = _vm$passengersRulesBy.rangeBirthFrom;

                        return utils.compareStringDate(dateOfBirth, rangeBirthFrom) !== -1 && utils.compareStringDate(dateOfBirth, rangeBirthTo) !== 1;
                    }).map(function (pax) {
                        var paxBonusCardNumber = pax.bonusCards && pax.bonusCards[0] && pax.bonusCards[0].number;
                        var availablePrivatePassenger = (0, _extends3.default)({}, pax, {
                            gender: pax.gender.toLowerCase(),
                            hasBonusCard: !!paxBonusCardNumber
                        });
                        if (paxBonusCardNumber) {
                            if (vm.ffpMemberTypes) {
                                var ffpMemberType = detectFfpMemberType(paxBonusCardNumber);
                                if (ffpMemberType) {
                                    availablePrivatePassenger.ffpMemberType = ffpMemberType.code;
                                    availablePrivatePassenger.bonusCardShort = generateBonusCardShort(paxBonusCardNumber, ffpMemberType);
                                }
                            } else {
                                availablePrivatePassenger.bonusCard = paxBonusCardNumber;
                            }
                        }
                        return availablePrivatePassenger;
                    });
                });
            });
        }
    }

    function setPrivatePassenger(num) {

        var privateNum = vm.passengers[num].privatePassenger,
            privatePassengerItem = vm.availablePrivatePassengers[num][privateNum] || {
            lastName: '',
            firstName: '',
            dateOfBirth: '',
            gender: '',
            nationality: '',
            phone: '',
            email: '',
            bonusCard: '',
            documents: [{
                documentType: '',
                documentNumber: '',
                documentDate: ''
            }]
        };
        var privatePassengerValidDocuments = void 0,
            privatePassengerSelectedDocument = void 0;

        var propsForCopy = ['lastName', 'firstName', 'dateOfBirth', 'gender', 'nationality', 'hasBonusCard'];

        if (vm.passengersCheck.allowEmail) {
            propsForCopy.push('email');
        }

        if (vm.passengersCheck.allowPhone) {
            propsForCopy.push('phone');
        }

        if (vm.passengers[num].type == 'ADULT' && vm.allowBonusCard || vm.passengers[num].type == 'CHILD' && vm.allowBonusCardsForChildren) {
            if (vm.ffpMemberTypes) {
                propsForCopy.push('bonusCardShort');
                propsForCopy.push('ffpMemberType');
            } else {
                propsForCopy.push('bonusCard');
            }
        }

        utils.copyPropList(vm.passengers[num], privatePassengerItem, propsForCopy);

        setDocumentTypesForPassenger(num);

        if (vm.availablePrivatePassengers[num][privateNum]) {
            privatePassengerValidDocuments = vm.availablePrivatePassengers[num][privateNum].documents.filter(function (privatePassengerDoc) {
                return _.findWhere(vm.documentTypesByPassenger[num], { code: privatePassengerDoc.documentType });
            });
            if (privatePassengerValidDocuments.length) {
                if (vm.passengers[num].documentType) {
                    privatePassengerSelectedDocument = _.findWhere(privatePassengerValidDocuments, { documentType: vm.passengers[num].documentType });
                }
                if (!privatePassengerSelectedDocument) {
                    privatePassengerSelectedDocument = privatePassengerValidDocuments[0];
                }
                utils.copyPropList(vm.passengers[num], privatePassengerSelectedDocument, ['documentType', 'documentNumber', 'documentDate']);
            }
        }

        documentTypeChangeHandler(num);

        if (vm.currentLanguage !== 'ru' || vm.passengersCheck.isLatinNamesOnly || vm.passengers[num].documentType === DOC_CODE.RussianForeignPassport || vm.passengers[num].documentType === DOC_CODE.NationalPassport) {
            if (privatePassengerItem.firstNameEn) {
                vm.passengers[num].firstName = privatePassengerItem.firstNameEn;
            }
            if (privatePassengerItem.lastNameEn) {
                vm.passengers[num].lastName = privatePassengerItem.lastNameEn;
            }
        }

        updateAvailableParentsByPassengers();
    }

    function updateAlreadySelectedParents() {
        var alreadySelectedParents = [];
        vm.passengers.forEach(function (pax) {
            if (pax.parentIndex !== undefined && !utils.hasInList(alreadySelectedParents, pax.parentIndex)) {
                alreadySelectedParents.push(pax.parentIndex);
            }
        });
        vm.alreadySelectedParents = alreadySelectedParents;
        vm.alreadySelectedParentsDoubles = alreadySelectedParents.filter(function (alreadySelectedParentIndex) {
            return vm.passengers.filter(function (pax) {
                return pax.parentIndex === alreadySelectedParentIndex;
            }).length > 1;
        });
    }

    function parentIndexChangeHandler() {
        updateAlreadySelectedParents();
        vm.passengers.forEach(function (pax, num) {
            if (pax.parentIndex !== undefined) {
                if (utils.hasInList(vm.alreadySelectedParentsDoubles, pax.parentIndex)) {
                    var form = vm.passengerForms[num];
                    form.parentIndex.$setValidity('customMessage', false);
                    form.parentIndex.$error.customMessage = backend.getAlias('web.messages.parentAlreadySelected');
                } else {
                    clearCustomError(num, 'parentIndex');
                    jQuery('form[name="vm.passengerForms[' + num + ']"] div[name="parentIndex"] input.ui-select-focusser').trigger('focus');
                    $rootScope.$broadcast('uis:closeAll', true);
                }
            }
        });
    }

    function documentTypeChangeHandler(num) {
        var privateNum = vm.passengers[num].privatePassenger,
            documentType = vm.passengers[num].documentType;
        var privateDoc = {
            documentNumber: '',
            documentDate: ''
        };
        if (privateNum) {
            vm.availablePrivatePassengers[num][privateNum].documents.forEach(function (paxDocument) {
                if (paxDocument.documentType === documentType) {
                    privateDoc = paxDocument;
                }
            });
            utils.copyPropList(vm.passengers[num], privateDoc, ['documentNumber', 'documentDate']);
            if (documentType === DOC_CODE.RussianForeignPassport) {
                if (vm.availablePrivatePassengers[num][privateNum].firstNameEn) {
                    vm.passengers[num].firstName = vm.availablePrivatePassengers[num][privateNum].firstNameEn;
                }
                if (vm.availablePrivatePassengers[num][privateNum].lastNameEn) {
                    vm.passengers[num].lastName = vm.availablePrivatePassengers[num][privateNum].lastNameEn;
                }
            }
        }
        setDocumentNumberRegexForPassenger(num);
        setRangeBirthForPassenger(num);
        setNamesRegexForPassenger(num);
        updateYnaoDiscountPossible(num);
        clearExpiry(num);
        clearCustomError(num, 'nationality');
        clearCustomError(num, 'documentType');
        clearCustomError(num, 'documentNumber');
        clearCustomError(num, 'dateOfBirth');
    }

    function nationalityChangeHandler(num) {
        setDocumentTypesForPassenger(num);
        setDocumentNumberRegexForPassenger(num);
        setNamesRegexForPassenger(num);
        updateYnaoDiscountPossible(num);
        setRangeBirthForPassenger(num);
        clearExpiry(num);
        clearCustomError(num, 'nationality');
        clearCustomError(num, 'documentType');
    }

    function documentNumberChangeHandler(index) {
        clearCustomError(index, 'documentNumber');
    }

    function additionalDocumentNumberChangeHandler(index) {
        clearCustomError(index, 'additionalDocumentNumber');
    }

    function documentDateChangeHandler(index) {
        clearCustomError(index, 'documentType');
        clearCustomError(index, 'nationality');
        clearCustomError(index, 'documentDate');
    }

    function genderChangeHandler(num) {

        var oldFrom = vm.rangeBirthByPassenger[num].from,
            oldTo = vm.rangeBirthByPassenger[num].to;
        var tmpDate = void 0;

        setRangeBirthForPassenger(num);

        // Если диапазон доступных дат поменялся - делаем обновление валидацию
        if (oldFrom !== vm.rangeBirthByPassenger[num].from || oldTo !== vm.rangeBirthByPassenger[num].to) {
            tmpDate = vm.passengers[num].dateOfBirth;
            delete vm.passengers[num].dateOfBirth;
            $timeout(function () {
                vm.passengers[num].dateOfBirth = tmpDate;
                $timeout(function () {
                    jQuery('form[name="vm.passengerForms[' + num + ']"] input[name="dateOfBirth"]').trigger('blur');
                });
            });
        }
    }

    function lastNameBlurHandler(num) {
        if (num === 0 && vm.passengers[num].lastName && !vm.customer.lastName) {
            vm.customer.lastName = vm.passengers[num].lastName;
        }
    }

    function firstNameBlurHandler(num) {
        if (num === 0 && vm.passengers[num].firstName && !vm.customer.firstName) {
            vm.customer.firstName = vm.passengers[num].firstName;
        }
    }

    function nameChangeHandler(num) {
        clearCustomError(num, 'promoCode');
        clearCustomError(num, 'bonusCard');
        updateAvailableParentsByPassengers();
        vm.passengers.forEach(function (pax, paxNum) {
            clearCustomError(paxNum, 'lastName');
            clearCustomError(paxNum, 'firstName');
        });
        var _vm$passengers$num = vm.passengers[num],
            firstName = _vm$passengers$num.firstName,
            lastName = _vm$passengers$num.lastName;

        if (firstName && lastName) {
            var form = vm.passengerForms[num];
            var isFullNameValid = utils.checkSirenaPassengerFullName(lastName, firstName);
            var isFullNameValidLength = utils.checkSirenaPassengerFullNameLength(lastName, firstName);
            if (!isFullNameValid) {
                // OS-2042
                form.lastName.$setValidity('customMessage', false);
                form.firstName.$setValidity('customMessage', false);
                form.lastName.$error.customMessage = backend.getAlias('web.messages.passengerFullNameErrorFormat');
                form.firstName.$error.customMessage = backend.getAlias('web.messages.passengerFullNameErrorFormat');
            } else if (!isFullNameValidLength) {
                form.lastName.$setValidity('customMessage', false);
                form.firstName.$setValidity('customMessage', false);
                form.lastName.$error.customMessage = backend.getAlias('web.messages.passengerFullNameOverflow');
                form.firstName.$error.customMessage = backend.getAlias('web.messages.passengerFullNameOverflow');
            } else {
                clearCustomError(num, 'lastName');
                clearCustomError(num, 'firstName');
            }
        }
    }

    function phoneBlurHandler(num) {
        if (num === 0 && vm.passengers[num].phone && !vm.customer.phone && backend.getParam('customer.copyContactsFromFirstPassenger')) {
            vm.customer.phone = vm.passengers[num].phone;
        }
    }

    function emailBlurHandler(num) {
        if (num === 0 && vm.passengers[num].email && !vm.customer.email && backend.getParam('customer.copyContactsFromFirstPassenger')) {
            vm.customer.email = vm.passengers[num].email;
        }
    }

    function setDocumentNumberRegexForPassenger(num) {
        var documentType = vm.passengers[num].documentType;
        if (documentType === DOC_CODE.RussianBirthCertificate && vm.passengers[num].nationality === 'RU') {
            vm.documentNumberRegexByPassenger[num] = backend.getParam('passengers.RU_SR_Regexp');
        } else if (documentsNumberRegex[documentType]) {
            vm.documentNumberRegexByPassenger[num] = documentsNumberRegex[documentType];
        } else {
            vm.documentNumberRegexByPassenger[num] = '^(.*)$';
        }
        $timeout(function () {
            jQuery('form[name="vm.passengerForms[' + num + ']"] input[name="documentNumber"]').trigger('blur');
        });
    }

    function setNamesRegexForPassenger(num) {
        var selectedDocumentType = vm.passengers[num].documentType;
        var selectedDocument = _.findWhere(vm.documentTypesByPassenger[num], { code: selectedDocumentType });
        if (selectedDocument && selectedDocument.lastNameRegexp && selectedDocument.firstNameRegexp) {
            vm.firstNameRegexpByPassenger[num] = selectedDocument.firstNameRegexp;
            vm.lastNameRegexpByPassenger[num] = selectedDocument.lastNameRegexp;
        } else {
            vm.firstNameRegexpByPassenger[num] = vm.passengersCheck.passengerFirstNameRegexp;
            vm.lastNameRegexpByPassenger[num] = vm.passengersCheck.passengerLastNameRegexp;
        }
        $timeout(function () {
            jQuery('form[name="vm.passengerForms[' + num + ']"] input[name="firstName"]').trigger('blur');
            jQuery('form[name="vm.passengerForms[' + num + ']"] input[name="lastName"]').trigger('blur');
        });
    }

    function setDocumentTypesForPassenger(num) {
        var passenger = vm.passengers[num];
        var docs = vm.passengersRulesByNum[num].documents;
        var domesticCountry = backend.getParam('site.domesticCountryForAirline');
        vm.documentTypesByPassenger[num] = docs.filter(function (doc) {
            return passenger.nationality === domesticCountry && doc.nationality === 'DOMESTIC_CITIZEN' || passenger.nationality === 'RU' && doc.nationality === 'RUSSIAN' || passenger.nationality !== 'RU' && passenger.nationality !== domesticCountry && doc.nationality === 'FOREIGN';
        });
        if (passenger.documentType && !_.findWhere(vm.documentTypesByPassenger[num], { code: passenger.documentType })) {
            passenger.documentType = getDefaultDocumentTypeCodeByNumAndNationality(num, passenger.nationality);
        }
    }

    function setRangeBirthForPassenger(num) {

        var passenger = vm.passengers[num];
        var rules = vm.passengersRulesByNum[num];
        var selectedDocumentType = passenger.documentType;
        var selectedDocument = _.findWhere(vm.documentTypesByPassenger[num], { code: selectedDocumentType });
        var paxRangeBirthIntervals = [];

        if (selectedDocument && selectedDocument.intervals && selectedDocument.intervals[0]) {
            paxRangeBirthIntervals.push(selectedDocument.intervals[0]);
        }

        if (passenger.gender === 'male' && rules.rangeBirthFromMale && rules.rangeBirthToMale) {
            paxRangeBirthIntervals.push(rules.rangeBirthFromMale + '-' + rules.rangeBirthToMale);
        }
        if (passenger.gender === 'female' && rules.rangeBirthFromFemale && rules.rangeBirthToFemale) {
            paxRangeBirthIntervals.push(rules.rangeBirthFromFemale + '-' + rules.rangeBirthToFemale);
        }
        if (rules.rangeBirthFrom && rules.rangeBirthTo) {
            paxRangeBirthIntervals.push(rules.rangeBirthFrom + '-' + rules.rangeBirthTo);
        }

        vm.isRangeBirthUpdate = true;
        $timeout(function () {
            vm.rangeBirthByPassenger[num] = utils.calcIntervalsIntersection(paxRangeBirthIntervals);
            vm.isRangeBirthUpdate = false;
        });
    }

    function initCustomerModel(orderInfo, authoriseCustomer) {
        var data = {};
        var restoredData = restoreCustomersData();
        if (orderInfo && orderInfo.customer) {
            data.firstName = orderInfo.customer.firstName;
            data.lastName = orderInfo.customer.lastName;
            data.email = orderInfo.email;
            data.phone = orderInfo.phone;
        } else if (authoriseCustomer) {
            data.firstName = authoriseCustomer.firstName;
            data.lastName = authoriseCustomer.lastName;
            data.email = authoriseCustomer.email;
            data.phone = authoriseCustomer.phone;
        } else if (restoredData) {
            data = restoredData;
        }

        if (authoriseCustomer) {
            data.sendEMail = authoriseCustomer.emailSendNotifications;
            data.sendSms = authoriseCustomer.phoneSendNotifications;
            data.sendAdvertisement = authoriseCustomer.sendAdvertisementNotifications;
        } else if (backend.getParam('customer.defaultIsMessageSend')) {
            data.sendEMail = true;
            data.sendSms = true;
            data.sendAdvertisement = true;
        }
        return data;
    }

    function initPassengersModel(passengersCheck, orderInfo) {
        var passengerForms = [],
            restoredData = void 0;
        if (orderInfo.passengers && orderInfo.passengers.length) {
            orderInfo.passengers.forEach(function (orderInfoPassenger, orderInfoPassengerNum) {
                var passengerItem = angular.extend({}, orderInfoPassenger);
                if (!vm.passengersCheck.allowPhone && passengerItem.phone) {
                    delete passengerItem.phone;
                }
                passengerItem.nationality = getCountryCodeByName(passengerItem.nationality) || backend.getDefaultNationalityCode();
                passengerItem.documentType = getDocumentTypeCodeByName(passengerItem.documentType, passengerItem.categoryId) || getDefaultDocumentTypeCodeByNumAndNationality(orderInfoPassengerNum, passengerItem.nationality);
                if (passengerItem.bonusCard) {
                    passengerItem.hasBonusCard = true;
                    if (vm.ffpMemberTypes) {
                        var ffpMemberType = detectFfpMemberType(passengerItem.bonusCard);
                        if (ffpMemberType) {
                            passengerItem.ffpMemberType = ffpMemberType.code;
                            passengerItem.bonusCardShort = generateBonusCardShort(passengerItem.bonusCard, ffpMemberType);
                        }
                    }
                }
                if (orderInfoPassenger.documentTypeDiscount) {
                    passengerItem.additionalDocumentType = getAdditionalDocumentTypeCodeByName(orderInfoPassenger.documentTypeDiscount, passengerItem.categoryId);
                }
                if (orderInfoPassenger.documentCodeDiscount) {
                    passengerItem.additionalDocumentType = orderInfoPassenger.documentCodeDiscount;
                }
                passengerItem.additionalDocumentNumber = orderInfoPassenger.documentNumberDiscount;
                if (passengerItem.additionalDocumentType === 'IDN') {
                    delete passengerItem.additionalDocumentType;
                    delete passengerItem.additionalDocumentNumber;
                }
                passengerForms.push(passengerItem);
            });
        } else {
            restoredData = restorePassengersData();
            passengersCheck.passengers.forEach(function (item) {
                var i = 0;
                var nationality = backend.getDefaultNationalityCode();
                while (i < item.count) {
                    passengerForms.push({
                        categoryId: item.categoryId,
                        type: item.passengerType,
                        rangeBirthFrom: item.rangeBirthFrom,
                        rangeBirthTo: item.rangeBirthTo,
                        nationality: nationality,
                        documentType: getDefaultDocumentTypeCodeByNumAndNationality(i, nationality),
                        promoCode: orderInfo.originalPromoCode || '',
                        ffpMemberType: vm.defaultSelectedFfpMemberType && vm.defaultSelectedFfpMemberType.code
                    });
                    i++;
                }
            });
            if (restoredData && checkSameCountAndCategoryId(restoredData, passengerForms)) {
                passengerForms = restoredData;
            }
        }
        return passengerForms;
    }

    function checkSameCountAndCategoryId(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length; i++) {
            if (a[i].categoryId !== b[i].categoryId) {
                return false;
            }
        }
        return true;
    }

    function initPassengersCategoryRules(passengersCheck, countriesList) {
        var passengersCategoryRules = {};
        passengersCheck.passengers.forEach(function (item) {
            var rules = angular.copy(item);
            delete rules.count;
            rules.availableCountriesList = countriesList.filter(function (country) {
                return !rules.allowedNationalities || utils.hasInList(rules.allowedNationalities, country.code);
            }).filter(function (country) {
                return !rules.blockedNationalities || !utils.hasInList(rules.blockedNationalities, country.code);
            });
            passengersCategoryRules[item.categoryId] = rules;
        });
        return passengersCategoryRules;
    }

    function submitHandler(ignoreCheckNames, ignoreFfpPromoCodesInfo) {

        vm.submitTouched = true;

        jQuery('form.passengerForm__js.ng-invalid, form.customerForm__js.ng-invalid').triggerHandler('submit');
        if (checkAllFormsValid() && (vm.personalDataShareAgree || !backend.getParam('passengers.usePersonalDataAgreeCheckbox')) && !vm.hasPassengersWithoutScannedDocs && !vm.hasNoSelectedSpecialNeedGroupSsr && (ignoreCheckNames || checkNames())) {
            vm.submitLoading = true;
            updateSpecialNeedGroupSsrs(vm.passengers);
            backend.passengersAdd(reformatPassengersAdd(vm.passengers)).then(function (passengersAddResp) {
                backend.customerAdd((0, _extends3.default)({}, vm.customer, {
                    passengersAddPageOpenTime: moment.utc(vm.passengersAddPageOpenTime).format('YYYY-MM-DDTHH:mm:ss')
                })).then(function () {
                    var ffpPromoCodesInfo = passengersAddResp.ffpPromoCodesInfo;

                    if (ffpPromoCodesInfo && !ignoreFfpPromoCodesInfo && ffpPromoCodesInfo.totalPriceWithDiscount && ffpPromoCodesInfo.totalPriceWithDiscount.price && ffpPromoCodesInfo.totalPriceWithoutDiscount && ffpPromoCodesInfo.totalPriceWithoutDiscount.price) {
                        if (ffpPromoCodesInfo.totalPriceWithoutDiscount.price !== ffpPromoCodesInfo.totalPriceWithDiscount.price) {
                            // Показываем попап только если цена со скидкой отличается от цены без скидки.
                            openPromoCodesDiscountPopup(ffpPromoCodesInfo);
                        } else {
                            // если вернулась инфа про скидку, по никакой скидки в ней нет, то переподать запрос добавления пассажиров с BONUS_MILE
                            confirmPromoCodesDiscount('BONUS_MILES');
                        }
                    } else if (passengersAddResp.ynaoDiscountPossible) {
                        openYnaoDiscountSelectPopup();
                    } else {
                        storePassengersData(vm.passengers);
                        storeCustomerData(vm.customer);
                        sendYandexAdd(vm.orderInfo, vm.passengers);
                        if (hasSeatSelectStep) {
                            if (backend.getParam('extraServices.enable')) {
                                redirect.goToSeatSelect();
                            } else {
                                redirect.goToConfirmBooking();
                            }
                        } else {
                            redirect.goToBooking();
                        }
                    }
                }, function (resp) {
                    vm.submitLoading = false;
                    vm.errorMessage = resp.error;
                });
            }, function (resp) {
                vm.submitLoading = false;
                if (resp.passengerChecks) {
                    $timeout(function () {
                        handlePassengerChecks(resp.passengerChecks);
                    });
                } else {
                    vm.errorMessage = resp.error;
                }
            });
        }
    }

    function handlePassengerChecks(passengerChecks) {
        passengerChecks.forEach(function (check, index) {
            var msg = backend.getAliasDynamic('web.passengerChecks.' + check.notValidReason);
            var form = vm.passengerForms[index];
            if (check.notValidReason === 'DOCUMENT_NUMBER_LATIN_ONLY') {
                form.documentNumber.$setValidity('customMessage', false);
                form.documentNumber.$error.customMessage = msg;
                triggerFieldErrorHighlight(index, 'documentNumber');
            } else if (check.notValidReason === 'YNAO_MIXED_CATEGORY_AGE' || check.notValidReason === 'DOCUMENT_AGE_DOES_NOT_FIT' || check.notValidReason === 'MIN_ADULT_AGE_VIOLATED' || check.notValidReason === 'SCANNED_DOCS_NOT_ALLOWED_DUE_TO_AGE') {
                form.dateOfBirth.$setValidity('customMessage', false);
                form.dateOfBirth.$error.customMessage = msg;
                triggerFieldErrorHighlight(index, 'dateOfBirth');
            } else if (check.notValidReason === 'DOCUMENT_NATIONALITY_DOES_NOT_FIT') {
                form.documentType.$setValidity('customMessage', false);
                form.nationality.$setValidity('customMessage', false);
                form.documentType.$error.customMessage = msg;
                form.nationality.$error.customMessage = msg;
                triggerFieldErrorHighlight(index, 'documentType', true);
                triggerFieldErrorHighlight(index, 'nationality', true);
            } else if (check.notValidReason === 'DISCOUNT_DOCUMENT_NUMBER_LATIN_ONLY') {
                form.additionalDocumentNumber.$setValidity('customMessage', false);
                form.additionalDocumentNumber.$error.customMessage = msg;
                triggerFieldErrorHighlight(index, 'additionalDocumentNumber');
            } else if (check.notValidReason === 'DOCUMENT_EXPIRED') {
                form.documentType.$setValidity('customMessage', false);
                form.nationality.$setValidity('customMessage', false);
                form.documentDate.$setValidity('customMessage', false);
                form.documentDate.$error.customMessage = msg;
                triggerFieldErrorHighlight(index, 'documentType', true);
                triggerFieldErrorHighlight(index, 'nationality', true);
                triggerFieldErrorHighlight(index, 'documentDate');
            } else if (check.notValidReason === 'PROMO_CODE_NOT_FOUND' || check.notValidReason === 'SEVERSTAL_LOYALTY_NOT_FOUND') {
                if (form.promoCode) {
                    form.promoCode.$setValidity('customMessage', false);
                    form.promoCode.$error.customMessage = msg;
                    triggerFieldErrorHighlight(index, 'promoCode');
                }
            } else if (check.notValidReason === 'NAME_DUPLICATE' || check.notValidReason === 'FORBIDDEN_CYRILLIC_FOR_INTERNATIONAL_FLIGHT') {
                form.lastName.$setValidity('customMessage', false);
                form.firstName.$setValidity('customMessage', false);
                form.lastName.$error.customMessage = msg;
                form.firstName.$error.customMessage = msg;
                triggerFieldErrorHighlight(index, 'lastName');
                triggerFieldErrorHighlight(index, 'firstName');
            } else if (check.notValidReason === 'FFP_CARD_INCORRECT') {
                if (vm.ffpMemberTypes) {
                    form.bonusCardShort.$setValidity('customMessage', false);
                    form.bonusCardShort.$error.customMessage = msg;
                    triggerFieldErrorHighlight(index, 'bonusCardShort');
                } else {
                    form.bonusCard.$setValidity('customMessage', false);
                    form.bonusCard.$error.customMessage = msg;
                    triggerFieldErrorHighlight(index, 'bonusCard');
                }
            }
        });
    }

    function triggerFieldErrorHighlight(index, fieldName, isSelect) {
        if (isSelect) {
            jQuery('form[name="vm.passengerForms[' + index + ']"] div[name="' + fieldName + '"] input.ui-select-focusser').trigger('blur').trigger('focus');
        } else {
            jQuery('form[name="vm.passengerForms[' + index + ']"] input[name="' + fieldName + '"]').trigger('blur').trigger('focus');
        }
    }

    function openPromoCodesDiscountPopup(promoCodesDiscountInfo) {
        vm.submitLoading = false;
        vm.promoCodesDiscountInfo = promoCodesDiscountInfo;
    }

    function closePromoCodesDiscountPopup() {
        vm.promoCodesDiscountInfo = false;
    }

    function confirmPromoCodesDiscount(mode) {
        vm.passengers.forEach(function (pax) {
            pax.ffpPromoCodeMode = mode;
        });
        closePromoCodesDiscountPopup();
        submitHandler(true, true);
    }

    function openYnaoDiscountSelectPopup() {
        vm.submitLoading = false;
        vm.showYnaoDiscountSelectPopup = true;
    }

    function closeYnaoDiscountSelectPopup() {
        vm.showYnaoDiscountSelectPopup = false;
    }

    function promoCodeChangeHandler(index) {
        clearCustomError(index, 'promoCode');
    }

    function bonusCardChangeHandler(index) {
        clearCustomError(index, 'bonusCard');
    }

    function bonusCardSwitchHandler(index) {
        vm.passengers[index].bonusCard = '';
        clearCustomError(index, 'bonusCard');
    }

    function checkAllFormsValid() {
        var i = 0;
        while (vm.passengerForms[i]) {
            if (vm.passengerForms[i].$invalid) {
                return false;
            }
            i++;
        }
        if (vm.customerForm.$invalid) {
            return false;
        }
        return true;
    }

    function checkNames() {
        var reRu = new RegExp("[а-яА-Я\\s\\']+");
        var firstNameMinLength = backend.getParam('passengers.checkSuspiciousFirstNameMinLength');
        var lastNameMinLength = backend.getParam('passengers.checkSuspiciousLastNameMinLength');

        vm.passengersWithSuspiciousNames = [];
        vm.emptyPatronymicPassengers = [];

        vm.passengers.forEach(function (passenger) {
            if (backend.getParam('passengers.emptyPatronymicAlert') && passenger.nationality === 'RU' && reRu.test(passenger.firstName) && passenger.firstName.split(' ').length < 2) {
                vm.emptyPatronymicPassengers.push(passenger);
            }
            if (firstNameMinLength && passenger.firstName.length < firstNameMinLength || lastNameMinLength && passenger.lastName.length < lastNameMinLength) {
                vm.passengersWithSuspiciousNames.push(passenger);
            }
        });

        if (vm.emptyPatronymicPassengers.length || vm.passengersWithSuspiciousNames.length) {
            vm.showConfirmPassengerNames = true;
            return false;
        }
        return true;
    }

    function getDescPassCountStr() {
        var result = '';
        for (var i = 0; i < vm.passengersCheck.passengers.length; i++) {
            if (vm.passengersCheck.passengers[i].count) {
                if (result !== '') {
                    result += ', ';
                }
                result += '' + utils.suffixCount(vm.passengersCheck.passengers[i].count, backend.getAliasWithPrefix('web.passengerCategories.', vm.passengersCheck.passengers[i].categoryId));
            }
        }
        return result;
    }

    function checkLogin() {

        vm.allowCreateAccount = false;
        vm.accountExist = false;

        backend.checkLogin(vm.customer.email).then(function () {
            vm.allowCreateAccount = backend.getParam('site.allowUserSimplifiedRegistration');
        }, function (resp) {
            if (resp.error === 'web.privateoffice.checkLogin') {
                vm.accountExist = true;
            }
        });
    }

    function getCountryCodeByName(name) {
        var i = 0;
        while (i < vm.countriesList.length) {
            if (vm.countriesList[i][vm.localNamePropName] === name) {
                return vm.countriesList[i].code;
            }
            i++;
        }
    }

    function getDocumentTypeCodeByName(name, categoryId) {
        var code = void 0;
        if (!vm.passengersCategoryRules[categoryId]) return;
        vm.passengersCategoryRules[categoryId].documents.forEach(function (doc) {
            if (doc.name === name) {
                code = doc.code;
            }
        });
        return code;
    }

    function getAdditionalDocumentTypeCodeByName(name, categoryId) {
        var code = void 0;
        if (!vm.passengersCategoryRules[categoryId]) return;
        if (vm.passengersCategoryRules[categoryId].additionalDocuments && vm.passengersCategoryRules[categoryId].additionalDocuments.length) {
            vm.passengersCategoryRules[categoryId].additionalDocuments.forEach(function (doc) {
                if (doc.name === name) {
                    code = doc.code;
                }
            });
        }
        return code;
    }

    function getDocumentTypeNameByCode(code, categoryId) {
        var name = void 0;
        vm.passengersCategoryRules[categoryId].documents.forEach(function (doc) {
            if (doc.code === code) {
                name = doc.name;
            }
        });
        return name;
    }

    function getExpiryByDocType(type, categoryId) {
        var expiry = void 0;
        vm.passengersCategoryRules[categoryId].documents.forEach(function (doc) {
            if (doc.code === type) {
                expiry = doc.expiry;
            }
        });
        return expiry;
    }

    function getOrderCountriesCssClasses() {
        if (vm.orderInfo && vm.orderInfo.orderCountries) {
            return vm.orderInfo.orderCountries.map(function (code) {
                return 'orderHasCountry_' + code;
            }).join(' ');
        } else {
            return '';
        }
    }

    function isMobile() {
        return $window.innerWidth <= 768;
    }

    function swithcSubmitButtonHoverState() {
        vm.submitButtonHover = !vm.submitButtonHover;
    }

    function dateOfBirthChangeHandler(num) {
        updateYnaoDiscountPossible(num);
        updateAvailableParentsByPassengers();
        if (vm.passengers[num].categoryId === 'adults') {
            resetInvalidParentsByPassengers();
        }
        clearCustomError(num, 'promoCode');
        clearCustomError(num, 'bonusCard');
        vm.passengers.forEach(function (pax, paxNum) {
            clearCustomError(paxNum, 'dateOfBirth');
        });
    }

    function updateYnaoDiscountPossible(num) {
        vm.passengers[num].ynaoDiscountPossible = vm.passengersCheck.ynaoDiscountPossible && vm.passengers[num].nationality === 'RU' && (vm.passengers[num].documentType === DOC_CODE.RussianInternalPassport || vm.passengers[num].documentType === DOC_CODE.RussianBirthCertificate) && isPassengerYnaoChildAgeInSomeFlight(num);
    }

    function isPassengerYnaoChildAgeInSomeFlight(num) {
        var dateOfBirth = moment(vm.passengers[num].dateOfBirth, 'DD.MM.YYYY');
        for (var i = 0; i < vm.orderInfo.plainFlights.length; i++) {
            var flightMoment = moment(vm.orderInfo.plainFlights[i].date, 'DD.MM.YYYY');
            var maxAge = flightMoment.year() >= 2020 ? 23 : 18;
            var yearsDiff = flightMoment.diff(dateOfBirth, 'years', false);
            if (yearsDiff < maxAge && yearsDiff >= 2) {
                return true;
            }
        }
        return false;
    }

    function switchSpecialNeed(num) {
        var passenger = vm.passengers[num];
        passenger.hasSpecialNeed = !passenger.hasSpecialNeed;
    }

    function specialNeedGroupChangeHandler(num, groupCode, ssrs) {
        var passenger = vm.passengers[num];
        if (ssrs && ssrs.length > 1) {
            updateHasNoSelectedSpecialNeedGroupSsr();
        }
        if (!passenger.specialNeedGroup[groupCode] && passenger.specialNeedSsrs && passenger.specialNeedSsrs[passenger.specialNeedGroupSsrs[groupCode]]) {
            delete passenger.specialNeedSsrs[passenger.specialNeedGroupSsrs[groupCode]];
        }
    }

    function specialNeedGroupSsrRadioSelectHandler() {
        updateHasNoSelectedSpecialNeedGroupSsr();
    }

    function updateHasNoSelectedSpecialNeedGroupSsr() {
        var hasNoSelectedSpecialNeedGroupSsr = false;
        vm.passengers.forEach(function (passenger) {
            _.keys(passenger.specialNeedGroup).map(function (key) {
                var checkboxOn = false;
                if (passenger.specialNeedGroup[key]) {
                    checkboxOn = true;
                }
                if (checkboxOn) {
                    if (!passenger.specialNeedGroupSsrs || !passenger.specialNeedGroupSsrs[key]) {
                        hasNoSelectedSpecialNeedGroupSsr = true;
                    }
                }
            });
        });
        vm.hasNoSelectedSpecialNeedGroupSsr = hasNoSelectedSpecialNeedGroupSsr;
    }

    function updateSpecialNeedGroupSsrs(passengers) {
        passengers.forEach(function (pax) {
            _.keys(pax.specialNeedGroup).forEach(function (code) {
                if (pax.specialNeedGroup[code]) {
                    if (!pax.specialNeedSsrs) {
                        pax.specialNeedSsrs = {};
                    }
                    pax.specialNeedSsrs[pax.specialNeedGroupSsrs[code]] = true;
                }
            });
        });
    }

    function initSpecialNeedGroupSsrs(passengers) {
        passengers.forEach(function (pax) {
            if (pax.personalWheelchairSsrCode && pax.specialNeedSsrs[pax.personalWheelchairSsrCode]) {
                delete pax.specialNeedSsrs[pax.personalWheelchairSsrCode];
            }
            _.keys(pax.specialNeedSsrs).forEach(function (ssr) {
                var groupCode = getGroupBySsr(ssr);
                if (groupCode) {
                    if (!pax.specialNeedGroup) {
                        pax.specialNeedGroup = {};
                    }
                    if (!pax.specialNeedGroupSsrs) {
                        pax.specialNeedGroupSsrs = {};
                    }
                    pax.specialNeedGroup[groupCode] = true;
                    pax.specialNeedGroupSsrs[groupCode] = ssr;
                }
            });
        });
    }

    function getGroupBySsr(ssrCode) {
        var result = false;
        vm.groupedSpecialNeedSsrs.forEach(function (groupItem) {
            if (groupItem.ssrs.length > 1) {
                groupItem.ssrs.forEach(function (ssr) {
                    if (ssr === ssrCode) {
                        result = groupItem.group;
                    }
                });
            }
        });
        return result;
    }

    function createAccountSwitchHandler() {
        if (vm.customer.createAccount) {
            watchman.notifyUserInterfaceEvent({
                name: 'registration-passengers'
            });
        }
    }

    function clearCustomError(index, fieldCode) {
        if (fieldCode && vm.passengerForms[index][fieldCode] && vm.passengerForms[index][fieldCode].$error.customMessage) {
            vm.passengerForms[index][fieldCode].$setValidity('customMessage', true);
            $timeout(function () {
                var formField = jQuery('form[name="vm.passengerForms[' + index + ']"] input[name="' + fieldCode + '"]');
                if (vm.passengerForms[index][fieldCode].focused) {
                    formField.trigger('blur').trigger('focus');
                } else {
                    formField.trigger('blur');
                }
            });
        }
    }

    function clearExpiry(num) {
        var hasExpiry = !!getExpiryByDocType(vm.passengers[num].documentType, vm.passengers[num].categoryId);
        if (!hasExpiry) {
            delete vm.passengers[num].documentDate;
        }
    }

    function sendYandexDetail(orderInfo, passengers) {

        var products = ymTracker.getFlightProducts(orderInfo, passengers);

        var ecommerce = {
            currencyCode: orderInfo.prices.currency,
            detail: { products: products }
        };

        watchman.notifyUserInterfaceEvent({
            name: 'go-to-passengers',
            data: { ecommerce: ecommerce }
        });
    }

    function sendYandexAdd(orderInfo, passengers) {

        var products = ymTracker.getFlightProducts(orderInfo, passengers);

        var ecommerce = {
            currencyCode: vm.orderInfo.currency,
            add: { products: products }
        };

        watchman.notifyUserInterfaceEvent({
            name: 'go-from-passengers',
            data: { ecommerce: ecommerce }
        });
    }

    function reformatPassengersAdd(passengersList) {
        var result = angular.copy(passengersList);
        result.forEach(function (pax, paxNum) {
            if (!vm.personalWheelchairSelected[paxNum]) {
                delete pax.personalWheelchairSsrCode;
                delete pax.personalWheelchairSsrText;
            }
            // OS-2525
            if (pax.categoryId !== 'infantsWithoutSeat') {
                if (pax.parentIndex !== undefined) {
                    delete pax.parentIndex;
                }
                if (pax.parentId !== undefined) {
                    delete pax.parentId;
                }
            }
        });
        return result;
    }

    function initFfpMemberTypes() {
        var ffpMemberTypesConfig = backend.getFfpMemberTypesConfig();
        if (ffpMemberTypesConfig && ffpMemberTypesConfig.length) {
            vm.ffpMemberTypes = ffpMemberTypesConfig.map(function (ffpMemberType) {
                return (0, _extends3.default)({}, ffpMemberType, {
                    name: backend.getAliasWithPrefix('web.ffpMemberType.', ffpMemberType.code)
                });
            });
            vm.ffpMemberTypes.forEach(function (ffpMemberType) {
                if (ffpMemberType.defaultSelected) {
                    vm.defaultSelectedFfpMemberType = ffpMemberType;
                }
            });
        }
    }

    function ffpMemberTypeChangeHandler(num) {
        updateBonusCardFull(num);
        updateBonusShortRegex();
    }

    function bonusCardShortChangeHandler(num) {
        updateBonusCardFull(num);
    }

    function updateBonusShortRegex() {
        if (vm.ffpMemberTypes) {
            vm.bonusCardShortRegex = vm.passengers.map(function (pax) {
                return getFfpMemberTypeCardNoRegex(pax.ffpMemberType);
            });
        }
    }

    function updateBonusCardFull(num) {
        var bonusCardFull = '';
        var bonusCardShort = vm.passengers[num].bonusCardShort;

        var form = vm.passengerForms[num];

        if (bonusCardShort && form.bonusCardShort.$valid) {
            var zeros = '';
            var ffpMemberTypePrefix = getFfpMemberTypePrefix(vm.passengers[num].ffpMemberType);
            var ffpMemberTypeFullLength = getFfpMemberTypeFullLength(vm.passengers[num].ffpMemberType);
            var zerosCount = ffpMemberTypeFullLength - ffpMemberTypePrefix.length - bonusCardShort.length;
            for (var i = 0; i < zerosCount; i++) {
                zeros += '0';
            }
            bonusCardFull = ffpMemberTypePrefix + zeros + bonusCardShort;
        }
        vm.passengers[num].bonusCard = bonusCardFull;
    }

    function getFfpMemberTypePrefix(ffpMemberTypeCode) {
        for (var i = 0; i < vm.ffpMemberTypes.length; i++) {
            if (vm.ffpMemberTypes[i].code === ffpMemberTypeCode) {
                return vm.ffpMemberTypes[i].prefix;
            }
        }
    }

    function getFfpMemberTypeCardNoRegex(ffpMemberTypeCode) {
        for (var i = 0; i < vm.ffpMemberTypes.length; i++) {
            if (vm.ffpMemberTypes[i].code === ffpMemberTypeCode) {
                return vm.ffpMemberTypes[i].cardNoRegex;
            }
        }
    }

    function generateBonusCardShort(bonusCardFull, ffpMemberType) {
        if (bonusCardFull) {
            var re = new RegExp(ffpMemberType.cardNoRegex);
            var bonusCardTmp = new String(bonusCardFull);
            while (!re.test(bonusCardTmp) && bonusCardTmp) {
                bonusCardTmp = cropFirstLetter(bonusCardTmp);
            }
            return bonusCardTmp;
        }
    }

    function cropFirstLetter(str) {
        return str.substring(1, str.length);
    }

    function detectFfpMemberType(bonusCardFull) {
        if (bonusCardFull && bonusCardFull.length) {
            for (var i = 0; i < vm.ffpMemberTypes.length; i++) {
                if (bonusCardFull.indexOf(vm.ffpMemberTypes[i].prefix) === 0) {
                    return vm.ffpMemberTypes[i];
                }
            }
        }
    }

    function getFfpMemberTypeFullLength(ffpMemberTypeCode) {
        for (var i = 0; i < vm.ffpMemberTypes.length; i++) {
            if (vm.ffpMemberTypes[i].code === ffpMemberTypeCode) {
                return vm.ffpMemberTypes[i].fullLength;
            }
        }
    }
}]);

},{"babel-runtime/helpers/extends":9}],603:[function(require,module,exports){
"use strict";

angular.module('app').controller('PaymentVariantsScreenController', ['backend', 'utils', 'redirect', 'modalTools', '$q', function (backend, utils, redirect, modalTools, $q) {

    var vm = this;
    vm.loading = true;
    vm.paymentVariantChangeHandler = paymentVariantChangeHandler;
    vm.swithcSubmitButtonHoverState = swithcSubmitButtonHoverState;
    vm.submitPayment = submitPayment;

    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/payment-variants';
    } else {
        vm.imagesPath = './themes/websky/assets/static/img/content/payment-variants';
    }

    backend.ready.then(function () {
        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'paymentVariants'));
        $q.all([backend.updateOrderInfo(), backend.paymentVariants()]).then(function (resp) {
            vm.loading = false;
            vm.orderInfo = resp[0];
            vm.insuranceAgreeText = backend.generateInsuranceAgreeText(vm.orderInfo.editableExtraServicesHeap);
            vm.paymentVariants = resp[1];
        });
    });

    function paymentVariantChangeHandler(newVariantIndex) {
        vm.showNeedSelectPaymentFormMesage = false;
        vm.selectedPaymentVariantIndex = newVariantIndex;
        backend.changePaymentForm(vm.paymentVariants[newVariantIndex].paymentForm);
    }

    function submitPayment() {
        if (vm.agree) {
            if (vm.paymentVariants[vm.selectedPaymentVariantIndex]) {
                if (vm.paymentVariants[vm.selectedPaymentVariantIndex].conflicts_with_aeroexpress || vm.paymentVariants[vm.selectedPaymentVariantIndex].conflicts_with_insurance) {
                    modalTools.openHandler('popup-cancel-conflict-services', false, {
                        paymentForm: vm.paymentVariants[vm.selectedPaymentVariantIndex].paymentForm,
                        aeroexpress: vm.paymentVariants[vm.selectedPaymentVariantIndex].conflicts_with_aeroexpress,
                        insurance: vm.paymentVariants[vm.selectedPaymentVariantIndex].conflicts_with_insurance,
                        submitCallback: submitPaymentHandler
                    });
                } else {
                    submitPaymentHandler();
                }
            } else {
                vm.showNeedSelectPaymentFormMesage = true;
            }
        }
    }

    function submitPaymentHandler(removeInsuranceAeroexpress) {

        var selectedPaymentVariant = vm.paymentVariants[vm.selectedPaymentVariantIndex];

        vm.doBookingAndRegisterOrderLoading = true;

        if (vm.bookingError) {
            delete vm.bookingError;
        }

        backend.doBookingAndRegisterOrder(selectedPaymentVariant.paymentForm, selectedPaymentVariant.paymentType, removeInsuranceAeroexpress, {
            save_new_card: vm.saveNewCard,
            card_token: selectedPaymentVariant.savedCard && selectedPaymentVariant.savedCard.token
        }).then(function (resp) {
            if (resp.extraServicesPayment && resp.extraServicesPayment.servicesToRemove.length) {
                modalTools.openHandler('popup-removed-services-warning', false, {
                    submitCallback: function submitCallback() {
                        submitPaymentHandler(removeInsuranceAeroexpress, resp.extraServicesToRemoveIds);
                    },
                    closeCallback: function closeCallback() {
                        backend.updateOrderServices(true);
                    },

                    extraServicesPayment: resp.extraServicesPayment,
                    disableOutsideCloseClick: true
                });
            } else if (resp.pnr && resp.lastName) {
                redirect.goToConfirmOrder();
            } else if (resp.eraseAeroexpressBecauseOfCurrency || resp.eraseInsuranceBecauseOfCurrency) {
                modalTools.openHandler('popup-change-currency-error', false, {
                    eraseAeroexpressBecauseOfCurrency: resp.eraseAeroexpressBecauseOfCurrency,
                    eraseInsuranceBecauseOfCurrency: resp.eraseInsuranceBecauseOfCurrency,
                    mode: 'booking',
                    submitCallback: submitPaymentHandler
                });
            }

            vm.doBookingAndRegisterOrderLoading = false;
        }, function (resp) {
            vm.doBookingAndRegisterOrderLoading = false;
            if (resp.error === 'web.bookingNoSeatsLeft') {
                vm.bookingErrorGotoSearch = resp.error;
            } else {
                vm.bookingError = resp.error;
            }
        });
    }

    function swithcSubmitButtonHoverState() {
        vm.submitButtonHover = !vm.submitButtonHover;
    }
}]);

},{}],604:[function(require,module,exports){
"use strict";

angular.module('app').controller('PrivacyPolicyScreenController', ['backend', 'redirect', 'watchman', function (backend, redirect, watchman) {

    var vm = this;
    vm.loading = true;
    vm.goToLastBookingStep = redirect.goToLastBookingStep;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privacyPolicy'));

        vm.telemetryProviders = watchman.getActiveProvidersListDetailed();

        vm.loading = false;
    });
}]);

},{}],605:[function(require,module,exports){
"use strict";

angular.module('app').controller('PrivateBankDetailsScreenController', ['$timeout', 'backend', 'redirect', 'watchman', function ($timeout, backend, redirect, watchman) {

    var vm = this;
    vm.loading = true;
    vm.saveHandler = saveHandler;
    vm.addBankDetails = addBankDetails;

    watchman.notifyUserInterfaceEvent({ name: 'account-bank-details' });

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privateOffice'));
        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
        if (!vm.authoriseCustomer) {
            redirect.goToStart();
            return;
        }

        backend.getUserBankDetailsList().then(function (bankDetailsList) {
            vm.loading = false;
            vm.bankDetailsList = bankDetailsList;
            vm.bankDetailsForm = [];
        }, function (resp) {
            vm.loading = false;
            vm.commonError = resp.error;
        });
    });

    function saveHandler() {
        vm.submitTouched = true;
        delete vm.saveError;
        jQuery('form.bankDetailsForm__js.ng-invalid').triggerHandler('submit');
        if (checkAllFormsValid()) {
            backend.saveUserBankDetailsList(vm.bankDetailsList).then(function () {
                vm.saveSuccess = true;
                $timeout(function () {
                    delete vm.saveSuccess;
                }, 20000);
            }, function (resp) {
                vm.saveError = typeof resp.error === 'string' ? resp.error : true;
                $timeout(function () {
                    delete vm.saveError;
                }, 20000);
            });
        }
    }

    function checkAllFormsValid() {
        var i = 0;
        while (vm.bankDetailsForm[i]) {
            if (vm.bankDetailsForm[i].$invalid) {
                return false;
            }
            i++;
        }
        return true;
    }

    function addBankDetails() {
        vm.bankDetailsList.push({});
    }
}]);

},{}],606:[function(require,module,exports){
"use strict";

angular.module('app').controller('PrivateOrderScreenController', ['$routeParams', 'backend', 'redirect', 'watchman', function ($routeParams, backend, redirect, watchman) {

    var vm = this;
    vm.loading = true;

    watchman.notifyUserInterfaceEvent({
        name: 'account-order-view',
        data: {
            label: $routeParams.pnrOrTicketNumber
        }
    });

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privateOffice'));
        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
        if (!vm.authoriseCustomer) {
            redirect.goToStart();
            return;
        }
        if (!$routeParams.pnrOrTicketNumber || !$routeParams.lastName) {
            redirect.goToPrivateOrders();
            return;
        }

        backend.searchOrder($routeParams.pnrOrTicketNumber, $routeParams.lastName).then(function (orderInfo) {
            vm.orderInfo = orderInfo;
            vm.loading = false;
        }, function (resp) {
            vm.loading = false;
            vm.errorMessage = resp.error;
        });
    });
}]);

},{}],607:[function(require,module,exports){
"use strict";

angular.module('app').controller('PrivateOrdersScreenController', ['$window', 'backend', 'watchman', 'redirect', function ($window, backend, watchman, redirect) {

    var vm = this;
    vm.loading = true;
    vm.getCityNameByCode = getCityNameByCode;
    vm.getPortNameByCode = getPortNameByCode;
    vm.openOrder = redirect.goToPrivateOrder;
    vm.viewMonthCount = getViewMonthCount();
    vm.loadOrders = loadOrders;

    watchman.notifyUserInterfaceEvent({ name: 'account-orders' });

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privateOffice'));
        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
        if (!vm.authoriseCustomer) {
            redirect.goToStart();
            return;
        }

        vm.fromDate = moment(backend.sessionParams.todayDate, 'DD.MM.YYYY').add(-3, 'months').format('DD.MM.YYYY');
        vm.toDate = backend.sessionParams.todayDate;

        loadOrders();
    });

    function loadOrders() {

        vm.loading = true;

        backend.getOrders({
            from: vm.fromDate,
            to: vm.toDate
        }).then(function (ordersList) {
            vm.ordersList = ordersList;
            vm.loading = false;
        }, function (resp) {
            vm.loading = false;
            vm.commonError = resp.error;
        });
    }

    function getCityNameByCode(code) {
        var city = backend.getCityByCode(code);
        if (city) {
            return city[backend.sessionParams.localNamePropName];
        } else {
            return code;
        }
    }

    function getPortNameByCode(code) {
        var port = backend.getPortByCode(code);
        if (port) {
            return port[backend.sessionParams.localNamePropName];
        } else {
            return code;
        }
    }

    function getViewMonthCount() {
        return $window.innerWidth > 768 ? 2 : 1;
    }
}]);

},{}],608:[function(require,module,exports){
"use strict";

angular.module('app').controller('PrivatePassengersScreenController', ['$timeout', 'backend', 'redirect', 'watchman', function ($timeout, backend, redirect, watchman) {

    var vm = this;
    var bonusProgramCode = void 0;

    vm.deletePassenger = deletePassenger;
    vm.deletePassengerConfirm = deletePassengerConfirm;
    vm.deleteTmpPassengerConfirm = deleteTmpPassengerConfirm;
    vm.addPassenger = addPassenger;
    vm.saveHandler = saveHandler;
    vm.searchSubstrChangeHandler = searchSubstrChangeHandler;

    vm.loading = true;
    vm.showConfirmRemovePax = -1;
    vm.showConfirmRemoveTmpPax = -1;

    watchman.notifyUserInterfaceEvent({ name: 'account-passengers' });

    backend.ready.then(function () {
        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privateOffice'));

        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
        if (!vm.authoriseCustomer) {
            redirect.goToStart();
            return;
        }

        backend.getDocumentsList().then(function (documentsList) {
            vm.documentsList = documentsList;
            if (backend.getParam('ffp.enable')) {
                backend.getBonusPrograms().then(function (resp) {
                    bonusProgramCode = resp.bonusPrograms && resp.bonusPrograms[0] && resp.bonusPrograms[0].bonusProgramCode;
                    updatePrivatePassengers();
                }, function (resp) {
                    vm.commonError = resp.error;
                    vm.loading = false;
                });
            } else {
                updatePrivatePassengers();
            }
        }, function (resp) {
            vm.commonError = resp.error;
            vm.loading = false;
        });
    });

    function updatePrivatePassengers() {
        vm.loading = true;
        backend.getPrivatePassengers().then(function (resp) {
            vm.nameRegexps = {
                passengerFirstNameLatRegexp: resp.passengerFirstNameLatRegexp,
                passengerFirstNameRegexp: resp.passengerFirstNameRegexp,
                passengerLastNameLatRegexp: resp.passengerLastNameLatRegexp,
                passengerLastNameRegexp: resp.passengerLastNameRegexp
            };
            vm.privatePassengers = initProfilePassengers(resp.passengers);
            vm.filteredPrivatePassengers = angular.copy(vm.privatePassengers);
            vm.loading = false;
        }, function (resp) {
            vm.commonError = resp.error;
            vm.loading = false;
        });
    }

    function initProfilePassengers(inPaxList) {
        return inPaxList.map(function (pax) {
            var paxState = angular.copy(pax);
            if (paxState.bonusCards && paxState.bonusCards[0] && paxState.bonusCards[0].number) {
                paxState.bonusCard = paxState.bonusCards[0].number;
            }
            return { data: paxState, openedState: false };
        });
    }

    function saveHandler(passenger) {
        vm.loading = true;
        var paxStateForSave = angular.copy(passenger.data);
        if (paxStateForSave.bonusCard) {
            paxStateForSave.bonusCards = [{
                number: paxStateForSave.bonusCard,
                bonusProgramCode: bonusProgramCode
            }];
            delete paxStateForSave.bonusCard;
        }
        backend[paxStateForSave.id ? 'modifyPrivatePassenger' : 'addPrivatePassenger'](paxStateForSave).then(function () {
            vm.saveSuccess = true;
            $timeout(function () {
                delete vm.saveSuccess;
            }, 20000);
            vm.loading = false;
        }, function (resp) {
            vm.saveError = typeof resp.error === 'string' ? resp.error : true;
            $timeout(function () {
                delete vm.saveError;
            }, 20000);
            vm.loading = false;
        });
    }

    function deleteTmpPassengerConfirm() {
        var isOther = function isOther(pax) {
            return pax.data.tmpId !== vm.showConfirmRemoveTmpPax;
        };
        vm.privatePassengers = vm.privatePassengers.filter(isOther);
        vm.filteredPrivatePassengers = vm.filteredPrivatePassengers.filter(isOther);
        vm.showConfirmRemoveTmpPax = -1;
    }

    function deletePassengerConfirm() {
        var isOther = function isOther(pax) {
            return pax.data.id !== vm.showConfirmRemovePax;
        };
        vm.privatePassengers = vm.privatePassengers.filter(isOther);
        vm.filteredPrivatePassengers = vm.filteredPrivatePassengers.filter(isOther);
        backend.removePrivatePassenger(vm.showConfirmRemovePax);
        vm.showConfirmRemovePax = -1;
    }

    function deletePassenger(pax) {
        if (pax.data.id) {
            vm.showConfirmRemovePax = pax.data.id;
        } else if (pax.data.tmpId) {
            vm.showConfirmRemoveTmpPax = pax.data.tmpId;
        }
    }

    function addPassenger() {
        var newPax = {
            data: {
                documents: [],
                tmpId: generateTmpId(vm.privatePassengers)
            },
            openedState: true
        };
        vm.privatePassengers.unshift(newPax);
        vm.filteredPrivatePassengers.unshift(newPax);
    }

    function generateTmpId(paxList) {
        var lastTmpId = 0;
        for (var i = 0; i < paxList.length; i++) {
            if (paxList[i].data.tmpId && paxList[i].data.tmpId > lastTmpId) {
                lastTmpId = paxList[i].data.tmpId;
            }
        }
        return lastTmpId + 1;
    }

    function searchSubstrChangeHandler() {
        vm.filteredPrivatePassengers = vm.privatePassengers.filter(function (pax) {
            if (!vm.searchSubstr || !pax.data.firstName || !pax.data.lastName) {
                return true;
            } else {
                var searchSubstrUpper = vm.searchSubstr.toUpperCase();
                var lastName = pax.data.lastName.toUpperCase();
                var firstName = pax.data.firstName.toUpperCase();
                return lastName.indexOf(searchSubstrUpper) !== -1 || firstName.indexOf(searchSubstrUpper) !== -1;
            }
        });
    }
}]);

},{}],609:[function(require,module,exports){
"use strict";

angular.module('app').controller('PrivatePasswordScreenController', ['$timeout', 'backend', 'redirect', 'watchman', function ($timeout, backend, redirect, watchman) {

    var vm = this;
    vm.loading = true;
    vm.passwordSaveHandler = passwordSaveHandler;

    watchman.notifyUserInterfaceEvent({ name: 'account-password' });

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privateOffice'));
        vm.loading = false;
        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
        if (!vm.authoriseCustomer) {
            redirect.goToStart();
            return;
        }
    });

    function passwordSaveHandler() {
        vm.submitTouched = true;
        delete vm.saveError;
        if (vm.passwordForm.$valid) {
            backend.changePassword({
                oldPassword: vm.oldPassword,
                newPassword: vm.newPassword
            }).then(function () {
                vm.saveSuccess = true;
                $timeout(function () {
                    delete vm.saveSuccess;
                }, 20000);
            }, function (resp) {
                vm.saveError = typeof resp.error === 'string' ? resp.error : true;
                $timeout(function () {
                    delete vm.saveError;
                }, 20000);
            });
        }
    }
}]);

},{}],610:[function(require,module,exports){
"use strict";

var _require = require('underscore.get'),
    get = _require.get;

angular.module('app').controller('PrivatePaymentsScreenController', ['$scope', 'backend', 'watchman', function ($scope, backend, watchman) {
    var vm = this;

    vm.cards = get(backend, 'sessionParams.authoriseCustomer.cards') || [];
    vm.loading = false;
    vm.errorMessage = false;
    vm.indexForDeleteConfirm = -1;

    watchman.notifyUserInterfaceEvent({ name: 'account-payments' });

    $scope.$on('removePaymentCardLoading', function (event, loading) {
        vm.loading = loading;
    });

    $scope.$on('removePaymentCardError', function (event, err) {
        vm.errorMessage = err;
        vm.loading = false;
    });

    $scope.$on('removePaymentCardSuccess', function () {
        vm.cards.splice(vm.indexForDeleteConfirm, 1);
        vm.errorMessage = false;
        vm.loading = false;
        vm.indexForDeleteConfirm = -1;
    });
}]);

},{"underscore.get":426}],611:[function(require,module,exports){
"use strict";

angular.module('app').controller('PrivateProfileScreenController', ['$timeout', 'backend', 'redirect', 'watchman', function ($timeout, backend, redirect, watchman) {

    var vm = this;
    vm.loading = true;
    vm.profileSaveHandler = profileSaveHandler;
    vm.profileDeleteHandler = profileDeleteHandler;

    watchman.notifyUserInterfaceEvent({ name: 'account-profile' });

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privateOffice'));
        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
        if (!vm.authoriseCustomer) {
            redirect.goToStart();
            return;
        }

        vm.profile = {
            login: vm.authoriseCustomer.login,
            firstName: vm.authoriseCustomer.firstName,
            lastName: vm.authoriseCustomer.lastName,
            phone: vm.authoriseCustomer.phone,
            phoneSendNotifications: vm.authoriseCustomer.phoneSendNotifications,
            emailSendNotifications: vm.authoriseCustomer.emailSendNotifications
        };

        vm.loading = false;
    });

    function profileSaveHandler() {
        vm.submitTouched = true;
        delete vm.saveError;
        if (vm.profileForm.$valid) {
            vm.loading = true;
            backend.saveProfile(vm.profile).then(function () {
                vm.saveSuccess = true;
                vm.loading = false;
                $timeout(function () {
                    delete vm.saveSuccess;
                }, 20000);
            }, function (resp) {
                vm.saveError = typeof resp.error === 'string' ? resp.error : true;
                vm.loading = false;
                $timeout(function () {
                    delete vm.saveError;
                }, 20000);
            });
        }
    }

    function profileDeleteHandler() {

        vm.loading = true;
        backend.deleteProfile(vm.profile).then(function () {
            vm.deleteProfileRequestSent = true;
            vm.loading = false;
        }, function (resp) {
            vm.saveError = typeof resp.error === 'string' ? resp.error : true;
            vm.loading = false;
        });
    }
}]);

},{}],612:[function(require,module,exports){
"use strict";

angular.module('app').controller('RefundScreenController', ['$routeParams', 'backend', 'utils', 'redirect', function ($routeParams, backend, utils, redirect) {

    var vm = this;
    vm.loading = true;

    vm.openOrder = redirect.goToSearchOrder;
    vm.confirmSelectedPassengers = confirmSelectedPassengers;
    vm.passengerRowClick = passengerRowClick;
    vm.submitManualRefund = submitManualRefund;
    vm.submitConfirmRefund = submitConfirmRefund;
    vm.swithcSubmitButtonHoverState = swithcSubmitButtonHoverState;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'refund'));

        vm.authoriseCustomer = backend.sessionParams.authoriseCustomer;
        if (vm.authoriseCustomer) {
            vm.manualRefundData = {
                eMail: vm.authoriseCustomer.login,
                phone: vm.authoriseCustomer.phone
            };
        }

        backend.clearOrderInfoListeners();

        backend.updateOrderInfo().then(function (orderInfo) {
            vm.orderInfo = orderInfo;
            backend.flownStatus().then(function (flownStatus) {
                vm.step = 'SELECT_PASSENGERS';
                vm.flownStatus = flownStatus;
                vm.loading = false;
            }, function (resp) {
                vm.step = 'REFUND_ERROR';
                vm.errorMessage = resp.error;
                vm.loading = false;
            });
        }, function (resp) {
            vm.step = 'REFUND_ERROR';
            vm.errorMessage = resp.error;
            vm.loading = false;
        });
    });

    function confirmSelectedPassengers() {
        var refundConfig = backend.getRefundConfig();
        if (vm.hasSelectedPassengers) {
            if (refundConfig.mode === 'MANUAL') {
                vm.step = 'REQUEST_FORM';
            } else {
                vm.loading = true;
                backend.calcRefund(getSelectedPassengers()).then(function (calcRefund) {
                    if (calcRefund.result && calcRefund.result === 'fall2manualRefund') {
                        vm.step = 'REQUEST_FORM';
                    } else {
                        vm.calcRefund = reformatCalcRefund(calcRefund);
                        vm.step = 'CONFIRM_REFUND';
                    }
                    vm.loading = false;
                }, function (resp) {
                    vm.step = 'REFUND_ERROR';
                    vm.errorMessage = resp.error;
                    vm.loading = false;
                });
            }
        }
    }

    function reformatCalcRefund(data) {
        var passengerSegments = data.passengerSegments;

        if (passengerSegments) {
            passengerSegments.forEach(function (passengerSegment) {
                var orderPax = _.findWhere(vm.orderInfo.passengers, { id: passengerSegment.passengerId });
                if (orderPax) {
                    passengerSegment.firstName = orderPax.firstName;
                    passengerSegment.lastName = orderPax.lastName;
                }
            });
            passengerSegments.sort(function (a, b) {
                return a.id - b.id;
            });
        }
        return data;
    }

    function passengerRowClick(passenger) {
        if (passenger.available) {
            passenger.selected = !passenger.selected;
            vm.hasSelectedPassengers = getSelectedPassengers().length > 0;
        }
    }

    function submitManualRefund() {
        vm.manualRefundSubmitTouched = true;

        jQuery('form[name="vm.manualRefundForm"].ng-invalid').triggerHandler('submit');

        if (vm.manualRefundForm.$valid && vm.agree) {
            vm.loading = true;
            backend.manualRefund({
                eMail: vm.manualRefundData.eMail,
                phone: vm.manualRefundData.phone,
                passengers: getSelectedPassengers()
            }).then(showRequestSuccessMessage, showErrorMessage).finally(function () {
                vm.loading = false;
            });
        }
    }

    function submitConfirmRefund() {
        if (vm.agree) {
            vm.confirmRefundLoading = true;
            backend.confirmRefund(vm.calcRefund.orgTotalSummRefund, getSelectedPassengers()).then(function (resp) {
                if (resp.result === 'fall2manualRefund') {
                    vm.step = 'REQUEST_FORM';
                } else {
                    showRefundSuccessMessage();
                }
            }, showErrorMessage).finally(function () {
                vm.confirmRefundLoading = false;
            });
        }
    }

    function getSelectedPassengers() {
        return vm.flownStatus.passengers.filter(function (pax) {
            return pax.selected;
        }).map(function (pax) {
            return { passengerId: pax.id };
        });
    }

    function showRequestSuccessMessage() {
        vm.step = 'REQUEST_SUCCESS';
    }

    function showRefundSuccessMessage() {
        vm.step = 'REFUND_SUCCESS';
    }

    function showErrorMessage(resp) {
        vm.errorMessage = resp.error;
        vm.step = 'REFUND_ERROR';
    }

    function swithcSubmitButtonHoverState() {
        vm.submitButtonHover = !vm.submitButtonHover;
    }
}]);

},{}],613:[function(require,module,exports){
"use strict";

angular.module('app').controller('RemoveProfileConfirmScreenController', ['backend', 'redirect', function (backend, redirect) {

    var vm = this;
    vm.loading = true;
    vm.confirmHandler = confirmHandler;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'removeProfileConfirm'));
        if (!o2context.pagePurifiedParameters.removeProfileToken || !o2context.pagePurifiedParameters.userRole) {
            redirect.goToStart();
            return;
        }
        vm.loading = false;
    });

    function confirmHandler() {
        backend.confirmRemoveProfile(o2context.pagePurifiedParameters.removeProfileToken, o2context.pagePurifiedParameters.userRole).then(function () {
            vm.confirmSuccess = true;
        }, function (resp) {
            vm.confirmError = typeof resp.error === 'string' ? resp.error : true;
        });
    }
}]);

},{}],614:[function(require,module,exports){
"use strict";

angular.module('app').controller('ResetForgetPasswordScreenController', ['backend', 'redirect', 'watchman', function (backend, redirect, watchman) {

    var vm = this;
    vm.loading = true;
    vm.passwordSaveHandler = passwordSaveHandler;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'privateOffice'));
        if (!o2context.tempAuthIdentity || !o2context.tempAuthUserRole) {
            redirect.goToStart();
            return;
        }
        watchman.notifyUserInterfaceEvent({ name: 'password-change' });
        vm.loading = false;
    });

    function passwordSaveHandler() {
        vm.submitTouched = true;
        if (vm.passwordForm.$valid) {

            backend.tempChangePassword({
                newPassword: vm.newPassword,
                userRole: o2context.tempAuthUserRole,
                tempAuthIdentity: o2context.tempAuthIdentity
            }).then(function () {
                vm.saveSuccess = true;
            }, function (resp) {
                vm.saveError = typeof resp.error === 'string' ? resp.error : true;
            });
        }
    }
}]);

},{}],615:[function(require,module,exports){
"use strict";

angular.module('app').controller('ScheduleScreenController', ['backend', 'utils', function (backend, utils) {

    var vm = this;

    vm.searchSubmitHandler = searchSubmitHandler;
    vm.redirectToSearchScreen = redirectToSearchScreen;
    vm.searchResultError = false;
    vm.formOpened = true;
    vm.showSearchSwitch = false;
    vm.loading = true;

    backend.ready.then(function () {
        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'schedule'));
        vm.bookingLimits = backend.getSoftBookingLimits();
        vm.loading = false;
    });

    function searchSubmitHandler(searchParams) {
        var params = {
            departure: searchParams.departure.portCode || searchParams.departure.cityCode,
            arrival: searchParams.arrival.portCode || searchParams.arrival.cityCode
        };
        if (searchParams.fromDate) {
            params.fromDate = searchParams.fromDate;
        }
        if (searchParams.toDate) {
            params.toDate = searchParams.toDate;
        }
        delete vm.searchResultError;
        vm.loadingSchedule = true;
        vm.searchParams = searchParams;
        backend.getSchedulePeriod(params).then(function (resp) {
            vm.loadingSchedule = false;
            vm.formOpened = !resp.scheduleFlights.length;
            vm.showSearchSwitch = !!resp.scheduleFlights.length;
            vm.scheduleFlights = reformatScheduleFlights(resp.scheduleFlights);
        }, function (error) {
            vm.formOpened = true;
            vm.showSearchSwitch = false;
            vm.loadingSchedule = false;
            vm.searchResultError = error;
        });
    }

    function reformatScheduleFlights(scheduleFlights) {
        scheduleFlights.forEach(function (scheduleRow) {
            scheduleRow.flightsInfo = utils.getFlightsInfo(scheduleRow);
        });
        return scheduleFlights;
    }

    function redirectToSearchScreen() {
        if (vm.selectedDate) {
            vm.loadingRedirect = true;
            /* eslint-disable */
            // Требуется полная перезагрузка страницы
            var redirectPath = './search?date[0]=' + vm.selectedDate + '&origin-city-code[0]=' + vm.searchParams.departure.cityCode + '&destination-city-code[0]=' + vm.searchParams.arrival.cityCode + '&';
            if (vm.searchParams.departure.portCode) {
                redirectPath += 'origin-port-code[0]=' + vm.searchParams.departure.portCode + '&';
            }
            if (vm.searchParams.arrival.portCode) {
                redirectPath += 'destination-port-code[0]=' + vm.searchParams.arrival.portCode + '&';
            }
            redirectPath += 'segmentsCount=1';
            window.location = redirectPath;
            /* eslint-enable */
        }
    }
}]);

},{}],616:[function(require,module,exports){
"use strict";

angular.module('app').controller('SearchOrderScreenController', ['$routeParams', 'backend', '$timeout', '$window', function ($routeParams, backend, $timeout, $window) {

    var vm = this;
    vm.loading = true;
    vm.showSearchForm = true;
    vm.searchParams = {};
    vm.partiallyAddedPassengers = [];
    vm.submitSearch = submitSearch;
    vm.confirmHandler = confirmHandler;
    vm.clear = clear;
    vm.addPassenger = addPassenger;
    vm.swithcSubmitButtonHoverState = swithcSubmitButtonHoverState;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'searchOrder'));

        vm.passengerLastNameRegexp = backend.applicationConstants.passengerLastNameRegexp;
        vm.pnrOrTicketRegexp = backend.applicationConstants.pnrOrTicketRegexp;
        vm.ticketRegexp = backend.applicationConstants.ticketRegexp;

        if ($routeParams.pnrOrTicketNumber && $routeParams.lastName && backend.getParam('site.searchOrdersBy') === 'LAST_NAME_PNR_TICKET') {
            vm.searchParams.pnrOrTicketNumber = $routeParams.pnrOrTicketNumber;
            vm.searchParams.lastName = $routeParams.lastName;
            vm.loading = false;
            $timeout(submitSearch);
        } else if (o2context.quickSearch) {
            backend.quickSearchHandler(o2context.quickSearch).then(updateOrderInfoHandler, errorHandler);
        } else {
            updateOrderInfoHandler();
        }
    });

    function clear() {
        backend.clearOrderFromSession();
        backend.clearOrderInfo();
        vm.orderInfo = false;
        vm.showSearchForm = true;
        vm.partiallyAddedPassengers = [];
    }

    function submitSearch() {
        vm.submitTouched = true;
        if ((!backend.getParam('site.useSearchOrderAgreeCheckbox') || vm.searchOrderAgree) && vm.searchOrderForm.$valid) {
            vm.searchLoading = true;
            vm.errorMessage = false;
            backend.searchOrderByParams(vm.searchParams, !!vm.partiallyAddedPassengers.length).then(function (resp) {
                if (resp.sirenaEngineUrl) {
                    vm.redirectPassengers = [{
                        pnr: resp.pnr,
                        ticketNumber: resp.ticketNumber,
                        lastName: resp.lastName
                    }];
                    vm.submitRedirect(resp.sirenaEngineUrl);
                } else {

                    if (vm.searchParams.flight && vm.searchParams.date) {
                        vm.searchParams = {
                            flight: vm.searchParams.flight,
                            date: vm.searchParams.date
                        };
                    } else if (!resp.needToSpecifyDocument) {
                        vm.searchParams = {};
                    }
                    vm.needToSpecifyDocument = resp.needToSpecifyDocument;
                    vm.showSearchForm = false;
                    vm.submitTouched = false;
                    if (resp.orderCompletelyInitialized) {
                        vm.partiallyAddedPassengers = [];
                        updateOrderInfoHandler();
                    } else {
                        if (resp.partiallyAddedPassengers) {
                            vm.partiallyAddedPassengers = resp.partiallyAddedPassengers;
                        }
                        if (vm.needToSpecifyDocument) {
                            vm.showSearchForm = true;
                        }
                    }
                    vm.searchLoading = false;
                }
            }, errorHandler);
        }
    }

    function updateOrderInfoHandler() {
        backend.updateOrderInfo().then(function (orderInfo) {
            if (orderInfo.passengers) {
                vm.orderInfo = orderInfo;
                vm.showSearchForm = false;
            }
            vm.loading = false;
        }, errorHandler);
    }

    function errorHandler(resp) {
        vm.loading = false;
        vm.searchLoading = false;
        if (resp.error === 'web.messages.emptyOrder') {
            gotoLeoEngine();
        } else {
            vm.errorMessage = resp.error;
        }
    }

    function confirmHandler() {
        backend.finishSeparatePassengersSearch().then(updateOrderInfoHandler, errorHandler);
    }

    function addPassenger() {
        vm.showSearchForm = true;
    }

    function swithcSubmitButtonHoverState() {
        vm.submitButtonHover = !vm.submitButtonHover;
    }

    function gotoLeoEngine() {
        var bookingLeoEngineUrl = backend.getEnvironmentUrl('bookingLeoEngine');
        if (bookingLeoEngineUrl) {
            $window.location = bookingLeoEngineUrl;
        }
    }
}]);

},{}],617:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').controller('SearchScreenController', ['$scope', '$rootScope', '$timeout', '$document', '$window', 'backend', 'utils', 'redirect', 'oxyScroll', function ($scope, $rootScope, $timeout, $document, $window, backend, utils, redirect, oxyScroll) {

    var vm = this;
    var lastSearchResult = void 0,
        lastSearchParams = void 0,
        lastSearchResultPeriod = void 0;

    vm.searchSubmitHandler = searchSubmitHandler;
    vm.searchChangeHandler = searchChangeHandler;
    vm.restoreLastSearch = restoreLastSearch;
    vm.monoBrandCartesianVariantSelectHandler = monoBrandCartesianVariantSelectHandler;
    vm.pricingRouteAndMonoBrandVariantSelectHandler = pricingRouteAndMonoBrandVariantSelectHandler;
    vm.fareGroupVariantSelectHandler = fareGroupVariantSelectHandler;
    vm.variantSelectHandler = variantSelectHandler;
    vm.ffpVariantSelectHandler = ffpVariantSelectHandler;
    vm.logoutFFP = logoutFFP;
    vm.isSinglePassenger = isSinglePassenger;
    vm.gotoPassengersHandler = gotoPassengersHandler;
    vm.loading = true;
    vm.loadingVariants = false;
    vm.loadingPeriodVariants = false;
    vm.loadingPricingVariant = false;
    vm.searchResult = false;
    vm.searchResultError = false;
    vm.nearestDates = false;
    vm.searchResultPeriod = false;
    vm.formOpened = true;
    vm.showSearchSwitch = false;

    if (o2context.authoriseFFPUser) {
        vm.ffpUser = o2context.authoriseFFPUser;
    }

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'search'));

        $scope.$watch('vm.formOpened', function (state) {
            angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', state ? 'search' : 'select'));
        });

        vm.bookingLimits = backend.getSoftBookingLimits();

        backend.clearOrderInfoListeners();
        backend.clearOrderInfo();

        if (expressCheckExternalSearchParams(o2context.externalSearchParams)) {
            vm.loading = false;
            vm.loadingPricevariant = true;
            backend.searchPricevariant(reformatPricevariantParams(o2context.externalSearchParams)).then(checkExpressGotoPassengers, function (resp) {
                vm.searchResultError = resp.error;
                vm.loadingPricevariant = false;
            });
            return;
        }

        backend.lastSearchParams().then(function (resp) {
            if (resp.result !== 'empty') {
                vm.lastSearchParams = resp;
            }
            screenReadyHandler();
        }, screenReadyHandler);
    });

    function reformatPricevariantParams(esp) {
        var result = {};
        _.keys(esp).forEach(function (code) {
            if (code.indexOf('Amount') !== -1) {
                var newCode = code.replace('Amount', 'Count');
                result[newCode] = esp[code];
            } else if (code === 'searchGroupId') {
                if (o2context.pagePurifiedParameters.searchGroupId) {
                    result[code] = o2context.pagePurifiedParameters.searchGroupId;
                }
            } else if (code !== 'passengersCountCheckedByConfig') {
                result[code] = esp[code];
            }
        });
        return result;
    }

    function screenReadyHandler() {
        vm.loading = false;
    }

    function searchChangeHandler() {
        if (vm.searchResult) {
            vm.showRestoreSearchMessage = true;
            lastSearchParams = angular.copy(vm.searchParams);
            lastSearchResult = angular.copy(vm.searchResult);
            lastSearchResultPeriod = angular.copy(vm.searchResultPeriod);
        }
        vm.searchResult = false;
        vm.selectedVariants = [];
        vm.selectedVariantsInfo = false;
        vm.alertMessagesByRoute = false;
        vm.formOpened = true;
        vm.showSearchSwitch = false;
    }

    function restoreLastSearch() {
        vm.updateSearchParams(lastSearchParams);
        $timeout(function () {
            vm.showRestoreSearchMessage = false;
            vm.formOpened = false;
            vm.showSearchSwitch = true;
            vm.searchParams = lastSearchParams;
            vm.searchResultPeriod = lastSearchResultPeriod;
            vm.searchResult = lastSearchResult;
        });
    }

    function searchSubmitHandler(searchParams) {

        vm.loadingVariants = true;
        vm.searchParams = searchParams;
        vm.searchResult = false;
        vm.searchResultError = false;
        vm.ffpLoginError = false;
        vm.nearestDates = false;
        vm.selectedVariants = [];
        vm.selectedVariantsInfo = false;
        vm.alertMessagesByRoute = false;
        vm.pricingVariant = false;
        vm.showRestoreSearchMessage = false;
        vm.searchResultPeriod = initPeriodResult(searchParams);

        if (vm.loadingPricingVariant) {
            backend.pricingVariantCancel();
            vm.loadingPricingVariant = false;
        }

        delete vm.pricingVariantError;

        $scope.$watch('vm.searchResult.segmentSort[0]', function (type) {
            updateSort(0, type);
        });
        $scope.$watch('vm.searchResult.segmentSort[1]', function (type) {
            updateSort(1, type);
        });
        $scope.$watch('vm.searchResult.priceRowsSort', function (sortParams) {
            var sortParamsArr = void 0;
            if (sortParams) {
                sortParamsArr = sortParams.split('_');
                updateSortPriceRows(sortParamsArr[0], sortParamsArr[1] || 0);
            }
        });

        if (vm.ffpUser) {
            backend.ffpBalance(o2context.authoriseFFPUser.cardNumber).then(function (ffpUser) {
                vm.ffpUser = ffpUser;
                performMileSearch(searchParams);
            }, function () {
                performMoneySearch(searchParams);
            });
        } else {
            if (searchParams.ffpCardNumber && searchParams.ffpCardPassword) {
                backend.ffpLogin(searchParams).then(function (ffpUser) {
                    vm.ffpUser = ffpUser;
                    o2context.authoriseFFPUser = ffpUser;
                    performMileSearch(searchParams);
                }, function () {
                    vm.ffpLoginError = true;
                    vm.loadingVariants = false;
                });
                vm.searchParams.ffpCardNumber = '';
                vm.searchParams.ffpCardPassword = '';
            } else {
                performMoneySearch(searchParams);
            }
        }
    }

    function moneySearchErrorCallback(error, searchParams) {
        vm.loadingVariants = false;
        vm.formOpened = true;
        vm.showSearchSwitch = false;
        vm.searchResultError = error;
        if (error === 'web.search.nullPricing') {
            backend.searchNearestDates(searchParams).then(function (nearestDates) {
                vm.nearestDates = nearestDates;
            });
        }
    }

    function checkExpressGotoPassengers(resp) {
        if (resp.gotoPassengers) {
            redirect.goToPassengers();
            return true;
        } else {
            return false;
        }
    }

    function cartesianReadyHandler() {
        if (!vm.loadingVariants && !vm.loadingPeriodVariants) {
            if (vm.searchResultError) {

                if (vm.searchResultPeriodError || vm.searchResultError === 'web.incorrectPromoCodeSearch') {
                    vm.formOpened = true;
                    vm.showSearchSwitch = false;
                    if (vm.searchResultError === 'web.search.nullPricing') {
                        backend.searchNearestDates(vm.searchParams).then(function (nearestDates) {
                            vm.nearestDates = nearestDates;
                        });
                    }
                } else {
                    vm.formOpened = false;
                    vm.showSearchSwitch = true;
                    vm.searchResultError = false;
                    vm.searchResultErrorButHasPeriodVariants = true;
                }
            } else {
                vm.formOpened = false;
                vm.showSearchSwitch = true;
            }
        }
    }

    function performMoneySearch(searchParams) {

        vm.pricingMode = false;

        if (backend.getParam('search.searchVariantsMode') === 'PRICING_ROUTE_MONO_BRAND_CARTESIAN' || backend.getParam('search.searchVariantsMode') === 'GEORGIAN_AVL_FARE') {
            vm.searchResultErrorButHasPeriodVariants = false;
            backend.searchVariantsMonoBrandCartesian(searchParams).then(function (data) {
                if (data.pricingMode === 'agency') {
                    vm.pricingMode = 'agency';
                    vm.searchResult = reformatSearchResult(data);
                } else {
                    vm.searchResult = reformatSearchVariantsMonoBrandCartesianResult(data);
                }
                $rootScope.selectVariantStepActive = true;
                vm.loadingVariants = false;
                cartesianReadyHandler();
            }, function (resp) {
                vm.searchResultError = resp.error;
                $rootScope.selectVariantStepActive = true;
                vm.loadingVariants = false;
                cartesianReadyHandler();
            });
            vm.loadingPeriodVariants = true;
            backend.searchCartesianPeriod(searchParams).then(function (searchResultPeriod) {
                vm.searchResultPeriod = extendPeiodResult(vm.searchResultPeriod, searchResultPeriod);
                vm.loadingPeriodVariants = false;
                cartesianReadyHandler();
            }, function (resp) {
                if (resp && resp.error) {
                    vm.searchResultPeriodError = resp.error;
                }
                vm.loadingPeriodVariants = false;
                cartesianReadyHandler();
            });
        } else if (backend.getParam('search.searchVariantsMode') === 'PRICING_ROUTE_AND_MONO_BRAND') {
            backend.searchVariantsPricingRouteAndMonoBrand(searchParams).then(function (resp) {
                vm.formOpened = false;
                vm.showSearchSwitch = true;
                vm.searchResult = reformatSearchVariantsPricingRouteAndMonoBrandResult(resp, searchParams);
                $rootScope.selectVariantStepActive = true;
                vm.loadingVariants = false;
            }, function (resp) {
                moneySearchErrorCallback(resp.error, searchParams);
                $rootScope.selectVariantStepActive = true;
            });
        } else if (backend.getParam('search.searchVariantsMode') === 'PRICING_ROUTE_SIMPLE') {
            backend.companySearchVariants(searchParams).then(function (data) {
                vm.loadingVariants = false;
                vm.formOpened = false;
                vm.showSearchSwitch = true;
                vm.searchResult = reformatSearchResult(data);
                $rootScope.selectVariantStepActive = true;
            }, function (resp) {
                moneySearchErrorCallback(resp.error, searchParams);
                $rootScope.selectVariantStepActive = true;
            });
            if (searchParams.segments.length === 1) {
                vm.loadingPeriodVariants = true;
                backend.searchVariantsPeriod(searchParams).then(function (searchResultPeriod) {
                    vm.searchResultPeriod = extendOneWayPeiodResult(vm.searchResultPeriod, searchResultPeriod);
                    vm.loadingPeriodVariants = false;
                }, function () {
                    vm.loadingPeriodVariants = false;
                });
            }
        }
    }

    function performMileSearch(searchParams) {
        backend.searchVariantsFFP(searchParams).then(function (data) {
            vm.loadingVariants = false;
            vm.formOpened = false;
            vm.showSearchSwitch = true;
            vm.searchResult = reformatSearchVariantsFFPResult(data);
            $rootScope.selectVariantStepActive = true;
        }, function (resp) {
            vm.loadingVariants = false;
            $rootScope.selectVariantStepActive = true;
            vm.searchResultError = resp.error;
        });
    }

    function initPeriodResult(searchParams) {
        return {
            segmentsCalendar: searchParams.segments.map(function (segment) {
                var i = void 0;
                var calendar = [];
                for (i = -3; i <= 3; i++) {
                    calendar.push({
                        date: moment(segment.date, 'DD.MM.YYYY').add(i, 'days').format('DD.MM.YYYY')
                    });
                }
                return calendar;
            })
        };
    }

    function extendPeiodResult(initialData, loadedData) {
        return {
            segmentsCalendar: initialData.segmentsCalendar.map(function (segmentCalendar, segNum) {
                return segmentCalendar.map(function (item) {
                    return _.findWhere(loadedData.segmentsCalendar[segNum], { date: item.date }) || item;
                });
            })
        };
    }

    function extendOneWayPeiodResult(initialData, loadedData) {
        return {
            segmentsCalendar: initialData.segmentsCalendar.map(function (segmentCalendar, segNum) {
                if (segNum === 0) {
                    return segmentCalendar.map(function (item) {
                        var loadedItem = _.findWhere(loadedData.prices, { to_date: item.date });
                        if (loadedItem && loadedItem.price) {
                            item.summ = loadedItem.price;
                            item.currency = loadedData.currency;
                        }
                        return item;
                    });
                } else {
                    return segmentCalendar;
                }
            })
        };
    }

    function reformatSearchVariantsPricingRouteAndMonoBrandResult(data, searchParams) {

        var fullBrandList = backend.getBrandConfig();
        var existBrandMask = fullBrandList.map(function (brandItem) {
            return (!brandItem.hideIfEmpty || hasBrandInPrices([data.firstChainPrices], brandItem.code)) && (!brandItem.hideIfOneWay || searchParams.segments.length !== 1) && (!brandItem.hideIfRoundTrip || searchParams.segments.length !== 2);
        });

        data.brandsList = fullBrandList.filter(function (brandItem, brandItemNum) {
            return existBrandMask[brandItemNum];
        }).map(function (brandItem) {
            return (0, _extends3.default)({}, brandItem, {
                compatible: brandItem.compatible.filter(function (brandItem, brandItemNum) {
                    return existBrandMask[brandItemNum];
                })
            });
        });

        data.segmentRows = searchParams.segments.map(function (segmentParams, segmentNum) {
            return data.flights.filter(function (chain) {
                return chain.chainIndex === segmentNum;
            }).map(function (chain) {
                var prices = false,
                    minPrice = false,
                    minPriceCurrency = false;

                prices = data.brandsList.map(function (brandItem) {
                    return _.findWhere(data.firstChainPrices[chain.chainId], { brand: brandItem.code }) || false;
                });
                if (prices) {
                    minPrice = getMinPrice(prices, 'artificialPriceForChain');
                    minPriceCurrency = getMinPriceCurrency(prices);
                }

                return {
                    prices: prices,
                    minPrice: minPrice,
                    minPriceCurrency: minPriceCurrency,
                    chainId: chain.chainId,
                    flights: chain.flights,
                    flightsInfo: utils.getFlightsInfo(chain, backend.getAlias('web.connectionsMessage.transfer'), backend.getAlias('web.connectionsMessage.noTransfer'))
                };
            });
        });

        data.segmentSort = searchParams.segments.map(function () {
            return backend.getParam('search.defaultVariantsSortProperty');
        });

        return data;
    }

    function reformatSearchVariantsMonoBrandCartesianResult(data) {

        var fullBrandList = backend.getBrandConfig();
        var existBrandMask = fullBrandList.map(function (brandItem) {
            return (!brandItem.hideIfEmpty || hasBrandInPrices(data.prices, brandItem.code)) && (!brandItem.hideIfOneWay || data.prices.length !== 1) && (!brandItem.hideIfRoundTrip || data.prices.length !== 2);
        });

        data.brandsList = fullBrandList.filter(function (brandItem, brandItemNum) {
            return existBrandMask[brandItemNum];
        }).map(function (brandItem) {
            return (0, _extends3.default)({}, brandItem, {
                compatible: brandItem.compatible.filter(function (brandItem, brandItemNum) {
                    return existBrandMask[brandItemNum];
                })
            });
        });

        data.segmentRows = data.prices.map(function (segmentPrices) {
            var segmentRowItems = _.keys(segmentPrices).map(function (chainId) {
                var chain = _.findWhere(data.flights, { chainId: chainId }),
                    prices = data.brandsList.map(function (brand) {
                    return _.findWhere(segmentPrices[chainId], { brand: brand.code }) || false;
                }),
                    minPrice = getMinPrice(prices),
                    minPriceCurrency = getMinPriceCurrency(prices);

                segmentPrices[chainId].forEach(function (price) {
                    backend.checkBrandExist(price.brand);
                });

                return {
                    prices: prices,
                    minPrice: minPrice,
                    minPriceCurrency: minPriceCurrency,
                    chainId: chainId,
                    flights: chain.flights,
                    flightsInfo: utils.getFlightsInfo(chain, backend.getAlias('web.connectionsMessage.transfer'), backend.getAlias('web.connectionsMessage.noTransfer'))
                };
            });
            segmentRowItems.filter(function (rowItem) {
                return !!rowItem.minPrice;
            });
            return segmentRowItems;
        });

        data.brandsMinPricesLists = data.segmentRows.map(function (segmentRowItems) {
            return data.brandsList.map(function (brand, priceNum) {
                var brandPrices = [];
                var currency = void 0;
                segmentRowItems.forEach(function (rowItem) {
                    if (rowItem.prices[priceNum]) {
                        brandPrices.push(rowItem.prices[priceNum]);
                        if (!currency) {
                            currency = rowItem.prices[priceNum].currency;
                        }
                    }
                });
                if (brandPrices.length) {
                    return {
                        price: getMinPrice(brandPrices),
                        currency: currency
                    };
                }
                return false;
            });
        });

        data.segmentSort = data.prices.map(function () {
            return backend.getParam('search.defaultVariantsSortProperty');
        });

        return data;
    }

    function reformatSearchVariantsFFPResult(data) {

        var ffpCompareConfig = backend.getFfpCompareConfig();

        data.fareGroups = data.fareGroups.map(function (fareGroup) {
            if (ffpCompareConfig[fareGroup.type]) {
                fareGroup.properties = ffpCompareConfig[fareGroup.type].properties.map(function (prop) {
                    return (0, _extends3.default)({}, prop, {
                        name: backend.getAliasWithPrefix('web.ffpComparePropertyName.', prop.code)
                    });
                });
            }
            return fareGroup;
        });

        data.segmentRows = data.prices.map(function (segmentPrices) {
            var segmentRowItems = _.keys(segmentPrices).map(function (chainId) {
                var chain = _.findWhere(data.flights, { chainId: chainId }),
                    prices = data.fareGroups.map(function (fareGroup) {
                    return _.findWhere(segmentPrices[chainId], { fareGroup: fareGroup.id }) || false;
                }),
                    minPrice = getMinPrice(prices),
                    minPriceCurrency = getMinPriceCurrency(prices);

                return {
                    prices: prices,
                    minPrice: minPrice,
                    minPriceCurrency: minPriceCurrency,
                    chainId: chainId,
                    flights: chain.flights,
                    flightsInfo: utils.getFlightsInfo(chain, backend.getAlias('web.connectionsMessage.transfer'), backend.getAlias('web.connectionsMessage.noTransfer'))
                };
            });
            segmentRowItems.filter(function (rowItem) {
                return !!rowItem.minPrice;
            });
            return segmentRowItems;
        });

        data.fareGroupMinPricesLists = data.segmentRows.map(function (segmentRowItems) {
            return data.fareGroups.map(function (fareGroup, priceNum) {
                var fareGroupPrices = [];
                var currency = void 0;
                segmentRowItems.forEach(function (rowItem) {
                    if (rowItem.prices[priceNum]) {
                        fareGroupPrices.push(rowItem.prices[priceNum]);
                        if (!currency) {
                            currency = rowItem.prices[priceNum].currency;
                        }
                    }
                });
                if (fareGroupPrices.length) {
                    return {
                        price: getMinPrice(fareGroupPrices),
                        currency: currency
                    };
                }
                return false;
            });
        });

        data.segmentSort = data.prices.map(function () {
            return backend.getParam('search.defaultVariantsSortProperty');
        });

        return data;
    }

    function getPricesByFareGroups(variants, fareGroups) {
        return fareGroups.map(function (fareGroup) {
            var variantForFareGroup = false;
            variants.forEach(function (variant) {
                if (variant.fareGroup === fareGroup.id) {
                    variantForFareGroup = variant;
                }
            });
            return variantForFareGroup;
        });
    }

    function reformatSearchResult(data) {
        var searchResult = {
            flights: data.flights,
            fareGroups: data.fareGroups || false,
            priceRows: []
        };

        data.prices.forEach(function (price) {
            price.flight_variants.forEach(function (flight_variant) {
                var priceRow = {
                    segments: flight_variant.direction.map(function (segment) {
                        var chain = _.findWhere(data.flights, { chainId: segment.chainId });
                        segment.flights = chain.flights;
                        segment.flightsInfo = utils.getFlightsInfo(chain, backend.getAlias('web.connectionsMessage.transfer'), backend.getAlias('web.connectionsMessage.noTransfer'));
                        return segment;
                    }),
                    price: data.fareGroups ? getPricesByFareGroups(price.price_variants, data.fareGroups) : {
                        price: price.price,
                        currency: price.currency
                    }
                };
                if (data.fareGroups) {
                    priceRow.minPrice = getMinPrice(priceRow.price);
                }
                searchResult.priceRows.push(priceRow);
            });
        });

        if (searchResult.fareGroups) {
            searchResult.fareGroups.forEach(function (fareGroup, fareGroupNum) {
                var pricesList = searchResult.priceRows.filter(function (priceRow) {
                    return !!priceRow.price[fareGroupNum];
                }).map(function (priceRow) {
                    return priceRow.price[fareGroupNum];
                });

                pricesList.forEach(function (price) {
                    fareGroup.minPriceCurrency = price.currency;
                });
                fareGroup.minPrice = getMinPrice(pricesList);
            });
            searchResult.priceRowsSort = 'price';
        } else {
            searchResult.priceRows = searchResult.priceRows.sort(function (a, b) {
                var compare = utils.compareStringTime(a.segments[0].flightsInfo.departuretime, b.segments[0].flightsInfo.departuretime);
                if (compare === 0) {
                    if (!a.price.price) {
                        return 1;
                    } else if (!b.price.price) {
                        return -1;
                    } else if (Big(a.price.price).gt(b.price.price)) {
                        return 1;
                    } else if (Big(a.price.price).lt(b.price.price)) {
                        return -1;
                    } else {
                        return 0;
                    }
                } else {
                    return compare;
                }
            });
        }

        return searchResult;
    }

    function hasBrandInPrices(segmentsPrices, brandCode) {
        var hasBrand = false;
        segmentsPrices.forEach(function (segmentPrices) {
            if (!hasBrand) {
                _.keys(segmentPrices).forEach(function (chainId) {
                    if (!hasBrand) {
                        hasBrand = !!_.findWhere(segmentPrices[chainId], { brand: brandCode }) || false;
                    }
                });
            }
        });
        return hasBrand;
    }

    function getMinPrice(prices) {
        var propName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'price';

        var i = 0,
            min = void 0;
        while (i < prices.length) {
            if (prices[i] && prices[i][propName]) {
                if (!min || min.gt(prices[i][propName])) {
                    min = Big(prices[i][propName]);
                }
            }
            i++;
        }
        if (!min) {
            return false;
        }
        return min.toFixed(2);
    }

    function getMinPriceCurrency(prices) {
        var i = 0;
        while (i < prices.length) {
            if (prices[i] && prices[i].currency) {
                return prices[i].currency;
            }
            i++;
        }
        return false;
    }

    function updateSort(segNum, type) {
        if (type) {
            vm.searchResult.segmentRows[segNum].sort(segmentRowsSorter(type));
        }
    }

    function segmentRowsSorter(type) {
        return {
            flighttime: function flighttime(a, b) {
                return utils.compareStringTime(a.flightsInfo.flighttime, b.flightsInfo.flighttime);
            },
            price: function price(a, b) {
                if (!a.minPrice) {
                    return 1;
                } else if (!b.minPrice) {
                    return -1;
                } else if (Big(a.minPrice).gt(b.minPrice)) {
                    return 1;
                } else if (Big(a.minPrice).lt(b.minPrice)) {
                    return -1;
                } else {
                    return 0;
                }
            },
            departuretime: function departuretime(a, b) {
                if (a.flightsInfo.departuredayshift > b.flightsInfo.departuredayshift) {
                    return 1;
                } else if (a.flightsInfo.departuredayshift < b.flightsInfo.departuredayshift) {
                    return -1;
                } else {
                    return utils.compareStringTime(a.flightsInfo.departuretime, b.flightsInfo.departuretime);
                }
            },
            arrivaltime: function arrivaltime(a, b) {
                if (a.flightsInfo.arrivaldayshift > b.flightsInfo.arrivaldayshift) {
                    return 1;
                } else if (a.flightsInfo.arrivaldayshift < b.flightsInfo.arrivaldayshift) {
                    return -1;
                } else {
                    return utils.compareStringTime(a.flightsInfo.arrivaltime, b.flightsInfo.arrivaltime);
                }
            }
        }[type];
    }

    function updateSortPriceRows(type, segNum) {
        vm.searchResult.priceRows.sort(priceRowsSorter(type, segNum));
    }

    function priceRowsSorter(type, segNum) {
        return {
            flighttime: function flighttime(a, b) {
                return utils.compareStringTime(a.segments[segNum].flightsInfo.flighttime, b.segments[segNum].flightsInfo.flighttime);
            },
            price: function price(a, b) {
                if (!a.minPrice) {
                    return 1;
                } else if (!b.minPrice) {
                    return -1;
                } else if (Big(a.minPrice).gt(b.minPrice)) {
                    return 1;
                } else if (Big(a.minPrice).lt(b.minPrice)) {
                    return -1;
                } else {
                    return 0;
                }
            },
            departuretime: function departuretime(a, b) {
                a = a.segments[segNum].flightsInfo;
                b = b.segments[segNum].flightsInfo;
                if (a.departuredayshift > b.departuredayshift) {
                    return 1;
                } else if (a.departuredayshift < b.departuredayshift) {
                    return -1;
                } else {
                    return utils.compareStringTime(a.departuretime, b.departuretime);
                }
            },
            arrivaltime: function arrivaltime(a, b) {
                a = a.segments[segNum].flightsInfo;
                b = b.segments[segNum].flightsInfo;
                if (a.arrivaldayshift > b.arrivaldayshift) {
                    return 1;
                } else if (a.arrivaldayshift < b.arrivaldayshift) {
                    return -1;
                } else {
                    return utils.compareStringTime(a.arrivaltime, b.arrivaltime);
                }
            }
        }[type];
    }

    function monoBrandCartesianVariantSelectHandler(segNum, rowNum, priceNum) {
        var flightsInfo = void 0,
            arrivaltimeTo = void 0,
            arrivaldateTo = void 0,
            departuredateFrom = void 0,
            departuretimeFrom = void 0,
            comparetime = void 0,
            comparedate = void 0;

        if (vm.searchResult.segmentRows[segNum][rowNum].prices[priceNum].selected || vm.searchResult.segmentRows[segNum][rowNum].prices[priceNum].comparedDateTimeDisable || segNum === 1 && (!vm.searchResult.brandsCompatibleState || !vm.searchResult.brandsCompatibleState[priceNum])) {
            return;
        }

        vm.searchResult.brandsCompatibleState = vm.searchResult.brandsList[priceNum].compatible;

        if (segNum === 0 && vm.searchResult.segmentRows[1]) {
            vm.searchResult.segmentRows[1].forEach(function (row) {
                row.prices.forEach(function (priceItem, backPriceNum) {
                    if (priceItem && priceItem.selected && !vm.searchResult.brandsCompatibleState[backPriceNum]) {
                        priceItem.selected = false;
                        if (row.prices[priceNum]) {
                            row.prices[priceNum].selected = true;
                        }
                    }
                });

                flightsInfo = vm.searchResult.segmentRows[segNum][rowNum].flightsInfo;
                arrivaltimeTo = flightsInfo.arrivaltime;
                arrivaldateTo = flightsInfo.arrivaldate;
                departuredateFrom = row.flightsInfo.departuredate;
                departuretimeFrom = row.flightsInfo.departuretime;
                comparetime = utils.compareStringTime(arrivaltimeTo, departuretimeFrom);
                comparedate = utils.compareStringDate(arrivaldateTo, departuredateFrom);

                if (comparetime === 1 && comparedate === 0) {
                    row.prices.forEach(function (priceItem) {
                        if (priceItem) {
                            priceItem.comparedDateTimeDisable = true;
                            if (priceItem.selected) {
                                priceItem.selected = false;
                            }
                        }
                    });
                } else {
                    row.prices.forEach(function (priceItem) {
                        if (priceItem) {
                            priceItem.comparedDateTimeDisable = false;
                        }
                    });
                }
            });
        }

        vm.searchResult.segmentRows[segNum].forEach(function (row) {
            row.prices.forEach(function (priceItem) {
                if (priceItem) {
                    priceItem.selected = false;
                }
            });
        });

        vm.searchResult.segmentRows[segNum][rowNum].prices[priceNum].selected = true;

        updateSelectedVariants('monoBrandCartesian');
    }

    function pricingRouteAndMonoBrandVariantSelectHandler(segNum, rowNum, priceNum) {
        var alreadySelectedBySegments = [];
        vm.searchResult.segmentRows[segNum].forEach(function (row) {
            row.prices.forEach(function (priceItem) {
                if (priceItem) {
                    priceItem.selected = false;
                }
            });
        });
        vm.searchResult.segmentRows[segNum][rowNum].prices[priceNum].selected = true;
        vm.searchResult.brandsCompatibleState = vm.searchResult.brandsList[priceNum].compatible;

        var _loop = function _loop(i) {
            alreadySelectedBySegments.push({});
            vm.searchResult.segmentRows[i].forEach(function (row) {
                row.prices.forEach(function (priceItem) {
                    if (priceItem.selected) {
                        alreadySelectedBySegments[i].chainId = row.chainId;
                        alreadySelectedBySegments[i].brand = priceItem.brand;
                        alreadySelectedBySegments[i].artificialPriceForChain = priceItem.artificialPriceForChain;
                    }
                });
            });
        };

        for (var i = 0; i <= segNum; i++) {
            _loop(i);
        }

        vm.pricingVariant = false;

        if (vm.searchResult.segmentRows[segNum + 1]) {
            vm.loadingVariants = true;
            backend.searchVariantsPricingRouteAndMonoBrand(false, segNum + 1, alreadySelectedBySegments).then(function (resp) {
                if (resp.currentChainPrices) {
                    vm.searchResult.segmentRows[segNum + 1].forEach(function (chainRow) {
                        chainRow.prices = vm.searchResult.brandsList.map(function (brandItem) {
                            return _.findWhere(resp.currentChainPrices[chainRow.chainId], { brand: brandItem.code }) || false;
                        });
                        if (chainRow.prices) {
                            chainRow.minPrice = getMinPrice(chainRow.prices, 'artificialPriceForChain');
                            chainRow.minPriceCurrency = getMinPriceCurrency(chainRow.prices);
                        }
                    });
                }
            }).finally(function () {
                vm.loadingVariants = false;
            });
            oxyScroll.scrollToAnchor('segment_' + (segNum + 1));
        } else {
            updateSelectedVariants('pricingRouteAndMonoBrand');
        }
    }

    function fareGroupVariantSelectHandler(rowNum, priceNum) {
        vm.searchResult.priceRows.forEach(function (priceRow, priceRowNum) {
            priceRow.price.forEach(function (priceItem, priceItemNum) {
                if (priceItem) {
                    priceItem.selected = priceRowNum === rowNum && priceItemNum === priceNum;
                }
            });
        });
        updateSelectedVariants('standard');
    }

    function variantSelectHandler(rowNum) {
        vm.searchResult.priceRows.forEach(function (priceRow, num) {
            priceRow.selected = rowNum === num;
        });
        updateSelectedVariants('standard');
    }

    function ffpVariantSelectHandler(segNum, rowNum, priceNum) {

        vm.searchResult.segmentRows[segNum].forEach(function (row) {
            row.prices.forEach(function (priceItem) {
                if (priceItem) {
                    priceItem.selected = false;
                }
            });
        });

        vm.searchResult.segmentRows[segNum][rowNum].prices[priceNum].selected = true;

        updateSelectedVariants('ffp');
    }

    function logoutFFP() {
        backend.ffpLogout();
        vm.ffpUser = false;
        o2context.authoriseFFPUser = false;
        searchSubmitHandler(vm.searchParams);
    }

    function isSinglePassenger(passengers) {
        var summ = _.reduce(_.values(passengers), function (memo, count) {
            return memo + count;
        }, 0);
        return summ === 1;
    }

    function gotoPassengersHandler() {
        if (vm.pricingVariant) {
            var searchGroupsConfig = backend.getSearchGroupsConfig();
            if (searchGroupsConfig && vm.searchParams.searchGroupId) {
                var selectedSearchGroup = _.findWhere(searchGroupsConfig, { id: vm.searchParams.searchGroupId });
                if (selectedSearchGroup && selectedSearchGroup.allowedBrands) {
                    var selectedBrands = vm.selectedVariants.map(function (variant) {
                        return variant.brand;
                    });
                    if (selectedBrands.some(function (selectedBrand) {
                        return utils.hasInList(selectedSearchGroup.allowedBrands, selectedBrand);
                    })) {
                        vm.showScannedDocsSearchGroupWarning = vm.searchParams.searchGroupId;
                        return;
                    }
                }
            }
            redirect.goToPassengers();
        }
    }

    function updateSelectedVariants(mode) {
        vm.selectedVariants = [];
        if (mode === 'standard') {
            vm.searchResult.priceRows.forEach(function (priceRow) {
                if (vm.searchResult.fareGroups) {
                    priceRow.price.forEach(function (priceItem) {
                        if (priceItem && priceItem.selected) {
                            priceRow.segments.forEach(function (segment) {
                                vm.selectedVariants.push({
                                    priceId: priceItem.priceId,
                                    chainId: segment.chainId
                                });
                            });
                        }
                    });
                } else {
                    if (priceRow.selected) {
                        priceRow.segments.forEach(function (segment) {
                            vm.selectedVariants.push({
                                priceId: priceRow.price.priceId,
                                chainId: segment.chainId
                            });
                        });
                    }
                }
            });
        } else if (mode === 'pricingRouteAndMonoBrand') {
            vm.searchResult.segmentRows.forEach(function (segment) {
                segment.forEach(function (row) {
                    row.prices.forEach(function (priceItem) {
                        if (priceItem && priceItem.selected) {
                            vm.selectedVariants.push({
                                price: priceItem.artificialPriceForChain,
                                brand: priceItem.brand,
                                chainId: row.chainId
                            });
                        }
                    });
                });
            });
        } else {
            vm.searchResult.segmentRows.forEach(function (segment) {
                segment.forEach(function (row) {
                    row.prices.forEach(function (priceItem) {
                        if (priceItem && priceItem.selected) {
                            vm.selectedVariants.push({
                                price: priceItem.price,
                                brand: priceItem.brand,
                                requestedBrands: priceItem.requestedBrands,
                                fareGroup: priceItem.fareGroup,
                                chainId: row.chainId
                            });
                        }
                    });
                });
            });
        }

        if (mode === 'standard' || vm.searchResult.segmentRows && vm.selectedVariants.length === vm.searchResult.segmentRows.length) {
            if (vm.loadingPricingVariant) {
                backend.pricingVariantCancel();
            }
            vm.loadingPricingVariant = true;
            delete vm.pricingVariantError;
            scrollToEnd();

            backend.pricingVariant(vm.selectedVariants, mode).then(function (pricingVariant) {
                vm.loadingPricingVariant = false;
                vm.pricingVariant = reformatPricingVariant(pricingVariant);
                vm.selectedVariantsInfo = vm.selectedVariants.map(function (segment, segNum) {
                    var chain = _.findWhere(vm.searchResult.flights, { chainId: segment.chainId });
                    segment.date = vm.searchParams.segments[segNum].date;
                    segment.flights = chain.flights;
                    segment.flightsInfo = utils.getFlightsInfo(chain, backend.getAlias('web.connectionsMessage.transfer'), backend.getAlias('web.connectionsMessage.noTransfer'));
                    if (segment.brand) {
                        segment.brandName = backend.getBrandName(segment.brand);
                        segment.brandAvailableProps = backend.getBrandProps(segment.brand, 'yes');
                        segment.brandUnavailableProps = backend.getBrandProps(segment.brand, 'no');
                        segment.brandPaidProps = backend.getBrandProps(segment.brand, 'paid');
                    }
                    return segment;
                });
                $timeout(scrollToEnd);

                vm.intermodalList = utils.concatLists(vm.selectedVariants.map(function (segment) {
                    return segment.flights.filter(function (flight) {
                        return backend.hasAlias('web.intermodalinfo.' + flight.vehicleCodeEn);
                    }).map(function (flight) {
                        return flight.vehicleCodeEn;
                    });
                }));

                vm.alertMessagesByRoute = generateAlertMessagesByRoute(vm.selectedVariants);
            }, function (resp) {
                vm.pricingVariant = false;
                vm.selectedVariantsInfo = false;
                vm.alertMessagesByRoute = false;
                if (resp.error !== 'web.messages.httpAbort') {
                    vm.loadingPricingVariant = false;
                    vm.pricingVariantError = resp.error;
                }
            });
        }
        if (vm.searchResult.segmentRows && vm.selectedVariants.length !== vm.searchResult.segmentRows.length) {
            oxyScroll.scrollToAnchor('segment_1');
        }
    }

    function generateAlertMessagesByRoute(selectedVariants) {
        var messages = [];
        selectedVariants.forEach(function (selectedVariant) {
            selectedVariant.flights.forEach(function (flight) {
                var destAlias = 'web.alertMessage.selectedVariant.destinationPort.' + (flight.destinationport || flight.destinationcity);
                var origAlias = 'web.alertMessage.selectedVariant.originPort.' + (flight.originport || flight.origincity);
                if (backend.hasAlias(destAlias)) {
                    messages.push(destAlias);
                }
                if (backend.hasAlias(origAlias)) {
                    messages.push(origAlias);
                }
            });
        });
        return messages;
    }

    function reformatPricingVariant(data) {

        var taxesGroupsList = backend.getTaxesGroupsList();

        if (data.pricesByCategory) {
            data.passengerCategories = data.pricesByCategory.map(function (pasPrice) {
                return {
                    passengerCategory: pasPrice.categoryCode,
                    passengerCount: pasPrice.quantity,
                    passengerCountLabel: utils.suffixCount(pasPrice.quantity, backend.getAliasWithPrefix('web.passengerCategories.', pasPrice.categoryCode)),
                    price: pasPrice.total,
                    tax: pasPrice.tax,
                    taxList: pasPrice.taxes || [],
                    fare: pasPrice.fare
                };
            });
        }

        if (taxesGroupsList && taxesGroupsList.length) {
            data.passengerCategories.forEach(function (pasData) {
                pasData.groupedTaxes = taxesGroupsList.map(function (taxesGroupItem) {
                    return {
                        groups: taxesGroupItem.groups,
                        code: taxesGroupItem.code,
                        showOnlyIfNotZero: taxesGroupItem.showOnlyIfNotZero,
                        value: '0'
                    };
                });
                pasData.otherTaxes = '0';
                pasData.taxList.forEach(function (taxItem) {
                    var hasInAnyGroup = false;
                    pasData.groupedTaxes.forEach(function (taxGroupItem) {
                        if (utils.hasInList(taxGroupItem.groups, taxItem.code)) {
                            taxGroupItem.value = Big(taxGroupItem.value).plus(taxItem.value).toFixed(2);
                            hasInAnyGroup = true;
                        }
                    });
                    if (!hasInAnyGroup) {
                        pasData.otherTaxes = Big(pasData.otherTaxes).plus(taxItem.value).toFixed(2);
                    }
                });
                if (Big(pasData.otherTaxes).eq(0)) {
                    delete pasData.otherTaxes;
                }

                pasData.groupedTaxes = pasData.groupedTaxes.filter(function (taxGroupItem) {
                    return !(Big(taxGroupItem.value).eq(0) && taxGroupItem.showOnlyIfNotZero);
                });
            });
        }

        return data;
    }

    function scrollToEnd() {
        var contentBlock = $document.querySelectorAll('div.content-search-result'),
            offsetHeight = contentBlock[0].offsetHeight,
            offset = contentBlock.offset(),
            h = Math.max($window.document.documentElement.clientHeight, $window.innerHeight || 0);
        oxyScroll.scrollTopAnimated(offsetHeight + offset.top - h);
    }

    function expressCheckExternalSearchParams(esp) {
        var segCount = esp.segmentsCount * 1;
        var i = void 0;
        if (!segCount || segCount <= 0) {
            return false;
        }
        for (i = 0; i < segCount; i++) {
            if (!esp['carrier[' + i + ']'] || !esp['flight[' + i + ']'] || !esp['subclass[' + i + ']'] && !esp['requestedBrands[' + i + ']']) {
                return false;
            }
        }
        return true;
    }
}]);

},{"babel-runtime/helpers/extends":9}],618:[function(require,module,exports){
"use strict";

angular.module('app').controller('SeatSelectScreenController', ['backend', 'utils', 'redirect', 'watchman', function (backend, utils, redirect, watchman) {
    var vm = this;

    vm.loading = true;
    vm.orderServicesLoading = true;

    backend.ready.then(function () {
        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'seatSelect'));

        backend.clearUpdateOrderServicesListeners();

        backend.addUpdateOrderServicesListener(function (resp) {
            vm.orderInfo = resp[1];
            vm.es = utils.reformatAvailableExtraServicesByCards(resp[0], vm.orderInfo, vm.es);
            if (vm.es.seat && !(vm.es.seat.unavailableBecauseOfCheckInBySegments && vm.es.seat.unavailableBecauseOfCheckInBySegments.every(function (flight) {
                return flight;
            }))) {
                vm.loading = false;
                vm.orderServicesLoading = false;
            } else {
                if (vm.orderInfo.header && vm.orderInfo.header.regnum) {
                    redirect.goToAddServices();
                } else {
                    redirect.goToBooking();
                }
            }
        }, function (resp) {
            vm.loading = false;
            vm.orderServicesLoading = false;
            vm.errorMessage = resp.error;
        });

        backend.updateOrderServices();

        watchman.notifyUserInterfaceEvent({ name: 'seat-select-from-booking' });

        backend.addExtraServiceListener(function (state) {
            vm.modifyServicesError = false;
            vm.modifyServicesLoading = !state;
            vm.orderServicesLoading = true;
        });

        backend.addExtraServiceErrorListener(function (resp) {
            vm.modifyServicesError = resp.error;
            vm.modifyServicesLoading = false;
            vm.orderServicesLoading = true;
        });
    });
}]);

},{}],619:[function(require,module,exports){
"use strict";

angular.module('app').controller('UnsubscribeEmailScreenController', ['backend', function (backend) {

    var vm = this;
    vm.loading = true;
    vm.saveHandler = saveHandler;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'unsubscribeEmail'));
        vm.loading = false;
        vm.captchaProvider = backend.applicationConstants.captchaProvider;
        vm.captchaEnabled = backend.applicationConstants.captchaEnabled;
    });

    function saveHandler() {
        vm.submitTouched = true;
        if (vm.unsubscribeForm.$valid && (vm.unsubscribeParams.captcha || !vm.captchaEnabled)) {
            vm.loading = true;
            backend.unsubscribe(vm.unsubscribeParams).then(function () {
                vm.unsubscribeSuccess = true;
                vm.loading = false;
            }, function (resp) {
                vm.unsubscribeError = typeof resp.error === 'string' ? resp.error : true;
                vm.loading = false;
            });
        }
    }
}]);

},{}],620:[function(require,module,exports){
"use strict";

angular.module('app').controller('UnsubscribePhoneScreenController', ['backend', function (backend) {

    var vm = this;
    vm.loading = true;
    vm.saveHandler = saveHandler;

    backend.ready.then(function () {

        angular.element('title').text(backend.getAliasWithPrefix('web.pageTitle.', 'unsubscribePhone'));
        vm.loading = false;
        vm.captchaProvider = backend.applicationConstants.captchaProvider;
        vm.captchaEnabled = backend.applicationConstants.captchaEnabled;
    });

    function saveHandler() {
        vm.submitTouched = true;
        if (vm.unsubscribeForm.$valid && (vm.unsubscribeParams.captcha || !vm.captchaEnabled)) {
            vm.loading = true;
            backend.unsubscribe(vm.unsubscribeParams).then(function () {
                vm.unsubscribeSuccess = true;
                vm.loading = false;
            }, function (resp) {
                vm.unsubscribeError = typeof resp.error === 'string' ? resp.error : true;
                vm.loading = false;
            });
        }
    }
}]);

},{}],621:[function(require,module,exports){
"use strict";

angular.module('app').factory('admitadTracker', ['$cookies', 'watchman', 'backend', 'utils', function ($cookies, watchman, backend, utils) {

    var uid = void 0,
        trackingConfig = void 0;

    return init;

    function init() {
        trackingConfig = getTrackingConfig();
        if (trackingConfig) {
            uid = updateUID();
            if (uid && isActiveTracking()) {
                updateESP();
                watchman.addOrderEventListener(orderOverlooker, 'admitad');
            }
        }
    }

    function orderOverlooker(orderEvent, orderInfo) {
        if (orderEvent.type === 'ORDER_PAYMENT_SUCCESSFULLY_FINISHED') {
            try {
                requestByImage(orderInfo);
            } catch (err) {
                console.log('Admitad tracking request failed: ', err);
            }
        }
    }

    function updateUID() {
        var uid = utils.getParamFromLocation('admitad_uid');
        if (uid) {
            $cookies.put('admitad_uid', uid, { expires: moment().add(90, 'days').toDate() });
            $cookies.put('websky_last_redirect_source', 'admitad');
        } else {
            uid = $cookies.get('admitad_uid');
        }
        return uid;
    }

    function updateESP() {
        if (!o2context.externalSearchParams) {
            o2context.externalSearchParams = {};
        }
        if (!o2context.externalSearchParams['search-engine']) {
            o2context.externalSearchParams['search-engine'] = 'admitad';
        }
    }

    function isActiveTracking() {
        return $cookies.get('websky_last_redirect_source') === 'admitad';
    }

    function getTrackingConfig() {
        var param = backend.getParam('site.admitadTrackingConfig');
        var config = false;
        if (param) {
            try {
                config = JSON.parse(param);
            } catch (err) {
                console.log('Invalid site.admitadTrackingConfig: ', err);
            }
        }
        return config;
    }

    function requestByImage(orderInfo) {
        var url = 'https://ad.admitad.com/r?postback=1';
        url += '&postback_key=' + trackingConfig.postback_key;
        url += '&campaign_code=' + trackingConfig.campaign_code;
        url += '&uid=' + uid;
        url += '&ac=1';
        url += '&tc=1';
        url += '&order_id=' + orderInfo.header.regnum;
        url += '&price=' + orderInfo.prices.totalPrice;
        url += '&pc=1';
        url += '&pid=1';
        url += '&quantity=1';
        url += '&product_id=' + orderInfo.header.regnum;
        url += '&payment_type=sale';
        $('body').append('<img src="' + url + '"/>');
    }
}]);

},{}],622:[function(require,module,exports){
"use strict";

angular.module('app').factory('appInit', ['$window', '$timeout', '$rootScope', 'backend', 'utils', 'modalTools', 'ROUTES', 'redirect', '$sce', '$route', 'skyscannerTracker', 'yandexTracker', 'admitadTracker', 'aviasalesTracker', 'gtagTracker', 'ymTracker', function ($window, $timeout, $rootScope, backend, utils, modalTools, ROUTES, redirect, $sce, $route, skyscannerTracker, yandexTracker, admitadTracker, aviasalesTracker, gtagTracker, ymTracker) {

    function checkO2contextPassengersCountByConfig(searchGroupsConfig) {
        o2context.externalSearchParams.searchGroupId = o2context.pagePurifiedParameters.searchGroupId || searchGroupsConfig[0].id;
        var categoriesList = [];
        searchGroupsConfig.forEach(function (group) {
            group.categories.forEach(function (category) {
                if (!utils.hasInList(categoriesList, category.id)) {
                    categoriesList.push(category.id);
                }
            });
        });
        categoriesList.forEach(function (categoryId) {
            var paramName = categoryId + 'Count';
            var paramNameOld = categoryId + 'Amount';
            var paramValue = o2context.pagePurifiedParameters[paramName] || o2context.pagePurifiedParameters[paramNameOld];
            if (paramValue) {
                o2context.externalSearchParams[paramName] = paramValue;
            }
        });
        o2context.externalSearchParams.passengersCountCheckedByConfig = true;
    }

    return function () {
        backend.setSessionInactiveHandler(function () {
            if (redirect.isPassengersScreen() && !$window.document.hidden) {
                backend.lastSearchParams();
            } else {
                modalTools.openHandler('popup-session-inactive');
            }
        });

        backend.setCancelSessionHandler(function (isParallelSession) {
            modalTools.openHandler('popup-cancel-session', false, {
                disableOutsideCloseClick: true,
                isParallelSession: isParallelSession
            });
            $timeout(redirect.goToStart, 200);
        });

        backend.setCaptchaRequiredHandler(function (submitCallback, rejectCallback, captchaError) {
            var captchaProvider = backend.applicationConstants.captchaProvider;

            if (captchaProvider === 'NL_SIMPLE_CAPTCHA') {
                modalTools.openHandler('popup-captcha-required', false, {
                    submitCallback: submitCallback,
                    rejectCallback: rejectCallback,
                    captchaError: captchaError
                });
            } else if (captchaProvider === 'GOOGLE_RECAPTCHA' && $window.grecaptcha) {
                jQuery('div.app-container').append('<div class="recaptcha-container" id="recaptchaContainer"></div>');
                $window.grecaptcha.render('recaptchaContainer', {
                    sitekey: backend.applicationConstants.recaptchaPublicKey,
                    callback: function callback(captchaText) {
                        jQuery('#recaptchaContainer').remove();
                        submitCallback(captchaText);
                    }
                });
            } else if (captchaProvider === 'YANDEX_SMARTCAPTCHA' && $window.smartCaptcha) {
                jQuery('div.app-container').append('<div class="smart-captcha-container" id="smartCaptchaContainer"></div>');
                $window.smartCaptcha.render('smartCaptchaContainer', {
                    sitekey: backend.applicationConstants.recaptchaPublicKey,
                    callback: function callback(captchaText) {
                        console.log('captchaText: ', captchaText);
                        jQuery('#smartCaptchaContainer').remove();
                        submitCallback(captchaText);
                    }
                });
            }
        });

        backend.setOrderEmailRequiredHandler(function (submitCallback, rejectCallback) {

            modalTools.openHandler('popup-order-email-required', false, {
                submitCallback: submitCallback,
                rejectCallback: rejectCallback
            });
        });

        backend.ready.then(function () {
            var searchGroupsConfig = backend.getSearchGroupsConfig();
            var captchaProvider = backend.applicationConstants.captchaProvider;

            $rootScope.localNamePropName = backend.sessionParams.localNamePropName;
            jQuery('#preloader').remove();
            if (o2context.externalSearchParams && !o2context.externalSearchParams.passengersCountCheckedByConfig) {
                checkO2contextPassengersCountByConfig(searchGroupsConfig);
            }
            skyscannerTracker();
            yandexTracker();
            admitadTracker();
            aviasalesTracker();
            gtagTracker();
            ymTracker.init();
            if (captchaProvider === 'YANDEX_SMARTCAPTCHA' && $window.smartCaptcha && o2context.useInvisibleSmartCaptcha) {
                console.log('invisible recaptchaPublicKey: ', backend.applicationConstants.recaptchaPublicKey);
                jQuery('div.app-container').append('<div class="smart-captcha-container" id="smartInvisibleCaptchaContainer"></div>');
                var smartCaptchaId = $window.smartCaptcha.render('smartInvisibleCaptchaContainer', {
                    sitekey: backend.applicationConstants.recaptchaPublicKey,
                    invisible: true,
                    callback: function callback(captchaText) {
                        console.log('invisible captchaText: ', captchaText);
                    }
                });
                console.log('invisible smartCaptchaId: ', smartCaptchaId);
            }

            if (backend.getParam('extraServices.useSvgAircraftScheme')) {
                var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');
                jQuery('head').append('<link rel="stylesheet" href="' + externalStorageUrl + '/seat-map/seat-map.css">');
            }
        });

        $rootScope.ROUTES = ROUTES;
        $rootScope.APP_LOADER_ALIAS = $sce.trustAsHtml($window.document.getElementById('appLoaderAlias').innerHTML);
        $rootScope.$on('$routeChangeSuccess', function () {
            if ($route.current.isBookingStep) {
                $rootScope.lastBookingStep = $route.current.originalPath;
            }
        });

        if (o2context.tempAuthIdentity) {
            redirect.goToResetForgetPassword();
        }
        if (o2context.registrationIdentityToken) {
            redirect.goToActivateAccount();
        }
        if (o2context.quickSearch) {
            redirect.goToSearchOrder();
        }
        if (o2context.loginToken) {
            backend.login({ token: o2context.loginToken });
        }
        if (o2context.pagePurifiedParameters && o2context.pagePurifiedParameters.removeProfileToken && o2context.pagePurifiedParameters.userRole) {
            redirect.goToRemoveProfileConfirm();
        }

        o2context.clientTimeDelta = Date.now() - o2context.serverDateTime;
    };
}]);

},{}],623:[function(require,module,exports){
"use strict";

angular.module('app').factory('aviasalesTracker', ['$cookies', 'backend', function ($cookies, backend) {

    return init;

    function init() {
        if (o2context.externalSearchParams && o2context.externalSearchParams['redirect-id'] && o2context.externalSearchParams['search-engine'] === 'aviasales') {
            var expires = moment().add(backend.getParam('site.aviasalesCookieDaysCount'), 'days').toDate();
            $cookies.put('websky_last_redirect_source', 'aviasales', { expires: expires });
            $cookies.put('websky_last_aviasales_redirect_id', o2context.externalSearchParams['redirect-id'], { expires: expires });
        } else if ($cookies.get('websky_last_redirect_source') === 'aviasales') {
            updateESP();
        }
    }

    function updateESP() {
        if (!o2context.externalSearchParams) {
            o2context.externalSearchParams = {};
        }
        if (!o2context.externalSearchParams['search-engine']) {
            o2context.externalSearchParams['search-engine'] = 'aviasales';
            o2context.externalSearchParams['redirect-id'] = $cookies.get('websky_last_aviasales_redirect_id');
        }
    }
}]);

},{}],624:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').factory('ffpTools', ['backend', function (backend) {

    var ffpMemberTypes = [];
    var defaultSelectedFfpMemberType = false;

    backend.ready.then(function () {
        initFfpMemberTypes();
    });

    return {
        getFfpMemberTypes: getFfpMemberTypes,
        getFfpMemberTypePrefix: getFfpMemberTypePrefix,
        getFfpMemberTypeCardNoRegex: getFfpMemberTypeCardNoRegex,
        generateBonusCardShort: generateBonusCardShort,
        detectFfpMemberType: detectFfpMemberType,
        tryCropBonusCardFullToShort: tryCropBonusCardFullToShort,
        getDefaultSelectedFfpMemberType: getDefaultSelectedFfpMemberType,
        getFfpMemberTypeFullLength: getFfpMemberTypeFullLength
    };

    function initFfpMemberTypes() {
        var ffpMemberTypesConfig = backend.getFfpMemberTypesConfig();
        if (ffpMemberTypesConfig && ffpMemberTypesConfig.length) {
            ffpMemberTypes = ffpMemberTypesConfig.map(function (ffpMemberType) {
                return (0, _extends3.default)({}, ffpMemberType, {
                    name: backend.getAliasWithPrefix('web.ffpMemberType.', ffpMemberType.code)
                });
            });
            ffpMemberTypes.forEach(function (ffpMemberType) {
                if (ffpMemberType.defaultSelected) {
                    defaultSelectedFfpMemberType = ffpMemberType;
                }
            });
        }
    }

    function getFfpMemberTypePrefix(ffpMemberTypeCode) {
        for (var i = 0; i < ffpMemberTypes.length; i++) {
            if (ffpMemberTypes[i].code === ffpMemberTypeCode) {
                return ffpMemberTypes[i].prefix;
            }
        }
    }

    function getFfpMemberTypeCardNoRegex(ffpMemberTypeCode) {
        for (var i = 0; i < ffpMemberTypes.length; i++) {
            if (ffpMemberTypes[i].code === ffpMemberTypeCode) {
                return ffpMemberTypes[i].cardNoRegex;
            }
        }
    }

    function generateBonusCardShort(bonusCardFull, ffpMemberType) {
        if (bonusCardFull) {
            var bonusCardFullParts = bonusCardFull.split('.');
            var bonusCardFullWithoutPostfix = bonusCardFullParts[0];
            var bonusCardFullPostfix = bonusCardFullParts[1] || false;
            var re = new RegExp(ffpMemberType.cardNoRegex);
            var bonusCardTmp = new String(bonusCardFullWithoutPostfix);
            while (!re.test(bonusCardTmp) && bonusCardTmp) {
                bonusCardTmp = cropFirstLetter(bonusCardTmp);
            }
            return bonusCardFullPostfix ? bonusCardTmp + '.' + bonusCardFullPostfix : bonusCardTmp;
        }
    }

    function cropFirstLetter(str) {
        return str.substring(1, str.length);
    }

    function getDefaultSelectedFfpMemberType() {
        return defaultSelectedFfpMemberType;
    }

    function getFfpMemberTypes() {
        return ffpMemberTypes.length ? ffpMemberTypes : false;
    }

    function detectFfpMemberType(bonusCardFull) {
        if (bonusCardFull && bonusCardFull.length) {
            for (var i = 0; i < ffpMemberTypes.length; i++) {
                if (bonusCardFull.indexOf(ffpMemberTypes[i].prefix) === 0) {
                    return ffpMemberTypes[i];
                }
            }
        }
    }

    function tryCropBonusCardFullToShort(bonusCardFull) {
        var memberType = detectFfpMemberType(bonusCardFull);
        if (memberType) {
            var bonusCardShort = generateBonusCardShort(bonusCardFull, memberType);
            if (bonusCardShort) {
                return bonusCardShort;
            }
        }
        return bonusCardFull;
    }

    function getFfpMemberTypeFullLength(ffpMemberTypeCode) {
        for (var i = 0; i < ffpMemberTypes.length; i++) {
            if (ffpMemberTypes[i].code === ffpMemberTypeCode) {
                return ffpMemberTypes[i].fullLength;
            }
        }
    }
}]);

},{"babel-runtime/helpers/extends":9}],625:[function(require,module,exports){
"use strict";

angular.module('app').factory('gtagTracker', ['$window', 'watchman', function ($window, watchman) {

    var eventsConfig = {
        ui: {
            'private-pax-select': {
                category: 'booking',
                action: 'booking-passengers-select'
            },
            'goto-passengers': {
                category: 'booking',
                action: 'booking-passengers'
            },
            'login-application': {
                category: 'account',
                action: 'login',
                label: 'application'
            },
            'login-passengers': {
                category: 'account',
                action: 'login',
                label: 'passengers'
            },
            'forget-password': {
                category: 'account',
                action: 'forget-password'
            },
            'registration-login': {
                category: 'account',
                action: 'registration',
                label: 'login'
            },
            'registration-passengers': {
                category: 'account',
                action: 'registration',
                label: 'passengers'
            },
            'add-services-from-private-order': {
                category: 'common',
                action: 'extra-services-request',
                label: 'account'
            },
            'add-services': {
                category: 'common',
                action: 'extra-services-request',
                label: 'choose'
            },
            'add-services-from-booking': {
                category: 'common',
                action: 'extra-services-request',
                label: 'booking'
            },
            'modify-language': {
                category: 'common',
                action: 'modify-language',
                labelFromData: 'code'
            },
            'modify-currency': {
                category: 'common',
                action: 'modify-currency',
                labelFromData: 'code'
            },
            'extra-services-group-hide': {
                categoryFromData: 'category',
                action: 'extra-services-group-hide'
            },
            'extra-services-group-show': {
                categoryFromData: 'category',
                action: 'extra-services-group-show'
            },
            'clear-session-by-timeout': {
                category: 'common',
                action: 'clear-session-by-timeout'
            },
            'receipt-print': {
                category: 'order',
                action: 'receipt-print'
            },
            'receipt-mail': {
                category: 'order',
                action: 'receipt-mail'
            },
            'flight-details': {
                categoryFromData: 'type',
                action: 'flight-details'
            },
            'exchange-order': {
                category: 'order',
                action: 'exchange-order'
            },
            'refund-order': {
                category: 'order',
                action: 'refund-order'
            },
            'tariff-info': {
                category: 'common',
                action: 'tariff-info',
                labelFromData: 'label'
            },
            'new-order': {
                category: 'order',
                action: 'new-order'
            },
            'account-orders': {
                category: 'account',
                action: 'account-orders'
            },
            'account-order-view': {
                category: 'account',
                action: 'account-order-view',
                labelFromData: 'label'
            },
            'account-passengers': {
                category: 'account',
                action: 'account-passengers'
            },
            'account-passengers-add': {
                category: 'account',
                action: 'account-passengers-add'
            },
            'account-passengers-delete': {
                category: 'account',
                action: 'account-passengers-delete'
            },
            'account-passengers-deleted': {
                category: 'account',
                action: 'account-passengers-deleted'
            },
            'account-bank-details': {
                category: 'account',
                action: 'account-bank-details'
            },
            'account-bank-details-add': {
                category: 'account',
                action: 'account-bank-details-add'
            },
            'account-profile': {
                category: 'account',
                action: 'account-profile'
            },
            'account-password': {
                category: 'account',
                action: 'account-password'
            },
            'account-payments': {
                category: 'account',
                action: 'account-payments'
            },
            'account-delete': {
                category: 'account',
                action: 'account-delete'
            },
            'account-back-to-booking': {
                category: 'account',
                action: 'account-back-to-booking'
            },
            'password-change': {
                category: 'account',
                action: 'password-change'
            }
        },
        json: {
            'search-variants-mono-brand-cartesian': {
                response: {
                    category: 'booking',
                    action: 'search-flight',
                    label: 'mono-brand-cartesian'
                }
            },
            'search-variants': {
                response: {
                    category: 'booking',
                    action: 'search-flight',
                    label: 'variants'
                }
            },
            'search-variants-period': {
                response: {
                    category: 'booking',
                    action: 'search-flight',
                    label: 'variants-period'
                }
            },
            'search-variants-ffp': {
                response: {
                    category: 'booking',
                    action: 'search-flight',
                    label: 'variants-ffp'
                }
            },
            'search-nearest-dates': {
                response: {
                    category: 'booking',
                    action: 'search-flight',
                    label: 'nearest-dates'
                }
            },
            'search-variants-pricing-route-and-mono-brand': {
                response: {
                    category: 'booking',
                    action: 'search-flight',
                    label: 'pricing-route-and-mono-brand'
                }
            },
            'search-pricevariant': {
                response: {
                    category: 'booking',
                    action: 'search-flight',
                    label: 'pricevariant'
                }
            },
            'ffp-login': {
                response: {
                    category: 'booking',
                    action: 'ffp-login'
                }
            },
            'ffp-logout': {
                response: {
                    category: 'booking',
                    action: 'ffp-logout'
                }
            },
            'search-schedule': {
                request: {
                    category: 'booking',
                    action: 'search-schedule'
                }
            },
            'pricing-variant': {
                response: {
                    category: 'booking',
                    action: 'pricing-variant',
                    label: 'default'
                }
            },
            'pricing-mono-brand': {
                response: {
                    category: 'booking',
                    action: 'pricing-variant',
                    label: 'mono-brand'
                }
            },
            'do-booking-and-register-order': {
                response: {
                    category: 'booking',
                    action: 'do-booking-and-register-order'
                }
            },
            'login': {
                response: {
                    category: 'account',
                    action: 'logged-in'
                }
            },
            'logout': {
                response: {
                    category: 'account',
                    action: 'logout'
                }
            },
            'forget-password': {
                response: {
                    category: 'account',
                    action: 'forget-password-send'
                }
            },
            'registration': {
                response: {
                    category: 'account',
                    action: 'registration-send'
                }
            },
            'resend-activation-mail': {
                request: {
                    category: 'account',
                    action: 'resend-activation-mail'
                }
            },
            'extra-services-modify': {
                request: {
                    action: 'extra-services-add',
                    setServiceData: true
                }
            },
            'extra-services-remove': {
                request: {
                    action: 'extra-services-remove',
                    setServiceData: true
                }
            },
            'change-payment-form': {
                request: {
                    category: 'payments',
                    action: 'change-payment-form',
                    labelFromData: 'formPay'
                }
            },
            'aeroexpress-refund': {
                request: {
                    category: 'payments',
                    action: 'aeroexpress-refund'
                }
            },
            'start-payment-for-extra-services': {
                request: {
                    category: 'payments',
                    action: 'start-payment-for-extra-services'
                }
            },
            'retry-register': {
                request: {
                    category: 'payments',
                    action: 'retry-register'
                }
            },
            'receipt-mail-send': {
                request: {
                    category: 'order',
                    action: 'receipt-mail-send'
                }
            },
            'exchange-variants': {
                request: {
                    category: 'order',
                    action: 'exchange-variants'
                }
            },
            'exchange-select': {
                request: {
                    category: 'order',
                    action: 'exchange-select'
                }
            },
            'exchange-confirm': {
                request: {
                    category: 'order',
                    action: 'exchange-confirm'
                }
            },
            'manual-refund': {
                request: {
                    category: 'order',
                    action: 'refund-manual'
                }
            },
            'confirm-refund': {
                request: {
                    category: 'order',
                    action: 'refund-confirm'
                }
            },
            'cancel-order': {
                response: {
                    category: 'order',
                    action: 'cancel-order'
                }
            },
            'search-order': {
                request: {
                    category: 'order',
                    action: 'search-order',
                    setSearchOrderParams: true
                }
            },
            'update-profile': {
                request: {
                    category: 'account',
                    action: 'account-update-profile'
                }
            },
            'change-password': {
                request: {
                    category: 'account',
                    action: 'account-change-password'
                }
            },
            'delete-profile': {
                request: {
                    category: 'account',
                    action: 'account-deleted'
                }
            },
            'activate': {
                request: {
                    category: 'account',
                    action: 'activate'
                }
            },
            'temp-change-password': {
                response: {
                    category: 'account',
                    action: 'password-changed'
                }
            },
            'order-info': {
                response: {
                    setAddingExtraServicesAllowed: true,
                    category: 'order',
                    action: 'order-info'
                }
            }
        }
    };

    return init;

    function init() {
        if ($window.gtag) {
            watchman.addOrderEventListener(orderOverlooker, 'googleAnalytics');
            watchman.addListener(backendOverlooker, 'googleAnalytics');
            watchman.addUserInterfaceListener(uiOverlooker, 'googleAnalytics');
        }
    }

    function orderOverlooker(orderEvent, orderInfo) {
        handleEvent({
            action: orderEvent.type,
            category: 'order-event',
            label: orderInfo.header.regnum
        });
    }

    function backendOverlooker(backendEvent) {
        if (backendEvent.type === 'response' && backendEvent.data.error) {
            return;
        }
        var gEvent = eventsConfig.json[backendEvent.name] && eventsConfig.json[backendEvent.name][backendEvent.type];
        if (gEvent) {
            if (gEvent.setServiceData && backendEvent.data && backendEvent.data.code) {
                gEvent.category = backendEvent.data.code;
                if (backendEvent.data.rfisc) {
                    gEvent.label = backendEvent.data.rfisc;
                } else if (backendEvent.data.code === 'insuranceOnline' || backendEvent.data.code === 'insurance') {
                    gEvent.label = generateInsuranceLabel(backendEvent.data);
                } else if (backendEvent.data.code === 'aeroexpress') {
                    gEvent.label = generateAeroexpressLabel(backendEvent.data);
                }
            }
            if (gEvent.labelFromData && backendEvent.data && backendEvent.data[gEvent.labelFromData]) {
                gEvent.label = backendEvent.data[gEvent.labelFromData];
            }
            if (gEvent.setSearchOrderParams && backendEvent.data && (backendEvent.data.ticket || backendEvent.data.pnr) && backendEvent.data.lastName) {
                gEvent.label = backendEvent.data.lastName + '_' + (backendEvent.data.ticket || backendEvent.data.pnr);
            }
            if (gEvent.setAddingExtraServicesAllowed && backendEvent.data) {
                gEvent.label = backendEvent.data.addingExtraServicesAllowed ? 'extra-services' : 'no-extra-services';
            }
            handleEvent(gEvent);
        }
    }

    function generateInsuranceLabel(data) {
        var label = 'insurance';
        if (data.ins) {
            label += '_' + data.ins;
        }
        if (data.tins) {
            label += '_' + data.tins;
        }
        if (data.productCode) {
            label += '_' + data.productCode;
        }
        return label;
    }

    function generateAeroexpressLabel(data) {
        var label = 'aeroexpress';
        if (data.type) {
            label += '_' + data.type;
        }
        return label;
    }

    function uiOverlooker(uiEvent) {
        var gEvent = eventsConfig.ui[uiEvent.name];
        if (gEvent) {
            if (gEvent.labelFromData && uiEvent.data && uiEvent.data[gEvent.labelFromData]) {
                gEvent.label = uiEvent.data[gEvent.labelFromData];
            }
            if (gEvent.categoryFromData && uiEvent.data && uiEvent.data[gEvent.categoryFromData]) {
                gEvent.category = uiEvent.data[gEvent.categoryFromData];
            }
            handleEvent(gEvent);
        }
    }

    function handleEvent(gEvent) {
        var params = {
            event_category: gEvent.category
        };
        if (gEvent.label) {
            params.event_label = gEvent.label;
        }
        $window.gtag('event', gEvent.action, params);
    }
}]);

},{}],626:[function(require,module,exports){
"use strict";

require('./oxyScroll');
require('./appInit');
require('./redirect');
require('./modalTools');
require('./skyscannerTracker');
require('./yandexTracker');
require('./admitadTracker');
require('./aviasalesTracker');
require('./gtagTracker');
require('./ymTracker');
require('./ffpTools');

},{"./admitadTracker":621,"./appInit":622,"./aviasalesTracker":623,"./ffpTools":624,"./gtagTracker":625,"./modalTools":627,"./oxyScroll":628,"./redirect":629,"./skyscannerTracker":630,"./yandexTracker":631,"./ymTracker":632}],627:[function(require,module,exports){
"use strict";

angular.module('app').factory('modalTools', ['$timeout', '$window', function ($timeout, $window) {

    var globalListener = void 0;
    var openListeners = {};

    return {
        openHandler: openHandler,
        closeHandler: closeHandler,
        setOpenListener: setOpenListener,
        setGlobalListener: setGlobalListener
    };

    function openHandler(id, link, params) {
        if (globalListener) {
            $window.document.documentElement.addEventListener('keydown', handleEsc);
            globalListener(id);
        }
        $timeout(function () {
            if (openListeners[id]) {
                openListeners[id](link, params);
            }
        });
    }

    function closeHandler() {
        if (globalListener) {
            $window.document.documentElement.removeEventListener('keydown', handleEsc);
            globalListener(false);
        }
    }

    function setOpenListener(id, cb) {
        openListeners[id] = cb;
    }

    function setGlobalListener(cb) {
        globalListener = cb;
    }

    function handleEsc(event) {
        if (event.keyCode === 27) {
            closeHandler();
        }
    }
}]);

},{}],628:[function(require,module,exports){
"use strict";

angular.module('app').factory('oxyScroll', ['$document', function ($document) {

    var service = {
        scrollTopAnimated: scrollTopAnimated,
        scrollToAnchor: scrollToAnchor
    };

    if (o2context.oxyScrollDuration === undefined) {
        o2context.oxyScrollDuration = 500;
    }

    if (o2context.oxyScrollOffset === undefined) {
        o2context.oxyScrollOffset = 10;
    }

    function scrollTopAnimated(top) {
        if (o2context.scrollTopAnimated) {
            o2context.scrollTopAnimated(top);
        } else {
            $document.scrollTopAnimated(top, o2context.oxyScrollDuration);
        }
    }

    function scrollToAnchor(name) {
        if (o2context.scrollToElement) {
            o2context.scrollToElement(name);
        } else {
            $document.scrollToElement($document.querySelectorAll('a[name="' + name + '"]'), o2context.oxyScrollOffset, o2context.oxyScrollDuration);
        }
    }

    return service;
}]);

},{}],629:[function(require,module,exports){
"use strict";

angular.module('app').factory('redirect', ['$rootScope', '$location', '$route', 'ROUTES', function ($rootScope, $location, $route, ROUTES) {

    function replaceOrderUrlParams(url, pnrOrTicketNumber, lastName) {
        url = url.replace(':lastName', lastName);
        url = url.replace(':pnrOrTicketNumber', pnrOrTicketNumber);
        return url;
    }

    return {
        goToStart: function goToStart() {
            $location.path(ROUTES.SEARCH);
        },
        goToPassengers: function goToPassengers() {
            $location.path(ROUTES.PASSENGERS);
        },
        goToBooking: function goToBooking() {
            $location.path(ROUTES.BOOKING_SERVICES);
        },
        goToSeatSelect: function goToSeatSelect() {
            $location.path(ROUTES.SEAT_SELECT);
        },
        goToResetForgetPassword: function goToResetForgetPassword() {
            $location.path(ROUTES.RESET_FORGET_PASSWORD);
        },
        goToActivateAccount: function goToActivateAccount() {
            $location.path(ROUTES.ACTIVATE_ACCOUNT);
        },
        goToPrivatePassengers: function goToPrivatePassengers() {
            $location.path(ROUTES.PRIVATE_PASSENGERS);
        },
        goToPrivateProfile: function goToPrivateProfile() {
            $location.path(ROUTES.PRIVATE_PROFILE);
        },
        goToPrivatePassword: function goToPrivatePassword() {
            $location.path(ROUTES.PRIVATE_PASSWORD);
        },
        goToPrivatePayments: function goToPrivatePayments() {
            $location.path(ROUTES.PRIVATE_PAYMENTS);
        },
        goToPrivateOrders: function goToPrivateOrders() {
            $location.path(ROUTES.PRIVATE_ORDERS);
        },
        goToPrivateOrder: function goToPrivateOrder(pnrOrTicketNumber, lastName) {
            $location.path(replaceOrderUrlParams(ROUTES.PRIVATE_ORDER, pnrOrTicketNumber, lastName));
        },
        goToPaymentVariants: function goToPaymentVariants() {
            $location.path(ROUTES.PAYMENT_VARIANTS);
        },
        goToConfirmOrder: function goToConfirmOrder() {
            $location.path(ROUTES.CONFIRM_ORDER);
        },
        goToConfirmBooking: function goToConfirmBooking() {
            $location.path(ROUTES.CONFIRM_BOOKING);
        },
        goToSearchOrder: function goToSearchOrder(pnrOrTicketNumber, lastName) {
            if (pnrOrTicketNumber && lastName) {
                $location.path(replaceOrderUrlParams(ROUTES.SEARCH_ORDER_WITH_PARAMS, pnrOrTicketNumber, lastName));
            } else {
                $location.path(ROUTES.SEARCH_ORDER);
            }
        },
        goToAddServices: function goToAddServices() {
            $location.path(ROUTES.ADD_SERVICES);
        },
        goToExchange: function goToExchange() {
            $location.path(ROUTES.EXCHANGE);
        },
        goToRefund: function goToRefund() {
            $location.path(ROUTES.REFUND);
        },
        goToLastBookingStep: function goToLastBookingStep() {
            $location.path($rootScope.lastBookingStep || ROUTES.SEARCH);
        },
        goToRemoveProfileConfirm: function goToRemoveProfileConfirm() {
            $location.path(ROUTES.REMOVE_PROFILE_CONFIRM);
        },
        isResetForgetPasswordScreen: function isResetForgetPasswordScreen() {
            return $location.path() === ROUTES.RESET_FORGET_PASSWORD;
        },
        isActivateAccountScreen: function isActivateAccountScreen() {
            return $location.path() === ROUTES.ACTIVATE_ACCOUNT;
        },
        isPassengersScreen: function isPassengersScreen() {
            return $location.path() === ROUTES.PASSENGERS;
        },
        isBookingScreen: function isBookingScreen() {
            return $location.path() === ROUTES.BOOKING_SERVICES;
        },
        isBookingStep: function isBookingStep(orderInfo) {
            if (orderInfo) {
                return $route.current.isBookingStep && (!orderInfo.header || !orderInfo.header.regnum);
            } else {
                return $route.current.isBookingStep;
            }
        },
        isConfrimBookingScreen: function isConfrimBookingScreen() {
            return $location.path() === ROUTES.CONFIRM_BOOKING;
        },
        isSearchScreen: function isSearchScreen() {
            return $location.path() === ROUTES.SEARCH;
        },
        isSearchOrderScreen: function isSearchOrderScreen() {
            return $location.path() === ROUTES.SEARCH_ORDER;
        }
    };
}]);

},{}],630:[function(require,module,exports){
"use strict";

angular.module('app').factory('skyscannerTracker', ['$window', '$cookies', 'watchman', 'backend', function ($window, $cookies, watchman, backend) {

    return init;

    function init() {
        if (backend.getParam('site.skyscannerTrackingID')) {
            if (isActiveTracking()) {
                appendSAT();
                watchman.addOrderEventListener(orderOverlooker, 'skyscanner');
            }
        }
    }

    function isActiveTracking() {
        if (o2context.externalSearchParams && o2context.externalSearchParams['search-engine'].toUpperCase() === 'SKYSCANNER') {
            $cookies.put('websky_last_redirect_source', 'skyscanner');
            return true;
        } else {
            return $cookies.get('websky_last_redirect_source') === 'skyscanner';
        }
    }

    function appendSAT() {
        // Append https://analytics.skyscanner.net/tag.js => sat namespace ready
        // eslint-disable-next-line
        (function (s, k, y, t, a, g) {
            s['SkyscannerAnalyticsTag'] = t;s[t] = s[t] || function () {
                (s[t].buffer = s[t].buffer = s[t].buffer || []).push(arguments);
            };s[t].u = y;var l = k.createElement("script");l.src = y + "/tag.js";l.async = 1;var h = k.getElementsByTagName("head")[0];h.appendChild(l);
        })(window, document, 'https://analytics.skyscanner.net', 'sat');
    }

    function orderOverlooker(orderEvent, orderInfo) {
        if (orderInfo.header && orderInfo.header.regnum && orderEvent.type === 'ORDER_PAYMENT_SUCCESSFULLY_FINISHED') {
            $window.sat('init', backend.getParam('site.skyscannerTrackingID'));
            $window.sat('send', 'conversion', { bookingReference: orderInfo.header.regnum });
        }
    }
}]);

},{}],631:[function(require,module,exports){
"use strict";

angular.module('app').factory('yandexTracker', ['$cookies', 'watchman', 'backend', 'utils', function ($cookies, watchman, backend, utils) {

    var marker = void 0;
    var orderEventTypes = {
        'ORDER_BOOKED': 'booking',
        'ORDER_PAYMENT_SUCCESSFULLY_FINISHED': 'paid',
        'ORDER_CANCELLED': 'cancel'
    };

    return init;

    function init() {
        if (backend.getParam('site.useYandexMarker')) {
            marker = updateMarker();
            if (marker && isActiveTracking()) {
                updateESP();
                watchman.addOrderEventListener(orderOverlooker, 'yandexMarker');
            }
        }
    }

    function orderOverlooker(orderEvent) {
        if (orderEventTypes[orderEvent.type]) {
            requestByImage(marker, orderEventTypes[orderEvent.type]);
        }
    }

    function updateMarker() {
        var marker = utils.getParamFromLocation('marker');
        if (marker) {
            $cookies.put('websky_yandex_marker', marker);
            $cookies.put('websky_last_redirect_source', 'yandex');
        } else {
            marker = $cookies.get('websky_yandex_marker');
        }
        return marker;
    }

    function updateESP() {
        if (!o2context.externalSearchParams) {
            o2context.externalSearchParams = {};
        }
        if (!o2context.externalSearchParams['search-engine']) {
            o2context.externalSearchParams['search-engine'] = 'yandex';
        }
    }

    function isActiveTracking() {
        return $cookies.get('websky_last_redirect_source') === 'yandex';
    }

    function requestByImage(marker, status) {
        $('body').append('<img src="https://avia.yandex.ru/order/pixel/' + marker + '/' + status + '.gif"/>');
    }
}]);

},{}],632:[function(require,module,exports){
"use strict";

angular.module('app').factory('ymTracker', ['$window', 'watchman', 'backend', 'utils', function ($window, watchman, backend, utils) {

    return {
        init: init,
        getFlightProducts: getFlightProducts
    };

    function init() {
        if ($window.ym || o2context.debug) {
            watchman.addUserInterfaceListener(uiOverlooker, 'yandexMetrika');
            watchman.addOrderEventListener(orderOverlooker, 'yandexMetrika');
        }
    }

    function uiOverlooker(uiEvent) {
        if (uiEvent.data) {
            var ecommerce = uiEvent.data.ecommerce;

            if (ecommerce) {
                // console.log('ecommerce: ', ecommerce);
                $window.dataLayer.push({ ecommerce: ecommerce });
            }
        }
    }

    function getFlightProducts(orderInfo, passengers) {

        var pricesByOrderFlights = utils.getPricesByOrderFlights(orderInfo);

        var products = pricesByOrderFlights.map(function (orderFlight) {
            var flights = orderFlight.flights.map(function (id) {
                return _.findWhere(orderInfo.plainFlights, { id: id });
            });
            var price = orderFlight.price;

            return {
                id: flights.map(function (flight) {
                    return flight.company.code_en + '-' + flight.racenumber;
                }).join(' '),
                name: flights[0].origincity + '-' + flights[flights.length - 1].destinationcity,
                price: price,
                coupon: orderInfo.originalPromoCode || '',
                brand: flights[0].brandName,
                category: 'ticket/' + flights[0].brandName,
                quantity: 1,
                variant: 'booking'
            };
        });

        var hasInfantsWithoutSeat = passengers.some(function (priceByCategory) {
            return priceByCategory.categoryId === 'infantsWithoutSeat';
        });

        if (hasInfantsWithoutSeat) {
            products.push({
                category: 'services/babynoseat',
                variant: 'booking',
                name: 'Младенец без места'
            });
        }

        return products;
    }

    function orderOverlooker(orderEvent, orderInfo) {
        var variantsByEventTypes = {
            'ORDER_PAYMENT_SUCCESSFULLY_FINISHED': 'booking',
            'EXTRA_SERVICES_PAYMENT_SUCCESSFULLY_FINISHED': 'mmb'
        };
        if (variantsByEventTypes[orderEvent.type]) {
            var products = [];

            if (orderEvent.type === 'ORDER_PAYMENT_SUCCESSFULLY_FINISHED') {
                var flightProducts = getFlightProducts(orderInfo, orderInfo.passengers);
                flightProducts.forEach(function (p) {
                    products.push(p);
                });
            }

            if (orderInfo.allExtraServicesHeap && orderInfo.allExtraServicesHeap.length) {
                var issuedExtraServicesHeap = orderInfo.allExtraServicesHeap.filter(function (item) {
                    return item.status === 'ISSUED_WITH_EMD' || item.status === 'ISSUED';
                });
                issuedExtraServicesHeap.forEach(function (item) {
                    if (orderEvent.type === 'ORDER_PAYMENT_SUCCESSFULLY_FINISHED' || item.paymentSuccessfullyFinishedEventId == orderEvent.id) {
                        if (item.rfisc) {
                            var product = {
                                'id': item.rfisc,
                                'name': item.title,
                                'price': item.totalPrice,
                                'category': 'services/' + item.groupCode,
                                'quantity': 1,
                                'variant': variantsByEventTypes[orderEvent.type]
                            };
                            if (item.groupCode === 'seat') {
                                if (item.value) {
                                    product.brand = item.value;
                                }
                                if (item.extraProperties && item.extraProperties.legendGroup) {
                                    product.name = item.extraProperties.legendGroup;
                                }
                            }
                            if (!item.groupCode === 'baggage' || item.totalPrice !== '0.00') {
                                products.push(product);
                            }
                        } else if (item.ins && item.tins && item.productCode) {
                            var insTinsProductCode = [item.ins, item.tins, item.productCode];
                            var itemId = insTinsProductCode.join('.');
                            var nameAlias = 'web.insuranceOnline.' + itemId;
                            products.push({
                                'id': item.ins + '-' + item.tins + '-' + item.productCode,
                                'name': backend.getAliasDynamic(nameAlias),
                                'price': item.price,
                                'category': 'services/insuranceOnline',
                                'quantity': 1,
                                'variant': variantsByEventTypes[orderEvent.type]
                            });
                        } else if (item.groupCode === 'aeroexpress') {
                            products.push({
                                'id': 'OBC',
                                'name': 'Аэроэкспресс',
                                'price': item.fare.cost,
                                'category': 'services/aeroexpress',
                                'quantity': 1,
                                'variant': variantsByEventTypes[orderEvent.type]
                            });
                        }
                    }
                });
            }

            var ecommerceOrderId = orderInfo.header.regnum;

            if (orderEvent.type === 'EXTRA_SERVICES_PAYMENT_SUCCESSFULLY_FINISHED') {
                var servicesPaymentEvents = orderInfo.events.filter(function (orderSomeEvent) {
                    return orderSomeEvent.type === 'EXTRA_SERVICES_PAYMENT_SUCCESSFULLY_FINISHED';
                });
                if (servicesPaymentEvents.length) {
                    ecommerceOrderId = ecommerceOrderId + '-' + servicesPaymentEvents.length;
                }
            }

            var ecommerce = {
                currencyCode: orderInfo.currency,
                purchase: {
                    actionField: { id: ecommerceOrderId },
                    products: products
                }
            };
            // console.log('ecommerce: ', ecommerce);
            $window.dataLayer.push({ ecommerce: ecommerce });
        }
    }
}]);

},{}]},{},[430]);
